import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type ReactiveFunction<TParam> = () => TParam;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * An unique identifier for datafield definitions
   * It must adhere to the following pattern: ^[_A-Za-z][_0-9A-Za-z]{0,128}$
   */
  DatafieldDefinitionID: any;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  DateTime: any;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  EmailAddress: any;
  /**
   * Reserved characters
   * The regular expression engine supports all Unicode characters. However, the following characters are reserved as operators:
   * . ? + * | { } [ ] ( ) " \ # @ & < >  ~
   * To use one of these characters literally, escape it with a preceding backslash or surround it with double quotes. For example:
   *
   * \@                  # renders as a literal '@'
   * \\                  # renders as a literal '\'
   * "john@smith.com"    # renders as 'john@smith.com'
   *
   *
   * The regular expression engine does not use the Perl Compatible Regular Expressions (PCRE) library, but it does support the following operators:
   *
   * .
   * Matches any character. For example:
   *
   * ab.     # matches 'aba', 'abb', 'abz', etc.
   * ?
   * Repeat the preceding character zero or one times. Often used to make the preceding character optional. For example:
   *
   * abc?     # matches 'ab' and 'abc'
   * +
   * Repeat the preceding character one or more times. For example:
   *
   * ab+     # matches 'ab', 'abb', 'abbb', etc.
   * *
   * Repeat the preceding character zero or more times. For example:
   *
   * ab*     # matches 'a', 'ab', 'abb', 'abbb', etc.
   *
   *
   * {}
   * Minimum and maximum number of times the preceding character can repeat. For example:
   *
   * a{2}    # matches 'aa'
   * a{2,4}  # matches 'aa', 'aaa', and 'aaaa'
   * a{2,}   # matches 'a` repeated two or more times
   *
   *
   * |
   * OR operator. The match will succeed if the longest pattern on either the left side OR the right side matches. For example:
   *
   * abc|xyz  # matches 'abc' and 'xyz'
   *
   *
   * ( … )
   * Forms a group. You can use a group to treat part of the expression as a single character. For example:
   *
   * abc(def)?  # matches 'abc' and 'abcdef' but not 'abcd'
   *
   *
   * [ … ]
   * Match one of the characters in the brackets. For example:
   *
   * [abc]   # matches 'a', 'b', 'c'
   *
   * Inside the brackets, - indicates a range unless - is the first character or escaped. For example:
   *
   * [a-c]   # matches 'a', 'b', or 'c'
   * [-abc]  # '-' is first character. Matches '-', 'a', 'b', or 'c'
   * [abc\-] # Escapes '-'. Matches 'a', 'b', 'c', or '-'
   *
   * A ^ before a character in the brackets negates the character or range. For example:
   *
   * [^abc]      # matches any character except 'a', 'b', or 'c'
   * [^a-c]      # matches any character except 'a', 'b', or 'c'
   * [^-abc]     # matches any character except '-', 'a', 'b', or 'c'
   * [^abc\-]    # matches any character except 'a', 'b', 'c', or '-'
   *
   *
   * COMPLEMENT
   * You can use ~ to negate the shortest following pattern. For example:
   * a~bc   # matches 'adc' and 'aec' but not 'abc'
   *
   *
   * INTERVAL
   * You can use <> to match a numeric range. For example:
   *
   * foo<1-100>      # matches 'foo1', 'foo2' ... 'foo99', 'foo100'
   * foo<01-100>     # matches 'foo01', 'foo02' ... 'foo99', 'foo100'
   *
   *
   * INTERSECTION
   * The match will succeed if patterns on both the left side AND the right side matches. For example:
   *
   * aaa.+&.+bbb  # matches 'aaabbb'
   *
   *
   * ANYSTRING
   * You can use @ to match any entire string.
   * You can combine the @ operator with & and ~ operators to create an "everything except" logic. For example:
   *
   * @&~(abc.+)  # matches everything except terms beginning with 'abc'
   */
  FilterRegex: any;
  /** Full text query type which is length limited */
  FullTextSearchQuery: any;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  JSON: any;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  JSONObject: any;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  Long: any;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  NoDynamicValueDefined: any;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  NonNegativeFloat: any;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  NonNegativeInt: any;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  PositiveInt: any;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  URL: any;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  Void: any;
};

/** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
export type AiAssistantConversationContext = {
  __typename?: 'AIAssistantConversationContext';
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  meta?: Maybe<AiAssistantConversationMetaContext>;
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  object?: Maybe<AiAssistantConversationObjectContext>;
};

/** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
export type AiAssistantConversationMetaContext = {
  __typename?: 'AIAssistantConversationMetaContext';
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  items?: Maybe<Array<Maybe<AiAssistantConversationMetaContextItem>>>;
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  pagination?: Maybe<AiAssistantPagination>;
};

/** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
export type AiAssistantConversationMetaContextItem = {
  __typename?: 'AIAssistantConversationMetaContextItem';
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  uri: Scalars['String'];
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  value: Scalars['String'];
};

/** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
export type AiAssistantConversationObjectContext = {
  __typename?: 'AIAssistantConversationObjectContext';
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  items?: Maybe<Array<Maybe<AiAssistantConversationObjectContextItem>>>;
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  pagination?: Maybe<AiAssistantPagination>;
};

/** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
export type AiAssistantConversationObjectContextItem = {
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  id: Scalars['ID'];
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  label: Scalars['String'];
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  match?: Maybe<AiAssistantConversationObjectContextItemNode>;
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  selector?: Maybe<AiAssistantSelector>;
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  text?: Maybe<Scalars['String']>;
};

/** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
export type AiAssistantConversationObjectContextItemNode = Topic;

/** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
export type AiAssistantConversationObjectContextTopicItem = AiAssistantConversationObjectContextItem & {
  __typename?: 'AIAssistantConversationObjectContextTopicItem';
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  id: Scalars['ID'];
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  label: Scalars['String'];
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  match?: Maybe<Topic>;
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  selector?: Maybe<AiAssistantSelector>;
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  text?: Maybe<Scalars['String']>;
};

/** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
export type AiAssistantEdge = {
  __typename?: 'AIAssistantEdge';
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  node: AiAssistantNode;
};

/** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
export type AiAssistantNode = {
  __typename?: 'AIAssistantNode';
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  content: Scalars['String'];
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  context?: Maybe<AiAssistantConversationContext>;
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  role: AiAssistantRole;
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  timestamp?: Maybe<Scalars['String']>;
};

/** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
export type AiAssistantPagination = {
  __typename?: 'AIAssistantPagination';
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  page?: Maybe<Scalars['NonNegativeInt']>;
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  pageCount?: Maybe<Scalars['NonNegativeInt']>;
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  pageSize?: Maybe<Scalars['NonNegativeInt']>;
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  total?: Maybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
export type AiAssistantQueryResult = {
  __typename?: 'AIAssistantQueryResult';
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  edges: Array<Maybe<AiAssistantEdge>>;
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  total: TotalCount;
};


/** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
export type AiAssistantQueryResultEdgesArgs = {
  after?: InputMaybe<Scalars['NonNegativeInt']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
export enum AiAssistantRole {
  system = 'system',
  user = 'user'
}

/** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
export type AiAssistantSearchInput = {
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  conversationId?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  language?: InputMaybe<Language>;
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  meta?: InputMaybe<Array<InputMaybe<AiAssistantSearchMetaInput>>>;
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  query: Scalars['String'];
};

/** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
export type AiAssistantSearchMetaInput = {
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  uri: Scalars['String'];
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  value: Scalars['String'];
};

/** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
export type AiAssistantSelector = {
  __typename?: 'AIAssistantSelector';
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  range?: Maybe<AiAssistantSelectorRange>;
};

/** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
export type AiAssistantSelectorRange = {
  __typename?: 'AIAssistantSelectorRange';
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  end?: Maybe<AiAssistantSelectorRangeConformity>;
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  start?: Maybe<AiAssistantSelectorRangeConformity>;
};

/** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
export type AiAssistantSelectorRangeConformity = {
  __typename?: 'AIAssistantSelectorRangeConformity';
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  conformsTo?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  value?: Maybe<Scalars['String']>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type AiImageMetaFilter = {
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  filterType: Scalars['String'];
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  filterValues: Array<Scalars['String']>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type AiImageSearchFilterOptions = {
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  conversationId?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  meta?: InputMaybe<Array<InputMaybe<AiImageMetaFilter>>>;
};

/** Sub Graph: **https://ai-parts-search-graph.qit-ai-parts-search.svc.cluster.local:8443** */
export type AiPartsSearchImageUploadConfig = {
  __typename?: 'AIPartsSearchImageUploadConfig';
  /** Are all mime types allowed */
  allowAllMimeTypes?: Maybe<Scalars['Boolean']>;
  /** The allowed dimensions for image files */
  allowedFileDimensions?: Maybe<AiPartsSearchImageUploadDimensions>;
  /** The allowed file extensions */
  allowedFileExtensions?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The allowed mime types */
  allowedMimeTypes: Array<Maybe<Scalars['String']>>;
  /** The limits for the files to upload */
  limits: AiPartsSearchImageUploadLimits;
};

/** Sub Graph: **https://tenant-settings-graph.qit-settings.svc.cluster.local:8443** */
export type AiPartsSearchImageUploadDimensions = {
  __typename?: 'AIPartsSearchImageUploadDimensions';
  /** Maximum height in pixels */
  maxHeightPx?: Maybe<Scalars['NonNegativeInt']>;
  /** Maximum size for smaller dimension (width or height) */
  maxMinDimension?: Maybe<Scalars['NonNegativeInt']>;
  /** Maximum total pixels (width * height) */
  maxPx?: Maybe<Scalars['NonNegativeInt']>;
  /** Maximum width in pixels */
  maxWidthPx?: Maybe<Scalars['NonNegativeInt']>;
  /** Minimum height in pixels */
  minHeightPx?: Maybe<Scalars['NonNegativeInt']>;
  /** Minimum width in pixels */
  minWidthPx?: Maybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://tenant-settings-graph.qit-settings.svc.cluster.local:8443** */
export type AiPartsSearchImageUploadLimits = {
  __typename?: 'AIPartsSearchImageUploadLimits';
  /** The maximal allowed size in bytes per file */
  maxFileSize?: Maybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://ai-parts-search-graph.qit-ai-parts-search.svc.cluster.local:8443** */
export type AiPartsSearchUploadConfig = {
  __typename?: 'AIPartsSearchUploadConfig';
  /** Upload config for the ai parts search image */
  image?: Maybe<AiPartsSearchImageUploadConfig>;
};

/** Sub Graph: **https://access-control-graph.qcc-auth.svc.cluster.local:8443** */
export type AccessControlSettings = {
  __typename?: 'AccessControlSettings';
  /** The unique id */
  id: Scalars['ID'];
  /**
   * The role configuration for the access control
   *
   * The result contains a dictionary of roles.
   * Each of the roles has a grants array which contains the specific resource,
   * action and allowed attributes.
   */
  rolesConfig?: Maybe<Scalars['JSON']>;
};

/**
 * An activity is a guided and logged action instruction.
 * It lists
 * - a title
 * - a brief introduction
 * - pre-requisites to perform the task (like material)
 * - steps to perform the action
 * - (intermediate) results
 * - safety notices
 * - indexed fields (custom fields)
 * - references to related products, assets and articles
 * - attachments which are required by the activity (e.g. images, style sheets, etc.)
 */
export type Activity = {
  __typename?: 'Activity';
  /** The related article ids */
  articleIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The related asset ids */
  assetIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Date and time when the activity was created */
  creationDate: Scalars['String'];
  /** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
  id: Scalars['ID'];
  /** Introduction information on the activity */
  introduction?: Maybe<Scalars['JSONObject']>;
  /** Language of the activity */
  language: Language;
  /** Text from the activity for use e.g. in details. */
  localizations?: Maybe<ActivityLocalizations>;
  /** Date and time of the last modification */
  modificationDate?: Maybe<Scalars['DateTime']>;
  /**
   * Relevant notes for the activity.
   *
   * This field only shows private, pendingApproval notes created by the requesting user and any public notes
   * that reference the activity.
   *
   * Even with administrative privileges this field only shows the above mentioned notes and therefore doesn't include any notes
   * which don't belong to the requesting user except the public ones. To view any note and filter them, refer to the
   * filter query for the notes.
   */
  notes?: Maybe<NoteQueryResult>;
  /** Steps to perform the activity */
  procedure?: Maybe<Scalars['JSONObject']>;
  /** Related information of the activity */
  relations?: Maybe<Array<Maybe<ActivityRelationGroup>>>;
  /** The source this activity was generated from */
  source?: Maybe<Scalars['String']>;
  /** The unique id of the source */
  sourceId?: Maybe<Scalars['String']>;
  /** Length limited text from the activity for use e.g. in result lists, previews, etc. */
  teasers?: Maybe<ActivityTeasers>;
  /** Title of the activity */
  title: MultilingualString;
  /** Most recent date and time when the activity was uploaded */
  uploadDate?: Maybe<Scalars['DateTime']>;
};


/**
 * An activity is a guided and logged action instruction.
 * It lists
 * - a title
 * - a brief introduction
 * - pre-requisites to perform the task (like material)
 * - steps to perform the action
 * - (intermediate) results
 * - safety notices
 * - indexed fields (custom fields)
 * - references to related products, assets and articles
 * - attachments which are required by the activity (e.g. images, style sheets, etc.)
 */
export type ActivityNotesArgs = {
  filter?: InputMaybe<NoteFilter>;
};

/** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
export type ActivityAccessFilter = {
  /**
   * TODO: if activityAccessFilter is removed this input can be made _internal. If the activityAccessFilter is removed the ActivityAccessFilter can be marked as internal only. the begin_template and end_template can be removed after the deprecation. Other domains should be handled in the same way. deprecated
   * Returns all activities if set to true
   */
  all?: InputMaybe<Scalars['Boolean']>;
  /** Allows the specification of further filter criteria, which are grouped together and connected with a logical AND operator */
  andGroup?: InputMaybe<Array<InputMaybe<ActivityFilter>>>;
  /** Boosts the score of all matches in this group by the specified factor. Heads up: The resulting score boost isn't mathematically exact due to rounding errors */
  boost?: InputMaybe<Scalars['Float']>;
  /** Returns activities that contain all of the exact values specified */
  equals?: InputMaybe<ActivityEqualsValueFilter>;
  /** Returns activities that contain one of the exact values specified */
  equalsOneOf?: InputMaybe<ActivityEqualsOneOfValueFilter>;
  /** Returns activities that match all of the specified full text searches */
  exists?: InputMaybe<Array<InputMaybe<ActivityExistsValueFields>>>;
  /** Returns activities that match all of the specified full text searches */
  fullText?: InputMaybe<ActivityFullTextFilter>;
  /** Returns activities with one of the specified unique identifiers */
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Allows you to specify logically negated filter criteria */
  not?: InputMaybe<ActivityFilter>;
  /** Allows the specification of further filter criteria, which are grouped together and connected with a logical OR operator */
  orGroup?: InputMaybe<Array<InputMaybe<ActivityFilter>>>;
  /** Returns activities with values within all of the ranges specified */
  range?: InputMaybe<ActivityRangeFilter>;
  /** Returns activities that match all of the regular expressions */
  regex?: InputMaybe<ActivityRegexFilter>;
  /** Returns activities that match a taxonomy value according to the taxonomy's evaluation type */
  taxonomy?: InputMaybe<ActivityTaxonomyFilter>;
};

/** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
export type ActivityAggregations = {
  __typename?: 'ActivityAggregations';
  /**
   * Provides aggregations for the language field
   * @deprecated API is likely to change in future versions
   */
  language?: Maybe<Array<AggregationEdge>>;
  /** Provides aggregations for the content's use context */
  useContext?: Maybe<DatafieldAggregations>;
};


/** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
export type ActivityAggregationsLanguageArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
export type ActivityAutocompleteHits = {
  __typename?: 'ActivityAutocompleteHits';
  /** The count of docs found containing the suggestion */
  docCount: Scalars['NonNegativeInt'];
  /** The found suggestion */
  suggest: Scalars['String'];
};

/** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
export type ActivityAutocompleteResult = {
  __typename?: 'ActivityAutocompleteResult';
  /** The hits found for the query */
  hits?: Maybe<Array<ActivityAutocompleteHits>>;
  /** The query used for this result */
  query: Scalars['String'];
};

/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type ActivityCollectionEntryNode = CollectionEntryNode & {
  __typename?: 'ActivityCollectionEntryNode';
  /** The activity object */
  activity: Activity;
  /** The result's collection object context. */
  navContext?: Maybe<CollectionEntryCommonNavigationContext>;
};

/** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
export type ActivityEdge = {
  __typename?: 'ActivityEdge';
  /** Unique cursor for pagination. See the query's `after` argument */
  cursor: Scalars['String'];
  /** Highlighted matches for equality and full text filters. Matched terms are wrapped in <em>...</em> Tags. */
  highlights?: Maybe<ActivityHighlights>;
  /** The result's activity type. */
  node: Activity;
  /** Calculated relevance score. */
  score: Scalars['NonNegativeFloat'];
};

/** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
export type ActivityEqualsOneOfValueFilter = {
  /** No regex filterable indexed field definitions exist. As soon as the first matching indexed field definition is defined, it's automatically listed here. */
  not_applicable_as_no_array_field_definitions_exist?: InputMaybe<Scalars['NoDynamicValueDefined']>;
};

/** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
export type ActivityEqualsValueFilter = {
  /** Returns only activities with the specified articleId */
  articleId?: InputMaybe<Scalars['String']>;
  /** Returns only activities with the specified assetId */
  assetId?: InputMaybe<Scalars['String']>;
  /** Returns only activities with the specified creation date */
  creationDate?: InputMaybe<Scalars['DateTime']>;
  /** Returns only activities with the specified language */
  language?: InputMaybe<Language>;
  /** Returns only activities with the specified modification date */
  modificationDate?: InputMaybe<Scalars['DateTime']>;
  /** Returns only activities with the specified source */
  source?: InputMaybe<Scalars['String']>;
  /** Returns only activities with the specified source id */
  sourceId?: InputMaybe<Scalars['String']>;
  /** Returns only activities with the specified title */
  title?: InputMaybe<Scalars['String']>;
  /** Returns only activities with the specified upload date */
  uploadDate?: InputMaybe<Scalars['DateTime']>;
};

/** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
export enum ActivityExistsValueFields {
  /** Returns only activities which have one or more article ids specified */
  articleIds = 'articleIds',
  /** Returns only activities which have one or more asset ids specified */
  assetIds = 'assetIds',
  /** Returns only activities which have a language specified */
  language = 'language',
  /** Returns only activities which have a source specified */
  source = 'source',
  /** Returns only activities which have a source id specified */
  sourceId = 'sourceId',
  /** Returns only activities which have a title specified */
  title = 'title'
}

/**
 * The `ActivityFilter` is used to specify filter criteria for activities.
 * If you specify more than one criterion, all criteria are grouped together and connected with a logical AND operator.
 * Further logical operations are possible by using `not` `andGroup` and `orGroup`.
 */
export type ActivityFilter = {
  /** Returns all activities if set to true */
  all?: InputMaybe<Scalars['Boolean']>;
  /** Allows the specification of further filter criteria, which are grouped together and connected with a logical AND operator */
  andGroup?: InputMaybe<Array<InputMaybe<ActivityFilter>>>;
  /** Boosts the score of all matches in this group by the specified factor. Heads up: The resulting score boost isn't mathematically exact due to rounding errors */
  boost?: InputMaybe<Scalars['Float']>;
  /** Returns activities that contain all of the exact values specified */
  equals?: InputMaybe<ActivityEqualsValueFilter>;
  /** Returns activities that contain one of the exact values specified */
  equalsOneOf?: InputMaybe<ActivityEqualsOneOfValueFilter>;
  /** Returns activities that match all of the specified full text searches */
  exists?: InputMaybe<Array<InputMaybe<ActivityExistsValueFields>>>;
  /** Returns activities that match all of the specified full text searches */
  fullText?: InputMaybe<ActivityFullTextFilter>;
  /** Returns activities with one of the specified unique identifiers */
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Allows you to specify logically negated filter criteria */
  not?: InputMaybe<ActivityFilter>;
  /** Allows the specification of further filter criteria, which are grouped together and connected with a logical OR operator */
  orGroup?: InputMaybe<Array<InputMaybe<ActivityFilter>>>;
  /** Returns activities with values within all of the ranges specified */
  range?: InputMaybe<ActivityRangeFilter>;
  /** Returns activities that match all of the regular expressions */
  regex?: InputMaybe<ActivityRegexFilter>;
  /** Returns activities that match a taxonomy value according to the taxonomy's evaluation type */
  taxonomy?: InputMaybe<ActivityTaxonomyFilter>;
};

/** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
export type ActivityFullTextFields = {
  /** Match the query against any full text searchable field and rank the results with the specified boost */
  any?: InputMaybe<Scalars['Float']>;
  /** Match the query against the text in any language and rank the results with the specified boost */
  text?: InputMaybe<Scalars['Float']>;
  /** Match the query against the title in any language and rank the results with the specified boost */
  title?: InputMaybe<Scalars['Float']>;
};

/** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
export type ActivityFullTextFilter = {
  /** Fields to search in with their respective score weights */
  fields?: InputMaybe<ActivityFullTextFields>;
  /** Indicates if a fuzzy search should be performed. */
  fuzzy?: InputMaybe<Scalars['Boolean']>;
  /** Specifies if either all or any query words need to match */
  operator?: InputMaybe<FullTextOperator>;
  /**
   * Text to search for
   * Be aware: The Limit for full text search queries is 1024 characters and
   * anything above that will result in an error.
   */
  query: Scalars['FullTextSearchQuery'];
  /** Type of fulltext search to perform */
  searchType?: InputMaybe<FullTextSearchType>;
  /** Options to configure the synonym search */
  synonymOptions?: InputMaybe<SynonymOptions>;
};

/** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
export type ActivityHighlights = {
  __typename?: 'ActivityHighlights';
  /** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
  text?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
  title?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
export type ActivityHighlightsTextArgs = {
  length?: InputMaybe<Scalars['NonNegativeInt']>;
};


/** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
export type ActivityHighlightsTitleArgs = {
  length?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Text from the activity for use e.g. in details. */
export type ActivityLocalizations = {
  __typename?: 'ActivityLocalizations';
  /** The activity's title */
  title?: Maybe<Scalars['String']>;
};


/** Text from the activity for use e.g. in details. */
export type ActivityLocalizationsTitleArgs = {
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard>>;
};

/** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
export type ActivityNavigationContextInput = {
  /** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
  assetId?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
  productId?: InputMaybe<Scalars['String']>;
};

/** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
export type ActivityQueryResult = {
  __typename?: 'ActivityQueryResult';
  /**
   * The query's matching activities.
   *
   * Use the `sort` argument to specify the list of fields and the order by which the results should be sorted.
   * Multiple fields and orders may be specified and are evaluated in the provided order.
   *
   * To limit the number of results, set the `first` argument.
   *
   * Pagination is possible by setting the `after` argument to the previous last result's `cursor` field value.
   * Please be careful not to change the query's `filter` or the `sort` argument between paginated calls.
   */
  activities: Array<Maybe<ActivityEdge>>;
  /**
   * Matched datafield values and number of matching activities per value
   *
   * To limit the number of results, set the `first` argument.
   *
   * Pagination is possible by setting the `after` argument to the previous last result's `cursor` field value.
   */
  aggregations: ActivityAggregations;
  /**
   * Returns the total count of results.
   *
   * Use the `trackLimit` argument to limit the track of the total count up to the specified amount.
   * If the result has more hits than the specified limit the total count is inaccurate.
   * See `CountRelation` for further information on how to interpret the result.
   *
   * Heads up: Setting the `trackLimit` to a high value may decrease performance.
   */
  total: TotalCount;
};


/** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
export type ActivityQueryResultActivitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  sort?: InputMaybe<Array<InputMaybe<ActivitySort>>>;
};


/** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
export type ActivityQueryResultTotalArgs = {
  trackLimit?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
export type ActivityRangeFilter = {
  /** Returns only activities with a creation date in the specified range */
  creationDate?: InputMaybe<DateRange>;
  /** Returns only activities with a modification date in the specified range */
  modificationDate?: InputMaybe<DateRange>;
  /** No number or dateTime datafield definitions exist. As soon as the first such datafield definition is defined, it's automatically listed here. */
  not_applicable_as_no_number_or_date_datafield_definitions_exist?: InputMaybe<Scalars['NoDynamicValueDefined']>;
  /** Returns only activities with a upload date in the specified range */
  uploadDate?: InputMaybe<DateRange>;
};

/** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
export type ActivityRegexFilter = {
  /** Returns only activities whose articleId matches the specified Regex */
  articleId?: InputMaybe<Scalars['String']>;
  /** Returns only activities whose assetId matches the specified Regex */
  assetId?: InputMaybe<Scalars['String']>;
  /** Returns only activities whose title matches the specified Regex */
  title?: InputMaybe<Scalars['FilterRegex']>;
};

/** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
export type ActivityRelationGroup = {
  __typename?: 'ActivityRelationGroup';
  /** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
  localizations?: Maybe<ActivityRelationGroupLocalizations>;
  /** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
  references?: Maybe<Array<Maybe<ReferencedEntity>>>;
  /** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
  teasers?: Maybe<ActivityRelationGroupTeasers>;
  /** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
  title: MultilingualString;
};

/** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
export type ActivityRelationGroupLocalizations = {
  __typename?: 'ActivityRelationGroupLocalizations';
  /** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
  title?: Maybe<Scalars['String']>;
};


/** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
export type ActivityRelationGroupLocalizationsTitleArgs = {
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard>>;
};

/** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
export type ActivityRelationGroupTeasers = {
  __typename?: 'ActivityRelationGroupTeasers';
  /** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
  title?: Maybe<Scalars['String']>;
};


/** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
export type ActivityRelationGroupTeasersTitleArgs = {
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard>>;
  length?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
export type ActivitySort = {
  /** Sort field */
  field: ActivitySortFields;
  /** Sort order */
  order?: InputMaybe<SortOrder>;
};

/** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
export enum ActivitySortFields {
  /** Sort by assetId */
  assetId = 'assetId',
  /** Sort by creation date */
  creationDate = 'creationDate',
  /** Sort by unique ID */
  id = 'id',
  /** Sort by language */
  language = 'language',
  /** Sort by modification date */
  modificationDate = 'modificationDate',
  /** Sort by productId */
  productId = 'productId',
  /** Sort by relevance score */
  score = 'score',
  /** Sort by source */
  source = 'source',
  /** Sort by source id */
  sourceId = 'sourceId',
  /** Sort by title */
  title = 'title',
  /** Sort by language-ar title */
  titleAr = 'title_ar',
  /** Sort by language-bg title */
  titleBg = 'title_bg',
  /** Sort by language-bn title */
  titleBn = 'title_bn',
  /** Sort by language-bs title */
  titleBs = 'title_bs',
  /** Sort by language-ca title */
  titleCa = 'title_ca',
  /** Sort by language-cs title */
  titleCs = 'title_cs',
  /** Sort by language-da title */
  titleDa = 'title_da',
  /** Sort by language-de title */
  titleDe = 'title_de',
  /** Sort by language-el title */
  titleEl = 'title_el',
  /** Sort by language-en title */
  titleEn = 'title_en',
  /** Sort by language-es title */
  titleEs = 'title_es',
  /** Sort by language-et title */
  titleEt = 'title_et',
  /** Sort by language-eu title */
  titleEu = 'title_eu',
  /** Sort by language-fa title */
  titleFa = 'title_fa',
  /** Sort by language-fi title */
  titleFi = 'title_fi',
  /** Sort by language-fr title */
  titleFr = 'title_fr',
  /** Sort by language-ga title */
  titleGa = 'title_ga',
  /** Sort by language-he title */
  titleHe = 'title_he',
  /** Sort by language-hi title */
  titleHi = 'title_hi',
  /** Sort by language-hr title */
  titleHr = 'title_hr',
  /** Sort by language-hu title */
  titleHu = 'title_hu',
  /** Sort by language-hy title */
  titleHy = 'title_hy',
  /** Sort by language-id title */
  titleId = 'title_id',
  /** Sort by language-is title */
  titleIs = 'title_is',
  /** Sort by language-it title */
  titleIt = 'title_it',
  /** Sort by language-ja title */
  titleJa = 'title_ja',
  /** Sort by language-kk title */
  titleKk = 'title_kk',
  /** Sort by language-ko title */
  titleKo = 'title_ko',
  /** Sort by language-ku title */
  titleKu = 'title_ku',
  /** Sort by language-lt title */
  titleLt = 'title_lt',
  /** Sort by language-lv title */
  titleLv = 'title_lv',
  /** Sort by language-mk title */
  titleMk = 'title_mk',
  /** Sort by language-ms title */
  titleMs = 'title_ms',
  /** Sort by language-mt title */
  titleMt = 'title_mt',
  /** Sort by language-nb title */
  titleNb = 'title_nb',
  /** Sort by language-nl title */
  titleNl = 'title_nl',
  /** Sort by language-no title */
  titleNo = 'title_no',
  /** Sort by language-pb title */
  titlePb = 'title_pb',
  /** Sort by language-pl title */
  titlePl = 'title_pl',
  /** Sort by language-pt title */
  titlePt = 'title_pt',
  /** Sort by language-ro title */
  titleRo = 'title_ro',
  /** Sort by language-ru title */
  titleRu = 'title_ru',
  /** Sort by language-sk title */
  titleSk = 'title_sk',
  /** Sort by language-sl title */
  titleSl = 'title_sl',
  /** Sort by language-sq title */
  titleSq = 'title_sq',
  /** Sort by language-sr title */
  titleSr = 'title_sr',
  /** Sort by language-sv title */
  titleSv = 'title_sv',
  /** Sort by language-th title */
  titleTh = 'title_th',
  /** Sort by language-tr title */
  titleTr = 'title_tr',
  /** Sort by language-uk title */
  titleUk = 'title_uk',
  /** Sort by language-vi title */
  titleVi = 'title_vi',
  /** Sort by language-zh title */
  titleZh = 'title_zh',
  /** Sort by upload date */
  uploadDate = 'uploadDate'
}

/** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
export type ActivityTaxonomyFilter = {
  /** No taxonomy datafield definitions exist. As soon as the first taxonomy is defined, it's automatically listed here. */
  not_applicable_as_no_taxonomy_datafield_definitions_exist?: InputMaybe<Scalars['NoDynamicValueDefined']>;
};

/** Length limited text from the activity for use e.g. in result lists, previews, etc. */
export type ActivityTeasers = {
  __typename?: 'ActivityTeasers';
  /** The activity's title limited to `length` characters */
  title?: Maybe<Scalars['String']>;
};


/** Length limited text from the activity for use e.g. in result lists, previews, etc. */
export type ActivityTeasersTitleArgs = {
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard>>;
  length?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type AddressInput = {
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  attnOfName?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  cityCode: Scalars['String'];
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  cityName: Scalars['String'];
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  companyName: Scalars['String'];
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  country: Scalars['String'];
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  extraInfo?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  houseNumber: Scalars['String'];
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  street: Scalars['String'];
};

/** Sub Graph: **https://schematic-graph.qit-schematic.svc.cluster.local:8443** */
export type AggregationEdge = {
  __typename?: 'AggregationEdge';
  /** Sub Graph: **https://schematic-graph.qit-schematic.svc.cluster.local:8443** */
  count: Scalars['NonNegativeInt'];
  /** Sub Graph: **https://schematic-graph.qit-schematic.svc.cluster.local:8443** */
  cursor: Scalars['String'];
  /** Sub Graph: **https://schematic-graph.qit-schematic.svc.cluster.local:8443** */
  value: Scalars['String'];
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type Aggregations = {
  __typename?: 'Aggregations';
  /** Provides aggregations for the contentId field */
  contentId?: Maybe<Array<AggregationEdge>>;
  /** Provides aggregations for the documentId field */
  documentId?: Maybe<Array<AggregationEdge>>;
  /** Provides aggregations for the language field */
  language?: Maybe<Array<AggregationEdge>>;
  /** Provides aggregations for the locale field */
  locale?: Maybe<Array<AggregationEdge>>;
  /** Provides aggregations for the mimeType field */
  mimeType?: Maybe<Array<AggregationEdge>>;
  /** Provides aggregations for the rendition field */
  rendition?: Maybe<Array<AggregationEdge>>;
  /** Provides aggregations for the source field */
  source?: Maybe<Array<AggregationEdge>>;
  /** Provides aggregations for the sourceId field */
  sourceId?: Maybe<Array<AggregationEdge>>;
  /** Provides aggregations for the type field */
  type?: Maybe<Array<AggregationEdge>>;
  /** Provides aggregations for the content's use context */
  useContext?: Maybe<UseContextAggregations>;
  /** Provides aggregations for the version field */
  version?: Maybe<Array<AggregationEdge>>;
  /** Provides aggregations for the versionLabel field */
  versionLabel?: Maybe<Array<AggregationEdge>>;
};


/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type AggregationsContentIdArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
};


/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type AggregationsDocumentIdArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
};


/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type AggregationsLanguageArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
};


/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type AggregationsLocaleArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
};


/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type AggregationsMimeTypeArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
};


/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type AggregationsRenditionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
};


/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type AggregationsSourceArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
};


/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type AggregationsSourceIdArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
};


/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type AggregationsTypeArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
};


/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type AggregationsVersionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
};


/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type AggregationsVersionLabelArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://tenant-settings-graph.qit-settings.svc.cluster.local:8443** */
export type AnalyticsSystem = {
  __typename?: 'AnalyticsSystem';
  /** Option to (de-) activate the analytics system. Default is true (active) */
  active: Scalars['Boolean'];
  /** Last characters of the API token for display and verification purposes */
  apiTokenMasked?: Maybe<Scalars['String']>;
  /** Additional configuration parameters for the analytics system, e.g. Measurement ID for Google Analytics */
  config?: Maybe<Scalars['JSON']>;
  /** DateTime of the analytics system configuration creation */
  creationDate: Scalars['DateTime'];
  /** Host URL of the analytics system */
  host: Scalars['String'];
  /** Internal ID of the analytics system configuration. ID is generated on creation. Required to update or delete a specific configuration. */
  id: Scalars['ID'];
  /** DateTime of the analytics system configuration modification. Initially matches creationDate */
  modificationDate: Scalars['DateTime'];
  /** Display name of the analytics system */
  name: Scalars['String'];
  /** Site ID of the analytics system. The value may differ for other vendors (e.g. Property ID for Google Analytics) */
  siteId: Scalars['String'];
  /** Vendor of the analytics system */
  type: AnalyticsSystemType;
};

/**
 * Analytics system filter
 *
 * Filter parameters are linked with AND logic
 */
export type AnalyticsSystemFilter = {
  /** Return only analytics systems that are (in-) active. If not set, return all analytics systems (default) */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Return only analytics systems of the given type */
  type?: InputMaybe<AnalyticsSystemType>;
};

/** Sub Graph: **https://tenant-settings-graph.qit-settings.svc.cluster.local:8443** */
export enum AnalyticsSystemType {
  matomo = 'MATOMO'
}

/** Sub Graph: **https://basic-services-graph.qit.svc.cluster.local:8443** */
export type ApiKey = {
  __typename?: 'ApiKey';
  /** Readable name for the api key */
  displayName: Scalars['String'];
  /** The api key's unique identifier */
  id: Scalars['ID'];
  /** Date until which the api key is valid */
  validUntil?: Maybe<Scalars['DateTime']>;
};

/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type Article = ReferencedEntity & {
  __typename?: 'Article';
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  articleNumber?: Maybe<Scalars['String']>;
  /** Date and time when it was created */
  creationDate?: Maybe<Scalars['DateTime']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  currency?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  files?: Maybe<Array<File>>;
  /** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
  id: Scalars['ID'];
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  localizations?: Maybe<ArticleLocalizations>;
  /** Date and time of the last modification */
  modificationDate?: Maybe<Scalars['DateTime']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  orderable?: Maybe<Scalars['Boolean']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  previewImage?: Maybe<BlobRef>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  price?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  referenceId?: Maybe<Scalars['String']>;
  /**
   * Related activity to the article id. The given activity filter is optional and is combined (AND clause) with
   * a static filter:
   * { equals: { custom_articles: [article.id] } }
   * This returns only activities related to the specific article.
   */
  relatedActivities: ActivityQueryResult;
  /**
   * WARNING: Does not work for now because the required filter could not be defined 100%
   *
   * Related content to the article id. The given content filter is optional and is combined (AND clause) with
   * a static filter:
   * const articleFilter = { articleIds: [article.id] };
   * This returns only contents related to the specific article.
   * The article id is used because an article is always related to a product.
   */
  relatedContents: ContentQueryResult;
  /** Same relation filter as `relatedContents`, grouped using a configured grouping criterion. */
  relatedContentsGrouped: ContentGroupedQueryResult;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  teasers?: Maybe<ArticleTeasers>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  title?: Maybe<MultilingualString>;
};


/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type ArticleFilesArgs = {
  fileTypes?: InputMaybe<Array<InputMaybe<FileType>>>;
};


/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type ArticleRelatedActivitiesArgs = {
  filter?: InputMaybe<ActivityFilter>;
};


/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type ArticleRelatedContentsArgs = {
  filter?: InputMaybe<ContentFilter>;
  filterOptions?: InputMaybe<ContentFilterOptions>;
};


/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type ArticleRelatedContentsGroupedArgs = {
  filter?: InputMaybe<ContentFilter>;
  filterOptions?: InputMaybe<ContentFilterOptions>;
  groupBy: ContentGroupBy;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export enum ArticleAiImageSearchField {
  id = 'id'
}

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type ArticleAiImageSearchFilter = {
  /** The blob ID of the image to search for */
  blobId: Scalars['String'];
  /** The field to query for matching article ids */
  field?: InputMaybe<ArticleAiImageSearchField>;
  /** Additional options for the image search */
  options?: InputMaybe<AiImageSearchFilterOptions>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type ArticleAutocompleteHits = {
  __typename?: 'ArticleAutocompleteHits';
  /** The count of docs found containing the suggestion */
  docCount: Scalars['NonNegativeInt'];
  /** The language this suggestion stems from */
  language?: Maybe<Language>;
  /** The found suggestion */
  suggest: Scalars['String'];
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type ArticleAutocompleteResult = {
  __typename?: 'ArticleAutocompleteResult';
  /** The hits found for the query */
  hits?: Maybe<Array<ArticleAutocompleteHits>>;
  /** The query used for this result */
  query: Scalars['String'];
};

/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type ArticleCollectionEntryNode = CollectionEntryNode & {
  __typename?: 'ArticleCollectionEntryNode';
  /** The article object */
  article: Article;
  /** The result's collection object context. */
  navContext?: Maybe<CollectionEntryCommonNavigationContext>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type ArticleEdge = {
  __typename?: 'ArticleEdge';
  /** Unique cursor for pagination. See the query's `after` argument */
  cursor: Scalars['String'];
  /** The result's article. */
  node: Article;
  /** Calculated relevance score. */
  score: Scalars['NonNegativeFloat'];
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type ArticleEqualsValueFilter = {
  /** Returns only articles with the specified article number */
  articleNumber?: InputMaybe<Scalars['String']>;
  /** Returns only with the specified creation date */
  creationDate?: InputMaybe<Scalars['DateTime']>;
  /** Returns only with the specified modification date */
  modificationDate?: InputMaybe<Scalars['DateTime']>;
  /** No equals filterable datafield definitions exist. As soon as the first matching datafield definition is defined, it's automatically listed here. */
  not_applicable_as_no_equals_filterable_datafield_definitions_exist?: InputMaybe<Scalars['NoDynamicValueDefined']>;
  /**
   * Returns only articles with the specified title
   * @deprecated Use two title_xx fields for InfoTwin language and tenant default language instead
   */
  title?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified ar title */
  title_ar?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified bg title */
  title_bg?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified bn title */
  title_bn?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified bs title */
  title_bs?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified ca title */
  title_ca?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified cs title */
  title_cs?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified da title */
  title_da?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified de title */
  title_de?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified el title */
  title_el?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified en title */
  title_en?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified es title */
  title_es?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified et title */
  title_et?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified eu title */
  title_eu?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified fa title */
  title_fa?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified fi title */
  title_fi?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified fr title */
  title_fr?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified ga title */
  title_ga?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified he title */
  title_he?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified hi title */
  title_hi?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified hr title */
  title_hr?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified hu title */
  title_hu?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified hy title */
  title_hy?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified id title */
  title_id?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified is title */
  title_is?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified it title */
  title_it?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified ja title */
  title_ja?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified kk title */
  title_kk?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified ko title */
  title_ko?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified ku title */
  title_ku?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified lt title */
  title_lt?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified lv title */
  title_lv?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified mk title */
  title_mk?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified ms title */
  title_ms?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified mt title */
  title_mt?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified nb title */
  title_nb?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified nl title */
  title_nl?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified no title */
  title_no?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified pb title */
  title_pb?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified pl title */
  title_pl?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified pt title */
  title_pt?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified ro title */
  title_ro?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified ru title */
  title_ru?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified sk title */
  title_sk?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified sl title */
  title_sl?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified sq title */
  title_sq?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified sr title */
  title_sr?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified sv title */
  title_sv?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified th title */
  title_th?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified tr title */
  title_tr?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified uk title */
  title_uk?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified vi title */
  title_vi?: InputMaybe<Scalars['String']>;
  /** Returns only articles with the specified zh title */
  title_zh?: InputMaybe<Scalars['String']>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export enum ArticleExistsValueFields {
  /** Returns only articles which have an article number specified */
  articleNumber = 'articleNumber',
  /** Returns only articles which have a title specified */
  title = 'title'
}

/**
 * The `ArticleFilter` is used to specify filter criteria for articles.
 * If you specify more than one criterion, all criteria are grouped together and connected with a logical AND operator.
 * Further logical operations are possible by using `not` `andGroup` and `orGroup`.
 */
export type ArticleFilter = {
  /** Returns all articles if set to true */
  all?: InputMaybe<Scalars['Boolean']>;
  /** Allows the specification of further filter criteria, which are grouped together and connected with a logical AND operator */
  andGroup?: InputMaybe<Array<InputMaybe<ArticleFilter>>>;
  /** Boosts the score of all matches in this group by the specified factor. Heads up: The resulting score boost isn't mathematically exact due to rounding errors */
  boost?: InputMaybe<Scalars['Float']>;
  /** Returns articles that contain all of the exact values specified */
  equals?: InputMaybe<ArticleEqualsValueFilter>;
  /**
   * Returns articles that have a value in all of the specified fields
   * @deprecated Please use 'has' filter instead
   */
  exists?: InputMaybe<Array<InputMaybe<ArticleExistsValueFields>>>;
  /** Returns articles that match all of the specified full text searches */
  fullText?: InputMaybe<ArticleFullTextFilter>;
  /** Returns articles that have a value in all of the specified fields */
  has?: InputMaybe<ArticleHasValueFilter>;
  /** Returns articles with one of the specified unique identifiers */
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Returns articles that are matched by an ai supported image search for the article */
  image?: InputMaybe<ArticleAiImageSearchFilter>;
  /** Allows you to specify logically negated filter criteria */
  not?: InputMaybe<ArticleFilter>;
  /** Allows the specification of further filter criteria, which are grouped together and connected with a logical OR operator */
  orGroup?: InputMaybe<Array<InputMaybe<ArticleFilter>>>;
  /** Returns articles with values within all of the ranges specified */
  range?: InputMaybe<ArticleRangeFilter>;
  /** Returns articles that match all of the regular expressions */
  regex?: InputMaybe<ArticleRegexFilter>;
  /** Returns articles that match a taxonomy value according to the taxonomy's evaluation type */
  taxonomy?: InputMaybe<ArticleTaxonomyFilter>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type ArticleFullTextFields = {
  /** Match the query against any full text searchable field and rank the results with the specified boost */
  any?: InputMaybe<Scalars['Float']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  articleNumber?: InputMaybe<Scalars['Float']>;
  /**
   * Match the query against the title and rank the results with the specified boost
   * @deprecated Use two title_xx fields for InfoTwin language and tenant default language instead
   */
  title?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_ar?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_bg?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_bn?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_bs?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_ca?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_cs?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_da?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_de?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_el?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_en?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_es?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_et?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_eu?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_fa?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_fi?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_fr?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_ga?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_he?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_hi?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_hr?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_hu?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_hy?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_id?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_is?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_it?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_ja?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_kk?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_ko?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_ku?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_lt?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_lv?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_mk?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_ms?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_mt?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_nb?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_nl?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_no?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_pb?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_pl?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_pt?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_ro?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_ru?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_sk?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_sl?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_sq?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_sr?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_sv?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_th?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_tr?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_uk?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_vi?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_zh?: InputMaybe<Scalars['Float']>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type ArticleFullTextFilter = {
  /** Fields to search in with their respective score weights */
  fields?: InputMaybe<ArticleFullTextFields>;
  /** Indicates if a fuzzy search should be performed. */
  fuzzy?: InputMaybe<Scalars['Boolean']>;
  /** Specifies if either all or any query words need to match */
  operator?: InputMaybe<FullTextOperator>;
  /** Text to search for */
  query: Scalars['String'];
  /** Type of fulltext search to perform */
  searchType?: InputMaybe<FullTextSearchType>;
};

/** Returns articles that have a value in all of the specified fields */
export type ArticleHasValueFilter = {
  /** Specify the fields that the returned articles must have a value in */
  valueInFields?: InputMaybe<Array<InputMaybe<ArticleHasValueInFields>>>;
};

/** Specify the fields that the returned articles must have a value in */
export enum ArticleHasValueInFields {
  /** Returns only articles which have an article number specified */
  articleNumber = 'articleNumber',
  /** Returns only articles which have a title specified */
  title = 'title'
}

/** identifier for the article information in hoops */
export type ArticleHoopsRef = {
  __typename?: 'ArticleHoopsRef';
  /** name of the node property containing the article information */
  nodeProperty?: Maybe<Scalars['String']>;
};

/** identifier for the article information in lattice */
export type ArticleLatticeRef = {
  __typename?: 'ArticleLatticeRef';
  /** datafield of the article */
  field?: Maybe<Scalars['String']>;
  /** the section type in 3d-Model */
  section?: Maybe<Scalars['String']>;
};

/** Text from the article for use e.g. in details. */
export type ArticleLocalizations = {
  __typename?: 'ArticleLocalizations';
  /** The article's title */
  title?: Maybe<Scalars['String']>;
};


/** Text from the article for use e.g. in details. */
export type ArticleLocalizationsTitleArgs = {
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard>>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type ArticleQueryResult = {
  __typename?: 'ArticleQueryResult';
  /**
   * Matched datafield values and number of matching articles per value
   *
   * To limit the number of results, set the `first` argument.
   *
   * Pagination is possible by setting the `after` argument to the previous last result's `cursor` field value.
   */
  aggregations: DatafieldAggregations;
  /**
   * The query's matching articles.
   *
   * Use the `sort` argument to specify the list of fields and the order by which the results should be sorted.
   * Multiple fields and orders may be specified and are evaluated in the provided order.
   *
   * To limit the number of results, set the `first` argument.
   *
   * Pagination is possible by setting the `after` argument to the previous last result's `cursor` field value.
   * Please be careful not to change the query's `filter` or the `sort` argument between paginated calls.
   */
  articles: Array<Maybe<ArticleEdge>>;
  /**
   * Returns the total count of results.
   *
   * Use the `trackLimit` argument to limit the track of the total count up to the specified amount.
   * If the result has more hits than the specified limit the total count is inaccurate.
   * See `CountRelation` for further information on how to interpret the result.
   *
   * Heads up: Setting the `trackLimit` to a high value may decrease performance.
   */
  total: TotalCount;
};


/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type ArticleQueryResultArticlesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  sort?: InputMaybe<Array<InputMaybe<ArticleSort>>>;
};


/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type ArticleQueryResultTotalArgs = {
  trackLimit?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type ArticleRangeFilter = {
  /** Returns only with a creation date in the specified range */
  creationDate?: InputMaybe<DateRange>;
  /** Returns only with a modification date in the specified range */
  modificationDate?: InputMaybe<DateRange>;
  /** No number or dateTime datafield definitions exist. As soon as the first such datafield definition is defined, it's automatically listed here. */
  not_applicable_as_no_number_or_date_datafield_definitions_exist?: InputMaybe<Scalars['NoDynamicValueDefined']>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type ArticleRegexFilter = {
  /** Returns only articles whose article numbers matches the specified Regex */
  articleNumber?: InputMaybe<Scalars['FilterRegex']>;
  /**
   * Returns only articles whose title matches the specified Regex
   * @deprecated Use two title_xx fields for InfoTwin language and tenant default language instead
   */
  title?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose ar title matches the specified Regex */
  title_ar?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose bg title matches the specified Regex */
  title_bg?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose bn title matches the specified Regex */
  title_bn?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose bs title matches the specified Regex */
  title_bs?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose ca title matches the specified Regex */
  title_ca?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose cs title matches the specified Regex */
  title_cs?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose da title matches the specified Regex */
  title_da?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose de title matches the specified Regex */
  title_de?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose el title matches the specified Regex */
  title_el?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose en title matches the specified Regex */
  title_en?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose es title matches the specified Regex */
  title_es?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose et title matches the specified Regex */
  title_et?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose eu title matches the specified Regex */
  title_eu?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose fa title matches the specified Regex */
  title_fa?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose fi title matches the specified Regex */
  title_fi?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose fr title matches the specified Regex */
  title_fr?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose ga title matches the specified Regex */
  title_ga?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose he title matches the specified Regex */
  title_he?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose hi title matches the specified Regex */
  title_hi?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose hr title matches the specified Regex */
  title_hr?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose hu title matches the specified Regex */
  title_hu?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose hy title matches the specified Regex */
  title_hy?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose id title matches the specified Regex */
  title_id?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose is title matches the specified Regex */
  title_is?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose it title matches the specified Regex */
  title_it?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose ja title matches the specified Regex */
  title_ja?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose kk title matches the specified Regex */
  title_kk?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose ko title matches the specified Regex */
  title_ko?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose ku title matches the specified Regex */
  title_ku?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose lt title matches the specified Regex */
  title_lt?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose lv title matches the specified Regex */
  title_lv?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose mk title matches the specified Regex */
  title_mk?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose ms title matches the specified Regex */
  title_ms?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose mt title matches the specified Regex */
  title_mt?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose nb title matches the specified Regex */
  title_nb?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose nl title matches the specified Regex */
  title_nl?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose no title matches the specified Regex */
  title_no?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose pb title matches the specified Regex */
  title_pb?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose pl title matches the specified Regex */
  title_pl?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose pt title matches the specified Regex */
  title_pt?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose ro title matches the specified Regex */
  title_ro?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose ru title matches the specified Regex */
  title_ru?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose sk title matches the specified Regex */
  title_sk?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose sl title matches the specified Regex */
  title_sl?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose sq title matches the specified Regex */
  title_sq?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose sr title matches the specified Regex */
  title_sr?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose sv title matches the specified Regex */
  title_sv?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose th title matches the specified Regex */
  title_th?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose tr title matches the specified Regex */
  title_tr?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose uk title matches the specified Regex */
  title_uk?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose vi title matches the specified Regex */
  title_vi?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only articles whose zh title matches the specified Regex */
  title_zh?: InputMaybe<Scalars['FilterRegex']>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type ArticleSort = {
  /** Sort field */
  field: ArticleSortFields;
  /** Sort order */
  order?: InputMaybe<SortOrder>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export enum ArticleSortFields {
  /** Sort by article number */
  articleNumber = 'articleNumber',
  /** Sort by creation date */
  creationDate = 'creationDate',
  /** Sort by unique ID */
  id = 'id',
  /** Sort by modification date */
  modificationDate = 'modificationDate',
  /** Sort by relevance score */
  score = 'score',
  /**
   * Sort by title
   * @deprecated Use two title_xx fields for InfoTwin language and tenant default language instead
   */
  title = 'title',
  /** Sort by language-ar title */
  titleAr = 'title_ar',
  /** Sort by language-bg title */
  titleBg = 'title_bg',
  /** Sort by language-bn title */
  titleBn = 'title_bn',
  /** Sort by language-bs title */
  titleBs = 'title_bs',
  /** Sort by language-ca title */
  titleCa = 'title_ca',
  /** Sort by language-cs title */
  titleCs = 'title_cs',
  /** Sort by language-da title */
  titleDa = 'title_da',
  /** Sort by language-de title */
  titleDe = 'title_de',
  /** Sort by language-el title */
  titleEl = 'title_el',
  /** Sort by language-en title */
  titleEn = 'title_en',
  /** Sort by language-es title */
  titleEs = 'title_es',
  /** Sort by language-et title */
  titleEt = 'title_et',
  /** Sort by language-eu title */
  titleEu = 'title_eu',
  /** Sort by language-fa title */
  titleFa = 'title_fa',
  /** Sort by language-fi title */
  titleFi = 'title_fi',
  /** Sort by language-fr title */
  titleFr = 'title_fr',
  /** Sort by language-ga title */
  titleGa = 'title_ga',
  /** Sort by language-he title */
  titleHe = 'title_he',
  /** Sort by language-hi title */
  titleHi = 'title_hi',
  /** Sort by language-hr title */
  titleHr = 'title_hr',
  /** Sort by language-hu title */
  titleHu = 'title_hu',
  /** Sort by language-hy title */
  titleHy = 'title_hy',
  /** Sort by language-id title */
  titleId = 'title_id',
  /** Sort by language-is title */
  titleIs = 'title_is',
  /** Sort by language-it title */
  titleIt = 'title_it',
  /** Sort by language-ja title */
  titleJa = 'title_ja',
  /** Sort by language-kk title */
  titleKk = 'title_kk',
  /** Sort by language-ko title */
  titleKo = 'title_ko',
  /** Sort by language-ku title */
  titleKu = 'title_ku',
  /** Sort by language-lt title */
  titleLt = 'title_lt',
  /** Sort by language-lv title */
  titleLv = 'title_lv',
  /** Sort by language-mk title */
  titleMk = 'title_mk',
  /** Sort by language-ms title */
  titleMs = 'title_ms',
  /** Sort by language-mt title */
  titleMt = 'title_mt',
  /** Sort by language-nb title */
  titleNb = 'title_nb',
  /** Sort by language-nl title */
  titleNl = 'title_nl',
  /** Sort by language-no title */
  titleNo = 'title_no',
  /** Sort by language-pb title */
  titlePb = 'title_pb',
  /** Sort by language-pl title */
  titlePl = 'title_pl',
  /** Sort by language-pt title */
  titlePt = 'title_pt',
  /** Sort by language-ro title */
  titleRo = 'title_ro',
  /** Sort by language-ru title */
  titleRu = 'title_ru',
  /** Sort by language-sk title */
  titleSk = 'title_sk',
  /** Sort by language-sl title */
  titleSl = 'title_sl',
  /** Sort by language-sq title */
  titleSq = 'title_sq',
  /** Sort by language-sr title */
  titleSr = 'title_sr',
  /** Sort by language-sv title */
  titleSv = 'title_sv',
  /** Sort by language-th title */
  titleTh = 'title_th',
  /** Sort by language-tr title */
  titleTr = 'title_tr',
  /** Sort by language-uk title */
  titleUk = 'title_uk',
  /** Sort by language-vi title */
  titleVi = 'title_vi',
  /** Sort by language-zh title */
  titleZh = 'title_zh'
}

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type ArticleTaxonomyFilter = {
  /** No taxonomy datafield definitions exist. As soon as the first taxonomy is defined, it's automatically listed here. */
  not_applicable_as_no_taxonomy_datafield_definitions_exist?: InputMaybe<Scalars['NoDynamicValueDefined']>;
};

/** Length limited text from the article for use e.g. in result lists, previews, etc. */
export type ArticleTeasers = {
  __typename?: 'ArticleTeasers';
  /** The article's title limited to `length` characters */
  title?: Maybe<Scalars['String']>;
};


/** Length limited text from the article for use e.g. in result lists, previews, etc. */
export type ArticleTeasersTitleArgs = {
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard>>;
  length?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type Asset = {
  __typename?: 'Asset';
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  assetId?: Maybe<Scalars['String']>;
  /** Date and time when it was created */
  creationDate?: Maybe<Scalars['DateTime']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  files?: Maybe<Array<File>>;
  /** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
  id: Scalars['ID'];
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  localizations?: Maybe<AssetLocalizations>;
  /** Date and time of the last modification */
  modificationDate?: Maybe<Scalars['DateTime']>;
  /**
   * Relevant notes for the asset.
   *
   * This field only shows private, pendingApproval notes created by the requesting user and any public notes
   * that reference the asset.
   *
   * Even with administrative privileges this field only shows the above mentioned notes and therefore doesn't include any notes
   * which don't belong to the requesting user except the public ones. To view any note and filter them, refer to the
   * filter query for the notes.
   */
  notes?: Maybe<NoteQueryResult>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  options?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  previewImage?: Maybe<BlobRef>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  productId?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  productionDate?: Maybe<Scalars['DateTime']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  referenceId?: Maybe<Scalars['String']>;
  /**
   * Related activity to the asset id. The given activity filter is optional and is combined (AND clause) with
   * a static filter:
   * { equals: { custom_assets: [asset.id] } }
   * This returns only activities related to the specific asset.
   */
  relatedActivities: ActivityQueryResult;
  /**
   * WARNING: Does not work for now because the required filter could not be defined 100%
   *
   * Related content to the product id. The given content filter is optional and is combined (AND clause) with
   * a static filter:
   * const assetFilter = { assetIds: [asset.id] };
   * This returns only contents related to the specific product.
   * The product id is used because an asset is always related to a product.
   */
  relatedContents: ContentQueryResult;
  /** Same relation filter as `relatedContents`, grouped using a configured grouping criterion. */
  relatedContentsGrouped: ContentGroupedQueryResult;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  serialNumber?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  teasers?: Maybe<AssetTeasers>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  title?: Maybe<MultilingualString>;
};


/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type AssetFilesArgs = {
  fileTypes?: InputMaybe<Array<InputMaybe<FileType>>>;
};


/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type AssetNotesArgs = {
  filter?: InputMaybe<NoteFilter>;
};


/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type AssetRelatedActivitiesArgs = {
  filter?: InputMaybe<ActivityFilter>;
};


/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type AssetRelatedContentsArgs = {
  filter?: InputMaybe<ContentFilter>;
  filterOptions?: InputMaybe<ContentFilterOptions>;
};


/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type AssetRelatedContentsGroupedArgs = {
  filter?: InputMaybe<ContentFilter>;
  filterOptions?: InputMaybe<ContentFilterOptions>;
  groupBy: ContentGroupBy;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type AssetAutocompleteHits = {
  __typename?: 'AssetAutocompleteHits';
  /** The count of docs found containing the suggestion */
  docCount: Scalars['NonNegativeInt'];
  /** The language this suggestion stems from */
  language?: Maybe<Language>;
  /** The found suggestion */
  suggest: Scalars['String'];
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type AssetAutocompleteResult = {
  __typename?: 'AssetAutocompleteResult';
  /** The hits found for the query */
  hits?: Maybe<Array<AssetAutocompleteHits>>;
  /** The query used for this result */
  query: Scalars['String'];
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type AssetDatafieldAggregations = {
  __typename?: 'AssetDatafieldAggregations';
  /** Provides composite aggregations with pagination support */
  composite?: Maybe<AssetDatafieldCompositeAggregation>;
  /**
   * Provides terms aggregations for custom datafields.
   * Supports prefix search and the results are ordered by count.
   */
  terms?: Maybe<DatafieldTermsAggregation>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type AssetDatafieldCompositeAggregation = {
  __typename?: 'AssetDatafieldCompositeAggregation';
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  assetId?: Maybe<Array<AggregationEdge>>;
  /** No field definitions exist. As soon as the first field definition is defined, it's automatically listed here. */
  not_applicable_as_no_field_definitions_exist?: Maybe<Scalars['NoDynamicValueDefined']>;
};


/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type AssetDatafieldCompositeAggregationAssetIdArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type AssetEdge = {
  __typename?: 'AssetEdge';
  /** Unique cursor for pagination. See the query's `after` argument */
  cursor: Scalars['String'];
  /** The result's asset type. */
  node: Asset;
  /** Calculated relevance score. */
  score: Scalars['NonNegativeFloat'];
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type AssetEqualsOneOfValueFilter = {
  /** Returns assets with one of the specified asset identifiers */
  assetId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Returns assets with one of the specified unique identifiers */
  id?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Returns assets with one of the specified product identifiers */
  productId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type AssetEqualsValueFilter = {
  /** Returns only asset types with the specified assetId */
  assetId?: InputMaybe<Scalars['String']>;
  /** Returns only with the specified creation date */
  creationDate?: InputMaybe<Scalars['DateTime']>;
  /** Returns only with the specified modification date */
  modificationDate?: InputMaybe<Scalars['DateTime']>;
  /** Returns only asset types with the specified productId */
  productId?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified production date */
  productionDate?: InputMaybe<Scalars['DateTime']>;
  /** Returns only asset types with the specified serial number */
  serialNumber?: InputMaybe<Scalars['String']>;
  /**
   * Returns only assets with the specified (product) title
   * @deprecated Use two title_xx fields for InfoTwin language and tenant default language instead
   */
  title?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified ar title */
  title_ar?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified bg title */
  title_bg?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified bn title */
  title_bn?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified bs title */
  title_bs?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified ca title */
  title_ca?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified cs title */
  title_cs?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified da title */
  title_da?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified de title */
  title_de?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified el title */
  title_el?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified en title */
  title_en?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified es title */
  title_es?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified et title */
  title_et?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified eu title */
  title_eu?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified fa title */
  title_fa?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified fi title */
  title_fi?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified fr title */
  title_fr?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified ga title */
  title_ga?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified he title */
  title_he?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified hi title */
  title_hi?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified hr title */
  title_hr?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified hu title */
  title_hu?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified hy title */
  title_hy?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified id title */
  title_id?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified is title */
  title_is?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified it title */
  title_it?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified ja title */
  title_ja?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified kk title */
  title_kk?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified ko title */
  title_ko?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified ku title */
  title_ku?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified lt title */
  title_lt?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified lv title */
  title_lv?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified mk title */
  title_mk?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified ms title */
  title_ms?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified mt title */
  title_mt?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified nb title */
  title_nb?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified nl title */
  title_nl?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified no title */
  title_no?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified pb title */
  title_pb?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified pl title */
  title_pl?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified pt title */
  title_pt?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified ro title */
  title_ro?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified ru title */
  title_ru?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified sk title */
  title_sk?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified sl title */
  title_sl?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified sq title */
  title_sq?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified sr title */
  title_sr?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified sv title */
  title_sv?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified th title */
  title_th?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified tr title */
  title_tr?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified uk title */
  title_uk?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified vi title */
  title_vi?: InputMaybe<Scalars['String']>;
  /** Returns only assets with the specified zh title */
  title_zh?: InputMaybe<Scalars['String']>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export enum AssetExistsValueFields {
  /** Returns only asset types which have a asset Id specified */
  assetId = 'assetId',
  /** Returns only asset types which have a productId specified */
  productId = 'productId',
  /** Returns only assets which have a production date specified */
  productionDate = 'productionDate',
  /** Returns only asset types which have a serial number specified */
  serialNumber = 'serialNumber',
  /** Returns only assets which have a title specified */
  title = 'title'
}

/**
 * The `AssetFilter` is used to specify filter criteria for asset types.
 * If you specify more than one criterion, all criteria are grouped together and connected with a logical AND operator.
 * Further logical operations are possible by using `not` `andGroup` and `orGroup`.
 */
export type AssetFilter = {
  /** Returns all asset types if set to true */
  all?: InputMaybe<Scalars['Boolean']>;
  /** Allows the specification of further filter criteria, which are grouped together and connected with a logical AND operator */
  andGroup?: InputMaybe<Array<InputMaybe<AssetFilter>>>;
  /** Boosts the score of all matches in this group by the specified factor. Heads up: The resulting score boost isn't mathematically exact due to rounding errors */
  boost?: InputMaybe<Scalars['Float']>;
  /** Returns asset types that contain all of the exact values specified */
  equals?: InputMaybe<AssetEqualsValueFilter>;
  /** Returns assets that contain any of the exact values specified */
  equalsOneOf?: InputMaybe<AssetEqualsOneOfValueFilter>;
  /**
   * Returns assets that have a value in all of the specified fields
   * @deprecated Please use 'has' filter instead
   */
  exists?: InputMaybe<Array<InputMaybe<AssetExistsValueFields>>>;
  /** Returns asset types that match all of the specified full text searches */
  fullText?: InputMaybe<AssetFullTextFilter>;
  /** Returns assets that have a value in all of the specified fields */
  has?: InputMaybe<AssetHasValueFilter>;
  /** Returns asset types with one of the specified unique identifiers */
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Allows you to specify logically negated filter criteria */
  not?: InputMaybe<AssetFilter>;
  /** Allows the specification of further filter criteria, which are grouped together and connected with a logical OR operator */
  orGroup?: InputMaybe<Array<InputMaybe<AssetFilter>>>;
  /** Returns asset types with values within all of the ranges specified */
  range?: InputMaybe<AssetRangeFilter>;
  /** Returns asset types that match all of the regular expressions */
  regex?: InputMaybe<AssetRegexFilter>;
  /** Returns asset types that match a taxonomy value according to the taxonomy's evaluation type */
  taxonomy?: InputMaybe<AssetTaxonomyFilter>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type AssetFullTextFields = {
  /** Match the query against any full text searchable field and rank the results with the specified boost */
  any?: InputMaybe<Scalars['Float']>;
  /** Match the query against the asset id and rank the results with the specified boost */
  assetId?: InputMaybe<Scalars['Float']>;
  /** Match the query against the product id and rank the results with the specified boost */
  productId?: InputMaybe<Scalars['Float']>;
  /**
   * Match the query against the title and rank the results with the specified boost
   * @deprecated Use two title_xx fields for InfoTwin language and tenant default language instead
   */
  title?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_ar?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_bg?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_bn?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_bs?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_ca?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_cs?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_da?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_de?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_el?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_en?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_es?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_et?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_eu?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_fa?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_fi?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_fr?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_ga?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_he?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_hi?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_hr?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_hu?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_hy?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_id?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_is?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_it?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_ja?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_kk?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_ko?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_ku?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_lt?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_lv?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_mk?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_ms?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_mt?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_nb?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_nl?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_no?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_pb?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_pl?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_pt?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_ro?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_ru?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_sk?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_sl?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_sq?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_sr?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_sv?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_th?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_tr?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_uk?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_vi?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_zh?: InputMaybe<Scalars['Float']>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type AssetFullTextFilter = {
  /** Fields to search in with their respective score weights */
  fields?: InputMaybe<AssetFullTextFields>;
  /** Indicates if a fuzzy search should be performed. */
  fuzzy?: InputMaybe<Scalars['Boolean']>;
  /** Specifies if either all or any query words need to match */
  operator?: InputMaybe<FullTextOperator>;
  /**
   * Text to search for
   * Be aware: The Limit for full text search queries is 1024 characters and
   * anything above that will result in an error.
   */
  query: Scalars['FullTextSearchQuery'];
  /** Type of fulltext search to perform */
  searchType?: InputMaybe<FullTextSearchType>;
};

/** Returns assets that have a value in all of the specified fields */
export type AssetHasValueFilter = {
  /** Specify the fields that the returned assets must have a value in */
  valueInFields?: InputMaybe<Array<InputMaybe<AssetHasValueInFields>>>;
};

/** Specify the fields that the returned assets must have a value in */
export enum AssetHasValueInFields {
  /** Returns only asset types which have a asset Id specified */
  assetId = 'assetId',
  /** Returns only asset types which have a productId specified */
  productId = 'productId',
  /** Returns only assets which have a production date specified */
  productionDate = 'productionDate',
  /** Returns only asset types which have a serial number specified */
  serialNumber = 'serialNumber',
  /** Returns only assets which have a title specified */
  title = 'title'
}

/** Text from the asset for use e.g. in details. */
export type AssetLocalizations = {
  __typename?: 'AssetLocalizations';
  /** The asset's title */
  title?: Maybe<Scalars['String']>;
};


/** Text from the asset for use e.g. in details. */
export type AssetLocalizationsTitleArgs = {
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard>>;
};

/** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
export enum AssetNames {
  assets = 'ASSETS',
  devices = 'DEVICES',
  equipments = 'EQUIPMENTS',
  machines = 'MACHINES',
  plants = 'PLANTS',
  products = 'PRODUCTS',
  vehicles = 'VEHICLES',
  versions = 'VERSIONS'
}

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type AssetQueryResult = {
  __typename?: 'AssetQueryResult';
  /**
   * Matched datafield values and number of matching assets per value
   *
   * To limit the number of results, set the `first` argument.
   *
   * Pagination is possible by setting the `after` argument to the previous last result's `cursor` field value.
   */
  aggregations: AssetDatafieldAggregations;
  /**
   * The query's matching asset types.
   *
   * Use the `sort` argument to specify the list of fields and the order by which the results should be sorted.
   * Multiple fields and orders may be specified and are evaluated in the provided order.
   *
   * To limit the number of results, set the `first` argument.
   *
   * Pagination is possible by setting the `after` argument to the previous last result's `cursor` field value.
   * Please be careful not to change the query's `filter` or the `sort` argument between paginated calls.
   */
  assets: Array<Maybe<AssetEdge>>;
  /**
   * Returns the total count of results.
   *
   * Use the `trackLimit` argument to limit the track of the total count up to the specified amount.
   * If the result has more hits than the specified limit the total count is inaccurate.
   * See `CountRelation` for further information on how to interpret the result.
   *
   * Heads up: Setting the `trackLimit` to a high value may decrease performance.
   */
  total: TotalCount;
};


/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type AssetQueryResultAssetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  sort?: InputMaybe<Array<InputMaybe<AssetSort>>>;
};


/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type AssetQueryResultTotalArgs = {
  trackLimit?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type AssetRangeFilter = {
  /** Returns only with a creation date in the specified range */
  creationDate?: InputMaybe<DateRange>;
  /** Returns only with a modification date in the specified range */
  modificationDate?: InputMaybe<DateRange>;
  /** Returns only asset types with a production date value in the specified range */
  productionDate?: InputMaybe<DateRange>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  serialNumberRange?: InputMaybe<LongInclusiveRangeSpec>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type AssetRegexFilter = {
  /** Returns only asset types whose asset Id matches the specified Regex */
  assetId?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only asset types whose productId matches the specified Regex */
  productId?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only asset types whose serial number matches the specified Regex */
  serialNumber?: InputMaybe<Scalars['FilterRegex']>;
  /**
   * Returns only assets whose title matches the specified Regex
   * @deprecated Use two title_xx fields for InfoTwin language and tenant default language instead
   */
  title?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose ar title matches the specified Regex */
  title_ar?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose bg title matches the specified Regex */
  title_bg?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose bn title matches the specified Regex */
  title_bn?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose bs title matches the specified Regex */
  title_bs?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose ca title matches the specified Regex */
  title_ca?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose cs title matches the specified Regex */
  title_cs?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose da title matches the specified Regex */
  title_da?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose de title matches the specified Regex */
  title_de?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose el title matches the specified Regex */
  title_el?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose en title matches the specified Regex */
  title_en?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose es title matches the specified Regex */
  title_es?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose et title matches the specified Regex */
  title_et?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose eu title matches the specified Regex */
  title_eu?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose fa title matches the specified Regex */
  title_fa?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose fi title matches the specified Regex */
  title_fi?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose fr title matches the specified Regex */
  title_fr?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose ga title matches the specified Regex */
  title_ga?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose he title matches the specified Regex */
  title_he?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose hi title matches the specified Regex */
  title_hi?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose hr title matches the specified Regex */
  title_hr?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose hu title matches the specified Regex */
  title_hu?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose hy title matches the specified Regex */
  title_hy?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose id title matches the specified Regex */
  title_id?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose is title matches the specified Regex */
  title_is?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose it title matches the specified Regex */
  title_it?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose ja title matches the specified Regex */
  title_ja?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose kk title matches the specified Regex */
  title_kk?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose ko title matches the specified Regex */
  title_ko?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose ku title matches the specified Regex */
  title_ku?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose lt title matches the specified Regex */
  title_lt?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose lv title matches the specified Regex */
  title_lv?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose mk title matches the specified Regex */
  title_mk?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose ms title matches the specified Regex */
  title_ms?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose mt title matches the specified Regex */
  title_mt?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose nb title matches the specified Regex */
  title_nb?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose nl title matches the specified Regex */
  title_nl?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose no title matches the specified Regex */
  title_no?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose pb title matches the specified Regex */
  title_pb?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose pl title matches the specified Regex */
  title_pl?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose pt title matches the specified Regex */
  title_pt?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose ro title matches the specified Regex */
  title_ro?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose ru title matches the specified Regex */
  title_ru?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose sk title matches the specified Regex */
  title_sk?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose sl title matches the specified Regex */
  title_sl?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose sq title matches the specified Regex */
  title_sq?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose sr title matches the specified Regex */
  title_sr?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose sv title matches the specified Regex */
  title_sv?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose th title matches the specified Regex */
  title_th?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose tr title matches the specified Regex */
  title_tr?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose uk title matches the specified Regex */
  title_uk?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose vi title matches the specified Regex */
  title_vi?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only assets whose zh title matches the specified Regex */
  title_zh?: InputMaybe<Scalars['FilterRegex']>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type AssetSort = {
  /** Sort field */
  field: AssetSortFields;
  /** Sort order */
  order?: InputMaybe<SortOrder>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export enum AssetSortFields {
  /** Sort by assetId */
  assetId = 'assetId',
  /** Sort by creation date */
  creationDate = 'creationDate',
  /** Sort by unique ID */
  id = 'id',
  /** Sort by modification date */
  modificationDate = 'modificationDate',
  /** Sort by productId */
  productId = 'productId',
  /** Sort by production date */
  productionDate = 'productionDate',
  /** Sort by relevance score */
  score = 'score',
  /** Sort by serial number */
  serialNumber = 'serialNumber',
  /**
   * Sort by title
   * @deprecated Use two title_xx fields for InfoTwin language and tenant default language instead
   */
  title = 'title',
  /** Sort by language-ar title */
  titleAr = 'title_ar',
  /** Sort by language-bg title */
  titleBg = 'title_bg',
  /** Sort by language-bn title */
  titleBn = 'title_bn',
  /** Sort by language-bs title */
  titleBs = 'title_bs',
  /** Sort by language-ca title */
  titleCa = 'title_ca',
  /** Sort by language-cs title */
  titleCs = 'title_cs',
  /** Sort by language-da title */
  titleDa = 'title_da',
  /** Sort by language-de title */
  titleDe = 'title_de',
  /** Sort by language-el title */
  titleEl = 'title_el',
  /** Sort by language-en title */
  titleEn = 'title_en',
  /** Sort by language-es title */
  titleEs = 'title_es',
  /** Sort by language-et title */
  titleEt = 'title_et',
  /** Sort by language-eu title */
  titleEu = 'title_eu',
  /** Sort by language-fa title */
  titleFa = 'title_fa',
  /** Sort by language-fi title */
  titleFi = 'title_fi',
  /** Sort by language-fr title */
  titleFr = 'title_fr',
  /** Sort by language-ga title */
  titleGa = 'title_ga',
  /** Sort by language-he title */
  titleHe = 'title_he',
  /** Sort by language-hi title */
  titleHi = 'title_hi',
  /** Sort by language-hr title */
  titleHr = 'title_hr',
  /** Sort by language-hu title */
  titleHu = 'title_hu',
  /** Sort by language-hy title */
  titleHy = 'title_hy',
  /** Sort by language-id title */
  titleId = 'title_id',
  /** Sort by language-is title */
  titleIs = 'title_is',
  /** Sort by language-it title */
  titleIt = 'title_it',
  /** Sort by language-ja title */
  titleJa = 'title_ja',
  /** Sort by language-kk title */
  titleKk = 'title_kk',
  /** Sort by language-ko title */
  titleKo = 'title_ko',
  /** Sort by language-ku title */
  titleKu = 'title_ku',
  /** Sort by language-lt title */
  titleLt = 'title_lt',
  /** Sort by language-lv title */
  titleLv = 'title_lv',
  /** Sort by language-mk title */
  titleMk = 'title_mk',
  /** Sort by language-ms title */
  titleMs = 'title_ms',
  /** Sort by language-mt title */
  titleMt = 'title_mt',
  /** Sort by language-nb title */
  titleNb = 'title_nb',
  /** Sort by language-nl title */
  titleNl = 'title_nl',
  /** Sort by language-no title */
  titleNo = 'title_no',
  /** Sort by language-pb title */
  titlePb = 'title_pb',
  /** Sort by language-pl title */
  titlePl = 'title_pl',
  /** Sort by language-pt title */
  titlePt = 'title_pt',
  /** Sort by language-ro title */
  titleRo = 'title_ro',
  /** Sort by language-ru title */
  titleRu = 'title_ru',
  /** Sort by language-sk title */
  titleSk = 'title_sk',
  /** Sort by language-sl title */
  titleSl = 'title_sl',
  /** Sort by language-sq title */
  titleSq = 'title_sq',
  /** Sort by language-sr title */
  titleSr = 'title_sr',
  /** Sort by language-sv title */
  titleSv = 'title_sv',
  /** Sort by language-th title */
  titleTh = 'title_th',
  /** Sort by language-tr title */
  titleTr = 'title_tr',
  /** Sort by language-uk title */
  titleUk = 'title_uk',
  /** Sort by language-vi title */
  titleVi = 'title_vi',
  /** Sort by language-zh title */
  titleZh = 'title_zh'
}

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type AssetTaxonomyFilter = {
  /** No taxonomy datafield definitions exist. As soon as the first taxonomy is defined, it's automatically listed here. */
  not_applicable_as_no_taxonomy_datafield_definitions_exist?: InputMaybe<Scalars['NoDynamicValueDefined']>;
};

/** Length limited text from the asset for use e.g. in result lists, previews, etc. */
export type AssetTeasers = {
  __typename?: 'AssetTeasers';
  /** The asset's title limited to `length` characters */
  title?: Maybe<Scalars['String']>;
};


/** Length limited text from the asset for use e.g. in result lists, previews, etc. */
export type AssetTeasersTitleArgs = {
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard>>;
  length?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://basic-services-graph.qit.svc.cluster.local:8443** */
export type Authenticator = {
  __typename?: 'Authenticator';
  /** Indicates the default authenticator */
  default?: Maybe<Scalars['Boolean']>;
  /** The description for the authenticator */
  description?: Maybe<Scalars['String']>;
  /** Readable name for the authenticator */
  displayName: Scalars['String'];
  /** The unique id of the authenticator */
  id: Scalars['ID'];
  /** Image url for display purpose */
  imageUrl?: Maybe<Scalars['String']>;
  /** The sortIndex of the authenticator. Has influence on the order of the authenticators (descending) */
  sortIndex: Scalars['Int'];
  /** The status of the authenticator */
  status?: Maybe<TenantAuthenticatorStatus>;
  /** The strategy used for the authenticator */
  strategyName: Scalars['String'];
  /** The url of the authenticator */
  url: Scalars['String'];
};

/** Sub Graph: **https://basic-services-graph.qit.svc.cluster.local:8443** */
export type AuthenticatorEdge = {
  __typename?: 'AuthenticatorEdge';
  /** The result's authenticator */
  node?: Maybe<Authenticator>;
};

/** Sub Graph: **https://basic-services-graph.qit.svc.cluster.local:8443** */
export type AuthenticatorQueryResult = {
  __typename?: 'AuthenticatorQueryResult';
  /**
   * The authenticators of the tenant.
   *
   * Currently there's no functionality to filter them nor using pagination.
   *
   * But for later compatibility and the ability to add paging or filtering, they are
   * returned in the appropriate format.
   *
   * The field will always contain any authenticator results which exist on the tenant.
   *
   * This might change in the future.
   */
  authenticators?: Maybe<Array<Maybe<AuthenticatorEdge>>>;
  /** Returns the total count of results. */
  total: TotalCount;
};

/** Common interface for autocompleteedge */
export type AutocompleteEdge = {
  /** The full datafield definition */
  datafieldDefinition?: Maybe<DatafieldDefinition>;
  /**
   * Id of the datafield definition in which the value was found
   * This value can be used as field name content query filters
   */
  datafieldDefinitionId: Scalars['DatafieldDefinitionID'];
  /** Display text for this autocomplete hit */
  displayName: Scalars['String'];
  /**
   * Language which this hit is based on
   * Is only returned if an exact language assignment can be made
   */
  language?: Maybe<Language>;
  /**
   * Unique value of the datafield definition value
   * This value can be used as operand in content query filters
   */
  value: Scalars['String'];
};

/** Typed binary data of `Topic`s. E.g. images, HTML and media files, style sheets, etc. */
export type Blob = {
  __typename?: 'Blob';
  /** Type of compression used for the blob or empty if the blob is not compressed. */
  compressionType?: Maybe<CompressionType>;
  /** The blob's unique, content hashed ID. */
  id: Scalars['ID'];
  /** The blob's mime type. May be empty if no mime type coud be detected. */
  mimeType?: Maybe<Scalars['String']>;
  /**
   * The blob's protection class.
   * See `BlobProtectionClass` for further information.
   */
  protectionClass?: Maybe<BlobProtectionClass>;
  /** The blob's (compressed) size in bytes. */
  size?: Maybe<Scalars['Int']>;
  /** Download URL for the blob's binary data */
  url?: Maybe<Scalars['URL']>;
};

/** Sub Graph: **https://user-generated-data-graph.qit.svc.cluster.local:8443** */
export type BlobEdge = {
  __typename?: 'BlobEdge';
  /** Unique cursor for pagination. See the query's `after` argument */
  cursor: Scalars['String'];
  /** The result's blob object */
  node: Blob;
  /** Calculated relevance score. */
  score: Scalars['NonNegativeFloat'];
};

/** Sub Graph: **https://user-generated-data-graph.qit.svc.cluster.local:8443** */
export type BlobEqualsValueFilter = {
  /** Returns only blobs with the specified mime type */
  mimeType?: InputMaybe<Scalars['String']>;
  /** Returns only blobs with the specified protection class */
  protectionClass?: InputMaybe<BlobProtectionClass>;
  /** Returns only blobs with the specified file size */
  size?: InputMaybe<Scalars['Long']>;
};

/** Sub Graph: **https://user-generated-data-graph.qit.svc.cluster.local:8443** */
export type BlobFilter = {
  /** Allows the specification of further filter criteria, which are grouped together and connected with a logical AND operator */
  andGroup?: InputMaybe<Array<InputMaybe<BlobFilter>>>;
  /** Boosts the score of all matches in this group by the specified factor. Heads up: The resulting score boost isn't mathematically exact due to rounding errors */
  boost?: InputMaybe<Scalars['Float']>;
  /** Returns blobs that contain all of the exact values specified */
  equals?: InputMaybe<BlobEqualsValueFilter>;
  /** Filter by ids */
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Allows you to specify logically negated filter criteria */
  not?: InputMaybe<BlobFilter>;
  /** Allows the specification of further filter criteria, which are grouped together and connected with a logical OR operator */
  orGroup?: InputMaybe<Array<InputMaybe<BlobFilter>>>;
  /** Returns blobs with values within all of the ranges specified */
  range?: InputMaybe<BlobRangeFilter>;
};

/** Blob protection classes which control who can access the specified blob */
export enum BlobProtectionClass {
  /** Can be accessed by every authenticated user. */
  authenticated = 'authenticated',
  /** Can only be accessed by users who have access to at least one content which uses this blob. */
  contentAuthorized = 'contentAuthorized',
  /** Can be accessed by everyone (including unauthenticated users). */
  public = 'public'
}

/** Sub Graph: **https://user-generated-data-graph.qit.svc.cluster.local:8443** */
export type BlobQueryResult = {
  __typename?: 'BlobQueryResult';
  /**
   * The query's matching blobs.
   *
   * Use the `sort` argument to specify the list of fields and the order by which the results should be sorted.
   * Multiple fields and orders may be specified and are evaluated in the provided order.
   *
   * To limit the number of results, set the `first` argument.
   *
   * Pagination is possible by setting the `after` argument to the previous last result's `cursor` field value.
   * Please be careful not to change the query's `filter` or the `sort` argument between paginated calls.
   */
  blobs: Array<Maybe<BlobEdge>>;
  /**
   * Returns the total count of results.
   *
   * Use the `trackLimit` argument to limit the track of the total count up to the specified amount.
   * If the result has more hits than the specified limit the total count is inaccurate.
   * See `CountRelation` for further information on how to interpret the result.
   *
   * Heads up: Setting the `trackLimit` to a high value may decrease performance.
   */
  total: TotalCount;
};


/** Sub Graph: **https://user-generated-data-graph.qit.svc.cluster.local:8443** */
export type BlobQueryResultBlobsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  sort?: InputMaybe<Array<InputMaybe<BlobSort>>>;
};


/** Sub Graph: **https://user-generated-data-graph.qit.svc.cluster.local:8443** */
export type BlobQueryResultTotalArgs = {
  trackLimit?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://user-generated-data-graph.qit.svc.cluster.local:8443** */
export type BlobRangeFilter = {
  /** Returns only blob whose size is in the specified range */
  size?: InputMaybe<LongRange>;
};

/** Reference to a binary blob */
export type BlobRef = {
  __typename?: 'BlobRef';
  /** The referenced `Blob` */
  blob?: Maybe<Blob>;
  /** The referenced blob's unique, content hashed ID. */
  blobId: Scalars['ID'];
  /** The referenced blob's mime type. May be empty if no mime type coud be detected. */
  mimeType?: Maybe<Scalars['String']>;
  /** The path and file name under which the blob is referenced in this context. */
  path?: Maybe<Scalars['String']>;
  /** Download URL for the blob's binary data */
  url?: Maybe<Scalars['URL']>;
};

/** Sub Graph: **https://user-generated-data-graph.qit.svc.cluster.local:8443** */
export type BlobSort = {
  /** Sort field */
  field: BlobSortFields;
  /** Sort order */
  order?: InputMaybe<SortOrder>;
};

/** Sub Graph: **https://user-generated-data-graph.qit.svc.cluster.local:8443** */
export enum BlobSortFields {
  /** Sort by unique ID */
  id = 'id',
  /** Sort by mime type */
  mimeType = 'mimeType',
  /** Sort by protection class */
  protectionClass = 'protectionClass',
  /** Sort by relevance score */
  score = 'score',
  /** Sort by file size */
  size = 'size'
}

/** Defines a boolean field */
export type BooleanDatafieldDefinition = DatafieldDefinition & {
  __typename?: 'BooleanDatafieldDefinition';
  /** Display texts for falseish values */
  falseValue?: Maybe<BooleanValue>;
  /** Type of this indexed field definition */
  fieldType?: Maybe<FieldDefinitionTypes>;
  /**
   * Unique identifier of this indexed field definition.
   * Is used as field name in all interfaces and must adhere to the
   * following pattern: ^[_A-Za-z][_0-9A-Za-z]{0,128}$
   */
  id: Scalars['DatafieldDefinitionID'];
  /** Text from the datafield definition for use e.g. in detail views, etc */
  localizations?: Maybe<DatafieldDefinitionLocalizations>;
  /** Field names which shall be mapped to this indexed field definition */
  mappedNames?: Maybe<Array<Scalars['String']>>;
  /** List of all objectTypes this definition is assigned to */
  objectTypes?: Maybe<Array<Maybe<ObjectType>>>;
  /** Length limited text from the indexed field definition for use e.g. in result lists, previews, etc. */
  teasers?: Maybe<DatafieldDefinitionTeasers>;
  /** Human readable description of this indexed field definition */
  title?: Maybe<MultilingualString>;
  /** Display texts for trueish values */
  trueValue?: Maybe<BooleanValue>;
};

/** Sub Graph: **https://data-filter-graph.qit-data-filter.svc.cluster.local:8443** */
export type BooleanFacetDefinition = FacetDefinition & {
  __typename?: 'BooleanFacetDefinition';
  /** Display texts for falseish values */
  falseValue?: Maybe<BooleanValue>;
  /** The datafield type of the field */
  fieldType: FieldDefinitionTypes;
  /** Display texts for trueish values */
  trueValue?: Maybe<BooleanValue>;
};

/** Sub Graph: **https://schematic-graph.qit-schematic.svc.cluster.local:8443** */
export type BooleanValue = {
  __typename?: 'BooleanValue';
  /** Length limited text from the enum value for use e.g. in result lists, previews, etc. */
  teasers?: Maybe<DatafieldValueTeasers>;
  /** Human readable name */
  title?: Maybe<MultilingualString>;
};

/** Combined unique identifier for the cart item in the shopping cart. */
export type CartItemId = {
  __typename?: 'CartItemId';
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  articleId: Scalars['String'];
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  partLocation?: Maybe<PartLocation>;
};

/** Input type for the unique identifier of a cart item. */
export type CartItemIdInput = {
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  articleId: Scalars['String'];
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  partLocation?: InputMaybe<PartLocationInput>;
};

/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type Collection = {
  __typename?: 'Collection';
  /** The access kind to this collection */
  access?: Maybe<CollectionAccessTypes>;
  /**
   * The collection's contents
   * @deprecated Use `entries` instead to query any kind of collection entry
   */
  contents: ContentQueryResult;
  /** The detailed description */
  description?: Maybe<Scalars['String']>;
  /** The display name */
  displayName?: Maybe<Scalars['String']>;
  /** The collection's entries */
  entries: CollectionEntryQueryResult;
  /** The unique id */
  id: Scalars['ID'];
  /** The indicator whether the collection should be shown on the dashboard */
  showInDashboard: Scalars['Boolean'];
  /** The user who owns the collection */
  user?: Maybe<User>;
  /** The visibility of the collection */
  visibility?: Maybe<CollectionVisibilityTypes>;
};


/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type CollectionContentsArgs = {
  filter?: InputMaybe<ContentFilter>;
};


/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type CollectionEntriesArgs = {
  filter?: InputMaybe<CollectionEntryFilter>;
};

/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export enum CollectionAccessTypes {
  /** The collection is a personal collection owned by the requesting user */
  personal = 'personal',
  /** The collection is public */
  public = 'public',
  /** The collection is a personal collection of another user */
  shared = 'shared'
}

/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type CollectionEdge = {
  __typename?: 'CollectionEdge';
  /** Unique cursor for pagination. See the query's `after` argument */
  cursor: Scalars['String'];
  /** The result's collection object. */
  node?: Maybe<Collection>;
  /** Calculated relevance score. */
  score: Scalars['NonNegativeFloat'];
};

/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type CollectionEntryCommonNavigationContext = CollectionEntryNavigationContext & {
  __typename?: 'CollectionEntryCommonNavigationContext';
  /** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
  asset?: Maybe<Asset>;
  /** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
  product?: Maybe<Product>;
};

/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type CollectionEntryEdge = {
  __typename?: 'CollectionEntryEdge';
  /** Unique cursor for pagination. See the query's `after` argument */
  cursor: Scalars['String'];
  /** The result's collection entry object. */
  node: CollectionEntryNode;
  /** Calculated relevance score. */
  score: Scalars['NonNegativeFloat'];
};

/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type CollectionEntryEqualsValueFilter = {
  /** Returns only collection entries with the specified object type */
  type?: InputMaybe<CollectionEntryType>;
};

/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type CollectionEntryFilter = {
  /** Allows the specification of further filter criteria, which are grouped together and connected with a logical AND operator */
  andGroup?: InputMaybe<Array<InputMaybe<CollectionEntryFilter>>>;
  /** Returns collection entries that contain all of the exact values specified */
  equals?: InputMaybe<CollectionEntryEqualsValueFilter>;
  /** Filter by ids */
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Allows you to specify logically negated filter criteria */
  not?: InputMaybe<CollectionEntryFilter>;
  /** Allows the specification of further filter criteria, which are grouped together and connected with a logical OR operator */
  orGroup?: InputMaybe<Array<InputMaybe<CollectionEntryFilter>>>;
};

/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type CollectionEntryMechanicNavigationContext = CollectionEntryNavigationContext & {
  __typename?: 'CollectionEntryMechanicNavigationContext';
  /** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
  asset?: Maybe<Asset>;
  /** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
  path?: Maybe<Array<Scalars['String']>>;
  /** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
  product?: Maybe<Product>;
};

/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type CollectionEntryMechanicNavigationContextInput = {
  /**
   * Asset context for the collection entry. Value is the assets assetId, not its id.
   * Please note that productId is always required when specifying the assetId
   */
  assetId?: InputMaybe<Scalars['String']>;
  /** Path of assembly ids to the mechanic entry */
  path?: InputMaybe<Array<Scalars['String']>>;
  /** Product context for the collection entry */
  productId?: InputMaybe<Scalars['String']>;
};

/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type CollectionEntryNavigationContext = {
  /** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
  asset?: Maybe<Asset>;
  /** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
  product?: Maybe<Product>;
};

/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type CollectionEntryNavigationContextInput = {
  /**
   * Asset context for the collection entry. Value is the assets assetId, not its id.
   * Please note that productId is always required when specifying the assetId
   */
  assetId?: InputMaybe<Scalars['String']>;
  /** Product context for the collection entry */
  productId?: InputMaybe<Scalars['String']>;
};

/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type CollectionEntryNode = {
  /** The result's collection object context. */
  navContext?: Maybe<CollectionEntryNavigationContext>;
};

/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type CollectionEntryQueryResult = {
  __typename?: 'CollectionEntryQueryResult';
  /**
   * The query's matching collections.
   *
   * Use the `sort` argument to specify the list of fields and the order by which the results should be sorted.
   * Multiple fields and orders may be specified and are evaluated in the provided order.
   *
   * To limit the number of results, set the `first` argument.
   *
   * Pagination is possible by setting the `after` argument to the previous last result's `cursor` field value.
   * Please be careful not to change the query's `filter` or the `sort` argument between paginated calls.
   */
  entries: Array<Maybe<CollectionEntryEdge>>;
  /**
   * Returns the total count of results.
   *
   * Use the `trackLimit` argument to limit the track of the total count up to the specified amount.
   * If the result has more hits than the specified limit the total count is inaccurate.
   * See `CountRelation` for further information on how to interpret the result.
   *
   * Heads up: Setting the `trackLimit` to a high value may decrease performance.
   */
  total: TotalCount;
};


/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type CollectionEntryQueryResultEntriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  sort?: InputMaybe<Array<InputMaybe<CollectionEntrySort>>>;
};


/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type CollectionEntryQueryResultTotalArgs = {
  trackLimit?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type CollectionEntrySort = {
  /** Sort field */
  field: CollectionEntrySortFields;
  /** Sort order */
  order?: InputMaybe<SortOrder>;
};

/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export enum CollectionEntrySortFields {
  /** Sort by sequence number */
  itemNumber = 'itemNumber'
}

/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export enum CollectionEntryType {
  activity = 'activity',
  article = 'article',
  content = 'content',
  mechanic = 'mechanic'
}

/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type CollectionEqualsValueFilter = {
  /** Returns only collections with the specified display name */
  displayName?: InputMaybe<Scalars['String']>;
  /** Returns only collections with the specified show in dashboard option */
  showInDashboard?: InputMaybe<Scalars['Boolean']>;
  /** Returns only collections with the specified visibility */
  visibility?: InputMaybe<CollectionVisibilityTypes>;
};

/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type CollectionExportResult = {
  __typename?: 'CollectionExportResult';
  /** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
  status: CollectionExportStatus;
  /** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
  url?: Maybe<Scalars['String']>;
};

/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export enum CollectionExportStatus {
  active = 'active',
  failed = 'failed',
  finished = 'finished',
  new = 'new',
  notfound = 'notfound'
}

/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export enum CollectionExportType {
  csv = 'csv',
  excel = 'excel'
}

/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type CollectionFilter = {
  /** Allows the specification of further filter criteria, which are grouped together and connected with a logical AND operator */
  andGroup?: InputMaybe<Array<InputMaybe<CollectionFilter>>>;
  /** Boosts the score of all matches in this group by the specified factor. Heads up: The resulting score boost isn't mathematically exact due to rounding errors */
  boost?: InputMaybe<Scalars['Float']>;
  /** Returns collections that contain all of the exact values specified */
  equals?: InputMaybe<CollectionEqualsValueFilter>;
  /** Full text search in collections */
  fullText?: InputMaybe<CollectionFullTextFilter>;
  /** Filter by ids */
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Allows you to specify logically negated filter criteria */
  not?: InputMaybe<CollectionFilter>;
  /** Allows the specification of further filter criteria, which are grouped together and connected with a logical OR operator */
  orGroup?: InputMaybe<Array<InputMaybe<CollectionFilter>>>;
};

/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type CollectionFullTextFields = {
  /** Match the query against any full text searchable field and rank the results with the specified boost */
  any?: InputMaybe<Scalars['Float']>;
  /** Match the query against the display name and rank the results with the specified boost */
  displayName?: InputMaybe<Scalars['Float']>;
};

/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type CollectionFullTextFilter = {
  /** Fields to search in with their respective score weights */
  fields?: InputMaybe<CollectionFullTextFields>;
  /** Indicates if a fuzzy search should be performed. */
  fuzzy?: InputMaybe<Scalars['Boolean']>;
  /** Specifies if either all or any query words need to match */
  operator?: InputMaybe<FullTextOperator>;
  /** Text to search for */
  query: Scalars['String'];
  /** Type of fulltext search to perform */
  searchType?: InputMaybe<FullTextSearchType>;
};

/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type CollectionQueryResult = {
  __typename?: 'CollectionQueryResult';
  /**
   * The query's matching collections.
   *
   * Use the `sort` argument to specify the list of fields and the order by which the results should be sorted.
   * Multiple fields and orders may be specified and are evaluated in the provided order.
   *
   * To limit the number of results, set the `first` argument.
   *
   * Pagination is possible by setting the `after` argument to the previous last result's `cursor` field value.
   * Please be careful not to change the query's `filter` or the `sort` argument between paginated calls.
   */
  collections: Array<Maybe<CollectionEdge>>;
  /**
   * Returns the total count of results.
   *
   * Use the `trackLimit` argument to limit the track of the total count up to the specified amount.
   * If the result has more hits than the specified limit the total count is inaccurate.
   * See `CountRelation` for further information on how to interpret the result.
   *
   * Heads up: Setting the `trackLimit` to a high value may decrease performance.
   */
  total: TotalCount;
};


/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type CollectionQueryResultCollectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  sort?: InputMaybe<Array<InputMaybe<CollectionSort>>>;
};


/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type CollectionQueryResultTotalArgs = {
  trackLimit?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type CollectionSort = {
  /** Sort field */
  field: CollectionSortFields;
  /** Sort order */
  order?: InputMaybe<SortOrder>;
};

/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export enum CollectionSortFields {
  /** Sort by display name */
  displayName = 'displayName',
  /** Sort by unique ID */
  id = 'id',
  /** Sort by relevance score */
  score = 'score',
  /** Sort by visibility */
  visibility = 'visibility'
}

/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export enum CollectionVisibilityTypes {
  /**
   * Only listed for the collection's creator but accessible for any user via
   * the collection's id
   */
  personal = 'personal',
  /** Listed for everyone */
  public = 'public'
}

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type CommonFile = File & {
  __typename?: 'CommonFile';
  /** Date and time when it was created */
  creationDate?: Maybe<Scalars['DateTime']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  file: BlobRef;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  id: Scalars['ID'];
  /** Date and time of the last modification */
  modificationDate?: Maybe<Scalars['DateTime']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  objectId: Scalars['String'];
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  objectSubType?: Maybe<FileSubType>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  objectType?: Maybe<FileType>;
};

/** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
export type CommonProcessDatafieldMapping = ProcessDatafieldMapping & {
  __typename?: 'CommonProcessDatafieldMapping';
  /** Returns column(s) which also map to the same field. In this case a process cannot be created due to ambiguousness. */
  ambiguousColumns?: Maybe<Array<Scalars['String']>>;
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  column: Scalars['String'];
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  field?: Maybe<Datafield>;
};

/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type ComponentInfo = {
  __typename?: 'ComponentInfo';
  /** Information about the component's sub components */
  components?: Maybe<Array<ComponentInfo>>;
  /** The component's name */
  name: Scalars['String'];
  /** The component's version */
  version: VersionInfo;
};

/** Type of content compression */
export enum CompressionType {
  gzip = 'gzip'
}

/** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
export type Config = {
  __typename?: 'Config';
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  config3dHoops?: Maybe<Config3dHoops>;
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  config3dLattice?: Maybe<Config3dLattice>;
  /**
   * Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443**
   * @deprecated Use config from shop server graphql api instead
   */
  configFdiShop?: Maybe<ConfigFdiShop>;
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  configProductAndAsset?: Maybe<ConfigProductAndAsset>;
  /**
   * Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443**
   * @deprecated Use config from shop server graphql api instead
   */
  configSwarovskiShop?: Maybe<ConfigSwarovskiShop>;
  /** Ignore this field */
  dummy?: Maybe<Scalars['Boolean']>;
};

/** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
export type Config3dHoops = {
  __typename?: 'Config3dHoops';
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  articleRef?: Maybe<Array<Maybe<ArticleHoopsRef>>>;
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  camera?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  fps?: Maybe<Scalars['Int']>;
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  hover?: Maybe<Scalars['Boolean']>;
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  id: Scalars['ID'];
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  outlineColor?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  selectionColor?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  selectionMode?: Maybe<SelectionMode>;
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  viewport?: Maybe<Scalars['String']>;
};

/** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
export type Config3dLattice = {
  __typename?: 'Config3dLattice';
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  articleRef?: Maybe<Array<Maybe<ArticleLatticeRef>>>;
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  camera?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  fps?: Maybe<Scalars['Int']>;
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  hover?: Maybe<Scalars['Boolean']>;
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  id: Scalars['ID'];
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  selectionColor?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  selectionMode?: Maybe<SelectionMode>;
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  viewport?: Maybe<Scalars['String']>;
};

/** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
export type ConfigFdiShop = {
  __typename?: 'ConfigFdiShop';
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  baseUrl?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  id: Scalars['ID'];
};

/** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
export type ConfigProductAndAsset = {
  __typename?: 'ConfigProductAndAsset';
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  assetName: AssetNames;
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  deactivateAssets?: Maybe<Scalars['Boolean']>;
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  id: Scalars['ID'];
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  productName: ProductNames;
};

/** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
export type ConfigSwarovskiShop = {
  __typename?: 'ConfigSwarovskiShop';
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  authUrl?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  baseUrl?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  id: Scalars['ID'];
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  shopServiceUrl?: Maybe<Scalars['String']>;
};

/** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type ContactInput = {
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  companyName: Scalars['String'];
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  emailCc?: InputMaybe<Array<Scalars['String']>>;
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  emailTo: Scalars['String'];
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  firstName: Scalars['String'];
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  jobTitle?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  lastName: Scalars['String'];
};

/** Common interface for contents as e.g. `ContentMap` or `Topic` */
export type Content = {
  /** The related article ids */
  articleIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The related asset ids */
  assetIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Unique identifier of the content itself */
  contentId: Scalars['ID'];
  /** Date and time when the content was created */
  creationDate?: Maybe<Scalars['DateTime']>;
  /** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
  id: Scalars['ID'];
  /** Language of the content */
  language?: Maybe<Language>;
  /** Locale of the content */
  locale?: Maybe<Scalars['String']>;
  /** The file type of the asset this topic refers to */
  mimeType?: Maybe<Scalars['String']>;
  /** Date and time of the last modification */
  modificationDate?: Maybe<Scalars['DateTime']>;
  /**
   * Relevant notes for the content.
   *
   * This field only shows private, pendingApproval notes created by the requesting user and any public notes
   * that reference the content.
   *
   * Even with administrative privileges this field only shows the above mentioned notes and therefore doesn't include any notes
   * which don't belong to the requesting user except the public ones. To view any note and filter them, refer to the
   * filter query for the notes.
   */
  notes?: Maybe<NoteQueryResult>;
  /** The source this content was generated from */
  source?: Maybe<Scalars['String']>;
  /** The unique id of the source */
  sourceId?: Maybe<Scalars['String']>;
  /** Length limited text from the content for use e.g. in result lists, previews, etc. */
  teasers?: Maybe<ContentTeasers>;
  /** Title of the content */
  title?: Maybe<MultilingualString>;
  /** Most recent date and time when the content was uploaded */
  uploadDate?: Maybe<Scalars['DateTime']>;
  /** The use context in which this content is used */
  useContext?: Maybe<UseContext>;
  /** The variants of the current content, having either a different language and or version. */
  variants: ContentQueryResult;
  /** Technical version of the content */
  version?: Maybe<Scalars['Long']>;
};


/** Common interface for contents as e.g. `ContentMap` or `Topic` */
export type ContentNotesArgs = {
  filter?: InputMaybe<NoteFilter>;
};


/** Common interface for contents as e.g. `ContentMap` or `Topic` */
export type ContentVariantsArgs = {
  filter?: InputMaybe<ContentFilter>;
  filterOptions?: InputMaybe<ContentFilterOptions>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type ContentAutocompleteHits = {
  __typename?: 'ContentAutocompleteHits';
  /** The count of docs found containing the suggestion */
  docCount: Scalars['NonNegativeInt'];
  /** The found suggestion */
  suggest: Scalars['String'];
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type ContentAutocompleteResult = {
  __typename?: 'ContentAutocompleteResult';
  /** The hits found for the query */
  hits?: Maybe<Array<ContentAutocompleteHits>>;
  /** The query used for this result */
  query: Scalars['String'];
};

/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type ContentCollectionEntryNode = CollectionEntryNode & {
  __typename?: 'ContentCollectionEntryNode';
  /** The content (content-map or topic) object */
  content: Content;
  /** The result's collection object context. */
  navContext?: Maybe<CollectionEntryCommonNavigationContext>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type ContentEdge = {
  __typename?: 'ContentEdge';
  /** Unique cursor for pagination. See the query's `after` argument */
  cursor: Scalars['String'];
  /** Highlighted matches for equality and full text filters. Matched terms are wrapped in <em>...</em> Tags. */
  highlights?: Maybe<ContentHighlights>;
  /** The result's content object. */
  node?: Maybe<Content>;
  /** Calculated relevance score. */
  score: Scalars['NonNegativeFloat'];
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type ContentEqualsOneOfValueFilter = {
  /** No regex filterable indexed field definitions exist. As soon as the first matching indexed field definition is defined, it's automatically listed here. */
  not_applicable_as_no_array_field_definitions_exist?: InputMaybe<Scalars['NoDynamicValueDefined']>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type ContentEqualsValueFilter = {
  /** Returns only contents with the specified creation date */
  creationDate?: InputMaybe<Scalars['DateTime']>;
  /** Returns only contents with the specified language */
  language?: InputMaybe<Language>;
  /** Returns only contents with the specified locale */
  locale?: InputMaybe<Scalars['String']>;
  /** Returns only topics with the specified mime type */
  mimeType?: InputMaybe<Scalars['String']>;
  /** Returns only contents with the specified modification date */
  modificationDate?: InputMaybe<Scalars['DateTime']>;
  /** Returns only contents used by the specified root content id */
  rootContentId?: InputMaybe<Scalars['ID']>;
  /** Returns only contents with the specified source */
  source?: InputMaybe<Scalars['String']>;
  /** Returns only contents with the specified source id */
  sourceId?: InputMaybe<Scalars['String']>;
  /** Returns only contents of the specified type */
  type?: InputMaybe<ContentType>;
  /** Returns only contents with the specified upload date */
  uploadDate?: InputMaybe<Scalars['DateTime']>;
  /** Returns only contents with the specified version */
  version?: InputMaybe<Scalars['Long']>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export enum ContentExistsValueFields {
  /** Returns only contents which have one or more article ids specified */
  articleIds = 'articleIds',
  /** Returns only contents which have one or more asset ids specified */
  assetIds = 'assetIds',
  /** Returns only contents which have a locale specified */
  locale = 'locale',
  /** Return only contents which have a version specified */
  version = 'version'
}

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type ContentFilter = {
  /** Allows the specification of further filter criteria, which are grouped together and connected with a logical AND operator */
  andGroup?: InputMaybe<Array<InputMaybe<ContentFilter>>>;
  /** Returns only contents with one of the specified article ids */
  articleIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Returns only contents with one of the specified asset ids */
  assetIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Boosts the score of all matches in this group by the specified factor. Heads up: The resulting score boost isn't mathematically exact due to rounding errors */
  boost?: InputMaybe<Scalars['Float']>;
  /** Returns contents with one of the specified content identifiers */
  contentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Returns contents that contain all of the exact values specified */
  equals?: InputMaybe<ContentEqualsValueFilter>;
  /** Returns contents that contain all of the exact values specified */
  equalsOneOf?: InputMaybe<ContentEqualsOneOfValueFilter>;
  /** Returns contents that have a value in all of the specified fields */
  exists?: InputMaybe<Array<InputMaybe<ContentExistsValueFields>>>;
  /** Returns contents that match all of the specified full text searches */
  fullText?: InputMaybe<ContentFullTextFilter>;
  /** Returns contents with one of the specified unique identifiers */
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Allows you to specify logically negated filter criteria */
  not?: InputMaybe<ContentFilter>;
  /** Allows the specification of further filter criteria, which are grouped together and connected with a logical OR operator */
  orGroup?: InputMaybe<Array<InputMaybe<ContentFilter>>>;
  /** Returns contents with values within all of the ranges specified */
  range?: InputMaybe<ContentRangeFilter>;
  /** Returns contents that match all of the regular expressions */
  regex?: InputMaybe<ContentRegexFilter>;
  /** Returns contents that match a taxonomy value according to the taxonomy's evaluation type */
  taxonomy?: InputMaybe<ContentTaxonomyFilter>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type ContentFilterOptions = {
  /** Returns contents including such with 'hidden' flag set to true. If set to false (default), only contents with 'hidden' flag set to false are returned. */
  includeHidden?: InputMaybe<Scalars['Boolean']>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type ContentFullTextFields = {
  /** Match the query against any full text searchable field and rank the results with the specified boost */
  any?: InputMaybe<Scalars['Float']>;
  /** Match the query against any text language and rank the results with the specified boost */
  text?: InputMaybe<Scalars['Float']>;
  /** Match the query against any title language and rank the results with the specified boost */
  title?: InputMaybe<Scalars['Float']>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type ContentFullTextFilter = {
  /** Fields to search in with their respective score weights */
  fields?: InputMaybe<ContentFullTextFields>;
  /** Indicates if a fuzzy search should be performed. */
  fuzzy?: InputMaybe<Scalars['Boolean']>;
  /** Specifies if either all or any query words need to match */
  operator?: InputMaybe<FullTextOperator>;
  /**
   * The text to search for.
   * Be aware: The Limit for full text search queries is 1024 characters and
   * anything above that will result in an error.
   */
  query: Scalars['FullTextSearchQuery'];
  /** Type of fulltext search to perform */
  searchType?: InputMaybe<FullTextSearchType>;
  /** Options to configure the synonym search */
  synonymOptions?: InputMaybe<SynonymOptions>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type ContentGroup = {
  __typename?: 'ContentGroup';
  /** Stable opaque cursor for groups(after:). */
  cursor: Scalars['String'];
  /**
   * Representative hits, sorted and paginated independently within this group.
   * The first page may be served from the grouping query; later pages use a
   * group-scoped search with the same filters and access control.
   */
  hits: Array<ContentEdge>;
  /** Composite key, one entry per field configured by the selected criterion. */
  key: Array<ContentGroupKeyEntry>;
  /** Teasers of the first content in the group. */
  teaser?: Maybe<ContentTeasers>;
  /** Number of contents in this group (exact for terms/composite). */
  total: TotalCount;
};


/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type ContentGroupHitsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  sort?: InputMaybe<Array<ContentSort>>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type ContentGroupBy = {
  /** Configured dimensions used to form each group's key. */
  criteria: ContentGroupingCriteria;
  /** Ascending or descending lexicographic order of group keys. */
  order?: InputMaybe<SortOrder>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export enum ContentGroupField {
  /** Stable key shared by format and language variants of the same content. */
  contentBaseIds = 'contentBaseIds',
  language = 'language',
  mimeType = 'mimeType'
}

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type ContentGroupKeyEntry = {
  __typename?: 'ContentGroupKeyEntry';
  /** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
  field: ContentGroupField;
  /** Length limited, human readable text for this entry's `value`, e.g. a mimeType's display name. */
  teasers?: Maybe<DatafieldValueTeasers>;
  /** Null when missing_bucket fired (no value for this field on those docs). */
  value?: Maybe<Scalars['String']>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type ContentGroupedQueryResult = {
  __typename?: 'ContentGroupedQueryResult';
  /** Paginatable, key-ordered listing of all groups. */
  groups: Array<ContentGroup>;
  /** Distinct group count up to trackLimit (server-capped at 39,999); countRelation is gte when more groups exist. */
  totalGroups: TotalCount;
};


/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type ContentGroupedQueryResultGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
};


/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type ContentGroupedQueryResultTotalGroupsArgs = {
  trackLimit?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type ContentGroupingConfig = {
  __typename?: 'ContentGroupingConfig';
  /** The grouping criteria. Set when enabled is true */
  criteria?: Maybe<ContentGroupingCriteria>;
  /** Whether grouping is enabled for this subject area */
  enabled: Scalars['Boolean'];
  /** The unique id of the subject area this grouping config applies to */
  id: Scalars['ID'];
};

/** The available grouping criteria presets for content subject areas */
export enum ContentGroupingCriteria {
  /** Group by key and format */
  keyFormat = 'keyFormat',
  /** Group by key, format and language */
  keyFormatLanguage = 'keyFormatLanguage',
  /** Group by key and language */
  keyLanguage = 'keyLanguage'
}

/** Highlighted matches for equality and full text filters. Matched terms are wrapped in <em>...</em> Tags. */
export type ContentHighlights = {
  /** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
  text?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
  title?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** Highlighted matches for equality and full text filters. Matched terms are wrapped in <em>...</em> Tags. */
export type ContentHighlightsTextArgs = {
  length?: InputMaybe<Scalars['NonNegativeInt']>;
};


/** Highlighted matches for equality and full text filters. Matched terms are wrapped in <em>...</em> Tags. */
export type ContentHighlightsTitleArgs = {
  length?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** A content map aggregates other content maps or topics into a table of content maps structure. */
export type ContentMap = Content & {
  __typename?: 'ContentMap';
  /** The related article ids */
  articleIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The related asset ids */
  assetIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Unique identifier of the content map itself */
  contentId: Scalars['ID'];
  /** Date and time when the content map was created */
  creationDate?: Maybe<Scalars['DateTime']>;
  /** Document identifier */
  documentId?: Maybe<Scalars['ID']>;
  /** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
  id: Scalars['ID'];
  /** Language of the content map */
  language?: Maybe<Language>;
  /** Locale of the content map */
  locale?: Maybe<Scalars['String']>;
  /** The file type of the asset this content map refers to */
  mimeType?: Maybe<Scalars['String']>;
  /** Date and time of the last modification */
  modificationDate?: Maybe<Scalars['DateTime']>;
  /**
   * Relevant notes for the content map.
   *
   * This field only shows private, pendingApproval notes created by the requesting user and any public notes
   * that reference the content.
   *
   * Even with administrative privileges this field only shows the above mentioned notes and therefore doesn't include any notes
   * which don't belong to the requesting user except the public ones. To view any note and filter them, refer to the
   * filter query for the notes.
   */
  notes?: Maybe<NoteQueryResult>;
  /** Original locale of the content map (if provided by source metadata) */
  originalLocale?: Maybe<Scalars['String']>;
  /** Flag if the content map is published */
  published?: Maybe<Scalars['Boolean']>;
  /** The rendition */
  rendition?: Maybe<Scalars['String']>;
  /** The source this content was generated from */
  source?: Maybe<Scalars['String']>;
  /** The unique id of the source */
  sourceId?: Maybe<Scalars['String']>;
  /** Length limited text from the content map for use e.g. in result lists, previews, etc. */
  teasers?: Maybe<ContentMapTeasers>;
  /** Title of the content map */
  title?: Maybe<MultilingualString>;
  /**
   * The content map's table of contents.
   * To fetch specific paths of the toc, specify the `paths` argument.
   * The root path is represented by the '~' character.
   * To fetch children of a `TocEdge` use the edge's `childPath` in the `paths` argument.
   * For each specified path, the immediate child-entries of the specified path will be returned.
   * If no `paths` are provided, the root-entries will be returned.
   */
  toc?: Maybe<TocResult>;
  /** The type of the node */
  type?: Maybe<Scalars['String']>;
  /** Most recent date and time when the content map was uploaded */
  uploadDate?: Maybe<Scalars['DateTime']>;
  /** The use context in which this content map is used */
  useContext?: Maybe<UseContext>;
  /** The validity period of the content map */
  validityPeriod?: Maybe<DateInclusiveRange>;
  /** The variants of the current content map, having either a different language and or version. */
  variants: ContentQueryResult;
  /** Technical version of the content map */
  version?: Maybe<Scalars['Long']>;
  /** Readable label for the version */
  versionLabel?: Maybe<Scalars['String']>;
};


/** A content map aggregates other content maps or topics into a table of content maps structure. */
export type ContentMapNotesArgs = {
  filter?: InputMaybe<NoteFilter>;
};


/** A content map aggregates other content maps or topics into a table of content maps structure. */
export type ContentMapTocArgs = {
  paths?: InputMaybe<Array<Scalars['String']>>;
};


/** A content map aggregates other content maps or topics into a table of content maps structure. */
export type ContentMapVariantsArgs = {
  filter?: InputMaybe<ContentFilter>;
  filterOptions?: InputMaybe<ContentFilterOptions>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type ContentMapEdge = {
  __typename?: 'ContentMapEdge';
  /** Unique cursor for pagination. See the query's `after` argument */
  cursor: Scalars['String'];
  /** Highlighted matches for equality and full text filters. Matched terms are wrapped in <em>...</em> Tags. */
  highlights?: Maybe<ContentMapHighlights>;
  /** The result's content map. */
  node: ContentMap;
  /** Calculated relevance score. */
  score: Scalars['NonNegativeFloat'];
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type ContentMapEqualsValueFilter = {
  /** Returns only content maps with the specified creation date */
  creationDate?: InputMaybe<Scalars['DateTime']>;
  /** Returns only documents with the specified document id */
  documentId?: InputMaybe<Scalars['String']>;
  /** Return only content maps with the specified language */
  language?: InputMaybe<Language>;
  /** Returns only content maps with the specified locale */
  locale?: InputMaybe<Scalars['String']>;
  /** Returns only contents with the specified mime type */
  mimeType?: InputMaybe<Scalars['String']>;
  /** Returns only content maps with the specified modification date */
  modificationDate?: InputMaybe<Scalars['DateTime']>;
  /** Returns only content maps with the published flag set */
  published?: InputMaybe<Scalars['Boolean']>;
  /** Returns only contents with the specified rendition */
  rendition?: InputMaybe<Scalars['String']>;
  /** Returns only content maps used by the specified root content id */
  rootContentId?: InputMaybe<Scalars['ID']>;
  /** Returns only contents with the specified source */
  source?: InputMaybe<Scalars['String']>;
  /** Returns only contents with the specified source id */
  sourceId?: InputMaybe<Scalars['String']>;
  /** Returns only content maps with the specified upload date */
  uploadDate?: InputMaybe<Scalars['DateTime']>;
  /** Returns only contents with the specified version */
  version?: InputMaybe<Scalars['Long']>;
  /** Returns only contents with the specified version label */
  versionLabel?: InputMaybe<Scalars['String']>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export enum ContentMapExistsValueFields {
  /** Returns only contents which have one or more article ids specified */
  articleIds = 'articleIds',
  /** Returns only contents which have one or more asset ids specified */
  assetIds = 'assetIds',
  /** Returns only content maps which have a locale specified */
  locale = 'locale',
  /** Returns only content maps which have a mime type specified */
  mimeType = 'mimeType',
  /** Returns only content maps which have a rendition specified */
  rendition = 'rendition',
  /** Returns only content maps which have a source specified */
  source = 'source',
  /** Returns only content maps which have a source id specified */
  sourceId = 'sourceId',
  /** Returns only content maps which have a version specified */
  version = 'version',
  /** Returns only content maps which have a version label specified */
  versionLabel = 'versionLabel'
}

/**
 * The `ContentMapFilter` is used to specify filter criteria for content maps.
 * If you specify more than one criterion, all criteria are grouped together and connected with a logical AND operator.
 * Further logical operations are possible by using `not` `andGroup` and `orGroup`.
 *
 * Important: Datafields in this filter is only accessible through the namespaced graphql id defined in the
 * definition of the corresponding datafield. For further information see `DatafieldDefinition`.
 */
export type ContentMapFilter = {
  /** Allows the specification of further filter criteria, which are grouped together and connected with a logical AND operator */
  andGroup?: InputMaybe<Array<InputMaybe<ContentMapFilter>>>;
  /** Boosts the relevance score of all matches in this group by the specified factor. Heads up: The resulting score boost isn't mathematically exact due to rounding errors */
  boost?: InputMaybe<Scalars['Float']>;
  /** Returns content maps with one of the specified content identifiers */
  contentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Returns content maps that contain all of the exact values specified */
  equals?: InputMaybe<ContentMapEqualsValueFilter>;
  /** Returns content maps that have a value in all of the specified fields */
  exists?: InputMaybe<Array<InputMaybe<ContentMapExistsValueFields>>>;
  /** Returns content maps that match all of the specified full text searches */
  fullText?: InputMaybe<ContentMapFullTextFilter>;
  /** Returns content maps with one of the specified unique identifiers */
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Allows you to specify logically negated filter criteria */
  not?: InputMaybe<ContentMapFilter>;
  /** Allows the specification of further filter criteria, which are grouped together and connected with a logical OR operator */
  orGroup?: InputMaybe<Array<InputMaybe<ContentMapFilter>>>;
  /** Returns content maps with values within all of the ranges specified */
  range?: InputMaybe<ContentMapRangeFilter>;
  /** Returns content maps that match all of the regular expressions */
  regex?: InputMaybe<ContentMapRegexFilter>;
  /** Returns contents that match a taxonomy value according to the taxonomy's evaluation type */
  taxonomy?: InputMaybe<ContentMapTaxonomyFilter>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type ContentMapFilterOptions = {
  /** Returns contents including such with 'hidden' flag set to true. If set to false (default), only contents with 'hidden' flag set to false are returned. */
  includeHidden?: InputMaybe<Scalars['Boolean']>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type ContentMapFullTextFields = {
  /** Match the query against any full text searchable field and rank the results with the specified boost */
  any?: InputMaybe<Scalars['Float']>;
  /** Match the query against any title language and rank the results with the specified boost */
  title?: InputMaybe<Scalars['Float']>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type ContentMapFullTextFilter = {
  /** Fields to search in with their respective score weights */
  fields?: InputMaybe<ContentMapFullTextFields>;
  /** Indicates if a fuzzy search should be performed. */
  fuzzy?: InputMaybe<Scalars['Boolean']>;
  /** Specifies if either all or any query words need to match */
  operator?: InputMaybe<FullTextOperator>;
  /**
   * The text to search for.
   * Be aware: The Limit for full text search queries is 1024 characters and
   * anything above that will result in an error.
   */
  query: Scalars['FullTextSearchQuery'];
  /** Type of fulltext search to perform */
  searchType?: InputMaybe<FullTextSearchType>;
  /** Options for synonyms */
  synonymOptions?: InputMaybe<SynonymOptions>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type ContentMapHighlights = ContentHighlights & {
  __typename?: 'ContentMapHighlights';
  /** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
  text?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
  title?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type ContentMapHighlightsTextArgs = {
  length?: InputMaybe<Scalars['NonNegativeInt']>;
};


/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type ContentMapHighlightsTitleArgs = {
  length?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type ContentMapQueryResult = {
  __typename?: 'ContentMapQueryResult';
  /**
   * Matched datafield values and number of matching content map uses per value
   *
   * To limit the number of results, set the `first` argument.
   *
   * Pagination is possible by setting the `after` argument to the previous last result's `cursor` field value.
   */
  aggregations: Aggregations;
  /**
   * The query's matching content maps.
   *
   * Use the `sort` argument to specify the list of fields and the order by which the results should be sorted.
   * Multiple fields and orders may be specified and are evaluated in the provided order.
   *
   * To limit the number of results, set the `first` argument.
   *
   * Pagination is possible by setting the `after` argument to the previous last result's `cursor` field value.
   * Please be careful not to change the query's `filter` or the `sort` argument between paginated calls.
   */
  contentMaps: Array<Maybe<ContentMapEdge>>;
  /**
   * Returns the total count of results.
   *
   * Use the `trackLimit` argument to limit the track of the total count up to the specified amount.
   * If the result has more hits than the specified limit the total count is inaccurate.
   * See `CountRelation` for further information on how to interpret the result.
   *
   * Heads up: Setting the `trackLimit` to a high value may decrease performance.
   */
  total: TotalCount;
};


/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type ContentMapQueryResultContentMapsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  sort?: InputMaybe<Array<InputMaybe<ContentMapSort>>>;
};


/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type ContentMapQueryResultTotalArgs = {
  trackLimit?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type ContentMapRangeFilter = {
  /** Returns only content maps with a creation date in the specified range */
  creationDate?: InputMaybe<DateRange>;
  /** Returns only content maps with a modification date in the specified range */
  modificationDate?: InputMaybe<DateRange>;
  /** Returns only content maps with a upload date in the specified range */
  uploadDate?: InputMaybe<DateRange>;
  /** Returns only contents with a version within the specified range */
  version?: InputMaybe<LongRange>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type ContentMapRegexFilter = {
  /** Returns contents with one of the specified unique identifiers */
  id?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns contents with one of the specified root content identifiers */
  rootContentId?: InputMaybe<Scalars['FilterRegex']>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type ContentMapSort = {
  /** Sort field */
  field: ContentMapSortFields;
  /** Sort order */
  order?: InputMaybe<SortOrder>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export enum ContentMapSortFields {
  /** Sort by content id */
  contentId = 'contentId',
  /** Sort by creation date */
  creationDate = 'creationDate',
  /** Sort by unique ID */
  id = 'id',
  /** Sort by language */
  language = 'language',
  /** Sort by locale */
  locale = 'locale',
  /** Sort by modification date */
  modificationDate = 'modificationDate',
  /** Sort by published flag */
  published = 'published',
  /** Sort by rendition */
  rendition = 'rendition',
  /** Sort by relevance score */
  score = 'score',
  /** Sort by source */
  source = 'source',
  /** Sort by source id */
  sourceId = 'sourceId',
  /** Sort by title */
  title = 'title',
  /** Sort by upload date */
  uploadDate = 'uploadDate',
  /** Sort by version */
  version = 'version',
  /** Sort by version label */
  versionLabel = 'versionLabel'
}

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type ContentMapTaxonomyFilter = {
  /** No taxonomy indexed field definitions exist. As soon as the first taxonomy is defined, it's automatically listed here. */
  not_applicable_as_no_taxonomy_field_definitions_exist?: InputMaybe<Scalars['NoDynamicValueDefined']>;
};

/** Length limited text from the content map for use e.g. in result lists, previews, etc. */
export type ContentMapTeasers = ContentTeasers & {
  __typename?: 'ContentMapTeasers';
  /** The content map's title limited to `length` characters */
  title?: Maybe<Scalars['String']>;
};


/** Length limited text from the content map for use e.g. in result lists, previews, etc. */
export type ContentMapTeasersTitleArgs = {
  length?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type ContentQueryResult = {
  __typename?: 'ContentQueryResult';
  /**
   * Matched datafield values and number of matching contents per value
   *
   * To limit the number of results, set the `first` argument.
   *
   * Pagination is possible by setting the `after` argument to the previous last result's `cursor` field value.
   */
  aggregations: Aggregations;
  /**
   * The query's matching contents.
   *
   * Use the `sort` argument to specify the list of fields and the order by which the results should be sorted.
   * Multiple fields and orders may be specified and are evaluated in the provided order.
   *
   * To limit the number of results, set the `first` argument.
   *
   * Pagination is possible by setting the `after` argument to the previous last result's `cursor` field value.
   * Please be careful not to change the query's `filter` or the `sort` argument between paginated calls.
   */
  contents: Array<Maybe<ContentEdge>>;
  /**
   * Returns the total count of results.
   *
   * Use the `trackLimit` argument to limit the track of the total count up to the specified amount.
   * If the result has more hits than the specified limit the total count is inaccurate.
   * See `CountRelation` for further information on how to interpret the result.
   *
   * Heads up: Setting the `trackLimit` to a high value may decrease performance.
   */
  total: TotalCount;
};


/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type ContentQueryResultContentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  sort?: InputMaybe<Array<InputMaybe<ContentSort>>>;
};


/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type ContentQueryResultTotalArgs = {
  trackLimit?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type ContentRangeFilter = {
  /** Returns only contents with a creation date in the specified range */
  creationDate?: InputMaybe<DateRange>;
  /** Returns only contents with a modification date in the specified range */
  modificationDate?: InputMaybe<DateRange>;
  /** Returns only contents with a upload date in the specified range */
  uploadDate?: InputMaybe<DateRange>;
  /** Returns only contents with a version within the specified range */
  version?: InputMaybe<LongRange>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type ContentRegexFilter = {
  /** No regex filterable indexed field definitions exist. As soon as the first matching indexed field definition is defined, it's automatically listed here. */
  not_applicable_as_no_regex_filterable_field_definitions_exist?: InputMaybe<Scalars['NoDynamicValueDefined']>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type ContentSort = {
  /** Sort field */
  field: ContentSortFields;
  /** Sort order */
  order?: InputMaybe<SortOrder>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export enum ContentSortFields {
  /** Sort by content id */
  contentId = 'contentId',
  /** Sort by creation date */
  creationDate = 'creationDate',
  /** Sort by unique ID */
  id = 'id',
  /** Sort by language */
  language = 'language',
  /** Sort by locale */
  locale = 'locale',
  /** Sort by modification date */
  modificationDate = 'modificationDate',
  /** Sort by relevance score */
  score = 'score',
  /** Sort by source */
  source = 'source',
  /** Sort by source id */
  sourceId = 'sourceId',
  /** Sort by title */
  title = 'title',
  /** Sort by upload date */
  uploadDate = 'uploadDate',
  /** Sort by technical version */
  version = 'version'
}

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type ContentTaxonomyFilter = {
  /** No taxonomy indexed field definitions exist. As soon as the first taxonomy is defined, it's automatically listed here. */
  not_applicable_as_no_taxonomy_field_definitions_exist?: InputMaybe<Scalars['NoDynamicValueDefined']>;
};

/** Length limited text from the content for use e.g. in result lists, previews, etc. */
export type ContentTeasers = {
  /** The content's title limited to `length` characters */
  title?: Maybe<Scalars['String']>;
};


/** Length limited text from the content for use e.g. in result lists, previews, etc. */
export type ContentTeasersTitleArgs = {
  length?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export enum ContentType {
  /** Specifies the content map */
  contentMap = 'contentMap',
  /** Specifies the topic */
  topic = 'topic'
}

/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export enum CountRelation {
  /** The count is accurate and equals the actual count of hits */
  eq = 'eq',
  /** The result is inaccurate and only a lower bound of the actual possible hits */
  gte = 'gte',
  /** The result is inaccurate and only a upper bound of the actual possible hits */
  lte = 'lte'
}

/** Sub Graph: **https://basic-services-graph.qit.svc.cluster.local:8443** */
export type CreateApiKeyInput = {
  /** The api key's readable name */
  displayName: Scalars['String'];
  /** The unique identifier of the user for whom the api key will be created */
  userId: Scalars['ID'];
  /** Date until which the api key will be valid */
  validUntil: Scalars['DateTime'];
};

/** Sub Graph: **https://basic-services-graph.qit.svc.cluster.local:8443** */
export type CreateApiKeyResponse = {
  __typename?: 'CreateApiKeyResponse';
  /**
   * The api pass is a verifiable string which contains all authentication information needed to access the application.
   * It can be distributed to trusted applications to provide access to the application without the need to retrieve
   * any other information.
   *
   * The api pass consists of the payload and the checksum part separated by a colon (:).
   * The payload part is a JSON object containing the url and the access token encoded in base 64.
   * To verify the integrity of the payload use the checksum part which is a md5 hash.
   *
   * Please note: Handle the pass with same caution as described in `token`.
   */
  apiPass: Scalars['String'];
  /** The api key's details */
  key?: Maybe<ApiKey>;
  /**
   * The access token for the api key.
   * Please note: The token is a credential which grants access to resources and should be treated like a password.
   * To provide the best security for the token, it isn't stored and can only be retrieved once during creation
   * of an api key.
   */
  token: Scalars['String'];
};

/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type CreateCollectionInput = {
  /** The detailed description */
  description?: InputMaybe<Scalars['String']>;
  /** The display name */
  displayName?: InputMaybe<Scalars['String']>;
  /** The indicator whether the collection should be displayed in the dashboard */
  showInDashboard?: InputMaybe<Scalars['Boolean']>;
  /**
   * The visibility of the new collection.
   * Can't be changed after creation
   */
  visibility: CollectionVisibilityTypes;
};

/** Sub Graph: **https://basic-services-graph.qit.svc.cluster.local:8443** */
export type CreateConnectorKeyInput = {
  /** The unique identifier of the user for whom the connector key will be created */
  userId: Scalars['ID'];
};

/** Sub Graph: **https://user-generated-data-graph.qit.svc.cluster.local:8443** */
export type CreateNoteCommentInput = {
  /** The text of the comment */
  text?: InputMaybe<Scalars['String']>;
};

/** Sub Graph: **https://user-generated-data-graph.qit.svc.cluster.local:8443** */
export type CreateNoteInput = {
  /** The attachments initially linked to the note */
  attachments?: InputMaybe<Array<Scalars['String']>>;
  /** The id of the object the note is created for */
  objectId: Scalars['ID'];
  /** The note text */
  text?: InputMaybe<MultilingualStringInput>;
  /** The visibility for the note */
  visibility: NoteVisibilityTypesInput;
};

/** Sub Graph: **https://users-settings-graph.qit-settings.svc.cluster.local:8443** */
export type CreateOrUpdateUserSettings = {
  /**
   * The settings as a string key value map.
   *
   * Be aware: Key and value must of type string. Otherwise
   * an error will be thrown.
   */
  settings: Scalars['JSONObject'];
};

/** ISO 4217 currency code. */
export enum CurrencyCode {
  aed = 'AED',
  afn = 'AFN',
  all = 'ALL',
  amd = 'AMD',
  ang = 'ANG',
  aoa = 'AOA',
  ars = 'ARS',
  aud = 'AUD',
  awg = 'AWG',
  azn = 'AZN',
  bam = 'BAM',
  bbd = 'BBD',
  bdt = 'BDT',
  bgn = 'BGN',
  bhd = 'BHD',
  bif = 'BIF',
  bmd = 'BMD',
  bnd = 'BND',
  bob = 'BOB',
  brl = 'BRL',
  bsd = 'BSD',
  btn = 'BTN',
  bwp = 'BWP',
  byn = 'BYN',
  bzd = 'BZD',
  cad = 'CAD',
  cdf = 'CDF',
  chf = 'CHF',
  clf = 'CLF',
  clp = 'CLP',
  cny = 'CNY',
  cop = 'COP',
  crc = 'CRC',
  cuc = 'CUC',
  cup = 'CUP',
  cve = 'CVE',
  czk = 'CZK',
  djf = 'DJF',
  dkk = 'DKK',
  dop = 'DOP',
  dzd = 'DZD',
  egp = 'EGP',
  ern = 'ERN',
  etb = 'ETB',
  eur = 'EUR',
  fjd = 'FJD',
  fkp = 'FKP',
  gbp = 'GBP',
  gel = 'GEL',
  ghs = 'GHS',
  gip = 'GIP',
  gmd = 'GMD',
  gnf = 'GNF',
  gtq = 'GTQ',
  gyd = 'GYD',
  hkd = 'HKD',
  hnl = 'HNL',
  hrk = 'HRK',
  htg = 'HTG',
  huf = 'HUF',
  idr = 'IDR',
  ils = 'ILS',
  inr = 'INR',
  iqd = 'IQD',
  irr = 'IRR',
  isk = 'ISK',
  jmd = 'JMD',
  jod = 'JOD',
  jpy = 'JPY',
  kes = 'KES',
  kgs = 'KGS',
  khr = 'KHR',
  kmf = 'KMF',
  kpw = 'KPW',
  krw = 'KRW',
  kwd = 'KWD',
  kyd = 'KYD',
  kzt = 'KZT',
  lak = 'LAK',
  lbp = 'LBP',
  lkr = 'LKR',
  lrd = 'LRD',
  lsl = 'LSL',
  lyd = 'LYD',
  mad = 'MAD',
  mdl = 'MDL',
  mga = 'MGA',
  mkd = 'MKD',
  mmk = 'MMK',
  mnt = 'MNT',
  mop = 'MOP',
  mru = 'MRU',
  mur = 'MUR',
  mvr = 'MVR',
  mwk = 'MWK',
  mxn = 'MXN',
  myr = 'MYR',
  mzn = 'MZN',
  nad = 'NAD',
  ngn = 'NGN',
  nio = 'NIO',
  nok = 'NOK',
  npr = 'NPR',
  nzd = 'NZD',
  omr = 'OMR',
  pab = 'PAB',
  pen = 'PEN',
  pgk = 'PGK',
  php = 'PHP',
  pkr = 'PKR',
  pln = 'PLN',
  pyg = 'PYG',
  qar = 'QAR',
  ron = 'RON',
  rsd = 'RSD',
  rub = 'RUB',
  rwf = 'RWF',
  sar = 'SAR',
  sbd = 'SBD',
  scr = 'SCR',
  sdg = 'SDG',
  sek = 'SEK',
  sgd = 'SGD',
  shp = 'SHP',
  sll = 'SLL',
  sos = 'SOS',
  srd = 'SRD',
  ssp = 'SSP',
  stn = 'STN',
  syp = 'SYP',
  szl = 'SZL',
  thb = 'THB',
  tjs = 'TJS',
  tmt = 'TMT',
  tnd = 'TND',
  top = 'TOP',
  try = 'TRY',
  ttd = 'TTD',
  twd = 'TWD',
  tzs = 'TZS',
  uah = 'UAH',
  ugx = 'UGX',
  usd = 'USD',
  uyu = 'UYU',
  uzs = 'UZS',
  ves = 'VES',
  vnd = 'VND',
  vuv = 'VUV',
  wst = 'WST',
  xaf = 'XAF',
  xcd = 'XCD',
  xof = 'XOF',
  xpf = 'XPF',
  yer = 'YER',
  zar = 'ZAR',
  zmw = 'ZMW',
  zwl = 'ZWL'
}

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type CustomDatafield = Datafield & {
  __typename?: 'CustomDatafield';
  /** The full indexed field definition */
  datafieldDefinition?: Maybe<DatafieldDefinition>;
  /** The indexed datafield definition id */
  datafieldId: Scalars['DatafieldDefinitionID'];
  /** The entries meta type */
  fieldType: FieldDefinitionTypes;
  /** Length unlimited text for the entry for use e.g. in result lists, previews, etc. */
  localizations?: Maybe<DatafieldLocalizations>;
  /** The referenced indexed field definition id */
  referencedId: Scalars['ID'];
  /** Length limited text for the indexed field definition for use e.g. in result lists, previews, etc. */
  teasers?: Maybe<DatafieldTeasers>;
  /** The title of the indexed field definition */
  title?: Maybe<MultilingualString>;
  /** The entries type */
  type: DatafieldType;
};

/** Sub Graph: **https://data-filter-graph.qit-data-filter.svc.cluster.local:8443** */
export type CustomDatafieldFacet = Facet & {
  __typename?: 'CustomDatafieldFacet';
  /** The full indexed field definition referenced by the facet */
  datafieldDefinition: DatafieldDefinition;
  /** The facets definition */
  definition?: Maybe<FacetDefinition>;
  /** Details about how the facet should be displayed by a frontend component */
  display: FacetDisplay;
  /** The unique id of the facet */
  id: Scalars['ID'];
  /**
   * Kind of facet, e.g. is it a filter or navigation facet.
   * The value isn't interpreted by the API. The frontend component(s) are responsible
   * for the value stored.
   */
  kind: Scalars['String'];
  /** The id of the field, indexed field definition etc. referenced by this facet */
  referencedId: Scalars['ID'];
  /** Length limited text */
  teasers?: Maybe<FacetTeasers>;
  /**
   * The title of the facet.
   * If the facet doesn't have a custom title specified
   * and has a valid datafield id specified, the title of the datafield
   * definition will be used as title.
   */
  title?: Maybe<MultilingualString>;
  /** The type of the facet */
  type: DatafieldType;
};

/** Sub Graph: **https://tenant-settings-graph.qit-settings.svc.cluster.local:8443** */
export type CustomLink = {
  __typename?: 'CustomLink';
  /** Sub Graph: **https://tenant-settings-graph.qit-settings.svc.cluster.local:8443** */
  icon: Scalars['String'];
  /** Sub Graph: **https://tenant-settings-graph.qit-settings.svc.cluster.local:8443** */
  target: Target;
  /** Sub Graph: **https://tenant-settings-graph.qit-settings.svc.cluster.local:8443** */
  title: Scalars['String'];
  /** Sub Graph: **https://tenant-settings-graph.qit-settings.svc.cluster.local:8443** */
  url: Scalars['URL'];
};

/** Sub Graph: **https://data-filter-graph.qit-data-filter.svc.cluster.local:8443** */
export type DataDisplayConfig = {
  __typename?: 'DataDisplayConfig';
  /**
   * Entries of this data display config.
   * The Field is ordered and always returns the entries in the defined order.
   */
  entries?: Maybe<Array<DataDisplayConfigEntry>>;
  /** The unique id */
  id: Scalars['ID'];
  /** Defines the separator characters with whom the information will be separated */
  separator: Scalars['String'];
};

/** Sub Graph: **https://data-filter-graph.qit-data-filter.svc.cluster.local:8443** */
export type DataDisplayConfigDatafieldEntry = DataDisplayConfigEntry & {
  __typename?: 'DataDisplayConfigDatafieldEntry';
  /** The full indexed field definition */
  datafieldDefinition?: Maybe<DatafieldDefinition>;
  /** The indexed field definition id */
  datafieldId: Scalars['DatafieldDefinitionID'];
  /**
   * Details about how the entry should be displayed by a frontend component.
   * The value isn't interpreted by the API. The frontend component(s) are responsible
   * for the value stored.
   */
  displayOptions?: Maybe<Scalars['JSONObject']>;
  /** The entries meta type */
  fieldType: FieldDefinitionTypes;
  /** The referenced indexed field definition id */
  referencedId: Scalars['ID'];
  /** Indicates whether the title should be shown as prefix */
  showTitlePrefix: Scalars['Boolean'];
  /** Length limited text for the field definition for use e.g. in result lists, previews, etc. */
  teasers?: Maybe<DataDisplayConfigEntryTeasers>;
  /** The title of the indexed field definition */
  title?: Maybe<MultilingualString>;
  /** The entries type */
  type: DatafieldType;
};

/** Sub Graph: **https://data-filter-graph.qit-data-filter.svc.cluster.local:8443** */
export type DataDisplayConfigEntry = {
  /**
   * Details about how the entry should be displayed by a frontend component.
   * The value isn't interpreted by the API. The frontend component(s) are responsible
   * for the value stored.
   */
  displayOptions?: Maybe<Scalars['JSONObject']>;
  /** The entries meta type */
  fieldType: FieldDefinitionTypes;
  /** The id of the field, indexed field definition, etc. referenced by this entry */
  referencedId: Scalars['ID'];
  /** Indicates whether the title should be shown as prefix */
  showTitlePrefix: Scalars['Boolean'];
  /** Length limited text for the entry for use e.g. in result lists, previews, etc. */
  teasers?: Maybe<DataDisplayConfigEntryTeasers>;
  /** The title of the entry */
  title?: Maybe<MultilingualString>;
  /** The entries type */
  type: DatafieldType;
};

/** Length limited text value for use e.g. in result lists, previews, etc. */
export type DataDisplayConfigEntryTeasers = {
  __typename?: 'DataDisplayConfigEntryTeasers';
  /**
   * The value's title limited to `length` characters.
   * Preferred language and the precedence of fallback languages can be specified via `acceptedLanguages`.
   */
  title?: Maybe<Scalars['String']>;
};


/** Length limited text value for use e.g. in result lists, previews, etc. */
export type DataDisplayConfigEntryTeasersTitleArgs = {
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard>>;
  length?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://data-filter-graph.qit-data-filter.svc.cluster.local:8443** */
export type DataDisplayConfigFieldEntry = DataDisplayConfigEntry & {
  __typename?: 'DataDisplayConfigFieldEntry';
  /**
   * The full indexed field definition
   * @deprecated This API may change in future releases
   */
  datafieldDefinition?: Maybe<DatafieldDefinition>;
  /**
   * Details about how the entry should be displayed by a frontend component.
   * The value isn't interpreted by the API. The frontend component(s) are responsible
   * for the value stored.
   */
  displayOptions?: Maybe<Scalars['JSONObject']>;
  /** The entries meta type */
  fieldType: FieldDefinitionTypes;
  /** Indicates to which data types the entry belongs to. */
  nodeTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The referenced field name */
  referencedId: Scalars['ID'];
  /** Indicates whether the title should be shown as prefix */
  showTitlePrefix: Scalars['Boolean'];
  /** Length limited text for the field definition for use e.g. in result lists, previews, etc. */
  teasers?: Maybe<DataDisplayConfigEntryTeasers>;
  /** The title of the indexed field definition */
  title?: Maybe<MultilingualString>;
  /** The entries type */
  type: DatafieldType;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type Datafield = {
  /** The entries meta type */
  fieldType: FieldDefinitionTypes;
  /** Length unlimited text for the entry for use e.g. in result lists, previews, etc. */
  localizations?: Maybe<DatafieldLocalizations>;
  /** The id of the field, indexed field definition, etc. referenced by this entry */
  referencedId: Scalars['ID'];
  /** Length limited text for the entry for use e.g. in result lists, previews, etc. */
  teasers?: Maybe<DatafieldTeasers>;
  /** The title of the entry */
  title?: Maybe<MultilingualString>;
  /** The entries type */
  type: DatafieldType;
};

/** Sub Graph: **https://schematic-graph.qit-schematic.svc.cluster.local:8443** */
export type DatafieldAggregations = {
  __typename?: 'DatafieldAggregations';
  /** Provides composite aggregations with pagination support */
  composite?: Maybe<DatafieldCompositeAggregation>;
  /**
   * Provides terms aggregations for custom datafields.
   * Supports prefix search and the results are ordered by count.
   */
  terms?: Maybe<DatafieldTermsAggregation>;
};

/** Sub Graph: **https://schematic-graph.qit-schematic.svc.cluster.local:8443** */
export type DatafieldAutocompleteEdge = AutocompleteEdge & {
  __typename?: 'DatafieldAutocompleteEdge';
  /** The full datafield definition */
  datafieldDefinition?: Maybe<DatafieldDefinition>;
  /**
   * Id of the datafield definition in which the value was found
   * This value can be used as field name content query filters
   */
  datafieldDefinitionId: Scalars['DatafieldDefinitionID'];
  /** Display text for this autocomplete hit */
  displayName: Scalars['String'];
  /**
   * Language which this hit is based on
   * Is only returned if an exact language assignment can be made
   */
  language?: Maybe<Language>;
  /**
   * Unique value of the datafield definition value
   * This value can be used as operand in content query filters
   */
  value: Scalars['String'];
};

/** Sub Graph: **https://schematic-graph.qit-schematic.svc.cluster.local:8443** */
export type DatafieldAutocompleteFilter = {
  /**
   * Indexed field definitions to search in
   * Only definitions of type `taxonomy` and `enum` are supported
   * The order of datafield definitions specifies their precedence
   */
  datafieldDefinitionIds: Array<Scalars['DatafieldDefinitionID']>;
  /**
   * Languages to search in (if applicable for the datafield definition).
   * The order of languages specifies their precedence.
   */
  languages: Array<Language>;
  /**
   * String to search for
   * The provided query is executed as a prefix search
   * Fulltext features like wildcards, fuzzy search, etc. aren't supported
   */
  query: Scalars['String'];
};

/** Sub Graph: **https://schematic-graph.qit-schematic.svc.cluster.local:8443** */
export type DatafieldAutocompleteResult = {
  __typename?: 'DatafieldAutocompleteResult';
  /** The search results */
  hits: Array<DatafieldAutocompleteEdge>;
  /**
   * The search string which produced this result
   * Can be used by clients to correlate queries and responses
   */
  query: Scalars['String'];
};

/** Sub Graph: **https://schematic-graph.qit-schematic.svc.cluster.local:8443** */
export type DatafieldCompositeAggregation = {
  __typename?: 'DatafieldCompositeAggregation';
  /** No field definitions exist. As soon as the first field definition is defined, it's automatically listed here. */
  not_applicable_as_no_field_definitions_exist?: Maybe<Scalars['NoDynamicValueDefined']>;
};

/** Sub Graph: **https://schematic-graph.qit-schematic.svc.cluster.local:8443** */
export type DatafieldDefinition = {
  /** Type of this datafield definition */
  fieldType?: Maybe<FieldDefinitionTypes>;
  /**
   * Unique identifier of this datafield definition.
   * Is used as field name in all interfaces and must adhere to the
   * following pattern: ^[_A-Za-z][_0-9A-Za-z]{0,128}$
   */
  id: Scalars['DatafieldDefinitionID'];
  /** Sub Graph: **https://schematic-graph.qit-schematic.svc.cluster.local:8443** */
  localizations?: Maybe<DatafieldDefinitionLocalizations>;
  /** Field names which shall be mapped to this datafield definition */
  mappedNames?: Maybe<Array<Scalars['String']>>;
  /** List of all objectTypes this definition is assigned to */
  objectTypes?: Maybe<Array<Maybe<ObjectType>>>;
  /** Length limited text from the datafield definition for use e.g. in result lists, previews, etc. */
  teasers?: Maybe<DatafieldDefinitionTeasers>;
  /** Human readable description of this datafield definition */
  title?: Maybe<MultilingualString>;
};

/** Sub Graph: **https://schematic-graph.qit-schematic.svc.cluster.local:8443** */
export type DatafieldDefinitionEdge = {
  __typename?: 'DatafieldDefinitionEdge';
  /** Unique cursor for pagination. See the query's `after` argument */
  cursor: Scalars['String'];
  /** The result's datafield definition */
  node: DatafieldDefinition;
  /** Calculated relevance score. */
  score: Scalars['NonNegativeFloat'];
};

/** Sub Graph: **https://schematic-graph.qit-schematic.svc.cluster.local:8443** */
export type DatafieldDefinitionEqualsValueFilter = {
  /** Returns only datafield definitions with the specified type */
  fieldType?: InputMaybe<FieldDefinitionTypes>;
  /** Returns only datafield definitions with the specified title */
  title?: InputMaybe<Scalars['String']>;
};

/** The `DatafieldDefinitionFilter` is used to specify filter criteria for datafield definitions. */
export type DatafieldDefinitionFilter = {
  /** Allows the specification of further filter criteria, which are grouped together and connected with a logical AND operator */
  andGroup?: InputMaybe<Array<InputMaybe<DatafieldDefinitionFilter>>>;
  /** Boosts the score of all matches in this group by the specified factor. Heads up: The resulting score boost isn't mathematically exact due to rounding errors */
  boost?: InputMaybe<Scalars['Float']>;
  /** Returns datafield definitions that contain all of the exact values specified */
  equals?: InputMaybe<DatafieldDefinitionEqualsValueFilter>;
  /** Returns datafield definitions with one of the specified unique identifiers */
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Allows you to specify logically negated filter criteria */
  not?: InputMaybe<DatafieldDefinitionFilter>;
  /** Allows the specification of further filter criteria, which are grouped together and connected with a logical OR operator */
  orGroup?: InputMaybe<Array<InputMaybe<DatafieldDefinitionFilter>>>;
  /** Returns datafield definitions that match all of the regular expressions */
  regex?: InputMaybe<DatafieldDefinitionRegexFilter>;
};

/** Text from the datafield definition for use e.g. in details etc. */
export type DatafieldDefinitionLocalizations = {
  __typename?: 'DatafieldDefinitionLocalizations';
  /**
   * The datafield definition's title.
   * Preferred language and the precedence of fallback languages can be specified via `acceptedLanguages`.
   */
  title?: Maybe<Scalars['String']>;
};


/** Text from the datafield definition for use e.g. in details etc. */
export type DatafieldDefinitionLocalizationsTitleArgs = {
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard>>;
};

/** Sub Graph: **https://schematic-graph.qit-schematic.svc.cluster.local:8443** */
export type DatafieldDefinitionQueryResult = {
  __typename?: 'DatafieldDefinitionQueryResult';
  /**
   * The query's datafield definitions.
   *
   * Use the `sort` argument to specify the list of fields and the order by which the results should be sorted.
   * Multiple fields and orders may be specified and are evaluated in the provided order.
   *
   * To limit the number of results, set the `first` argument.
   *
   * Pagination is possible by setting the `after` argument to the previous last result's `cursor` field value.
   * Please be careful not to change the query's `filter` or the `sort` argument between paginated calls.
   */
  fieldDefinitions: Array<Maybe<DatafieldDefinitionEdge>>;
  /**
   * Returns the total count of results.
   *
   * Use the `trackLimit` argument to limit the track of the total count up to the specified amount.
   * If the result has more hits than the specified limit the total count is inaccurate.
   * See `CountRelation` for further information on how to interpret the result.
   *
   * Heads up: Setting the `trackLimit` to a high value may decrease performance.
   */
  total: TotalCount;
};


/** Sub Graph: **https://schematic-graph.qit-schematic.svc.cluster.local:8443** */
export type DatafieldDefinitionQueryResultFieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  sort?: InputMaybe<Array<InputMaybe<DatafieldDefinitionSort>>>;
};


/** Sub Graph: **https://schematic-graph.qit-schematic.svc.cluster.local:8443** */
export type DatafieldDefinitionQueryResultTotalArgs = {
  trackLimit?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://schematic-graph.qit-schematic.svc.cluster.local:8443** */
export type DatafieldDefinitionRegexFilter = {
  /** Returns only datafield definitions whose event matches the specified Regex */
  fieldType?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns definitions with one of the specified unique identifiers */
  id?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only datafield definitions whose title matches the specified Regex */
  title?: InputMaybe<Scalars['String']>;
};

/** Sub Graph: **https://schematic-graph.qit-schematic.svc.cluster.local:8443** */
export type DatafieldDefinitionSort = {
  /** Sort field */
  field: DatafieldDefinitionSortFields;
  /** Sort order */
  order?: InputMaybe<SortOrder>;
};

/** Sub Graph: **https://schematic-graph.qit-schematic.svc.cluster.local:8443** */
export enum DatafieldDefinitionSortFields {
  /** Sort by event type */
  eventType = 'eventType',
  /** Sort by unique ID */
  id = 'id',
  /** Sort by relevance score */
  score = 'score',
  /** Sort by title */
  title = 'title',
  /** Sort by language-ar title */
  titleAr = 'title_ar',
  /** Sort by language-bg title */
  titleBg = 'title_bg',
  /** Sort by language-bn title */
  titleBn = 'title_bn',
  /** Sort by language-bs title */
  titleBs = 'title_bs',
  /** Sort by language-ca title */
  titleCa = 'title_ca',
  /** Sort by language-cs title */
  titleCs = 'title_cs',
  /** Sort by language-da title */
  titleDa = 'title_da',
  /** Sort by language-de title */
  titleDe = 'title_de',
  /** Sort by language-el title */
  titleEl = 'title_el',
  /** Sort by language-en title */
  titleEn = 'title_en',
  /** Sort by language-es title */
  titleEs = 'title_es',
  /** Sort by language-et title */
  titleEt = 'title_et',
  /** Sort by language-eu title */
  titleEu = 'title_eu',
  /** Sort by language-fa title */
  titleFa = 'title_fa',
  /** Sort by language-fi title */
  titleFi = 'title_fi',
  /** Sort by language-fr title */
  titleFr = 'title_fr',
  /** Sort by language-ga title */
  titleGa = 'title_ga',
  /** Sort by language-he title */
  titleHe = 'title_he',
  /** Sort by language-hi title */
  titleHi = 'title_hi',
  /** Sort by language-hr title */
  titleHr = 'title_hr',
  /** Sort by language-hu title */
  titleHu = 'title_hu',
  /** Sort by language-hy title */
  titleHy = 'title_hy',
  /** Sort by language-id title */
  titleId = 'title_id',
  /** Sort by language-is title */
  titleIs = 'title_is',
  /** Sort by language-it title */
  titleIt = 'title_it',
  /** Sort by language-ja title */
  titleJa = 'title_ja',
  /** Sort by language-kk title */
  titleKk = 'title_kk',
  /** Sort by language-ko title */
  titleKo = 'title_ko',
  /** Sort by language-ku title */
  titleKu = 'title_ku',
  /** Sort by language-lt title */
  titleLt = 'title_lt',
  /** Sort by language-lv title */
  titleLv = 'title_lv',
  /** Sort by language-mk title */
  titleMk = 'title_mk',
  /** Sort by language-ms title */
  titleMs = 'title_ms',
  /** Sort by language-mt title */
  titleMt = 'title_mt',
  /** Sort by language-nb title */
  titleNb = 'title_nb',
  /** Sort by language-nl title */
  titleNl = 'title_nl',
  /** Sort by language-no title */
  titleNo = 'title_no',
  /** Sort by language-pb title */
  titlePb = 'title_pb',
  /** Sort by language-pl title */
  titlePl = 'title_pl',
  /** Sort by language-pt title */
  titlePt = 'title_pt',
  /** Sort by language-ro title */
  titleRo = 'title_ro',
  /** Sort by language-ru title */
  titleRu = 'title_ru',
  /** Sort by language-sk title */
  titleSk = 'title_sk',
  /** Sort by language-sl title */
  titleSl = 'title_sl',
  /** Sort by language-sq title */
  titleSq = 'title_sq',
  /** Sort by language-sr title */
  titleSr = 'title_sr',
  /** Sort by language-sv title */
  titleSv = 'title_sv',
  /** Sort by language-th title */
  titleTh = 'title_th',
  /** Sort by language-tr title */
  titleTr = 'title_tr',
  /** Sort by language-uk title */
  titleUk = 'title_uk',
  /** Sort by language-vi title */
  titleVi = 'title_vi',
  /** Sort by language-zh title */
  titleZh = 'title_zh'
}

/** Length limited text from the datafield definition for use e.g. in result lists, previews, etc. */
export type DatafieldDefinitionTeasers = {
  __typename?: 'DatafieldDefinitionTeasers';
  /**
   * The datafield definition's title limited to `length` characters.
   * Preferred language and the precedence of fallback languages can be specified via `acceptedLanguages`.
   */
  title?: Maybe<Scalars['String']>;
};


/** Length limited text from the datafield definition for use e.g. in result lists, previews, etc. */
export type DatafieldDefinitionTeasersTitleArgs = {
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard>>;
  length?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Length unlimited text from the metadata definition value for use e.g. in result lists, previews, etc. */
export type DatafieldLocalizations = {
  __typename?: 'DatafieldLocalizations';
  /**
   * The value's title.
   * Preferred language and the precedence of fallback languages can be specified via `acceptedLanguages`.
   */
  title?: Maybe<Scalars['String']>;
};


/** Length unlimited text from the metadata definition value for use e.g. in result lists, previews, etc. */
export type DatafieldLocalizationsTitleArgs = {
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard>>;
};

/** Length limited text from the indexed field definition value for use e.g. in result lists, previews, etc. */
export type DatafieldTeasers = {
  __typename?: 'DatafieldTeasers';
  /**
   * The value's title limited to `length` characters.
   * Preferred language and the precedence of fallback languages can be specified via `acceptedLanguages`.
   */
  title?: Maybe<Scalars['String']>;
};


/** Length limited text from the indexed field definition value for use e.g. in result lists, previews, etc. */
export type DatafieldTeasersTitleArgs = {
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard>>;
  length?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://schematic-graph.qit-schematic.svc.cluster.local:8443** */
export type DatafieldTermsAggregation = {
  __typename?: 'DatafieldTermsAggregation';
  /** No field definitions exist. As soon as the first field definition is defined, it's automatically listed here. */
  not_applicable_as_no_field_definitions_exist?: Maybe<Scalars['NoDynamicValueDefined']>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export enum DatafieldType {
  field = 'field',
  metadata = 'metadata'
}

/** Length limited text from a defined datafield value for use e.g. in result lists, previews, etc. */
export type DatafieldValueTeasers = {
  __typename?: 'DatafieldValueTeasers';
  /**
   * The value's title limited to `length` characters.
   * Preferred language and the precedence of fallback languages can be specified via `acceptedLanguages`.
   */
  title?: Maybe<Scalars['String']>;
};


/** Length limited text from a defined datafield value for use e.g. in result lists, previews, etc. */
export type DatafieldValueTeasersTitleArgs = {
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard>>;
  length?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type Datafields = {
  __typename?: 'Datafields';
  /** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
  activity?: Maybe<Array<Datafield>>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  article?: Maybe<Array<Datafield>>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  asset?: Maybe<Array<Datafield>>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  assetOption?: Maybe<Array<Datafield>>;
  /** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
  contentMap?: Maybe<Array<Datafield>>;
  /** Ignore this field */
  dummy?: Maybe<Scalars['Boolean']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  mechanic?: Maybe<Array<Datafield>>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  product?: Maybe<Array<Datafield>>;
  /** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
  topic?: Maybe<Array<Datafield>>;
};

/** Defines a date field */
export type DateDatafieldDefinition = DatafieldDefinition & {
  __typename?: 'DateDatafieldDefinition';
  /** Type of this indexed field definition */
  fieldType?: Maybe<FieldDefinitionTypes>;
  /**
   * Unique identifier of this indexed field definition.
   * Is used as field name in all interfaces and must adhere to the
   * following pattern: ^[_A-Za-z][_0-9A-Za-z]{0,128}$
   */
  id: Scalars['DatafieldDefinitionID'];
  /** Text from the datafield definition for use e.g. in detail views, etc */
  localizations?: Maybe<DatafieldDefinitionLocalizations>;
  /** Field names which shall be mapped to this indexed field definition */
  mappedNames?: Maybe<Array<Scalars['String']>>;
  /** List of all objectTypes this definition is assigned to */
  objectTypes?: Maybe<Array<Maybe<ObjectType>>>;
  /** Length limited text from the indexed field definition for use e.g. in result lists, previews, etc. */
  teasers?: Maybe<DatafieldDefinitionTeasers>;
  /** Human readable description of this indexed field definition */
  title?: Maybe<MultilingualString>;
};

/** Sub Graph: **https://data-filter-graph.qit-data-filter.svc.cluster.local:8443** */
export type DateFacetDefinition = FacetDefinition & {
  __typename?: 'DateFacetDefinition';
  /** The datafield type of the field */
  fieldType: FieldDefinitionTypes;
};

/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type DateInclusiveRange = {
  __typename?: 'DateInclusiveRange';
  /** Greater than or equal to */
  gte?: Maybe<Scalars['DateTime']>;
  /** Less than or equal to */
  lte?: Maybe<Scalars['DateTime']>;
};

/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type DateOffset = {
  /** Amount of `unit` to offset. May be positive or negative. */
  amount: Scalars['Int'];
  /** Unit to offset */
  unit: DateOffsetUnit;
};

/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export enum DateOffsetUnit {
  days = 'days',
  hours = 'hours',
  minutes = 'minutes',
  months = 'months',
  seconds = 'seconds',
  weeks = 'weeks',
  years = 'years'
}

/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type DateRange = {
  /** Greater than */
  gt?: InputMaybe<DateSpec>;
  /** Greater than or equal to */
  gte?: InputMaybe<DateSpec>;
  /** Less than */
  lt?: InputMaybe<DateSpec>;
  /** Less than or equal to */
  lte?: InputMaybe<DateSpec>;
};

/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type DateSpec = {
  /** Anchor date for the date spec. If no date is provided defaults to <now>. */
  date?: InputMaybe<Scalars['DateTime']>;
  /** Zero or more date offsets relative to the anchor date. */
  offset?: InputMaybe<Array<InputMaybe<DateOffset>>>;
  /** Specifies if the resulting date should be rounded down to the nearest day. */
  roundDownToNearestDay?: InputMaybe<Scalars['Boolean']>;
};

/** Defines a date time field */
export type DateTimeDatafieldDefinition = DatafieldDefinition & {
  __typename?: 'DateTimeDatafieldDefinition';
  /** Type of this indexed field definition */
  fieldType?: Maybe<FieldDefinitionTypes>;
  /**
   * Unique identifier of this indexed field definition.
   * Is used as field name in all interfaces and must adhere to the
   * following pattern: ^[_A-Za-z][_0-9A-Za-z]{0,128}$
   */
  id: Scalars['DatafieldDefinitionID'];
  /** Text from the datafield definition for use e.g. in detail views, etc */
  localizations?: Maybe<DatafieldDefinitionLocalizations>;
  /** Field names which shall be mapped to this indexed field definition */
  mappedNames?: Maybe<Array<Scalars['String']>>;
  /** List of all objectTypes this definition is assigned to */
  objectTypes?: Maybe<Array<Maybe<ObjectType>>>;
  /** Length limited text from the indexed field definition for use e.g. in result lists, previews, etc. */
  teasers?: Maybe<DatafieldDefinitionTeasers>;
  /** Human readable description of this indexed field definition */
  title?: Maybe<MultilingualString>;
};

/** Sub Graph: **https://data-filter-graph.qit-data-filter.svc.cluster.local:8443** */
export type DateTimeFacetDefinition = FacetDefinition & {
  __typename?: 'DateTimeFacetDefinition';
  /** The datafield type of the field */
  fieldType: FieldDefinitionTypes;
};

/** Defines a date time datafield field */
export type DateTimeRangeDatafieldDefinition = DatafieldDefinition & {
  __typename?: 'DateTimeRangeDatafieldDefinition';
  /** Type of this datafield definition */
  fieldType?: Maybe<FieldDefinitionTypes>;
  /**
   * Unique identifier of this datafield definition.
   * Is used as field name in all interfaces and must adhere to the
   * following pattern: ^[_A-Za-z][_0-9A-Za-z]{0,128}$
   */
  id: Scalars['DatafieldDefinitionID'];
  /** Text from the datafield definition for use e.g. in detail views, etc */
  localizations?: Maybe<DatafieldDefinitionLocalizations>;
  /** Datafield names which shall be mapped to this datafield definition */
  mappedNames?: Maybe<Array<Scalars['String']>>;
  /** List of all objectTypes this definition is assigned to */
  objectTypes?: Maybe<Array<Maybe<ObjectType>>>;
  /** Length limited text from the datafield definition for use e.g. in result lists, previews, etc. */
  teasers?: Maybe<DatafieldDefinitionTeasers>;
  /** Human readable description of this datafield definition */
  title?: Maybe<MultilingualString>;
};

/** Sub Graph: **https://data-filter-graph.qit-data-filter.svc.cluster.local:8443** */
export type DateTimeRangeFacetDefinition = FacetDefinition & {
  __typename?: 'DateTimeRangeFacetDefinition';
  /** The datafield type of the field */
  fieldType: FieldDefinitionTypes;
};

/**
 * Defines a enum datafield.
 * An enum datafield is a string field restricted to a fixed set of values.
 */
export type EnumDatafieldDefinition = DatafieldDefinition & {
  __typename?: 'EnumDatafieldDefinition';
  /** Type of this indexed field definition */
  fieldType?: Maybe<FieldDefinitionTypes>;
  /**
   * Unique identifier of this indexed field definition.
   * Is used as field name in all interfaces and must adhere to the
   * following pattern: ^[_A-Za-z][_0-9A-Za-z]{0,128}$
   */
  id: Scalars['DatafieldDefinitionID'];
  /** Text from the datafield definition for use e.g. in detail views, etc */
  localizations?: Maybe<DatafieldDefinitionLocalizations>;
  /** Datafield names which shall be mapped to this indexed field definition */
  mappedNames?: Maybe<Array<Scalars['String']>>;
  /** List of all objectTypes this definition is assigned to */
  objectTypes?: Maybe<Array<Maybe<ObjectType>>>;
  /** Length limited text from the indexed field definition for use e.g. in result lists, previews, etc. */
  teasers?: Maybe<DatafieldDefinitionTeasers>;
  /** Human readable description of this indexed field definition */
  title?: Maybe<MultilingualString>;
  /** List of valid values */
  values?: Maybe<Array<EnumValue>>;
};

/** Sub Graph: **https://data-filter-graph.qit-data-filter.svc.cluster.local:8443** */
export type EnumFacetDefinition = FacetDefinition & {
  __typename?: 'EnumFacetDefinition';
  /** The datafield type of the field */
  fieldType: FieldDefinitionTypes;
  /** The values the field represented by this facet may have */
  values?: Maybe<Array<EnumValue>>;
};

/** Valid value for an enum */
export type EnumValue = {
  __typename?: 'EnumValue';
  /**
   * Data value
   * Must be unique within the enum
   */
  key: Scalars['String'];
  /** Length limited text from the enum value for use e.g. in result lists, previews, etc. */
  teasers?: Maybe<DatafieldValueTeasers>;
  /** Human readable name */
  title?: Maybe<MultilingualString>;
};

/** Sub Graph: **https://data-filter-graph.qit-data-filter.svc.cluster.local:8443** */
export type Facet = {
  /** The facets definition */
  definition?: Maybe<FacetDefinition>;
  /** Details about how the facet should be displayed by a frontend component */
  display: FacetDisplay;
  /** The unique id of the facet */
  id: Scalars['ID'];
  /**
   * Kind of facet, e.g. is it a filter or navigation facet.
   * The value isn't interpreted by the API. The frontend component(s) are responsible
   * for the value stored.
   */
  kind: Scalars['String'];
  /** The id of the field, indexed field definition etc. referenced by this facet */
  referencedId: Scalars['ID'];
  /** Length limited text */
  teasers?: Maybe<FacetTeasers>;
  /** The title of the facet. */
  title?: Maybe<MultilingualString>;
  /** The type of the facet */
  type: DatafieldType;
};

/** Sub Graph: **https://data-filter-graph.qit-data-filter.svc.cluster.local:8443** */
export type FacetDatafieldAutocompleteEdge = AutocompleteEdge & {
  __typename?: 'FacetDatafieldAutocompleteEdge';
  /** The full datafield definition */
  datafieldDefinition?: Maybe<DatafieldDefinition>;
  /**
   * Id of the datafield definition in which the value was found
   * This value can be used as field name content query filters
   */
  datafieldDefinitionId: Scalars['DatafieldDefinitionID'];
  /** Display text for this autocomplete hit */
  displayName: Scalars['String'];
  /** The filter selection. */
  filterSelection?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Language which this hit is based on
   * Is only returned if an exact language assignment can be made
   */
  language?: Maybe<Language>;
  /**
   * Unique value of the datafield definition value
   * This value can be used as operand in content query filters
   */
  value: Scalars['String'];
};

/** Sub Graph: **https://data-filter-graph.qit-data-filter.svc.cluster.local:8443** */
export type FacetDatafieldAutocompleteFilter = {
  /**
   * Filter selections to search in
   * Only active datafield definitions are considered
   */
  filterSelection: Array<Scalars['String']>;
  /**
   * Languages to search in (if applicable for the datafield definition).
   * The order of languages specifies their precedence.
   */
  languages: Array<Language>;
  /**
   * String to search for
   * The provided query is executed as a prefix search
   * Fulltext features like wildcards, fuzzy search, etc. aren't supported
   */
  query: Scalars['String'];
};

/** Sub Graph: **https://data-filter-graph.qit-data-filter.svc.cluster.local:8443** */
export type FacetDatafieldAutocompleteResult = {
  __typename?: 'FacetDatafieldAutocompleteResult';
  /** The search results */
  hits: Array<FacetDatafieldAutocompleteEdge>;
  /**
   * The search string which produced this result
   * Can be used by clients to correlate queries and responses
   */
  query: Scalars['String'];
};

/** Sub Graph: **https://data-filter-graph.qit-data-filter.svc.cluster.local:8443** */
export type FacetDefinition = {
  /** The datafield type of the field */
  fieldType: FieldDefinitionTypes;
};

/** Sub Graph: **https://data-filter-graph.qit-data-filter.svc.cluster.local:8443** */
export type FacetDisplay = {
  __typename?: 'FacetDisplay';
  /**
   * Display options for the facet.
   * The value isn't interpreted by the API. The frontend component(s) are responsible
   * for the value stored.
   */
  options?: Maybe<Scalars['JSONObject']>;
  /**
   * Display type for the facet.
   * The value isn't interpreted by the API. The frontend component(s) are responsible
   * for the value stored.
   */
  type: Scalars['String'];
};

/** Length limited text from the facet for use e.g. in result lists, previews, etc. */
export type FacetTeasers = {
  __typename?: 'FacetTeasers';
  /**
   * The facets title limited to `length` characters.
   * Preferred language and the precedence of fallback languages can be specified via `acceptedLanguages`.
   * For further information about the titel see `Facet`'s title attribute.
   */
  title?: Maybe<Scalars['String']>;
};


/** Length limited text from the facet for use e.g. in result lists, previews, etc. */
export type FacetTeasersTitleArgs = {
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard>>;
  length?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://data-filter-graph.qit-data-filter.svc.cluster.local:8443** */
export type FacetsCollection = {
  __typename?: 'FacetsCollection';
  /**
   * Ordered facets of the collection.
   * The order is specified by the order of the array.
   */
  facets?: Maybe<Array<Maybe<Facet>>>;
  /** The unique id of the facets collection */
  id: Scalars['ID'];
};


/** Sub Graph: **https://data-filter-graph.qit-data-filter.svc.cluster.local:8443** */
export type FacetsCollectionFacetsArgs = {
  referencedIds?: InputMaybe<Array<Scalars['String']>>;
};

/** Sub Graph: **https://shops-config-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type FdiShopConfig = {
  __typename?: 'FdiShopConfig';
  /** Sub Graph: **https://shops-config-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  baseUrl?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://shops-config-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  id: Scalars['ID'];
  /** Sub Graph: **https://shops-config-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  shopServiceUrl?: Maybe<Scalars['String']>;
};

/** Sub Graph: **https://data-filter-graph.qit-data-filter.svc.cluster.local:8443** */
export type Feature = {
  __typename?: 'Feature';
  /** The unique id of the feature */
  id: Scalars['ID'];
};

/** Sub Graph: **https://schematic-graph.qit-schematic.svc.cluster.local:8443** */
export enum FieldDefinitionTypes {
  boolean = 'boolean',
  date = 'date',
  dateTime = 'dateTime',
  dateTimeRange = 'dateTimeRange',
  enum = 'enum',
  keyword = 'keyword',
  number = 'number',
  numberRange = 'numberRange',
  taxonomy = 'taxonomy',
  text = 'text'
}

/** Sub Graph: **https://data-filter-graph.qit-data-filter.svc.cluster.local:8443** */
export type FieldFacet = Facet & {
  __typename?: 'FieldFacet';
  /** The facets definition */
  definition?: Maybe<FacetDefinition>;
  /** Details about how the facet should be displayed by a frontend component */
  display: FacetDisplay;
  /** The unique id of the facet */
  id: Scalars['ID'];
  /**
   * Kind of facet, e.g. is it a filter or navigation facet.
   * The value isn't interpreted by the API. The frontend component(s) are responsible
   * for the value stored.
   */
  kind: Scalars['String'];
  /** The id of the field, indexed field definition etc. referenced by this facet */
  referencedId: Scalars['ID'];
  /** Length limited text */
  teasers?: Maybe<FacetTeasers>;
  /** The title of the facet. */
  title?: Maybe<MultilingualString>;
  /** The type of the facet */
  type: DatafieldType;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type File = {
  /** Date and time when it was created */
  creationDate?: Maybe<Scalars['DateTime']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  file: BlobRef;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  id: Scalars['ID'];
  /** Date and time of the last modification */
  modificationDate?: Maybe<Scalars['DateTime']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  objectId: Scalars['String'];
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  objectSubType?: Maybe<FileSubType>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  objectType?: Maybe<FileType>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type FileEdge = {
  __typename?: 'FileEdge';
  /** Unique cursor for pagination. See the query's `after` argument */
  cursor: Scalars['String'];
  /** The result's file. */
  node: File;
  /** Calculated relevance score. */
  score: Scalars['NonNegativeFloat'];
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type FileEqualsValueFilter = {
  /** Returns only with the specified creation date */
  creationDate?: InputMaybe<Scalars['DateTime']>;
  /** Returns only with the specified modification date */
  modificationDate?: InputMaybe<Scalars['DateTime']>;
  /** Returns only files with the specified text */
  objectId?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  objectType?: InputMaybe<FileType>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export enum FileExistsValueFields {
  /** Returns only files which have a text specified */
  objectId = 'objectId'
}

/**
 * The `FileFilter` is used to specify filter criteria for files.
 * If you specify more than one criterion, all criteria are grouped together and connected with a logical AND operator.
 * Further logical operations are possible by using `not` `andGroup` and `orGroup`.
 */
export type FileFilter = {
  /** Returns all files if set to true */
  all?: InputMaybe<Scalars['Boolean']>;
  /** Allows the specification of further filter criteria, which are grouped together and connected with a logical AND operator */
  andGroup?: InputMaybe<Array<InputMaybe<FileFilter>>>;
  /** Boosts the score of all matches in this group by the specified factor. Heads up: The resulting score boost isn't mathematically exact due to rounding errors */
  boost?: InputMaybe<Scalars['Float']>;
  /** Returns files that contain all of the exact values specified */
  equals?: InputMaybe<FileEqualsValueFilter>;
  /**
   * Returns files that have a value in all of the specified fields
   * @deprecated Please use 'has' filter instead
   */
  exists?: InputMaybe<Array<InputMaybe<FileExistsValueFields>>>;
  /** Returns files that have a value in all of the specified fields */
  has?: InputMaybe<FileHasValueFilter>;
  /** Returns files with one of the specified unique identifiers */
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Allows you to specify logically negated filter criteria */
  not?: InputMaybe<FileFilter>;
  /** Allows the specification of further filter criteria, which are grouped together and connected with a logical OR operator */
  orGroup?: InputMaybe<Array<InputMaybe<FileFilter>>>;
  /** Returns files with values within all of the ranges specified */
  range?: InputMaybe<ProductRangeFilter>;
  /** Returns files that match all of the regular expressions */
  regex?: InputMaybe<FileRegexFilter>;
};

/** Returns files that have a value in all of the specified fields */
export type FileHasValueFilter = {
  /** Specify the fields that the returned files must have a value in */
  valueInFields?: InputMaybe<Array<InputMaybe<FileHasValueInFields>>>;
};

/** Specify the fields that the returned files must have a value in */
export enum FileHasValueInFields {
  /** Returns only files which have a text specified */
  objectId = 'objectId'
}

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type FileQueryResult = {
  __typename?: 'FileQueryResult';
  /**
   * The query's matching files.
   *
   * Use the `sort` argument to specify the list of fields and the order by which the results should be sorted.
   * Multiple fields and orders may be specified and are evaluated in the provided order.
   *
   * To limit the number of results, set the `first` argument.
   *
   * Pagination is possible by setting the `after` argument to the previous last result's `cursor` field value.
   * Please be careful not to change the query's `filter` or the `sort` argument between paginated calls.
   */
  files: Array<Maybe<FileEdge>>;
  /**
   * Returns the total count of results.
   *
   * Use the `trackLimit` argument to limit the track of the total count up to the specified amount.
   * If the result has more hits than the specified limit the total count is inaccurate.
   * See `CountRelation` for further information on how to interpret the result.
   *
   * Heads up: Setting the `trackLimit` to a high value may decrease performance.
   */
  total: TotalCount;
};


/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type FileQueryResultFilesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  sort?: InputMaybe<Array<InputMaybe<FileSort>>>;
};


/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type FileQueryResultTotalArgs = {
  trackLimit?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type FileRegexFilter = {
  /** Returns files with one of the specified unique identifiers */
  id?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only files whose text matches the specified Regex */
  objectId?: InputMaybe<Scalars['FilterRegex']>;
};

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type FileSchematicWithHotspots = File & {
  __typename?: 'FileSchematicWithHotspots';
  /** Date and time when it was created */
  creationDate?: Maybe<Scalars['DateTime']>;
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  file: BlobRef;
  /** Hotspots with schematic-specific fields (decimal coords, itemType, itemId) */
  hotspots?: Maybe<Array<Maybe<HotspotSchematic>>>;
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  id: Scalars['ID'];
  /** Date and time of the last modification */
  modificationDate?: Maybe<Scalars['DateTime']>;
  /** Optional schematic sheet name/title */
  name?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  objectId: Scalars['String'];
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  objectSubType?: Maybe<FileSubType>;
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  objectType?: Maybe<FileType>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type FileSort = {
  /** Sort field */
  field: FileSortFields;
  /** Sort order */
  order?: InputMaybe<SortOrder>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export enum FileSortFields {
  /** Sort by creation date */
  creationDate = 'creationDate',
  /** Sort by unique ID */
  id = 'id',
  /** Sort by modification date */
  modificationDate = 'modificationDate',
  /** Sort by objectId */
  objectId = 'objectId',
  /** Sort by objectType */
  objectType = 'objectType',
  /** Sort by relevance score */
  score = 'score'
}

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export enum FileSubType {
  bmp = 'BMP',
  glb = 'GLB',
  hoopsScs = 'HOOPS_SCS',
  html = 'HTML',
  jpg = 'JPG',
  json = 'JSON',
  latticeXvl = 'LATTICE_XVL',
  /** A file type where a subtype does not make sense */
  none = 'NONE',
  pdf = 'PDF',
  png = 'PNG',
  svg = 'SVG',
  text = 'TEXT',
  /** A file type where the subtype is currently not determined */
  unknown = 'UNKNOWN'
}

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type FileSvgWithHotspots = File & {
  __typename?: 'FileSvgWithHotspots';
  /** Date and time when it was created */
  creationDate?: Maybe<Scalars['DateTime']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  file: BlobRef;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  hotspots?: Maybe<Array<Maybe<HotspotSvg>>>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  id: Scalars['ID'];
  /** Date and time of the last modification */
  modificationDate?: Maybe<Scalars['DateTime']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  objectId: Scalars['String'];
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  objectSubType?: Maybe<FileSubType>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  objectType?: Maybe<FileType>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export enum FileType {
  document = 'DOCUMENT',
  image_2D = 'IMAGE_2D',
  image_3D = 'IMAGE_3D',
  imagePlain = 'IMAGE_PLAIN',
  previewImage = 'PREVIEW_IMAGE'
}

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type FileWithHotspots = File & {
  __typename?: 'FileWithHotspots';
  /** Date and time when it was created */
  creationDate?: Maybe<Scalars['DateTime']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  file: BlobRef;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  hotspots?: Maybe<Array<Maybe<Hotspot>>>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  id: Scalars['ID'];
  /** Date and time of the last modification */
  modificationDate?: Maybe<Scalars['DateTime']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  objectId: Scalars['String'];
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  objectSubType?: Maybe<FileSubType>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  objectType?: Maybe<FileType>;
};

/** Sub Graph: **https://webhooks-graph.qit-webhooks.svc.cluster.local:8443** */
export enum FullTextOperator {
  /** Contents must contain all of the query's words */
  and = 'AND',
  /** Contents must contain only one of the query's words */
  or = 'OR'
}

/** Sub Graph: **https://webhooks-graph.qit-webhooks.svc.cluster.local:8443** */
export enum FullTextSearchType {
  /** Finds contents which match any field, but uses the score from the best field */
  bestFields = 'best_fields',
  /** Finds contents which match any field and combines the score from each field */
  mostFields = 'most_fields',
  /** Returns contents that contain the words of a provided text, in the same order as provided. */
  phrase = 'phrase',
  /** Returns contents that match all terms in the provided text except the last term. The last term is used as a prefix search */
  prefix = 'prefix'
}

/** Sub Graph: **https://shops-config-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type GenericShopConfig = {
  __typename?: 'GenericShopConfig';
  /** GraphQL endpoint URL of the external generic shop middleware */
  graphqlUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  shopServiceUrl?: Maybe<Scalars['String']>;
};

/** A gui element that can be added to extend the UI. */
export type GuiElement = {
  __typename?: 'GuiElement';
  /** Arbitrary configuration object for the gui element */
  config: Scalars['JSONObject'];
  /** Unique identifier for the gui element */
  id: Scalars['ID'];
};

/** A group of gui elements by type. */
export type GuiElementGroup = {
  __typename?: 'GuiElementGroup';
  /** Array of gui elements for this type */
  elements: Array<GuiElement>;
  /** The type of gui elements in this group (e.g., 'view', 'card', 'menu') */
  type: Scalars['String'];
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type Hotspot = {
  __typename?: 'Hotspot';
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  linkType?: Maybe<HotspotLinkType>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  linkValue?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  x1?: Maybe<Scalars['Int']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  x2?: Maybe<Scalars['Int']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  y1?: Maybe<Scalars['Int']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  y2?: Maybe<Scalars['Int']>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export enum HotspotLinkType {
  /** Refers to another assembly (no reference to the current parts list) */
  g = 'G',
  /** Refers to data field in parts list */
  n = 'N'
}

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type HotspotSchematic = {
  __typename?: 'HotspotSchematic';
  /** Hotspot ID from EPLAN XML */
  hotspotId?: Maybe<Scalars['String']>;
  /** EPLAN item ID */
  itemId?: Maybe<Scalars['String']>;
  /** EPLAN item type (e.g. '', 'I', 'A', 'X', 'W', 'C', 'P') */
  itemType?: Maybe<Scalars['String']>;
  /** X1 coordinate (decimal percentage) */
  x1?: Maybe<Scalars['Float']>;
  /** X2 coordinate (decimal percentage) */
  x2?: Maybe<Scalars['Float']>;
  /** Y1 coordinate (decimal percentage) */
  y1?: Maybe<Scalars['Float']>;
  /** Y2 coordinate (decimal percentage) */
  y2?: Maybe<Scalars['Float']>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type HotspotSvg = {
  __typename?: 'HotspotSvg';
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  linkText?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  linkType?: Maybe<HotspotLinkType>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  linkValue?: Maybe<Scalars['String']>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type Image3dFile = File & {
  __typename?: 'Image3dFile';
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  binaryFile?: Maybe<BlobRef>;
  /** Date and time when it was created */
  creationDate?: Maybe<Scalars['DateTime']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  file: BlobRef;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  id: Scalars['ID'];
  /** Date and time of the last modification */
  modificationDate?: Maybe<Scalars['DateTime']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  objectId: Scalars['String'];
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  objectSubType?: Maybe<FileSubType>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  objectType?: Maybe<FileType>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type InherentDatafield = Datafield & {
  __typename?: 'InherentDatafield';
  /**
   * The full indexed field definition
   * @deprecated This API may change in future releases
   */
  datafieldDefinition?: Maybe<DatafieldDefinition>;
  /** The entries meta type */
  fieldType: FieldDefinitionTypes;
  /** Length unlimited text for the entry for use e.g. in result lists, previews, etc. */
  localizations?: Maybe<DatafieldLocalizations>;
  /** The referenced field name */
  referencedId: Scalars['ID'];
  /** Length limited text for the indexed field definition for use e.g. in result lists, previews, etc. */
  teasers?: Maybe<DatafieldTeasers>;
  /** The title of the indexed field definition */
  title?: Maybe<MultilingualString>;
  /** The entries type */
  type: DatafieldType;
};

/** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
export type Insight = {
  __typename?: 'Insight';
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  content: Scalars['String'];
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  context?: Maybe<InsightsConversationContext>;
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  role: InsightsRole;
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  timestamp?: Maybe<Scalars['String']>;
};

/** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
export type InsightSelector = {
  __typename?: 'InsightSelector';
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  range?: Maybe<InsightSelectorRange>;
};

/** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
export type InsightSelectorRange = {
  __typename?: 'InsightSelectorRange';
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  end?: Maybe<InsightSelectorRangeConformity>;
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  start?: Maybe<InsightSelectorRangeConformity>;
};

/** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
export type InsightSelectorRangeConformity = {
  __typename?: 'InsightSelectorRangeConformity';
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  conformsTo?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  value?: Maybe<Scalars['String']>;
};

/** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
export type InsightsConversationContext = {
  __typename?: 'InsightsConversationContext';
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  meta?: Maybe<InsightsConversationMetaContext>;
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  object?: Maybe<InsightsConversationObjectContext>;
};

/** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
export type InsightsConversationMetaContext = {
  __typename?: 'InsightsConversationMetaContext';
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  items?: Maybe<Array<Maybe<InsightsConversationMetaContextItem>>>;
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  pagination?: Maybe<InsightsPagination>;
};

/** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
export type InsightsConversationMetaContextItem = {
  __typename?: 'InsightsConversationMetaContextItem';
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  uri: Scalars['String'];
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  value: Scalars['String'];
};

/** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
export type InsightsConversationObjectContext = {
  __typename?: 'InsightsConversationObjectContext';
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  items?: Maybe<Array<Maybe<InsightsConversationObjectContextItem>>>;
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  pagination?: Maybe<InsightsPagination>;
};

/** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
export type InsightsConversationObjectContextItem = {
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  id: Scalars['ID'];
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  label: Scalars['String'];
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  match?: Maybe<InsightsConversationObjectContextItemNode>;
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  selector?: Maybe<InsightSelector>;
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  text?: Maybe<Scalars['String']>;
};

/** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
export type InsightsConversationObjectContextItemNode = Topic;

/** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
export type InsightsConversationObjectContextTopicItem = InsightsConversationObjectContextItem & {
  __typename?: 'InsightsConversationObjectContextTopicItem';
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  id: Scalars['ID'];
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  label: Scalars['String'];
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  match?: Maybe<Topic>;
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  selector?: Maybe<InsightSelector>;
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  text?: Maybe<Scalars['String']>;
};

/** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
export type InsightsEdge = {
  __typename?: 'InsightsEdge';
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  node: Insight;
};

/** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
export type InsightsPagination = {
  __typename?: 'InsightsPagination';
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  page?: Maybe<Scalars['NonNegativeInt']>;
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  pageCount?: Maybe<Scalars['NonNegativeInt']>;
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  pageSize?: Maybe<Scalars['NonNegativeInt']>;
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  total?: Maybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
export type InsightsQueryResult = {
  __typename?: 'InsightsQueryResult';
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  insights: Array<Maybe<InsightsEdge>>;
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  total: TotalCount;
};


/** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
export type InsightsQueryResultInsightsArgs = {
  after?: InputMaybe<Scalars['NonNegativeInt']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
export enum InsightsRole {
  system = 'system',
  user = 'user'
}

/** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
export type InsightsSearchInput = {
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  conversationId?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  language?: InputMaybe<Language>;
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  meta?: InputMaybe<Array<InputMaybe<InsightsSearchMetaInput>>>;
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  query: Scalars['String'];
};

/** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
export type InsightsSearchMetaInput = {
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  uri: Scalars['String'];
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  value: Scalars['String'];
};

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type Item = {
  __typename?: 'Item';
  /** Date and time when it was created */
  creationDate?: Maybe<Scalars['DateTime']>;
  /** Description (bilingual from translations) */
  description?: Maybe<MultilingualString>;
  /** Unique identifier for this item (format: itemId_type, e.g., '1_', '840_I', '3000_P') */
  id: Scalars['ID'];
  /** Whether this is a sub-item */
  isSubItem?: Maybe<Scalars['Boolean']>;
  /** Item identifier from the XML */
  itemId: Scalars['String'];
  /** Localizations for detail views */
  localizations?: Maybe<ItemLocalizations>;
  /** Main hotspot ID linking to sheet hotspot */
  mainHotspotId?: Maybe<Scalars['String']>;
  /** Main sheet ID where this item appears */
  mainSheet?: Maybe<Scalars['String']>;
  /** Date and time of the last modification */
  modificationDate?: Maybe<Scalars['DateTime']>;
  /** Full name/designation of the item */
  name?: Maybe<Scalars['String']>;
  /** Node caption (language-neutral short label) */
  nodecaption?: Maybe<Scalars['String']>;
  /** Parent item identifier for hierarchy navigation */
  parentItemId: Scalars['String'];
  /** Schematic document ID this item belongs to */
  schematicId: Scalars['String'];
  /** Teasers for list views */
  teasers?: Maybe<ItemTeasers>;
  /** Title (derived from nodecaption for both languages) */
  title?: Maybe<MultilingualString>;
  /** Item type: '' (root/assembly), 'I' (component), 'P' (connection point) */
  type: Scalars['String'];
};

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type ItemDatafieldAggregations = {
  __typename?: 'ItemDatafieldAggregations';
  /** Provides composite aggregations with pagination support */
  composite?: Maybe<ItemDatafieldCompositeAggregation>;
  /**
   * Provides terms aggregations for custom datafields.
   * Supports prefix search and the results are ordered by count.
   */
  terms?: Maybe<DatafieldTermsAggregation>;
};

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type ItemDatafieldCompositeAggregation = {
  __typename?: 'ItemDatafieldCompositeAggregation';
  /** Aggregation by schematic ID */
  schematicId?: Maybe<Array<AggregationEdge>>;
  /** Aggregation by item type */
  type?: Maybe<Array<AggregationEdge>>;
};


/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type ItemDatafieldCompositeAggregationSchematicIdArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
};


/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type ItemDatafieldCompositeAggregationTypeArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type ItemEdge = {
  __typename?: 'ItemEdge';
  /** Unique cursor for pagination. See the query's `after` argument */
  cursor: Scalars['String'];
  /** The result's item */
  node: Item;
  /** Calculated relevance score */
  score: Scalars['NonNegativeFloat'];
};

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type ItemEqualsValueFilter = {
  /** Returns only items with the specified creation date */
  creationDate?: InputMaybe<Scalars['DateTime']>;
  /** Returns only items which are sub-items */
  isSubItem?: InputMaybe<Scalars['Boolean']>;
  /** Returns only items with the specified item ID */
  itemId?: InputMaybe<Scalars['String']>;
  /** Returns only items with the specified main hotspot ID */
  mainHotspotId?: InputMaybe<Scalars['String']>;
  /** Returns only items with the specified main sheet */
  mainSheet?: InputMaybe<Scalars['String']>;
  /** Returns only items with the specified modification date */
  modificationDate?: InputMaybe<Scalars['DateTime']>;
  /** Returns only items with the specified name */
  name?: InputMaybe<Scalars['String']>;
  /** Returns only items with the specified node caption */
  nodecaption?: InputMaybe<Scalars['String']>;
  /** Returns only items with the specified parent item ID */
  parentItemId?: InputMaybe<Scalars['String']>;
  /** Returns only items with the specified schematic ID */
  schematicId?: InputMaybe<Scalars['String']>;
  /** Returns only items with the specified title */
  title?: InputMaybe<Scalars['String']>;
  /** Returns only items with the specified type */
  type?: InputMaybe<Scalars['String']>;
};

/**
 * The `ItemFilter` is used to specify filter criteria for items.
 * If you specify more than one criterion, all criteria are grouped together and connected with a logical AND operator.
 * Further logical operations are possible by using `not` `andGroup` and `orGroup`.
 */
export type ItemFilter = {
  /** Returns all items if set to true */
  all?: InputMaybe<Scalars['Boolean']>;
  /** Allows the specification of further filter criteria, which are grouped together and connected with a logical AND operator */
  andGroup?: InputMaybe<Array<InputMaybe<ItemFilter>>>;
  /** Boosts the score of all matches in this group by the specified factor */
  boost?: InputMaybe<Scalars['Float']>;
  /** Returns items that contain all of the exact values specified */
  equals?: InputMaybe<ItemEqualsValueFilter>;
  /** Returns items that match all of the specified full text searches */
  fullText?: InputMaybe<ItemFullTextFilter>;
  /** Returns items that have a value in all of the specified fields */
  has?: InputMaybe<ItemHasValueFilter>;
  /** Returns items with one of the specified unique identifiers */
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Allows you to specify logically negated filter criteria */
  not?: InputMaybe<ItemFilter>;
  /** Allows the specification of further filter criteria, which are grouped together and connected with a logical OR operator */
  orGroup?: InputMaybe<Array<InputMaybe<ItemFilter>>>;
  /** Returns items with values within all of the ranges specified */
  range?: InputMaybe<ItemRangeFilter>;
  /** Returns items that match all of the regular expressions */
  regex?: InputMaybe<ItemRegexFilter>;
};

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type ItemFullTextFields = {
  /** Match the query against any full text searchable field and rank the results with the specified boost */
  any?: InputMaybe<Scalars['Float']>;
  /** Match the query against the name */
  name?: InputMaybe<Scalars['Float']>;
  /** Match the query against the node caption */
  nodecaption?: InputMaybe<Scalars['Float']>;
  /** Match the query against the schematic ID */
  schematicId?: InputMaybe<Scalars['Float']>;
  /** Match the query against the title and rank the results with the specified boost */
  title?: InputMaybe<Scalars['Float']>;
};

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type ItemFullTextFilter = {
  /** Fields to search in with their respective score weights */
  fields?: InputMaybe<ItemFullTextFields>;
  /** Indicates if a fuzzy search should be performed */
  fuzzy?: InputMaybe<Scalars['Boolean']>;
  /** Specifies if either all or any query words need to match */
  operator?: InputMaybe<FullTextOperator>;
  /** Text to search for */
  query: Scalars['FullTextSearchQuery'];
  /** Type of fulltext search to perform */
  searchType?: InputMaybe<FullTextSearchType>;
};

/** Returns items that have a value in all of the specified fields */
export type ItemHasValueFilter = {
  /** Specify the fields that the returned items must have a value in */
  valueInFields?: InputMaybe<Array<InputMaybe<ItemHasValueInFields>>>;
};

/** Specify the fields that the returned items must have a value in */
export enum ItemHasValueInFields {
  /** Returns only items which have an item ID specified */
  itemId = 'itemId',
  /** Returns only items which have a main hotspot ID specified */
  mainHotspotId = 'mainHotspotId',
  /** Returns only items which have a main sheet specified */
  mainSheet = 'mainSheet',
  /** Returns only items which have a name specified */
  name = 'name',
  /** Returns only items which have a nodecaption specified */
  nodecaption = 'nodecaption',
  /** Returns only items which have a parent item ID specified */
  parentItemId = 'parentItemId',
  /** Returns only items which have a schematic ID specified */
  schematicId = 'schematicId',
  /** Returns only items which have a title specified */
  title = 'title',
  /** Returns only items which have a type specified */
  type = 'type'
}

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type ItemLocalizations = {
  __typename?: 'ItemLocalizations';
  /** Full description */
  description?: Maybe<Scalars['String']>;
  /** Full node caption */
  nodecaption?: Maybe<Scalars['String']>;
  /** Full title */
  title?: Maybe<Scalars['String']>;
};


/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type ItemLocalizationsDescriptionArgs = {
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard>>;
};


/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type ItemLocalizationsTitleArgs = {
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard>>;
};

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type ItemQueryResult = {
  __typename?: 'ItemQueryResult';
  /**
   * Matched datafield values and number of matching items per value
   *
   * To limit the number of results, set the `first` argument.
   *
   * Pagination is possible by setting the `after` argument to the previous last result's `cursor` field value.
   */
  aggregations: ItemDatafieldAggregations;
  /**
   * The query's matching items.
   *
   * Use the `sort` argument to specify the list of fields and the order by which the results should be sorted.
   * Multiple fields and orders may be specified and are evaluated in the provided order.
   *
   * To limit the number of results, set the `first` argument.
   *
   * Pagination is possible by setting the `after` argument to the previous last result's `cursor` field value.
   * Please be careful not to change the query's `filter` or the `sort` argument between paginated calls.
   */
  items: Array<Maybe<ItemEdge>>;
  /**
   * Returns the total count of results.
   *
   * Use the `trackLimit` argument to limit the track of the total count up to the specified amount.
   * If the result has more hits than the specified limit the total count is inaccurate.
   * See `CountRelation` for further information on how to interpret the result.
   *
   * Heads up: Setting the `trackLimit` to a high value may decrease performance.
   */
  total: TotalCount;
};


/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type ItemQueryResultItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  sort?: InputMaybe<Array<InputMaybe<ItemSort>>>;
};


/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type ItemQueryResultTotalArgs = {
  trackLimit?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type ItemRangeFilter = {
  /** Returns only items with a creation date in the specified range */
  creationDate?: InputMaybe<DateRange>;
  /** Returns only items with a modification date in the specified range */
  modificationDate?: InputMaybe<DateRange>;
};

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type ItemRegexFilter = {
  /** Returns only items whose item ID matches the specified Regex */
  itemId?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only items whose name matches the specified Regex */
  name?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only items whose node caption matches the specified Regex */
  nodecaption?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only items whose parent item ID matches the specified Regex */
  parentItemId?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only items whose schematic ID matches the specified Regex */
  schematicId?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only items whose title matches the specified Regex */
  title?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only items whose type matches the specified Regex */
  type?: InputMaybe<Scalars['FilterRegex']>;
};

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type ItemSort = {
  /** Sort field */
  field: ItemSortFields;
  /** Sort order */
  order?: InputMaybe<SortOrder>;
};

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export enum ItemSortFields {
  /** Sort by creation date */
  creationDate = 'creationDate',
  /** Sort by unique ID */
  id = 'id',
  /** Sort by item ID */
  itemId = 'itemId',
  /** Sort by modification date */
  modificationDate = 'modificationDate',
  /** Sort by name */
  name = 'name',
  /** Sort by node caption */
  nodecaption = 'nodecaption',
  /** Sort by schematic ID */
  schematicId = 'schematicId',
  /** Sort by relevance score */
  score = 'score',
  /** Sort by title */
  title = 'title',
  /** Sort by type */
  type = 'type'
}

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type ItemTeasers = {
  __typename?: 'ItemTeasers';
  /** Node caption limited to specified length */
  nodecaption?: Maybe<Scalars['String']>;
  /** Title limited to specified length */
  title?: Maybe<Scalars['String']>;
};


/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type ItemTeasersNodecaptionArgs = {
  length?: InputMaybe<Scalars['NonNegativeInt']>;
};


/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type ItemTeasersTitleArgs = {
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard>>;
  length?: InputMaybe<Scalars['NonNegativeInt']>;
};

/**
 * Defines a keyword datafield.
 * A keyword datafield is a string field which can be used for filtering by exact values or regex matches.
 */
export type KeywordDatafieldDefinition = DatafieldDefinition & {
  __typename?: 'KeywordDatafieldDefinition';
  /** Type of this indexed field definition */
  fieldType?: Maybe<FieldDefinitionTypes>;
  /**
   * Unique identifier of this indexed field definition.
   * Is used as field name in all interfaces and must adhere to the
   * following pattern: ^[_A-Za-z][_0-9A-Za-z]{0,128}$
   */
  id: Scalars['DatafieldDefinitionID'];
  /** Text from the datafield definition for use e.g. in detail views, etc */
  localizations?: Maybe<DatafieldDefinitionLocalizations>;
  /** Datafield names which shall be mapped to this indexed field definition */
  mappedNames?: Maybe<Array<Scalars['String']>>;
  /** List of all objectTypes this definition is assigned to */
  objectTypes?: Maybe<Array<Maybe<ObjectType>>>;
  /** Length limited text from the indexed field definition for use e.g. in result lists, previews, etc. */
  teasers?: Maybe<DatafieldDefinitionTeasers>;
  /** Human readable description of this indexed field definition */
  title?: Maybe<MultilingualString>;
};

/** Sub Graph: **https://data-filter-graph.qit-data-filter.svc.cluster.local:8443** */
export type KeywordFacetDefinition = FacetDefinition & {
  __typename?: 'KeywordFacetDefinition';
  /** The datafield type of the field */
  fieldType: FieldDefinitionTypes;
};

/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export enum Language {
  ar = 'ar',
  bg = 'bg',
  bn = 'bn',
  bs = 'bs',
  ca = 'ca',
  cs = 'cs',
  da = 'da',
  de = 'de',
  el = 'el',
  en = 'en',
  es = 'es',
  et = 'et',
  eu = 'eu',
  fa = 'fa',
  fi = 'fi',
  fr = 'fr',
  ga = 'ga',
  he = 'he',
  hi = 'hi',
  hr = 'hr',
  hu = 'hu',
  hy = 'hy',
  id = 'id',
  is = 'is',
  it = 'it',
  ja = 'ja',
  kk = 'kk',
  ko = 'ko',
  ku = 'ku',
  lt = 'lt',
  lv = 'lv',
  mk = 'mk',
  ms = 'ms',
  mt = 'mt',
  nb = 'nb',
  nl = 'nl',
  no = 'no',
  pb = 'pb',
  pl = 'pl',
  pt = 'pt',
  ro = 'ro',
  ru = 'ru',
  sk = 'sk',
  sl = 'sl',
  sq = 'sq',
  sr = 'sr',
  sv = 'sv',
  th = 'th',
  tr = 'tr',
  uk = 'uk',
  vi = 'vi',
  zh = 'zh'
}

/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export enum LanguageWithWildcard {
  any = 'any',
  ar = 'ar',
  bg = 'bg',
  bn = 'bn',
  bs = 'bs',
  ca = 'ca',
  cs = 'cs',
  da = 'da',
  de = 'de',
  el = 'el',
  en = 'en',
  es = 'es',
  et = 'et',
  eu = 'eu',
  fa = 'fa',
  fi = 'fi',
  fr = 'fr',
  ga = 'ga',
  he = 'he',
  hi = 'hi',
  hr = 'hr',
  hu = 'hu',
  hy = 'hy',
  id = 'id',
  is = 'is',
  it = 'it',
  ja = 'ja',
  kk = 'kk',
  ko = 'ko',
  ku = 'ku',
  lt = 'lt',
  lv = 'lv',
  mk = 'mk',
  ms = 'ms',
  mt = 'mt',
  nb = 'nb',
  nl = 'nl',
  no = 'no',
  pb = 'pb',
  pl = 'pl',
  pt = 'pt',
  ro = 'ro',
  ru = 'ru',
  sk = 'sk',
  sl = 'sl',
  sq = 'sq',
  sr = 'sr',
  sv = 'sv',
  th = 'th',
  tr = 'tr',
  uk = 'uk',
  vi = 'vi',
  zh = 'zh'
}

/** Sub Graph: **https://basic-services-graph.qit.svc.cluster.local:8443** */
export type LanguagesQueryResult = {
  __typename?: 'LanguagesQueryResult';
  /** Available languages for the tenant */
  available?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The tenant´s default language */
  default?: Maybe<Scalars['String']>;
};

/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type LongInclusiveRange = {
  __typename?: 'LongInclusiveRange';
  /** Greater than or equal to */
  gte?: Maybe<Scalars['Float']>;
  /** Less than or equal to */
  lte?: Maybe<Scalars['Float']>;
};

/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type LongInclusiveRangeSpec = {
  /** Greater than or equal to */
  gte?: InputMaybe<Scalars['Float']>;
  /** Less than or equal to */
  lte?: InputMaybe<Scalars['Float']>;
};

/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type LongRange = {
  /** Greater than */
  gt?: InputMaybe<Scalars['Float']>;
  /** Greater than or equal to */
  gte?: InputMaybe<Scalars['Float']>;
  /** Less than */
  lt?: InputMaybe<Scalars['Float']>;
  /** Less than or equal to */
  lte?: InputMaybe<Scalars['Float']>;
};

/** Input type for sending e-mail. */
export type MailDataInput = {
  /** Language the e-mail will generated with. Only 'de' and 'en' are supported. Other values will fallback to 'en'. */
  language: Scalars['String'];
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  priority: Priority;
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  request?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  subject: Scalars['String'];
};

/** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
export type MappingOption = {
  __typename?: 'MappingOption';
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  type?: Maybe<ProcessMappingType>;
  /** Useful only for mapping type `FILENAME_UP_TO_CHAR`. One character expected; more ignored */
  upToChar?: Maybe<Scalars['String']>;
};

/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type Mechanic = {
  __typename?: 'Mechanic';
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  articleId?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  articleNumber?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  assemblyId?: Maybe<Scalars['String']>;
  /** Date and time when it was created. Creation date will always be set if mechanic for this product is re-/imported or on publications. */
  creationDate?: Maybe<Scalars['DateTime']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  currency?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  files?: Maybe<Array<File>>;
  /** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
  id: Scalars['ID'];
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  isAssembly?: Maybe<Scalars['Boolean']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  itemNumber?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  localizations?: Maybe<MechanicLocalizations>;
  /** Date and time of the last modification. Modifications will happen due e.g. referenced article changes. */
  modificationDate?: Maybe<Scalars['DateTime']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  option?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  orderable?: Maybe<Scalars['Boolean']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  parentAssemblyId?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  pathsToRoot?: Maybe<Array<Maybe<MechanicPath>>>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  previewImage?: Maybe<BlobRef>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  price?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  product?: Maybe<Product>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  productionDateRange?: Maybe<DateInclusiveRange>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  quantity?: Maybe<Scalars['NonNegativeFloat']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  reference2d?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  reference3d?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  referenceId?: Maybe<Scalars['String']>;
  /**
   * Related content to the article id - in the current context of a product and/or asset id.
   * The given content filter is optional and is combined (AND clause) with a static filter:
   *
   * This returns only contents related to the specific mechanic entry.
   */
  relatedActivities: ActivityQueryResult;
  /**
   * WARNING: Does not work for now because the required filter could not be defined 100%
   *
   * Related content to the article id - in the current context of a product and/or asset id.
   * The given content filter is optional and is combined (AND clause) with a static filter:
   *
   * This returns only contents related to the specific mechanic entry.
   */
  relatedContents: ContentQueryResult;
  /** Same relation filter as `relatedContents`, grouped using a configured grouping criterion. */
  relatedContentsGrouped: ContentGroupedQueryResult;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  serialNumberRange?: Maybe<LongInclusiveRange>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  teasers?: Maybe<MechanicTeasers>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  title?: Maybe<MultilingualString>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  unit?: Maybe<Scalars['String']>;
  /** Mechanics used in these assets */
  usedInAssets?: Maybe<UsedInAssets>;
};


/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type MechanicFilesArgs = {
  fileTypes?: InputMaybe<Array<InputMaybe<FileType>>>;
};


/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type MechanicRelatedActivitiesArgs = {
  filter?: InputMaybe<ActivityFilter>;
};


/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type MechanicRelatedContentsArgs = {
  filter?: InputMaybe<ContentFilter>;
  filterOptions?: InputMaybe<ContentFilterOptions>;
};


/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type MechanicRelatedContentsGroupedArgs = {
  filter?: InputMaybe<ContentFilter>;
  filterOptions?: InputMaybe<ContentFilterOptions>;
  groupBy: ContentGroupBy;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export enum MechanicAiImageSearchField {
  articleId = 'articleId'
}

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type MechanicAiImageSearchFilter = {
  /** The blob ID of the image to search for */
  blobId: Scalars['String'];
  /** The field to query for matching article ids */
  field?: InputMaybe<MechanicAiImageSearchField>;
  /** Additional options for the image search */
  options?: InputMaybe<AiImageSearchFilterOptions>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type MechanicAutocompleteHits = {
  __typename?: 'MechanicAutocompleteHits';
  /** The count of docs found containing the suggestion */
  docCount: Scalars['NonNegativeInt'];
  /** The language this suggestion stems from */
  language?: Maybe<Language>;
  /** The found suggestion */
  suggest: Scalars['String'];
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type MechanicAutocompleteResult = {
  __typename?: 'MechanicAutocompleteResult';
  /** The hits found for the query */
  hits?: Maybe<Array<MechanicAutocompleteHits>>;
  /** The query used for this result */
  query: Scalars['String'];
};

/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type MechanicCollectionEntryNode = CollectionEntryNode & {
  __typename?: 'MechanicCollectionEntryNode';
  /** The mechanic object */
  mechanic: Mechanic;
  /** The result's collection object context. */
  navContext?: Maybe<CollectionEntryMechanicNavigationContext>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type MechanicDatafieldAggregations = {
  __typename?: 'MechanicDatafieldAggregations';
  /** Provides composite aggregations with pagination support */
  composite?: Maybe<MechanicDatafieldCompositeAggregation>;
  /**
   * Provides terms aggregations for custom datafields.
   * Supports prefix search and the results are ordered by count.
   */
  terms?: Maybe<DatafieldTermsAggregation>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type MechanicDatafieldCompositeAggregation = {
  __typename?: 'MechanicDatafieldCompositeAggregation';
  /** No field definitions exist. As soon as the first field definition is defined, it's automatically listed here. */
  not_applicable_as_no_field_definitions_exist?: Maybe<Scalars['NoDynamicValueDefined']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  productId?: Maybe<Array<AggregationEdge>>;
};


/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type MechanicDatafieldCompositeAggregationProductIdArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type MechanicEdge = {
  __typename?: 'MechanicEdge';
  /** Unique cursor for pagination. See the query's `after` argument */
  cursor: Scalars['String'];
  /** The result's mechanic. */
  node: Mechanic;
  /** Calculated relevance score. */
  score: Scalars['NonNegativeFloat'];
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type MechanicEqualsValueFilter = {
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  articleId?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  articleNumber?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  assemblyId?: InputMaybe<Scalars['String']>;
  /** Returns only with the specified creation date */
  creationDate?: InputMaybe<Scalars['DateTime']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  isAssembly?: InputMaybe<Scalars['Boolean']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  itemNumber?: InputMaybe<Scalars['String']>;
  /** Returns only with the specified modification date */
  modificationDate?: InputMaybe<Scalars['DateTime']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  parentAssemblyId?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified object type (product type) */
  product?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  productionDateRange?: InputMaybe<Scalars['DateTime']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  reference3d?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  serialNumberRange?: InputMaybe<Scalars['Float']>;
  /**
   * Returns only mechanics with the specified title
   * @deprecated Use two title_xx fields for InfoTwin language and tenant default language instead
   */
  title?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified ar title */
  title_ar?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified bg title */
  title_bg?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified bn title */
  title_bn?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified bs title */
  title_bs?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified ca title */
  title_ca?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified cs title */
  title_cs?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified da title */
  title_da?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified de title */
  title_de?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified el title */
  title_el?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified en title */
  title_en?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified es title */
  title_es?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified et title */
  title_et?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified eu title */
  title_eu?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified fa title */
  title_fa?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified fi title */
  title_fi?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified fr title */
  title_fr?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified ga title */
  title_ga?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified he title */
  title_he?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified hi title */
  title_hi?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified hr title */
  title_hr?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified hu title */
  title_hu?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified hy title */
  title_hy?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified id title */
  title_id?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified is title */
  title_is?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified it title */
  title_it?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified ja title */
  title_ja?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified kk title */
  title_kk?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified ko title */
  title_ko?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified ku title */
  title_ku?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified lt title */
  title_lt?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified lv title */
  title_lv?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified mk title */
  title_mk?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified ms title */
  title_ms?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified mt title */
  title_mt?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified nb title */
  title_nb?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified nl title */
  title_nl?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified no title */
  title_no?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified pb title */
  title_pb?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified pl title */
  title_pl?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified pt title */
  title_pt?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified ro title */
  title_ro?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified ru title */
  title_ru?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified sk title */
  title_sk?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified sl title */
  title_sl?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified sq title */
  title_sq?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified sr title */
  title_sr?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified sv title */
  title_sv?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified th title */
  title_th?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified tr title */
  title_tr?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified uk title */
  title_uk?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified vi title */
  title_vi?: InputMaybe<Scalars['String']>;
  /** Returns only mechanics with the specified zh title */
  title_zh?: InputMaybe<Scalars['String']>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export enum MechanicExistsValueFields {
  /** Returns only mechanics which have an article id specified */
  articleId = 'articleId',
  articleNumber = 'articleNumber',
  /** Returns only mechanics which have an item number specified */
  itemNumber = 'itemNumber',
  /** Returns only mechanics which have a product specified */
  product = 'product',
  /** Returns only mechanics which have a date (range) specified */
  productionDateRange = 'productionDateRange',
  reference3d = 'reference3d',
  /** Returns only mechanics which have a serial number (range) specified */
  serialNumberRange = 'serialNumberRange',
  /** Returns only mechanics which have a text specified */
  text = 'text',
  /** Returns only mechanics which have a title specified */
  title = 'title'
}

/**
 * The `MechanicFilter` is used to specify filter criteria for mechanics.
 * If you specify more than one criterion, all criteria are grouped together and connected with a logical AND operator.
 * Further logical operations are possible by using `not` `andGroup` and `orGroup`.
 */
export type MechanicFilter = {
  /** Returns all mechanics if set to true */
  all?: InputMaybe<Scalars['Boolean']>;
  /** Allows the specification of further filter criteria, which are grouped together and connected with a logical AND operator */
  andGroup?: InputMaybe<Array<InputMaybe<MechanicFilter>>>;
  /** Boosts the score of all matches in this group by the specified factor. Heads up: The resulting score boost isn't mathematically exact due to rounding errors */
  boost?: InputMaybe<Scalars['Float']>;
  /** Returns mechanics that contain all of the exact values specified */
  equals?: InputMaybe<MechanicEqualsValueFilter>;
  /**
   * Returns mechanics that have a value in all of the specified fields
   * @deprecated Please use 'has' filter instead
   */
  exists?: InputMaybe<Array<InputMaybe<MechanicExistsValueFields>>>;
  /** Returns mechanics that match all of the specified full text searches */
  fullText?: InputMaybe<MechanicFullTextFilter>;
  /** Returns mechanics that have a value in all of the specified fields */
  has?: InputMaybe<MechanicHasValueFilter>;
  /** Returns mechanics with one of the specified unique identifiers */
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Returns mechanics that are matched by an ai supported image search for the article */
  image?: InputMaybe<MechanicAiImageSearchFilter>;
  /** Allows you to specify logically negated filter criteria */
  not?: InputMaybe<MechanicFilter>;
  /** Allows the specification of further filter criteria, which are grouped together and connected with a logical OR operator */
  orGroup?: InputMaybe<Array<InputMaybe<MechanicFilter>>>;
  /** Returns mechanics with values within all of the ranges specified */
  range?: InputMaybe<MechanicRangeFilter>;
  /** Returns mechanics that match all of the regular expressions */
  regex?: InputMaybe<MechanicRegexFilter>;
  /** Returns mechanics that match a taxonomy value according to the taxonomy's evaluation type */
  taxonomy?: InputMaybe<MechanicTaxonomyFilter>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type MechanicFullTextFields = {
  /** Match the query against any full text searchable field and rank the results with the specified boost */
  any?: InputMaybe<Scalars['Float']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  articleId?: InputMaybe<Scalars['Float']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  articleNumber?: InputMaybe<Scalars['Float']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  itemNumber?: InputMaybe<Scalars['Float']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  product?: InputMaybe<Scalars['Float']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  reference3d?: InputMaybe<Scalars['Float']>;
  /**
   * Match the query against the title and rank the results with the specified boost
   * @deprecated Use two title_xx fields for InfoTwin language and tenant default language instead
   */
  text?: InputMaybe<Scalars['Float']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  title?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_ar?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_bg?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_bn?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_bs?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_ca?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_cs?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_da?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_de?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_el?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_en?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_es?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_et?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_eu?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_fa?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_fi?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_fr?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_ga?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_he?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_hi?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_hr?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_hu?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_hy?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_id?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_is?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_it?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_ja?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_kk?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_ko?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_ku?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_lt?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_lv?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_mk?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_ms?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_mt?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_nb?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_nl?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_no?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_pb?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_pl?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_pt?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_ro?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_ru?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_sk?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_sl?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_sq?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_sr?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_sv?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_th?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_tr?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_uk?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_vi?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_zh?: InputMaybe<Scalars['Float']>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type MechanicFullTextFilter = {
  /** Fields to search in with their respective score weights */
  fields?: InputMaybe<MechanicFullTextFields>;
  /** Indicates if a fuzzy search should be performed. */
  fuzzy?: InputMaybe<Scalars['Boolean']>;
  /** Specifies if either all or any query words need to match */
  operator?: InputMaybe<FullTextOperator>;
  /** Text to search for */
  query: Scalars['FullTextSearchQuery'];
  /** Type of fulltext search to perform */
  searchType?: InputMaybe<FullTextSearchType>;
};

/** Returns mechanics that have a value in all of the specified fields */
export type MechanicHasValueFilter = {
  /** Specify the fields that the returned mechanics must have a value in */
  valueInFields?: InputMaybe<Array<InputMaybe<MechanicHasValueInFields>>>;
};

/** Specify the fields that the returned mechanics must have a value in */
export enum MechanicHasValueInFields {
  /** Returns only mechanics which have an article id specified */
  articleId = 'articleId',
  articleNumber = 'articleNumber',
  /** Returns only mechanics which have an item number specified */
  itemNumber = 'itemNumber',
  /** Returns only mechanics which have a product specified */
  product = 'product',
  /** Returns only mechanics which have a date (range) specified */
  productionDateRange = 'productionDateRange',
  reference3d = 'reference3d',
  /** Returns only mechanics which have a serial number (range) specified */
  serialNumberRange = 'serialNumberRange',
  /** Returns only mechanics which have a text specified */
  text = 'text',
  /** Returns only mechanics which have a title specified */
  title = 'title'
}

/** Text from the mechanic for use e.g. in details etc. */
export type MechanicLocalizations = {
  __typename?: 'MechanicLocalizations';
  /** The title from the part */
  title?: Maybe<Scalars['String']>;
  /** The partlist entry's unit */
  unit?: Maybe<Scalars['String']>;
};


/** Text from the mechanic for use e.g. in details etc. */
export type MechanicLocalizationsTitleArgs = {
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard>>;
};


/** Text from the mechanic for use e.g. in details etc. */
export type MechanicLocalizationsUnitArgs = {
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard>>;
};

/** Array of MechanicPathEntry specifying a path through the mechanics graph between a start end a end mechanic */
export type MechanicPath = {
  __typename?: 'MechanicPath';
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  path?: Maybe<Array<Maybe<MechanicPathEntry>>>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type MechanicPathEntry = {
  __typename?: 'MechanicPathEntry';
  /** Returning a mechanic to obtain e.g. description will involve query costs */
  mechanic?: Maybe<Mechanic>;
  /** The mechanic id will be returned without any query costs */
  mechanicId: Scalars['String'];
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type MechanicQueryResult = {
  __typename?: 'MechanicQueryResult';
  /**
   * Matched datafield values and number of matching mechanics per value
   *
   * To limit the number of results, set the `first` argument.
   *
   * Pagination is possible by setting the `after` argument to the previous last result's `cursor` field value.
   */
  aggregations: MechanicDatafieldAggregations;
  /**
   * The query's matching mechanics.
   *
   * Use the `sort` argument to specify the list of fields and the order by which the results should be sorted.
   * Multiple fields and orders may be specified and are evaluated in the provided order.
   *
   * To limit the number of results, set the `first` argument.
   *
   * Pagination is possible by setting the `after` argument to the previous last result's `cursor` field value.
   * Please be careful not to change the query's `filter` or the `sort` argument between paginated calls.
   */
  mechanics: Array<Maybe<MechanicEdge>>;
  /**
   * Returns the total count of results.
   *
   * Use the `trackLimit` argument to limit the track of the total count up to the specified amount.
   * If the result has more hits than the specified limit the total count is inaccurate.
   * See `CountRelation` for further information on how to interpret the result.
   *
   * Heads up: Setting the `trackLimit` to a high value may decrease performance.
   */
  total: TotalCount;
  /**
   * List products used in any of the mechanics results.
   * Mechanics used in these products limited to a maximum of 10000 products.
   */
  usedInProducts?: Maybe<UsedInProducts>;
};


/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type MechanicQueryResultMechanicsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  sort?: InputMaybe<Array<InputMaybe<MechanicSort>>>;
};


/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type MechanicQueryResultTotalArgs = {
  trackLimit?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type MechanicRangeFilter = {
  /** Returns only with a creation date in the specified range */
  creationDate?: InputMaybe<DateRange>;
  /** Returns only with a modification date in the specified range */
  modificationDate?: InputMaybe<DateRange>;
  /** No number or dateTime datafield definitions exist. As soon as the first such datafield definition is defined, it's automatically listed here. */
  not_applicable_as_no_number_or_date_datafield_definitions_exist?: InputMaybe<Scalars['NoDynamicValueDefined']>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type MechanicRegexFilter = {
  /** Returns only mechanics whose object type matches the specified Regex */
  articleId?: InputMaybe<Scalars['FilterRegex']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  articleNumber?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose object type matches the specified Regex */
  itemNumber?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose object type matches the specified Regex */
  product?: InputMaybe<Scalars['FilterRegex']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  reference3d?: InputMaybe<Scalars['FilterRegex']>;
  /**
   * Returns only mechanics whose title matches the specified Regex
   * @deprecated Use two title_xx fields for InfoTwin language and tenant default language instead
   */
  title?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose ar title matches the specified Regex */
  title_ar?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose bg title matches the specified Regex */
  title_bg?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose bn title matches the specified Regex */
  title_bn?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose bs title matches the specified Regex */
  title_bs?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose ca title matches the specified Regex */
  title_ca?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose cs title matches the specified Regex */
  title_cs?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose da title matches the specified Regex */
  title_da?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose de title matches the specified Regex */
  title_de?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose el title matches the specified Regex */
  title_el?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose en title matches the specified Regex */
  title_en?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose es title matches the specified Regex */
  title_es?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose et title matches the specified Regex */
  title_et?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose eu title matches the specified Regex */
  title_eu?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose fa title matches the specified Regex */
  title_fa?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose fi title matches the specified Regex */
  title_fi?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose fr title matches the specified Regex */
  title_fr?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose ga title matches the specified Regex */
  title_ga?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose he title matches the specified Regex */
  title_he?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose hi title matches the specified Regex */
  title_hi?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose hr title matches the specified Regex */
  title_hr?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose hu title matches the specified Regex */
  title_hu?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose hy title matches the specified Regex */
  title_hy?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose id title matches the specified Regex */
  title_id?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose is title matches the specified Regex */
  title_is?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose it title matches the specified Regex */
  title_it?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose ja title matches the specified Regex */
  title_ja?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose kk title matches the specified Regex */
  title_kk?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose ko title matches the specified Regex */
  title_ko?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose ku title matches the specified Regex */
  title_ku?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose lt title matches the specified Regex */
  title_lt?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose lv title matches the specified Regex */
  title_lv?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose mk title matches the specified Regex */
  title_mk?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose ms title matches the specified Regex */
  title_ms?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose mt title matches the specified Regex */
  title_mt?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose nb title matches the specified Regex */
  title_nb?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose nl title matches the specified Regex */
  title_nl?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose no title matches the specified Regex */
  title_no?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose pb title matches the specified Regex */
  title_pb?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose pl title matches the specified Regex */
  title_pl?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose pt title matches the specified Regex */
  title_pt?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose ro title matches the specified Regex */
  title_ro?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose ru title matches the specified Regex */
  title_ru?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose sk title matches the specified Regex */
  title_sk?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose sl title matches the specified Regex */
  title_sl?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose sq title matches the specified Regex */
  title_sq?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose sr title matches the specified Regex */
  title_sr?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose sv title matches the specified Regex */
  title_sv?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose th title matches the specified Regex */
  title_th?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose tr title matches the specified Regex */
  title_tr?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose uk title matches the specified Regex */
  title_uk?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose vi title matches the specified Regex */
  title_vi?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only mechanics whose zh title matches the specified Regex */
  title_zh?: InputMaybe<Scalars['FilterRegex']>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type MechanicSort = {
  /** Sort field */
  field: MechanicSortFields;
  /** Sort order */
  order?: InputMaybe<SortOrder>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export enum MechanicSortFields {
  /** Sort by article id */
  articleId = 'articleId',
  /** Sort by article number */
  articleNumber = 'articleNumber',
  /** Sort by creation date */
  creationDate = 'creationDate',
  /** Sort by unique ID */
  id = 'id',
  /** Sort by item number */
  itemNumber = 'itemNumber',
  /** Sort by modification date */
  modificationDate = 'modificationDate',
  /** Sort by object type (product type) */
  product = 'product',
  reference3d = 'reference3d',
  /** Sort by relevance score */
  score = 'score',
  /**
   * Sort by title
   * @deprecated Use two title_xx fields for InfoTwin language and tenant default language instead
   */
  title = 'title',
  /** Sort by language-ar title */
  titleAr = 'title_ar',
  /** Sort by language-bg title */
  titleBg = 'title_bg',
  /** Sort by language-bn title */
  titleBn = 'title_bn',
  /** Sort by language-bs title */
  titleBs = 'title_bs',
  /** Sort by language-ca title */
  titleCa = 'title_ca',
  /** Sort by language-cs title */
  titleCs = 'title_cs',
  /** Sort by language-da title */
  titleDa = 'title_da',
  /** Sort by language-de title */
  titleDe = 'title_de',
  /** Sort by language-el title */
  titleEl = 'title_el',
  /** Sort by language-en title */
  titleEn = 'title_en',
  /** Sort by language-es title */
  titleEs = 'title_es',
  /** Sort by language-et title */
  titleEt = 'title_et',
  /** Sort by language-eu title */
  titleEu = 'title_eu',
  /** Sort by language-fa title */
  titleFa = 'title_fa',
  /** Sort by language-fi title */
  titleFi = 'title_fi',
  /** Sort by language-fr title */
  titleFr = 'title_fr',
  /** Sort by language-ga title */
  titleGa = 'title_ga',
  /** Sort by language-he title */
  titleHe = 'title_he',
  /** Sort by language-hi title */
  titleHi = 'title_hi',
  /** Sort by language-hr title */
  titleHr = 'title_hr',
  /** Sort by language-hu title */
  titleHu = 'title_hu',
  /** Sort by language-hy title */
  titleHy = 'title_hy',
  /** Sort by language-id title */
  titleId = 'title_id',
  /** Sort by language-is title */
  titleIs = 'title_is',
  /** Sort by language-it title */
  titleIt = 'title_it',
  /** Sort by language-ja title */
  titleJa = 'title_ja',
  /** Sort by language-kk title */
  titleKk = 'title_kk',
  /** Sort by language-ko title */
  titleKo = 'title_ko',
  /** Sort by language-ku title */
  titleKu = 'title_ku',
  /** Sort by language-lt title */
  titleLt = 'title_lt',
  /** Sort by language-lv title */
  titleLv = 'title_lv',
  /** Sort by language-mk title */
  titleMk = 'title_mk',
  /** Sort by language-ms title */
  titleMs = 'title_ms',
  /** Sort by language-mt title */
  titleMt = 'title_mt',
  /** Sort by language-nb title */
  titleNb = 'title_nb',
  /** Sort by language-nl title */
  titleNl = 'title_nl',
  /** Sort by language-no title */
  titleNo = 'title_no',
  /** Sort by language-pb title */
  titlePb = 'title_pb',
  /** Sort by language-pl title */
  titlePl = 'title_pl',
  /** Sort by language-pt title */
  titlePt = 'title_pt',
  /** Sort by language-ro title */
  titleRo = 'title_ro',
  /** Sort by language-ru title */
  titleRu = 'title_ru',
  /** Sort by language-sk title */
  titleSk = 'title_sk',
  /** Sort by language-sl title */
  titleSl = 'title_sl',
  /** Sort by language-sq title */
  titleSq = 'title_sq',
  /** Sort by language-sr title */
  titleSr = 'title_sr',
  /** Sort by language-sv title */
  titleSv = 'title_sv',
  /** Sort by language-th title */
  titleTh = 'title_th',
  /** Sort by language-tr title */
  titleTr = 'title_tr',
  /** Sort by language-uk title */
  titleUk = 'title_uk',
  /** Sort by language-vi title */
  titleVi = 'title_vi',
  /** Sort by language-zh title */
  titleZh = 'title_zh'
}

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type MechanicTaxonomyFilter = {
  /** No taxonomy datafield definitions exist. As soon as the first taxonomy is defined, it's automatically listed here. */
  not_applicable_as_no_taxonomy_datafield_definitions_exist?: InputMaybe<Scalars['NoDynamicValueDefined']>;
};

/** Length limited text from the mechanic for use e.g. in result lists, previews, etc. */
export type MechanicTeasers = {
  __typename?: 'MechanicTeasers';
  /** The title limited to `length` characters */
  title?: Maybe<Scalars['String']>;
  /** The partlist entry's unit limited to `length` characters */
  unit?: Maybe<Scalars['String']>;
};


/** Length limited text from the mechanic for use e.g. in result lists, previews, etc. */
export type MechanicTeasersTitleArgs = {
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard>>;
  length?: InputMaybe<Scalars['NonNegativeInt']>;
};


/** Length limited text from the mechanic for use e.g. in result lists, previews, etc. */
export type MechanicTeasersUnitArgs = {
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard>>;
  length?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
export type MultilingualDatafieldMapping = ProcessDatafieldMapping & {
  __typename?: 'MultilingualDatafieldMapping';
  /** Returns column(s) which also map to the same field. In this case a process cannot be created due to ambiguousness. */
  ambiguousColumns?: Maybe<Array<Scalars['String']>>;
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  column: Scalars['String'];
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  field?: Maybe<Datafield>;
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  language: Language;
};

/** A string in a single or multiple of the available languages */
export type MultilingualString = {
  __typename?: 'MultilingualString';
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  ar?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  bg?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  bn?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  bs?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  ca?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  cs?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  da?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  de?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  el?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  en?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  es?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  et?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  eu?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  fa?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  fi?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  fr?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  ga?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  he?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  hi?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  hr?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  hu?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  hy?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  id?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  is?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  it?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  ja?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  kk?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  ko?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  ku?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  lt?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  lv?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://webhooks-graph.qit-webhooks.svc.cluster.local:8443** */
  mk?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  ms?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  mt?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  nb?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  nl?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  no?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  pb?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  pl?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  pt?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  ro?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  ru?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  sk?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  sl?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  sq?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  sr?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  sv?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  th?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  tr?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  uk?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  vi?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  zh?: Maybe<Scalars['String']>;
};

/** A string in a single or multiple of the available languages */
export type MultilingualStringInput = {
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  ar?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  bg?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  bn?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  bs?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  ca?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  cs?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  da?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  de?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  el?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  en?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  es?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  et?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  eu?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  fa?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  fi?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  fr?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  ga?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  he?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  hi?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  hr?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  hu?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  hy?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  id?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  is?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  it?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  ja?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  kk?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  ko?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  ku?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  lt?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  lv?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://webhooks-graph.qit-webhooks.svc.cluster.local:8443** */
  mk?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  ms?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  mt?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  nb?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  nl?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  no?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  pb?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  pl?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  pt?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  ro?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  ru?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  sk?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  sl?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  sq?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  sr?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  sv?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  th?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  tr?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  uk?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  vi?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  zh?: InputMaybe<Scalars['String']>;
};

/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type Mutation = {
  __typename?: 'Mutation';
  /**
   * Add activities to a collection.
   *
   * Required permission\
   * Resource: **collections**\
   * Action: **write**
   *
   * See below for additional permission required to add contents to a collection with visibility 'public'.
   *
   * Required permission\
   * Resource: **collections**\
   * Action: **write.public**
   */
  addActivitiesToCollection?: Maybe<Scalars['Boolean']>;
  /**
   * Add articles to a collection.
   *
   * Required permission\
   * Resource: **collections**\
   * Action: **write**
   *
   * See below for additional permission required to add contents to a collection with visibility 'public'.
   *
   * Required permission\
   * Resource: **collections**\
   * Action: **write.public**
   */
  addArticlesToCollection?: Maybe<Scalars['Boolean']>;
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  addCartItem: ShopLightCartItem;
  /**
   * Add contents to a collection.
   * `idsOfContents` takes a list of ids of content-like objects (e.g. `Topic` and `ContentMap`).
   * Please take care to use the objects' `id`s and not the objects' `contentId`s.
   *
   * Required permission\
   * Resource: **collections**\
   * Action: **write**
   *
   * See below for additional permission required to add contents to a collection with visibility 'public'.
   *
   * Required permission\
   * Resource: **collections**\
   * Action: **write.public**
   */
  addContentsToCollection?: Maybe<Scalars['Boolean']>;
  /**
   * Add mechanic articles to a collection.
   *
   * Required permission\
   * Resource: **collections**\
   * Action: **write**
   *
   * See below for additional permission required to add contents to a collection with visibility 'public'.
   *
   * Required permission\
   * Resource: **collections**\
   * Action: **write.public**
   */
  addMechanicsToCollection?: Maybe<Scalars['Boolean']>;
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  assessAIAssistant?: Maybe<Scalars['Boolean']>;
  /**
   * Create an api key for the user
   *
   * Required permission\
   * Resource: **users.api-keys**\
   * Action: **write**
   */
  createApiKey: CreateApiKeyResponse;
  /**
   * Create or replace an app key for the current user.
   * An app key is a special kind of api key which allows the companion app to access the info twin api.
   * Each user can only create his/her own app key and can only have one app key at any time.
   * The app key expires after 1 year.
   *
   * Required permission\
   * Resource: **user.app-key**\
   * Action: **write**
   */
  createAppKey: CreateApiKeyResponse;
  /**
   * Create a new collection.
   *
   * Required permission\
   * Resource: **collections**\
   * Action: **write**
   *
   * See below for additional permission required to be able to create collections with the visibility set to 'public'.
   *
   * Required permission\
   * Resource: **collections**\
   * Action: **write.public**
   */
  createCollection: Scalars['ID'];
  /**
   * Create a connector key for the user.
   * A connector key is a special kind of api key which is limited to uploading contents and
   * syncing notes.
   *
   * Required permission\
   * Resource: **users.api-keys**\
   * Action: **write**
   */
  createConnectorKey: CreateApiKeyResponse;
  /**
   * Create a new note.
   *
   * Required permission\
   * Resource: **notes**\
   * Action: **write**
   *
   * See below for additional permission required to be able to create notes with the visibility status set to 'public'.
   * If the invoking user doesn't have the permission below and creates a note with the visibility 'public', the note
   * will be on status 'pendingApproval' (see `VisibilityTypes`).
   *
   * To attach files directly to the note, upload them in advance to the `/api/upload/notes/attachments` endpoint
   * and pass the returned reference tokens in the `attachments` field.
   *
   * Required permission\
   * Resource: **notes**\
   * Action: **write.public**
   */
  createNote: Scalars['ID'];
  /**
   * Create new comment for a note.
   *
   * Required permission\
   * Resource: **notes.comments**\
   * Action: **write**
   */
  createNoteComment: Scalars['ID'];
  /**
   * Create or update user settings.
   *
   * Required permission\
   * Resource: **users-settings**\
   * Action: **write**
   */
  createOrUpdateUserSettings: UserSettings;
  /**
   * Initiate the creation of a PDF catalog based on the provided PdfRequestData.
   * It will create a new PDF catalog request and send an email notification with a download link to the user.
   * Returns the PdfCatalogRequestStatus.
   */
  createPdfCatalogRequestAndSendEmail?: Maybe<PdfCatalogRequestStatus>;
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  deleteCartItem: Scalars['Boolean'];
  /**
   * Delete an existing collection.
   *
   * Required permission\
   * Resource: **collections**\
   * Action: **delete**
   *
   * See below for additional permission required to be able to delete a collection with visibility 'public'.
   *
   * Required permission\
   * Resource: **collections**\
   * Action: **delete.public**
   */
  deleteCollection: Scalars['ID'];
  /**
   * Delete an existing note.
   *
   * Required permission\
   * Resource: **notes**\
   * Action: **delete**
   */
  deleteNote: Scalars['ID'];
  /**
   * Delete multiple attachments from a note.
   *
   * Required permission\
   * Resource: **notes.attachments**\
   * Action: **delete**
   */
  deleteNoteAttachments?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /**
   * Delete an existing note comment.
   *
   * Required permission\
   * Resource: **notes.comments**\
   * Action: **delete**
   */
  deleteNoteComment: Scalars['ID'];
  /**
   * Deletes existing notes by ids.
   *
   * Required permission\
   * Resource: **notes**\
   * Action: **delete**
   */
  deleteNotes?: Maybe<Scalars['Boolean']>;
  /**
   * Delete entries in the user settings.
   *
   * Required permission\
   * Resource: **users-settings**\
   * Action: **write**
   */
  deleteUserSettingEntries: Scalars['Boolean'];
  /**
   * Delete the user settings.
   *
   * Required permission\
   * Resource: **users-settings**\
   * Action: **delete**
   */
  deleteUserSettings: Scalars['Boolean'];
  /**
   * Export collection as excel or csv file
   *
   * Required permission\
   * Resource: **collections**\
   * Action: **export**
   */
  exportCollection: Scalars['String'];
  /** Imports one schematic XML payload and stores the parsed raw document as raw-v2 storage with persisted struct ids. */
  importSchematicRaw: SchematicImportResult;
  /**
   * Marks notification as read. Gets notification by id and sets read date.
   *
   * Required permission\
   * Resource: **notifications**\
   * Action: **mark-as-read**
   */
  markNotificationsAsRead: Array<Maybe<Scalars['ID']>>;
  /** Parses the stored sample schematic XML file and stores the parsed raw document under a fixed sample id in raw-v2 format. */
  parseStoredSampleSchematicXml: SchematicImportResult;
  /** Connection test. Responds with the provided `tagLine` */
  ping?: Maybe<Scalars['String']>;
  /**
   * Remove activities from a collection.
   *
   * Required permission\
   * Resource: **collections**\
   * Action: **write**
   *
   * See below for additional permission required to remove entries from a collection with visibility 'public'.
   *
   * Required permission\
   * Resource: **collections**\
   * Action: **write.public**
   */
  removeActivitiesFromCollection?: Maybe<Scalars['Boolean']>;
  /**
   * Remove articles from a collection.
   *
   * Required permission\
   * Resource: **collections**\
   * Action: **write**
   *
   * See below for additional permission required to remove entries from a collection with visibility 'public'.
   *
   * Required permission\
   * Resource: **collections**\
   * Action: **write.public**
   */
  removeArticlesFromCollection?: Maybe<Scalars['Boolean']>;
  /**
   * Remove contents from a collection.
   * `idsOfContents` takes a list of ids of content-like objects (e.g. `Topic` and `ContentMap`).
   * Please take care to use the objects' `id`s and not the objects' `contentId`s.
   *
   * Required permission\
   * Resource: **collections**\
   * Action: **write**
   *
   * See below for additional permission required to remove contents from a collection with visibility 'public'.
   *
   * Required permission\
   * Resource: **collections**\
   * Action: **write.public**
   */
  removeContentsFromCollection?: Maybe<Scalars['Boolean']>;
  /**
   * Remove mechanic articles from a collection.
   *
   * Required permission\
   * Resource: **collections**\
   * Action: **write**
   *
   * See below for additional permission required to remove entries from a collection with visibility 'public'.
   *
   * Required permission\
   * Resource: **collections**\
   * Action: **write.public**
   */
  removeMechanicsFromCollection?: Maybe<Scalars['Boolean']>;
  /**
   * Revoke an api key for the user by it's unique id
   *
   * Required permission\
   * Resource: **users.api-keys**\
   * Action: **delete**
   */
  revokeApiKey: Scalars['ID'];
  /**
   * Revoke the app key for the current user
   *
   * Required permission\
   * Resource: **user.app-key**\
   * Action: **delete**
   */
  revokeAppKey?: Maybe<Scalars['Void']>;
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  sendMails: Scalars['String'];
  /**
   * Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443**
   * @deprecated Please use assessAIAssistant instead
   */
  sendRagFeedback?: Maybe<Scalars['Boolean']>;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  shopBasketAddItem: ShopBasket;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  shopBasketClear: ShopBasket;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  shopBasketRemoveItem: ShopBasket;
  /** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  shopBasketSetItemAmount: ShopBasket;
  /**
   * Update an existing activity. Please note that the API is likely to change in future releases
   *
   * Required permission\
   * Resource: **activities**\
   * Action: **write**
   */
  updateActivityProcess?: Maybe<Scalars['ID']>;
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  updateCartItem: ShopLightCartItem;
  /**
   * Update an existing collection.
   *
   * Required permission\
   * Resource: **collections**\
   * Action: **write**
   *
   * See below for additional permission required to be able to update a collection with visibility 'public'.
   *
   * Required permission\
   * Resource: **collections**\
   * Action: **write.public**
   */
  updateCollection: Collection;
  /**
   * Update an existing note.
   *
   * Required permission\
   * Resource: **notes**\
   * Action: **write**
   *
   * See below for additional permission required to be able to update the visibility status to 'public'. If the
   * invoking user doesn't have the permission below and creates a note with the visibility 'public', the note will be
   * on status 'pendingApproval' (see `VisibilityTypes`).
   *
   * Required permission\
   * Resource: **notes**\
   * Action: **write.public**
   */
  updateNote: Note;
  /**
   * Update an existing note comment.
   *
   * Required permission\
   * Resource: **notes.comments**\
   * Action: **write**
   */
  updateNoteComment: NoteComment;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type MutationAddActivitiesToCollectionArgs = {
  activityIds: Array<Scalars['ID']>;
  collectionId: Scalars['ID'];
  navContext?: InputMaybe<CollectionEntryNavigationContextInput>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type MutationAddArticlesToCollectionArgs = {
  articleIds: Array<Scalars['ID']>;
  collectionId: Scalars['ID'];
  navContext?: InputMaybe<CollectionEntryNavigationContextInput>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type MutationAddCartItemArgs = {
  spec: ShopLightCartItemInput;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type MutationAddContentsToCollectionArgs = {
  collectionId: Scalars['ID'];
  idsOfContents: Array<Scalars['ID']>;
  navContext?: InputMaybe<CollectionEntryNavigationContextInput>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type MutationAddMechanicsToCollectionArgs = {
  collectionId: Scalars['ID'];
  mechanicIds: Array<Scalars['ID']>;
  navContext?: InputMaybe<CollectionEntryMechanicNavigationContextInput>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type MutationAssessAiAssistantArgs = {
  feedback: Scalars['JSONObject'];
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type MutationCreateApiKeyArgs = {
  apiKeySpec: CreateApiKeyInput;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type MutationCreateCollectionArgs = {
  spec?: InputMaybe<CreateCollectionInput>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type MutationCreateConnectorKeyArgs = {
  connectorKeySpec: CreateConnectorKeyInput;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type MutationCreateNoteArgs = {
  noteSpec: CreateNoteInput;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type MutationCreateNoteCommentArgs = {
  commentSpec: CreateNoteCommentInput;
  noteId: Scalars['ID'];
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type MutationCreateOrUpdateUserSettingsArgs = {
  diff?: InputMaybe<CreateOrUpdateUserSettings>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type MutationCreatePdfCatalogRequestAndSendEmailArgs = {
  pdfRequestData: PdfRequestData;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type MutationDeleteCartItemArgs = {
  spec: ShopLightCartItemDelete;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type MutationDeleteCollectionArgs = {
  id: Scalars['ID'];
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type MutationDeleteNoteArgs = {
  id: Scalars['ID'];
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type MutationDeleteNoteAttachmentsArgs = {
  attachmentIds: Array<InputMaybe<Scalars['ID']>>;
  noteId: Scalars['ID'];
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type MutationDeleteNoteCommentArgs = {
  commentId: Scalars['ID'];
  noteId: Scalars['ID'];
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type MutationDeleteNotesArgs = {
  ids: Array<Scalars['ID']>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type MutationDeleteUserSettingEntriesArgs = {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type MutationExportCollectionArgs = {
  acceptedLanguages: Array<LanguageWithWildcard>;
  collectionExportType: CollectionExportType;
  id: Scalars['ID'];
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type MutationImportSchematicRawArgs = {
  id: Scalars['ID'];
  xml: Scalars['String'];
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type MutationMarkNotificationsAsReadArgs = {
  ids: Array<InputMaybe<Scalars['ID']>>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type MutationPingArgs = {
  tagLine?: InputMaybe<Scalars['String']>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type MutationRemoveActivitiesFromCollectionArgs = {
  activityIds: Array<Scalars['ID']>;
  collectionId: Scalars['ID'];
  navContext?: InputMaybe<CollectionEntryNavigationContextInput>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type MutationRemoveArticlesFromCollectionArgs = {
  articleIds: Array<Scalars['ID']>;
  collectionId: Scalars['ID'];
  navContext?: InputMaybe<CollectionEntryNavigationContextInput>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type MutationRemoveContentsFromCollectionArgs = {
  collectionId: Scalars['ID'];
  idsOfContents: Array<Scalars['ID']>;
  navContext?: InputMaybe<CollectionEntryNavigationContextInput>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type MutationRemoveMechanicsFromCollectionArgs = {
  collectionId: Scalars['ID'];
  mechanicIds: Array<Scalars['ID']>;
  navContext?: InputMaybe<CollectionEntryMechanicNavigationContextInput>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type MutationRevokeApiKeyArgs = {
  apiKeyId: Scalars['ID'];
  userId: Scalars['ID'];
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type MutationSendMailsArgs = {
  spec: SendMailsInput;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type MutationSendRagFeedbackArgs = {
  feedback: Scalars['JSONObject'];
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type MutationShopBasketAddItemArgs = {
  item: ShopBasketAddItemInput;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type MutationShopBasketRemoveItemArgs = {
  item: ShopBasketItemReferenceInput;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type MutationShopBasketSetItemAmountArgs = {
  item: ShopBasketAddItemInput;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type MutationUpdateActivityProcessArgs = {
  spec: UpdateActivityProcessInput;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type MutationUpdateCartItemArgs = {
  spec: ShopLightCartItemInput;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type MutationUpdateCollectionArgs = {
  diff?: InputMaybe<UpdateCollectionInput>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type MutationUpdateNoteArgs = {
  partialNote: UpdateNoteInput;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type MutationUpdateNoteCommentArgs = {
  noteId: Scalars['ID'];
  partialComment: UpdateNoteCommentInput;
};

/** Sub Graph: **https://user-generated-data-graph.qit.svc.cluster.local:8443** */
export type Note = {
  __typename?: 'Note';
  /** Activity the note was created for */
  activity?: Maybe<Asset>;
  /**
   * The latest date the note got approved for publication.
   *
   * Due to the possibility that the note gets revoked, the field shows the latest approval and is no indicator
   * if the note is currently public.
   */
  approvalDate?: Maybe<Scalars['DateTime']>;
  /** Asset the note was created for */
  asset?: Maybe<Asset>;
  /** Optional attachments for the note (e.g. images) */
  attachments?: Maybe<Array<Maybe<BlobRef>>>;
  /** Comments for the note */
  comments?: Maybe<Array<Maybe<NoteComment>>>;
  /** Content the note was created for */
  content?: Maybe<Content>;
  /** The creation date */
  creationDate?: Maybe<Scalars['DateTime']>;
  /** The unique id */
  id: Scalars['ID'];
  /** The latest modification date */
  modificationDate?: Maybe<Scalars['DateTime']>;
  /** ID of object referenced by the note */
  objectId?: Maybe<Scalars['ID']>;
  /** Type of object referenced by the note */
  objectType?: Maybe<Scalars['String']>;
  /** Product the note was created for */
  product?: Maybe<Product>;
  /**
   * User that reviewed the note and approved publication.
   *
   * If the note gets revoked, the reviewer will not be updated until the
   * note is again in review process and is reviewed by eventually another reviewer.
   */
  reviewer?: Maybe<User>;
  /** Length limited text from the note for use e.g. in result lists, previews, etc. */
  teasers?: Maybe<NoteTeasers>;
  /** The note text */
  text?: Maybe<MultilingualString>;
  /** The user who owns the note */
  user?: Maybe<User>;
  /** The visibility for the note */
  visibility?: Maybe<NoteVisibilityTypes>;
};

/** Sub Graph: **https://user-generated-data-graph.qit.svc.cluster.local:8443** */
export type NoteComment = {
  __typename?: 'NoteComment';
  /** The creation date */
  creationDate?: Maybe<Scalars['DateTime']>;
  /** The unique id of the note comment */
  id: Scalars['ID'];
  /** The latest modification date */
  modificationDate?: Maybe<Scalars['DateTime']>;
  /** The text of the comment */
  text?: Maybe<Scalars['String']>;
  /** The user who created the comment */
  user?: Maybe<User>;
};

/** Sub Graph: **https://user-generated-data-graph.qit.svc.cluster.local:8443** */
export type NoteEdge = {
  __typename?: 'NoteEdge';
  /** Unique cursor for pagination. See the query's `after` argument */
  cursor: Scalars['String'];
  /** The result's note object */
  node: Note;
  /** Calculated relevance score. */
  score: Scalars['NonNegativeFloat'];
};

/** Sub Graph: **https://user-generated-data-graph.qit.svc.cluster.local:8443** */
export type NoteEqualsValueFilter = {
  /** Returns only notes with the specified approval date */
  approvalDate?: InputMaybe<Scalars['DateTime']>;
  /** Returns only notes with the specified creation date */
  creationDate?: InputMaybe<Scalars['DateTime']>;
  /** Returns only notes with the specified modification date */
  modificationDate?: InputMaybe<Scalars['DateTime']>;
  /** Returns only notes which reference the specified object id */
  objectId?: InputMaybe<Scalars['ID']>;
  /** Returns only notes reviewed by an user with the specified id */
  reviewerId?: InputMaybe<Scalars['ID']>;
  /** Returns only notes owned by an user with the specified id */
  userId?: InputMaybe<Scalars['ID']>;
  /** Returns only notes with the specified visibility */
  visibility?: InputMaybe<NoteVisibilityTypes>;
};

/** Sub Graph: **https://user-generated-data-graph.qit.svc.cluster.local:8443** */
export type NoteFilter = {
  /** Allows the specification of further filter criteria, which are grouped together and connected with a logical AND operator */
  andGroup?: InputMaybe<Array<InputMaybe<NoteFilter>>>;
  /** Boosts the score of all matches in this group by the specified factor. Heads up: The resulting score boost isn't mathematically exact due to rounding errors */
  boost?: InputMaybe<Scalars['Float']>;
  /** Returns notes that contain all of the exact values specified */
  equals?: InputMaybe<NoteEqualsValueFilter>;
  /** Full text search in notes */
  fullText?: InputMaybe<NoteFullTextFilter>;
  /** Filter by ids */
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Allows you to specify logically negated filter criteria */
  not?: InputMaybe<NoteFilter>;
  /** Allows the specification of further filter criteria, which are grouped together and connected with a logical OR operator */
  orGroup?: InputMaybe<Array<InputMaybe<NoteFilter>>>;
  /** Returns notes with values within all of the ranges specified */
  range?: InputMaybe<NoteRangeFilter>;
};

/** Sub Graph: **https://user-generated-data-graph.qit.svc.cluster.local:8443** */
export type NoteFullTextFields = {
  /** Match the query against any full text searchable field and rank the results with the specified boost */
  any?: InputMaybe<Scalars['Float']>;
  /** Match the query against the note text and rank the results with the specified boost */
  text?: InputMaybe<Scalars['Float']>;
};

/** Sub Graph: **https://user-generated-data-graph.qit.svc.cluster.local:8443** */
export type NoteFullTextFilter = {
  /** Fields to search in with their respective score weights */
  fields?: InputMaybe<NoteFullTextFields>;
  /** Indicates if a fuzzy search should be performed. */
  fuzzy?: InputMaybe<Scalars['Boolean']>;
  /** Specifies if either all or any query words need to match */
  operator?: InputMaybe<FullTextOperator>;
  /** Text to search for */
  query: Scalars['FullTextSearchQuery'];
  /** Type of fulltext search to perform */
  searchType?: InputMaybe<FullTextSearchType>;
};

/** Sub Graph: **https://user-generated-data-graph.qit.svc.cluster.local:8443** */
export type NoteQueryResult = {
  __typename?: 'NoteQueryResult';
  /**
   * The query's matching notes.
   *
   * Use the `sort` argument to specify the list of fields and the order by which the results should be sorted.
   * Multiple fields and orders may be specified and are evaluated in the provided order.
   *
   * To limit the number of results, set the `first` argument.
   *
   * Pagination is possible by setting the `after` argument to the previous last result's `cursor` field value.
   * Please be careful not to change the query's `filter` or the `sort` argument between paginated calls.
   */
  notes: Array<Maybe<NoteEdge>>;
  /**
   * Returns the total count of results.
   *
   * Use the `trackLimit` argument to limit the track of the total count up to the specified amount.
   * If the result has more hits than the specified limit the total count is inaccurate.
   * See `CountRelation` for further information on how to interpret the result.
   *
   * Heads up: Setting the `trackLimit` to a high value may decrease performance.
   */
  total: TotalCount;
};


/** Sub Graph: **https://user-generated-data-graph.qit.svc.cluster.local:8443** */
export type NoteQueryResultNotesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  sort?: InputMaybe<Array<InputMaybe<NoteSort>>>;
};


/** Sub Graph: **https://user-generated-data-graph.qit.svc.cluster.local:8443** */
export type NoteQueryResultTotalArgs = {
  trackLimit?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://user-generated-data-graph.qit.svc.cluster.local:8443** */
export type NoteRangeFilter = {
  /** Returns only notes with an approval date in the specified range */
  approvalDate?: InputMaybe<DateRange>;
  /** Returns only notes with a creation date in the specified range */
  creationDate?: InputMaybe<DateRange>;
  /** Returns only notes with a modification date in the specified range */
  modificationDate?: InputMaybe<DateRange>;
};

/** Sub Graph: **https://user-generated-data-graph.qit.svc.cluster.local:8443** */
export type NoteSort = {
  /** Sort field */
  field: NoteSortFields;
  /** Sort order */
  order?: InputMaybe<SortOrder>;
};

/** Sub Graph: **https://user-generated-data-graph.qit.svc.cluster.local:8443** */
export enum NoteSortFields {
  /** Sort by approval date */
  approvalDate = 'approvalDate',
  /** Sort by creation date */
  creationDate = 'creationDate',
  /** Sort by unique ID */
  id = 'id',
  /** Sort by modification date */
  modificationDate = 'modificationDate',
  /** Sort by object id */
  objectId = 'objectId',
  /** Sort by reviewer id */
  reviewerId = 'reviewerId',
  /** Sort by relevance score */
  score = 'score',
  /** Sort by user id */
  userId = 'userId',
  /** Sort by visibility */
  visibility = 'visibility'
}

/** Length limited text from the note for use e.g. in result lists, previews, etc. */
export type NoteTeasers = {
  __typename?: 'NoteTeasers';
  /**
   * The notes text limited to `length` characters.
   * Preferred language and the precedence of fallback languages can be specified via `acceptedLanguages`.
   */
  text?: Maybe<Scalars['String']>;
};


/** Length limited text from the note for use e.g. in result lists, previews, etc. */
export type NoteTeasersTextArgs = {
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard>>;
  length?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://user-generated-data-graph.qit.svc.cluster.local:8443** */
export type NoteTextUploadConfig = {
  __typename?: 'NoteTextUploadConfig';
  /** The maximal allowed text length per language */
  maxLength: Scalars['NonNegativeInt'];
};

/** The different visibility types for notes */
export enum NoteVisibilityTypes {
  /**
   * Indicates that the note is marked for publication, but has not yet approved
   * by an user with administrative privileges.
   *
   * Visibility is equal to 'private'.
   */
  pendingApproval = 'pendingApproval',
  /** Only visible to users with administrative privileges and the creator itself */
  private = 'private',
  /** Visible to everyone */
  public = 'public'
}

/** Sub Graph: **https://user-generated-data-graph.qit.svc.cluster.local:8443** */
export enum NoteVisibilityTypesInput {
  /** Visible to users with administrative privileges and the creator itself */
  private = 'private',
  /**
   * Visible to everyone with access to the referenced content.
   *
   * If the user doesn't have privileges to publish notes, the visibility state is changed to 'pendingApproval'
   * and needs to be reviewed by an user with administrative privileges. If the note gets approved the state is changed
   * to 'public', in case the note doesn't get approved the state is changed to 'private'
   */
  public = 'public'
}

/** Sub Graph: **https://user-generated-data-graph.qit.svc.cluster.local:8443** */
export type NotesUploadConfig = {
  __typename?: 'NotesUploadConfig';
  /** Upload config for the note attachments */
  attachments?: Maybe<UploadMultipleConfig>;
  /** Upload config for the text */
  text?: Maybe<NoteTextUploadConfig>;
};

/** Sub Graph: **https://basic-services-graph.qit.svc.cluster.local:8443** */
export type Notification = {
  __typename?: 'Notification';
  /** The creation date */
  creationDate?: Maybe<Scalars['DateTime']>;
  /** The unique id */
  id: Scalars['ID'];
  /** The type of the notification. */
  notificationType?: Maybe<Scalars['String']>;
  /** ID of object referenced by the notification */
  objectId?: Maybe<Scalars['ID']>;
  /** ID of object referenced by the notification */
  objectType?: Maybe<Scalars['String']>;
  /** Date the user read / clicked on the notification */
  readDate?: Maybe<Scalars['DateTime']>;
  /** Length limited text from the notification for use e.g. in result lists, previews, etc. */
  teasers?: Maybe<NotificationTeasers>;
  /** The notification text */
  text?: Maybe<MultilingualString>;
  /** Users that should receive the notification */
  users?: Maybe<Array<Maybe<User>>>;
};

/** Sub Graph: **https://basic-services-graph.qit.svc.cluster.local:8443** */
export type NotificationEdge = {
  __typename?: 'NotificationEdge';
  /** Unique cursor for pagination. See the query's `after` argument */
  cursor: Scalars['String'];
  /** The result's notification object */
  node: Notification;
  /** Calculated relevance score. */
  score: Scalars['NonNegativeFloat'];
};

/** Sub Graph: **https://basic-services-graph.qit.svc.cluster.local:8443** */
export type NotificationEqualsValueFilter = {
  /** Returns only notifications with the specified creation date */
  creationDate?: InputMaybe<Scalars['DateTime']>;
  /** Returns only notifications with the specified type */
  notificationType?: InputMaybe<Scalars['String']>;
  /** Returns only notifications with the specified object id */
  objectId?: InputMaybe<Scalars['ID']>;
  /** Returns only notifications with the specified object type */
  objectType?: InputMaybe<Scalars['String']>;
  /** Returns only notifications with the specified read date */
  readDate?: InputMaybe<Scalars['DateTime']>;
  /** Returns only notifications with the specified user id */
  userId?: InputMaybe<Scalars['ID']>;
};

/** Sub Graph: **https://basic-services-graph.qit.svc.cluster.local:8443** */
export enum NotificationExistsValueFields {
  /** Returns only notifications which have a read date specified */
  readDate = 'readDate'
}

/** Sub Graph: **https://basic-services-graph.qit.svc.cluster.local:8443** */
export type NotificationFilter = {
  /** Allows to filter all notifications */
  all?: InputMaybe<Scalars['Boolean']>;
  /** Allows the specification of further filter criteria, which are grouped together and connected with a logical AND operator */
  andGroup?: InputMaybe<Array<InputMaybe<NotificationFilter>>>;
  /** Boosts the score of all matches in this group by the specified factor. Heads up: The resulting score boost isn't mathematically exact due to rounding errors */
  boost?: InputMaybe<Scalars['Float']>;
  /** Returns notifications that contain all of the exact values specified */
  equals?: InputMaybe<NotificationEqualsValueFilter>;
  /** Returns notifications that have a value in all of the specified fields */
  exists?: InputMaybe<Array<InputMaybe<NotificationExistsValueFields>>>;
  /** Full text search in notifications */
  fullText?: InputMaybe<NotificationFullTextFilter>;
  /** Filter by ids */
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Allows you to specify logically negated filter criteria */
  not?: InputMaybe<NotificationFilter>;
  /** Allows the specification of further filter criteria, which are grouped together and connected with a logical OR operator */
  orGroup?: InputMaybe<Array<InputMaybe<NotificationFilter>>>;
  /** Returns notifications with values within all of the ranges specified */
  range?: InputMaybe<NotificationRangeFilter>;
};

/** Sub Graph: **https://basic-services-graph.qit.svc.cluster.local:8443** */
export type NotificationFullTextFields = {
  /** Match the query against any full text searchable field and rank the results with the specified boost */
  any?: InputMaybe<Scalars['Float']>;
  /** Match the query against the notification message and rank the results with the specified boost */
  text?: InputMaybe<Scalars['Float']>;
};

/** Sub Graph: **https://basic-services-graph.qit.svc.cluster.local:8443** */
export type NotificationFullTextFilter = {
  /** Fields to search in with their respective score weights */
  fields?: InputMaybe<NotificationFullTextFields>;
  /** Indicates if a fuzzy search should be performed. */
  fuzzy?: InputMaybe<Scalars['Boolean']>;
  /** Specifies if either all or any query words need to match */
  operator?: InputMaybe<FullTextOperator>;
  /**
   * The text to search for.
   * Be aware: The Limit for full text search queries is 1024 characters and
   * anything above that will result in an error.
   */
  query: Scalars['FullTextSearchQuery'];
  /** Type of fulltext search to perform */
  searchType?: InputMaybe<FullTextSearchType>;
};

/** Sub Graph: **https://basic-services-graph.qit.svc.cluster.local:8443** */
export type NotificationQueryResult = {
  __typename?: 'NotificationQueryResult';
  /**
   * The query's matching notifications.
   *
   * Use the `sort` argument to specify the list of fields and the order by which the results should be sorted.
   * Multiple fields and orders may be specified and are evaluated in the provided order.
   *
   * To limit the number of results, set the `first` argument.
   *
   * Pagination is possible by setting the `after` argument to the previous last result's `cursor` field value.
   * Please be careful not to change the query's `filter` or the `sort` argument between paginated calls.
   */
  notifications: Array<Maybe<NotificationEdge>>;
  /**
   * Returns the total count of results.
   *
   * Use the `trackLimit` argument to limit the track of the total count up to the specified amount.
   * If the result has more hits than the specified limit the total count is inaccurate.
   * See `CountRelation` for further information on how to interpret the result.
   *
   * Heads up: Setting the `trackLimit` to a high value may decrease performance.
   */
  total: TotalCount;
};


/** Sub Graph: **https://basic-services-graph.qit.svc.cluster.local:8443** */
export type NotificationQueryResultNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  sort?: InputMaybe<Array<InputMaybe<NotificationSort>>>;
};


/** Sub Graph: **https://basic-services-graph.qit.svc.cluster.local:8443** */
export type NotificationQueryResultTotalArgs = {
  trackLimit?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://basic-services-graph.qit.svc.cluster.local:8443** */
export type NotificationRangeFilter = {
  /** Returns only notifications with a creation date in the specified range */
  creationDate?: InputMaybe<DateRange>;
  /** Returns only notifications with a read date in the specified range */
  readDate?: InputMaybe<DateRange>;
};

/** Sub Graph: **https://basic-services-graph.qit.svc.cluster.local:8443** */
export type NotificationSort = {
  /** Sort field */
  field: NotificationSortFields;
  /** Sort order */
  order?: InputMaybe<SortOrder>;
};

/** Sub Graph: **https://basic-services-graph.qit.svc.cluster.local:8443** */
export enum NotificationSortFields {
  /** Sort by creation date */
  creationDate = 'creationDate',
  /** Sort by unique ID */
  id = 'id',
  /** Sort by relevance score */
  score = 'score'
}

/** Length limited text from the notification for use e.g. in result lists, previews, etc. */
export type NotificationTeasers = {
  __typename?: 'NotificationTeasers';
  /**
   * The notifications title limited to `length` characters.
   * Preferred language and the precedence of fallback languages can be specified via `acceptedLanguages`.
   */
  text?: Maybe<Scalars['String']>;
};


/** Length limited text from the notification for use e.g. in result lists, previews, etc. */
export type NotificationTeasersTextArgs = {
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard>>;
  length?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Defines a numeric datafield. */
export type NumberDatafieldDefinition = DatafieldDefinition & {
  __typename?: 'NumberDatafieldDefinition';
  /** Type of this indexed field definition */
  fieldType?: Maybe<FieldDefinitionTypes>;
  /**
   * Unique identifier of this indexed field definition.
   * Is used as field name in all interfaces and must adhere to the
   * following pattern: ^[_A-Za-z][_0-9A-Za-z]{0,128}$
   */
  id: Scalars['DatafieldDefinitionID'];
  /** Text from the datafield definition for use e.g. in detail views, etc */
  localizations?: Maybe<DatafieldDefinitionLocalizations>;
  /** Datafield names which shall be mapped to this indexed field definition */
  mappedNames?: Maybe<Array<Scalars['String']>>;
  /** Optional maximum value for this datafield */
  max?: Maybe<Scalars['Float']>;
  /** Optional minimum value for this datafield */
  min?: Maybe<Scalars['Float']>;
  /** List of all objectTypes this definition is assigned to */
  objectTypes?: Maybe<Array<Maybe<ObjectType>>>;
  /** Length limited text from the indexed field definition for use e.g. in result lists, previews, etc. */
  teasers?: Maybe<DatafieldDefinitionTeasers>;
  /** Human readable description of this indexed field definition */
  title?: Maybe<MultilingualString>;
};

/** Defines a numeric datafield field. */
export type NumberRangeDatafieldDefinition = DatafieldDefinition & {
  __typename?: 'NumberRangeDatafieldDefinition';
  /** Type of this datafield definition */
  fieldType?: Maybe<FieldDefinitionTypes>;
  /**
   * Unique identifier of this datafield definition.
   * Is used as field name in all interfaces and must adhere to the
   * following pattern: ^[_A-Za-z][_0-9A-Za-z]{0,128}$
   */
  id: Scalars['DatafieldDefinitionID'];
  /** Text from the datafield definition for use e.g. in detail views, etc */
  localizations?: Maybe<DatafieldDefinitionLocalizations>;
  /** Datafield names which shall be mapped to this datafield definition */
  mappedNames?: Maybe<Array<Scalars['String']>>;
  /** List of all objectTypes this definition is assigned to */
  objectTypes?: Maybe<Array<Maybe<ObjectType>>>;
  /** Length limited text from the datafield definition for use e.g. in result lists, previews, etc. */
  teasers?: Maybe<DatafieldDefinitionTeasers>;
  /** Human readable description of this datafield definition */
  title?: Maybe<MultilingualString>;
};

/** Sub Graph: **https://data-filter-graph.qit-data-filter.svc.cluster.local:8443** */
export type NumberRangeFacetDefinition = FacetDefinition & {
  __typename?: 'NumberRangeFacetDefinition';
  /** The datafield type of the field */
  fieldType: FieldDefinitionTypes;
};

/** Sub Graph: **https://schematic-graph.qit-schematic.svc.cluster.local:8443** */
export enum ObjectType {
  activity = 'activity',
  article = 'article',
  asset = 'asset',
  assetOption = 'assetOption',
  contentMap = 'contentMap',
  mechanic = 'mechanic',
  product = 'product',
  topic = 'topic'
}

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type Part = {
  __typename?: 'Part';
  /** Date and time when it was created */
  creationDate?: Maybe<Scalars['DateTime']>;
  /** Raw part data key/value rows */
  data: Array<PartDataEntry>;
  /** Unique identifier for this part */
  id: Scalars['ID'];
  /** Reference part number */
  linkPartNo?: Maybe<Scalars['String']>;
  /** Date and time of the last modification */
  modificationDate?: Maybe<Scalars['DateTime']>;
  /** Order number */
  orderNo?: Maybe<Scalars['String']>;
  /** Part number from XML */
  partNo: Scalars['String'];
  /** Schematic document ID this part belongs to */
  schematicId: Scalars['String'];
  /** Part title (bilingual from translations) */
  title?: Maybe<MultilingualString>;
  /** Visible part number */
  visiblePartNo?: Maybe<Scalars['String']>;
};

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type PartDataEntry = {
  __typename?: 'PartDataEntry';
  /** Data key */
  key: Scalars['String'];
  /** Data value */
  value?: Maybe<Scalars['String']>;
};

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type PartDatafieldAggregations = {
  __typename?: 'PartDatafieldAggregations';
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  composite?: Maybe<PartDatafieldCompositeAggregation>;
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  terms?: Maybe<DatafieldTermsAggregation>;
};

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type PartDatafieldCompositeAggregation = {
  __typename?: 'PartDatafieldCompositeAggregation';
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  orderNo?: Maybe<Array<AggregationEdge>>;
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  partNo?: Maybe<Array<AggregationEdge>>;
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  schematicId?: Maybe<Array<AggregationEdge>>;
};


/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type PartDatafieldCompositeAggregationOrderNoArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
};


/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type PartDatafieldCompositeAggregationPartNoArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
};


/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type PartDatafieldCompositeAggregationSchematicIdArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type PartEdge = {
  __typename?: 'PartEdge';
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  cursor: Scalars['String'];
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  node: Part;
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  score: Scalars['NonNegativeFloat'];
};

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type PartEqualsValueFilter = {
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  linkPartNo?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  orderNo?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  partNo?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  schematicId?: InputMaybe<Scalars['String']>;
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  visiblePartNo?: InputMaybe<Scalars['String']>;
};

/** The `PartFilter` is used to specify filter criteria for parts. */
export type PartFilter = {
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  all?: InputMaybe<Scalars['Boolean']>;
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  andGroup?: InputMaybe<Array<InputMaybe<PartFilter>>>;
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  boost?: InputMaybe<Scalars['Float']>;
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  equals?: InputMaybe<PartEqualsValueFilter>;
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  fullText?: InputMaybe<PartFullTextFilter>;
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  has?: InputMaybe<PartHasValueFilter>;
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  not?: InputMaybe<PartFilter>;
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  orGroup?: InputMaybe<Array<InputMaybe<PartFilter>>>;
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  regex?: InputMaybe<PartRegexFilter>;
};

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type PartFullTextFields = {
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  any?: InputMaybe<Scalars['Float']>;
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  orderNo?: InputMaybe<Scalars['Float']>;
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  partNo?: InputMaybe<Scalars['Float']>;
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  title?: InputMaybe<Scalars['Float']>;
};

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type PartFullTextFilter = {
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  fields?: InputMaybe<PartFullTextFields>;
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  fuzzy?: InputMaybe<Scalars['Boolean']>;
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  operator?: InputMaybe<FullTextOperator>;
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  query: Scalars['FullTextSearchQuery'];
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  searchType?: InputMaybe<FullTextSearchType>;
};

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type PartHasValueFilter = {
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  valueInFields?: InputMaybe<Array<InputMaybe<PartHasValueInFields>>>;
};

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export enum PartHasValueInFields {
  linkPartNo = 'linkPartNo',
  orderNo = 'orderNo',
  partNo = 'partNo',
  title = 'title',
  visiblePartNo = 'visiblePartNo'
}

/** Context information for the cart item. */
export type PartLocation = {
  __typename?: 'PartLocation';
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  mechanicId?: Maybe<Scalars['String']>;
};

/** Input types */
export type PartLocationInput = {
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  mechanicId: Scalars['String'];
};

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type PartQueryResult = {
  __typename?: 'PartQueryResult';
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  aggregations: PartDatafieldAggregations;
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  parts: Array<Maybe<PartEdge>>;
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  total: TotalCount;
};


/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type PartQueryResultPartsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  sort?: InputMaybe<Array<InputMaybe<PartSort>>>;
};


/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type PartQueryResultTotalArgs = {
  trackLimit?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type PartRegexFilter = {
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  linkPartNo?: InputMaybe<Scalars['FilterRegex']>;
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  orderNo?: InputMaybe<Scalars['FilterRegex']>;
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  partNo?: InputMaybe<Scalars['FilterRegex']>;
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  schematicId?: InputMaybe<Scalars['FilterRegex']>;
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  visiblePartNo?: InputMaybe<Scalars['FilterRegex']>;
};

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type PartSort = {
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  field: PartSortFields;
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  order?: InputMaybe<SortOrder>;
};

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export enum PartSortFields {
  creationDate = 'creationDate',
  id = 'id',
  linkPartNo = 'linkPartNo',
  modificationDate = 'modificationDate',
  orderNo = 'orderNo',
  partNo = 'partNo',
  schematicId = 'schematicId',
  score = 'score',
  visiblePartNo = 'visiblePartNo'
}

/** Sub Graph: **https://pdf-structure-creator-graph.qit-basic-services.svc.cluster.local:8443** */
export type PdfCatalogRequestStatus = {
  __typename?: 'PdfCatalogRequestStatus';
  /** Sub Graph: **https://pdf-structure-creator-graph.qit-basic-services.svc.cluster.local:8443** */
  creationDate: Scalars['DateTime'];
  /** Sub Graph: **https://pdf-structure-creator-graph.qit-basic-services.svc.cluster.local:8443** */
  modificationDate: Scalars['DateTime'];
  /** Sub Graph: **https://pdf-structure-creator-graph.qit-basic-services.svc.cluster.local:8443** */
  requestId: Scalars['String'];
  /** Sub Graph: **https://pdf-structure-creator-graph.qit-basic-services.svc.cluster.local:8443** */
  status: PdfCatalogRequestStatusEnum;
};

/** Sub Graph: **https://pdf-structure-creator-graph.qit-basic-services.svc.cluster.local:8443** */
export enum PdfCatalogRequestStatusEnum {
  active = 'ACTIVE',
  completed = 'COMPLETED',
  failed = 'FAILED',
  new = 'NEW'
}

/** PDF Catalog Request API for requesting the creation of PDF catalogs based on product and asset information. */
export type PdfRequestData = {
  /** Sub Graph: **https://pdf-structure-creator-graph.qit-basic-services.svc.cluster.local:8443** */
  assetId?: InputMaybe<Scalars['String']>;
  /**
   * At least one and optionally a second languge.
   * One language is typicically the current UI language.
   * Duplicate languages are not allowed - each language must be unique.
   */
  languages: Array<Language>;
  /** Sub Graph: **https://pdf-structure-creator-graph.qit-basic-services.svc.cluster.local:8443** */
  productId: Scalars['String'];
};

/** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export enum Priority {
  high = 'high',
  low = 'low',
  standard = 'standard'
}

/** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
export type Process = {
  __typename?: 'Process';
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  columns?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  deleteAll?: Maybe<Scalars['Boolean']>;
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  delimiter?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  encoding?: Maybe<ProcessEncodingType>;
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  escape?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  filenameSchemaName?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  id?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  mappingOptions?: Maybe<Array<Maybe<MappingOption>>>;
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  name: Scalars['String'];
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  processType: ProcessType;
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  svgRegexPattern?: Maybe<Scalars['String']>;
};

/** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
export type ProcessDatafieldMapping = {
  /** Returns column(s) which also map to the same field. In this case a process cannot be created due to ambiguousness. */
  ambiguousColumns?: Maybe<Array<Scalars['String']>>;
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  column: Scalars['String'];
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  field?: Maybe<Datafield>;
};

/** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
export enum ProcessEncodingType {
  latin1 = 'LATIN1',
  utf8 = 'UTF8',
  utf16Le = 'UTF16LE'
}

/** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
export enum ProcessMappingType {
  filenameComplete = 'FILENAME_COMPLETE',
  filenameUpToChar = 'FILENAME_UP_TO_CHAR',
  folderName = 'FOLDER_NAME'
}

/** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
export enum ProcessType {
  activity = 'ACTIVITY',
  article = 'ARTICLE',
  asset = 'ASSET',
  assetOption = 'ASSET_OPTION',
  documentation = 'DOCUMENTATION',
  file = 'FILE',
  mechanic = 'MECHANIC',
  product = 'PRODUCT',
  relation = 'RELATION',
  schematicZip = 'SCHEMATIC_ZIP'
}

/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type Product = {
  __typename?: 'Product';
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  assets?: Maybe<ProductAssetsQueryResult>;
  /** Date and time when it was created */
  creationDate?: Maybe<Scalars['DateTime']>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  files?: Maybe<Array<File>>;
  /** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
  id: Scalars['ID'];
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  localizations?: Maybe<ProductLocalizations>;
  /** Date and time of the last modification */
  modificationDate?: Maybe<Scalars['DateTime']>;
  /**
   * Relevant notes for the product.
   *
   * This field only shows private, pendingApproval notes created by the requesting user and any public notes
   * that reference the product.
   *
   * Even with administrative privileges this field only shows the above mentioned notes and therefore doesn't include any notes
   * which don't belong to the requesting user except the public ones. To view any note and filter them, refer to the
   * filter query for the notes.
   */
  notes?: Maybe<NoteQueryResult>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  previewImage?: Maybe<BlobRef>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  referenceId?: Maybe<Scalars['String']>;
  /**
   * Related activity to the product id. The given activity filter is optional and is combined (AND clause) with
   * a static filter:
   * { taxonomy: { custom_products: [product.id] } }
   * This returns only activities related to the specific product.
   */
  relatedActivities: ActivityQueryResult;
  /**
   * Related content to the product id. The given content filter is optional and is combined (AND clause) with
   * a static filter:
   * { taxonomy: { custom_products: [product.id] } }
   * This returns only contents related to the specific product.
   */
  relatedContents: ContentQueryResult;
  /** Same relation filter as `relatedContents`, grouped using a configured grouping criterion. */
  relatedContentsGrouped: ContentGroupedQueryResult;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  teasers?: Maybe<ProductTeasers>;
  /** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
  title?: Maybe<MultilingualString>;
};


/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type ProductFilesArgs = {
  fileTypes?: InputMaybe<Array<InputMaybe<FileType>>>;
};


/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type ProductNotesArgs = {
  filter?: InputMaybe<NoteFilter>;
};


/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type ProductRelatedActivitiesArgs = {
  filter?: InputMaybe<ActivityFilter>;
};


/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type ProductRelatedContentsArgs = {
  filter?: InputMaybe<ContentFilter>;
  filterOptions?: InputMaybe<ContentFilterOptions>;
};


/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type ProductRelatedContentsGroupedArgs = {
  filter?: InputMaybe<ContentFilter>;
  filterOptions?: InputMaybe<ContentFilterOptions>;
  groupBy: ContentGroupBy;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type ProductAssetsQueryResult = {
  __typename?: 'ProductAssetsQueryResult';
  /**
   * Returns the total count of results.
   *
   * Use the `trackLimit` argument to limit the track of the total count up to the specified amount.
   * If the result has more hits than the specified limit the total count is inaccurate.
   * See `CountRelation` for further information on how to interpret the result.
   *
   * Heads up: Setting the `trackLimit` to a high value may decrease performance.
   */
  total: TotalCount;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type ProductAutocompleteHits = {
  __typename?: 'ProductAutocompleteHits';
  /** The count of docs found containing the suggestion */
  docCount: Scalars['NonNegativeInt'];
  /** The language this suggestion stems from */
  language?: Maybe<Language>;
  /** The found suggestion */
  suggest: Scalars['String'];
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type ProductAutocompleteResult = {
  __typename?: 'ProductAutocompleteResult';
  /** The hits found for the query */
  hits?: Maybe<Array<ProductAutocompleteHits>>;
  /** The query used for this result */
  query: Scalars['String'];
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type ProductEdge = {
  __typename?: 'ProductEdge';
  /** Unique cursor for pagination. See the query's `after` argument */
  cursor: Scalars['String'];
  /** The result's product type. */
  node: Product;
  /** Calculated relevance score. */
  score: Scalars['NonNegativeFloat'];
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type ProductEqualsOneOfValueFilter = {
  /** Returns products with one of the specified unique identifiers */
  id?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type ProductEqualsValueFilter = {
  /** Returns only with the specified creation date */
  creationDate?: InputMaybe<Scalars['DateTime']>;
  /** Returns only products with the specified unique identifier */
  id?: InputMaybe<Scalars['String']>;
  /** Returns only with the specified modification date */
  modificationDate?: InputMaybe<Scalars['DateTime']>;
  /**
   * Returns only products with the specified title
   * @deprecated Use two title_xx fields for InfoTwin language and tenant default language instead
   */
  title?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified ar title */
  title_ar?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified bg title */
  title_bg?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified bn title */
  title_bn?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified bs title */
  title_bs?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified ca title */
  title_ca?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified cs title */
  title_cs?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified da title */
  title_da?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified de title */
  title_de?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified el title */
  title_el?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified en title */
  title_en?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified es title */
  title_es?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified et title */
  title_et?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified eu title */
  title_eu?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified fa title */
  title_fa?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified fi title */
  title_fi?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified fr title */
  title_fr?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified ga title */
  title_ga?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified he title */
  title_he?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified hi title */
  title_hi?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified hr title */
  title_hr?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified hu title */
  title_hu?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified hy title */
  title_hy?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified id title */
  title_id?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified is title */
  title_is?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified it title */
  title_it?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified ja title */
  title_ja?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified kk title */
  title_kk?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified ko title */
  title_ko?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified ku title */
  title_ku?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified lt title */
  title_lt?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified lv title */
  title_lv?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified mk title */
  title_mk?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified ms title */
  title_ms?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified mt title */
  title_mt?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified nb title */
  title_nb?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified nl title */
  title_nl?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified no title */
  title_no?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified pb title */
  title_pb?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified pl title */
  title_pl?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified pt title */
  title_pt?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified ro title */
  title_ro?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified ru title */
  title_ru?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified sk title */
  title_sk?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified sl title */
  title_sl?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified sq title */
  title_sq?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified sr title */
  title_sr?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified sv title */
  title_sv?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified th title */
  title_th?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified tr title */
  title_tr?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified uk title */
  title_uk?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified vi title */
  title_vi?: InputMaybe<Scalars['String']>;
  /** Returns only products with the specified zh title */
  title_zh?: InputMaybe<Scalars['String']>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export enum ProductExistsValueFields {
  /** Returns only products which have a title specified */
  title = 'title'
}

/**
 * The `ProductFilter` is used to specify filter criteria for products.
 * If you specify more than one criterion, all criteria are grouped together and connected with a logical AND operator.
 * Further logical operations are possible by using `not` `andGroup` and `orGroup`.
 */
export type ProductFilter = {
  /** Returns all products if set to true */
  all?: InputMaybe<Scalars['Boolean']>;
  /** Allows the specification of further filter criteria, which are grouped together and connected with a logical AND operator */
  andGroup?: InputMaybe<Array<InputMaybe<ProductFilter>>>;
  /** Boosts the score of all matches in this group by the specified factor. Heads up: The resulting score boost isn't mathematically exact due to rounding errors */
  boost?: InputMaybe<Scalars['Float']>;
  /** Returns products that contain all of the exact values specified */
  equals?: InputMaybe<ProductEqualsValueFilter>;
  /** Returns products that contain any of the exact values specified */
  equalsOneOf?: InputMaybe<ProductEqualsOneOfValueFilter>;
  /**
   * Returns products that have a value in all of the specified fields
   * @deprecated Please use 'has' filter instead
   */
  exists?: InputMaybe<Array<InputMaybe<ProductExistsValueFields>>>;
  /** Returns products that match all of the specified full text searches */
  fullText?: InputMaybe<ProductFullTextFilter>;
  /** Returns products that have a value in all of the specified fields */
  has?: InputMaybe<ProductHasValueFilter>;
  /** Returns products with one of the specified unique identifiers */
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Allows you to specify logically negated filter criteria */
  not?: InputMaybe<ProductFilter>;
  /** Allows the specification of further filter criteria, which are grouped together and connected with a logical OR operator */
  orGroup?: InputMaybe<Array<InputMaybe<ProductFilter>>>;
  /** Returns products with values within all of the ranges specified */
  range?: InputMaybe<ProductRangeFilter>;
  /** Returns products that match all of the regular expressions */
  regex?: InputMaybe<ProductRegexFilter>;
  /** Returns products that match a taxonomy value according to the taxonomy's evaluation type */
  taxonomy?: InputMaybe<ProductTaxonomyFilter>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type ProductFullTextFields = {
  /** Match the query against any full text searchable field and rank the results with the specified boost */
  any?: InputMaybe<Scalars['Float']>;
  /**
   * Match the query against the title of the current language and the tenant default language and rank the results with the specified boost
   * @deprecated Use two title_xx fields for InfoTwin language and tenant default language instead
   */
  title?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_ar?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_bg?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_bn?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_bs?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_ca?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_cs?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_da?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_de?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_el?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_en?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_es?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_et?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_eu?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_fa?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_fi?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_fr?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_ga?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_he?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_hi?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_hr?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_hu?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_hy?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_id?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_is?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_it?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_ja?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_kk?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_ko?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_ku?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_lt?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_lv?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_mk?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_ms?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_mt?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_nb?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_nl?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_no?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_pb?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_pl?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_pt?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_ro?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_ru?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_sk?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_sl?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_sq?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_sr?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_sv?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_th?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_tr?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_uk?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_vi?: InputMaybe<Scalars['Float']>;
  /** Match the query against the  title and rank the results with the specified boost */
  title_zh?: InputMaybe<Scalars['Float']>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type ProductFullTextFilter = {
  /** Fields to search in with their respective score weights */
  fields?: InputMaybe<ProductFullTextFields>;
  /** Indicates if a fuzzy search should be performed. */
  fuzzy?: InputMaybe<Scalars['Boolean']>;
  /** Specifies if either all or any query words need to match */
  operator?: InputMaybe<FullTextOperator>;
  /**
   * Text to search for
   * Be aware: The Limit for full text search queries is 1024 characters and
   * anything above that will result in an error.
   */
  query: Scalars['FullTextSearchQuery'];
  /** Type of fulltext search to perform */
  searchType?: InputMaybe<FullTextSearchType>;
};

/** Returns products that have a value in all of the specified fields */
export type ProductHasValueFilter = {
  /** Specify the fields that the returned products must have a value in */
  valueInFields?: InputMaybe<Array<InputMaybe<ProductHasValueInFields>>>;
};

/** Specify the fields that the returned products must have a value in */
export enum ProductHasValueInFields {
  /** Returns only products which have a title specified */
  title = 'title'
}

/** Text from the product for use e.g. in details. */
export type ProductLocalizations = {
  __typename?: 'ProductLocalizations';
  /** The product's title */
  title?: Maybe<Scalars['String']>;
};


/** Text from the product for use e.g. in details. */
export type ProductLocalizationsTitleArgs = {
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard>>;
};

/** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
export enum ProductNames {
  devices = 'DEVICES',
  machines = 'MACHINES',
  models = 'MODELS',
  plants = 'PLANTS',
  products = 'PRODUCTS',
  types = 'TYPES'
}

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type ProductQueryResult = {
  __typename?: 'ProductQueryResult';
  /**
   * Matched datafield values and number of matching products per value
   *
   * To limit the number of results, set the `first` argument.
   *
   * Pagination is possible by setting the `after` argument to the previous last result's `cursor` field value.
   */
  aggregations: DatafieldAggregations;
  /**
   * The query's matching products.
   *
   * Use the `sort` argument to specify the list of fields and the order by which the results should be sorted.
   * Multiple fields and orders may be specified and are evaluated in the provided order.
   *
   * To limit the number of results, set the `first` argument.
   *
   * Pagination is possible by setting the `after` argument to the previous last result's `cursor` field value.
   * Please be careful not to change the query's `filter` or the `sort` argument between paginated calls.
   */
  products: Array<Maybe<ProductEdge>>;
  /**
   * Returns the total count of results.
   *
   * Use the `trackLimit` argument to limit the track of the total count up to the specified amount.
   * If the result has more hits than the specified limit the total count is inaccurate.
   * See `CountRelation` for further information on how to interpret the result.
   *
   * Heads up: Setting the `trackLimit` to a high value may decrease performance.
   */
  total: TotalCount;
};


/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type ProductQueryResultProductsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  sort?: InputMaybe<Array<InputMaybe<ProductSort>>>;
};


/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type ProductQueryResultTotalArgs = {
  trackLimit?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type ProductRangeFilter = {
  /** Returns only with a creation date in the specified range */
  creationDate?: InputMaybe<DateRange>;
  /** Returns only with a modification date in the specified range */
  modificationDate?: InputMaybe<DateRange>;
  /** No number or dateTime datafield definitions exist. As soon as the first such datafield definition is defined, it's automatically listed here. */
  not_applicable_as_no_number_or_date_datafield_definitions_exist?: InputMaybe<Scalars['NoDynamicValueDefined']>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type ProductRegexFilter = {
  /** Returns only products whose id matches the specified Regex */
  id?: InputMaybe<Scalars['FilterRegex']>;
  /**
   * Returns only products whose title of the current language and the tenant default language matches the specified Regex
   * @deprecated Use two title_xx fields for InfoTwin language and tenant default language instead
   */
  title?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose ar title matches the specified Regex */
  title_ar?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose bg title matches the specified Regex */
  title_bg?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose bn title matches the specified Regex */
  title_bn?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose bs title matches the specified Regex */
  title_bs?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose ca title matches the specified Regex */
  title_ca?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose cs title matches the specified Regex */
  title_cs?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose da title matches the specified Regex */
  title_da?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose de title matches the specified Regex */
  title_de?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose el title matches the specified Regex */
  title_el?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose en title matches the specified Regex */
  title_en?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose es title matches the specified Regex */
  title_es?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose et title matches the specified Regex */
  title_et?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose eu title matches the specified Regex */
  title_eu?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose fa title matches the specified Regex */
  title_fa?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose fi title matches the specified Regex */
  title_fi?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose fr title matches the specified Regex */
  title_fr?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose ga title matches the specified Regex */
  title_ga?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose he title matches the specified Regex */
  title_he?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose hi title matches the specified Regex */
  title_hi?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose hr title matches the specified Regex */
  title_hr?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose hu title matches the specified Regex */
  title_hu?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose hy title matches the specified Regex */
  title_hy?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose id title matches the specified Regex */
  title_id?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose is title matches the specified Regex */
  title_is?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose it title matches the specified Regex */
  title_it?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose ja title matches the specified Regex */
  title_ja?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose kk title matches the specified Regex */
  title_kk?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose ko title matches the specified Regex */
  title_ko?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose ku title matches the specified Regex */
  title_ku?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose lt title matches the specified Regex */
  title_lt?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose lv title matches the specified Regex */
  title_lv?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose mk title matches the specified Regex */
  title_mk?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose ms title matches the specified Regex */
  title_ms?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose mt title matches the specified Regex */
  title_mt?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose nb title matches the specified Regex */
  title_nb?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose nl title matches the specified Regex */
  title_nl?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose no title matches the specified Regex */
  title_no?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose pb title matches the specified Regex */
  title_pb?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose pl title matches the specified Regex */
  title_pl?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose pt title matches the specified Regex */
  title_pt?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose ro title matches the specified Regex */
  title_ro?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose ru title matches the specified Regex */
  title_ru?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose sk title matches the specified Regex */
  title_sk?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose sl title matches the specified Regex */
  title_sl?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose sq title matches the specified Regex */
  title_sq?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose sr title matches the specified Regex */
  title_sr?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose sv title matches the specified Regex */
  title_sv?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose th title matches the specified Regex */
  title_th?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose tr title matches the specified Regex */
  title_tr?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose uk title matches the specified Regex */
  title_uk?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose vi title matches the specified Regex */
  title_vi?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only products whose zh title matches the specified Regex */
  title_zh?: InputMaybe<Scalars['FilterRegex']>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type ProductSort = {
  /** Sort field */
  field: ProductSortFields;
  /** Sort order */
  order?: InputMaybe<SortOrder>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export enum ProductSortFields {
  /** Sort by creation date */
  creationDate = 'creationDate',
  /** Sort by unique ID */
  id = 'id',
  /** Sort by modification date */
  modificationDate = 'modificationDate',
  /** Sort by relevance score */
  score = 'score',
  /**
   * Sort by title
   * @deprecated Use two title_xx fields for InfoTwin language and tenant default language instead
   */
  title = 'title',
  /** Sort by language-ar title */
  titleAr = 'title_ar',
  /** Sort by language-bg title */
  titleBg = 'title_bg',
  /** Sort by language-bn title */
  titleBn = 'title_bn',
  /** Sort by language-bs title */
  titleBs = 'title_bs',
  /** Sort by language-ca title */
  titleCa = 'title_ca',
  /** Sort by language-cs title */
  titleCs = 'title_cs',
  /** Sort by language-da title */
  titleDa = 'title_da',
  /** Sort by language-de title */
  titleDe = 'title_de',
  /** Sort by language-el title */
  titleEl = 'title_el',
  /** Sort by language-en title */
  titleEn = 'title_en',
  /** Sort by language-es title */
  titleEs = 'title_es',
  /** Sort by language-et title */
  titleEt = 'title_et',
  /** Sort by language-eu title */
  titleEu = 'title_eu',
  /** Sort by language-fa title */
  titleFa = 'title_fa',
  /** Sort by language-fi title */
  titleFi = 'title_fi',
  /** Sort by language-fr title */
  titleFr = 'title_fr',
  /** Sort by language-ga title */
  titleGa = 'title_ga',
  /** Sort by language-he title */
  titleHe = 'title_he',
  /** Sort by language-hi title */
  titleHi = 'title_hi',
  /** Sort by language-hr title */
  titleHr = 'title_hr',
  /** Sort by language-hu title */
  titleHu = 'title_hu',
  /** Sort by language-hy title */
  titleHy = 'title_hy',
  /** Sort by language-id title */
  titleId = 'title_id',
  /** Sort by language-is title */
  titleIs = 'title_is',
  /** Sort by language-it title */
  titleIt = 'title_it',
  /** Sort by language-ja title */
  titleJa = 'title_ja',
  /** Sort by language-kk title */
  titleKk = 'title_kk',
  /** Sort by language-ko title */
  titleKo = 'title_ko',
  /** Sort by language-ku title */
  titleKu = 'title_ku',
  /** Sort by language-lt title */
  titleLt = 'title_lt',
  /** Sort by language-lv title */
  titleLv = 'title_lv',
  /** Sort by language-mk title */
  titleMk = 'title_mk',
  /** Sort by language-ms title */
  titleMs = 'title_ms',
  /** Sort by language-mt title */
  titleMt = 'title_mt',
  /** Sort by language-nb title */
  titleNb = 'title_nb',
  /** Sort by language-nl title */
  titleNl = 'title_nl',
  /** Sort by language-no title */
  titleNo = 'title_no',
  /** Sort by language-pb title */
  titlePb = 'title_pb',
  /** Sort by language-pl title */
  titlePl = 'title_pl',
  /** Sort by language-pt title */
  titlePt = 'title_pt',
  /** Sort by language-ro title */
  titleRo = 'title_ro',
  /** Sort by language-ru title */
  titleRu = 'title_ru',
  /** Sort by language-sk title */
  titleSk = 'title_sk',
  /** Sort by language-sl title */
  titleSl = 'title_sl',
  /** Sort by language-sq title */
  titleSq = 'title_sq',
  /** Sort by language-sr title */
  titleSr = 'title_sr',
  /** Sort by language-sv title */
  titleSv = 'title_sv',
  /** Sort by language-th title */
  titleTh = 'title_th',
  /** Sort by language-tr title */
  titleTr = 'title_tr',
  /** Sort by language-uk title */
  titleUk = 'title_uk',
  /** Sort by language-vi title */
  titleVi = 'title_vi',
  /** Sort by language-zh title */
  titleZh = 'title_zh'
}

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type ProductTaxonomyFilter = {
  /** No taxonomy datafield definitions exist. As soon as the first taxonomy is defined, it's automatically listed here. */
  not_applicable_as_no_taxonomy_datafield_definitions_exist?: InputMaybe<Scalars['NoDynamicValueDefined']>;
};

/** Length limited text from the product for use e.g. in result lists, previews, etc. */
export type ProductTeasers = {
  __typename?: 'ProductTeasers';
  /** The product's title limited to `length` characters */
  title?: Maybe<Scalars['String']>;
};


/** Length limited text from the product for use e.g. in result lists, previews, etc. */
export type ProductTeasersTitleArgs = {
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard>>;
  length?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type Query = {
  __typename?: 'Query';
  /** Returns the active access control configuration */
  accessControlSettings: AccessControlSettings;
  /** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
  activities: ActivityQueryResult;
  /** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
  activity?: Maybe<Activity>;
  /**
   * Query for building activity filter criteria for access filters. The result of the activity filter can be tested via this query
   *
   * Required permission\
   * Resource: **activities.access-filters**\
   * Action: **query**
   * @deprecated ActivityAccessFilter is only for internal use and will be removed in future versions
   */
  activityAccessFilter: ActivityQueryResult;
  /**
   * Query word-based autocomplete suggestions for activities.
   * Suggestions are found within activity titles and extracted texts
   * and must be at least 3 characters long. The result contains up to
   * 5 suggestions.
   *
   * Required permission\
   * Resource: **activities.autocomplete**\
   * Action: **query**
   */
  activityAutocomplete: ActivityAutocompleteResult;
  /** Returns details about the application providing this API */
  api?: Maybe<ComponentInfo>;
  /**
   * Returns the app key for the current user. For security reasons only metadata about the key is returned.
   *
   * Required permission\
   * Resource: **user.app-key**\
   * Action: **query**
   */
  appKey?: Maybe<ApiKey>;
  /**
   * Get an article it's unique id.
   *
   * Required permission\
   * FeatureId: **spare_parts**\
   * Resource: **article**\
   * Action: **query**
   */
  article?: Maybe<Article>;
  /**
   * Query word-based autocomplete suggestions for articles.
   * Suggestions are found within article titles
   * and must be at least 3 characters long. The result contains up to
   * 5 suggestions.
   * Enter as many available languages as you want and get search hits in the same order as the languages were specified.
   * Get hits by any languages if 'languages' left empty.
   *
   * Required permission\
   * Resource: **articles.autocomplete**\
   * Action: **query**
   */
  articleAutocomplete: ArticleAutocompleteResult;
  /**
   * Query `Articles`s. Filters con be specified via the `filter` argument. See `ArticleFilter` for further details.
   *
   * Required permission\
   * FeatureId: **spare_parts**\
   * Resource: **articles**\
   * Action: **query**
   */
  articles: ArticleQueryResult;
  /**
   * Get an asset it's unique id.
   *
   * Required permission\
   * Resource: **asset**\
   * Action: **query**
   */
  asset?: Maybe<Asset>;
  /**
   * Query word-based autocomplete suggestions for assets.
   * Suggestions are found within asset titles
   * and must be at least 3 characters long. The result contains up to
   * 5 suggestions.
   * Enter as many available languages as you want and get search hits in the same order as the languages were specified.
   * Get hits by any languages if 'languages' left empty.
   *
   * Required permission\
   * Resource: **assets.autocomplete**\
   * Action: **query**
   */
  assetAutocomplete: AssetAutocompleteResult;
  /**
   * Query `Assets`s. Filters con be specified via the `filter` argument. See `AssetFilter` for further details.
   *
   * Required permission\
   * Resource: **assets**\
   * Action: **query**
   */
  assets: AssetQueryResult;
  /**
   * Queries the available features for the tenant.
   *
   * Required permission\
   * Resource: **features**\
   * Action: **query**
   */
  availableFeatures?: Maybe<Array<Maybe<Feature>>>;
  /**
   * Fetch `Blob`s by filter criteria.
   *
   * Required permission\
   * Resource: **blobs**\
   * Action: **query**
   */
  blobs?: Maybe<BlobQueryResult>;
  /**
   * Get a single collection by its unique id.
   * This query allows access to public collections, personal collections of the requesting user as well as
   * personal collections of other users and thus can be used to get the details of a shared collection.
   *
   * Required permission\
   * Resource: **collections**\
   * Action: **query.by-id**
   */
  collection?: Maybe<Collection>;
  /**
   * Query `Collection`s. Filters can be specified via the `filter` argument. See `CollectionFilter` for further details.
   * The results can contain public collections as well as personal collections of the requesting user. Personal
   * collections of other users won't be returned.
   *
   * Required permission\
   * Resource: **collections**\
   * Action: **query**
   */
  collections: CollectionQueryResult;
  /**
   * Returns a configuration file of type Config of available configs
   *
   * Required permission\
   * Resource: **config**\
   * Action: **query**
   */
  config?: Maybe<Config>;
  /**
   * Query word-based autocomplete suggestions for contents.
   * Suggestions are found within content titles and extracted texts
   * and must be at least 3 characters long. The result contains up to
   * 5 suggestions.
   *
   * Required permission\
   * Resource: **contents.autocomplete**\
   * Action: **query**
   */
  contentAutocomplete: ContentAutocompleteResult;
  /**
   * Query the grouping config for a content subject area by id.
   *
   * Required permission\
   * Resource: **grouping-configs**\
   * Action: **query**
   */
  contentGroupingConfig?: Maybe<ContentGroupingConfig>;
  /**
   * Query the uses of a specific content in an use context (e.g. in a content map).
   *
   * Returns all uses of the content in the specified context as TOC entries.
   */
  contentInContext?: Maybe<Array<TocEdge>>;
  /** Query available `ContentMap`s. Filters can be specified via the `filter` argument. See `ContentMapFilter` for further details. */
  contentMaps: ContentMapQueryResult;
  /** Query available `Content`s. Filters can be specified via the `filter` argument. See `ContentFilter` for further details. */
  contents: ContentQueryResult;
  /**
   * Query available contents using a configured grouping criterion. Filters can be specified via the `filter` argument. See `ContentFilter` for further details.
   *
   * Use `groups(first, after)` for paginatable browsing in KEY order.
   */
  contentsGrouped: ContentGroupedQueryResult;
  /**
   * Query a data display config by its unique id.
   *
   * Required permission\
   * Resource: **data-display-configs**\
   * Action: **query**
   */
  dataDisplayConfig?: Maybe<DataDisplayConfig>;
  /**
   * Returns autocomplete suggestions from the values of the selected datafield definitions.
   * The query string is compared against the value's title and the first matching values are returned.
   *
   * Required permission\
   * Resource: **datafield-definitions.autocomplete**\
   * Action: **query**
   */
  datafieldAutocomplete: DatafieldAutocompleteResult;
  /**
   * Get a `DatafieldDefinition` by the definition's unique id
   *
   * Required permission\
   * Resource: **datafield-definitions**\
   * Action: **query**
   */
  datafieldDefinition?: Maybe<DatafieldDefinition>;
  /**
   * Queries all available fields which may be
   * used as entry in different list configs.
   *
   * Required permission\
   * Resource: **datafield.type**\
   * Action: **query**
   */
  datafields?: Maybe<Datafields>;
  /**
   * Query `Collection`s which are editable by the current user.
   * Filters can be specified via the `filter` argument. See `CollectionFilter` for further details.
   *
   * Required permission\
   * Resource: **collections**\
   * Action: **write**
   */
  editableCollections: CollectionQueryResult;
  /**
   * Returns autocomplete suggestions from the values of the selected filter selections.
   * The query string is compared against the value's title and the first matching values are returned.
   *
   * Required permission\
   * Resource: **datafield-definitions.autocomplete**\
   * Action: **query**
   */
  facetDatafieldAutocomplete: FacetDatafieldAutocompleteResult;
  /**
   * Query a facets collection by id.
   *
   * Required permission\
   * Resource: **facet-collections**\
   * Action: **query**
   */
  facetsCollection?: Maybe<FacetsCollection>;
  /**
   * Query `DatafieldDefinition`s. Filters can be specified via the `filter` argument. See `DatafieldDefinitionFilter` for further details.
   *
   * Required permission\
   * Resource: **datafield-definitions**\
   * Action: **query**
   */
  fieldDefinitions: DatafieldDefinitionQueryResult;
  /**
   * Get a single file by its unique id.
   *
   * Required permission\
   * Resource: **files**\
   * Action: **query**
   */
  file?: Maybe<File>;
  /**
   * Query `File`s. Filters con be specified via the `filter` argument. See `FileFilter` for further details.
   *
   * Required permission\
   * Resource: **files**\
   * Action: **query**
   */
  files: FileQueryResult;
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  getCart?: Maybe<ShopLightCart>;
  /** Sub Graph: **https://shops-config-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  getFdiShopConfig?: Maybe<FdiShopConfig>;
  /** Sub Graph: **https://shops-config-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  getGenericShopConfig?: Maybe<GenericShopConfig>;
  /** Sub Graph: **https://shops-config-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  getSalesforceConfig?: Maybe<SalesforceConfig>;
  /** Sub Graph: **https://shops-config-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  getSapShopConfig?: Maybe<SapConfig>;
  /** Sub Graph: **https://shops-config-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  getShopLightConfig?: Maybe<ShopLightConfig>;
  /**
   * Get the requesting users user settings. The settings may be filtered
   * by setting the `keys` argument to only receive the specified entries.
   * To get all settings omit the keys parameter.
   *
   * Required permission\
   * Resource: **users-settings**\
   * Action: **query**
   */
  getUserSettings?: Maybe<UserSettings>;
  /** Get gui elements of a specific type for a view */
  guiElements: Array<GuiElement>;
  /**
   * Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443**
   * @deprecated Please use promptAIAssistant instead
   */
  insights: InsightsQueryResult;
  /**
   * Get an item by its unique id.
   *
   * Required permission\
   * Resource: **schematics**\
   * Action: **query**
   */
  item?: Maybe<Item>;
  /**
   * Query items with filters, pagination, and sorting.
   *
   * Use the `schematicId` argument to limit the results to a specific schematic.
   *
   * Required permission\
   * Resource: **schematics**\
   * Action: **query**
   */
  items: ItemQueryResult;
  /**
   * Returns the current user's data.
   *
   * Required permission\
   * Resource: **users.me**\
   * Action: **query**
   */
  me: User;
  /**
   * Get an mechanic object by it's unique id.
   *
   * Required permission\
   * FeatureId: **spare_parts**\
   * Resource: **mechanics**\
   * Action: **query**
   */
  mechanic?: Maybe<Mechanic>;
  /**
   * Query word-based autocomplete suggestions for mechanics.
   * Suggestions are found within mechanic titles
   * and must be at least 3 characters long. The result contains up to
   * 5 suggestions.
   * Enter as many available languages as you want and get search hits in the same order as the languages were specified.
   * Get hits by any languages if 'languages' left empty.
   *
   * Required permission\
   * Resource: **mechanics.autocomplete**\
   * Action: **query**
   */
  mechanicAutocomplete: MechanicAutocompleteResult;
  /**
   * Returns the mechanic objects matching the filter rules
   *
   * Use the `productId` argument to limit the mechanic results to a specific product.
   * Use the `assetId` argument to limit the mechanic results to a specific product asset.
   *
   * Please note: If `assetId` argument is used, `productId` argument is mandatory!
   *
   * Required permission\
   * FeatureId: **spare_parts**\
   * Resource: **mechanics**\
   * Action: **query**
   */
  mechanics: MechanicQueryResult;
  /**
   * Get a single note by its unique id.
   *
   * Required permission\
   * Resource: **notes**\
   * Action: **query**
   */
  note?: Maybe<Note>;
  /**
   * Query `Note`s. Filters con be specified via the `filter` argument. See `NoteFilter` for further details.
   *
   * Required permission\
   * Resource: **notes**\
   * Action: **query**
   */
  notes?: Maybe<NoteQueryResult>;
  /**
   * Query Notifications. Filters can be specified via the `filter` argument. See `NotificationFilter` for further details.
   *
   * Required permission\
   * Resource: **notifications**\
   * Action: **query**
   */
  notifications?: Maybe<NotificationQueryResult>;
  /**
   * Get a part by its unique id.
   *
   * Required permission\
   * Resource: **schematics**\
   * Action: **query**
   */
  part?: Maybe<Part>;
  /**
   * Query parts with filters, pagination, and sorting.
   *
   * Use the `schematicId` argument to limit the results to a specific schematic.
   *
   * Required permission\
   * Resource: **schematics**\
   * Action: **query**
   */
  parts: PartQueryResult;
  /** Get the status of a PDF catalog request by its unique request ID. */
  pdfCatalogRequestStatus?: Maybe<PdfCatalogRequestStatus>;
  /**
   * Get a process by it's unique id.
   *
   * Required permission\
   * Resource: **processtypes**\
   * Action: **query**
   */
  process?: Maybe<Process>;
  /**
   * Get process-datafield-mappings by processType and columns.
   *
   * Required permission\
   * Resource: **processtypes**\
   * Action: **query**
   */
  processDatafieldMappings?: Maybe<Array<Maybe<ProcessDatafieldMapping>>>;
  /**
   * Get a all available process encoding types..
   *
   * Required permission\
   * Resource: **processtypes**\
   * Action: **query**
   */
  processEncodingTypes?: Maybe<Array<Maybe<ProcessEncodingType>>>;
  /**
   * Gets all available process types.
   *
   * Required permission\
   * Resource: **processtypes**\
   * Action: **query**
   */
  processTypes?: Maybe<Array<Maybe<ProcessType>>>;
  /**
   * Get a list of all processes.
   *
   * Required permission\
   * Resource: **processtypes**\
   * Action: **query**
   */
  processes?: Maybe<Array<Maybe<Process>>>;
  /**
   * Get a product by it's unique id.
   *
   * Required permission\
   * Resource: **product**\
   * Action: **query**
   */
  product?: Maybe<Product>;
  /**
   * Query word-based autocomplete suggestions for products.
   * Suggestions are found within product titles
   * and must be at least 3 characters long. The result contains up to
   * 5 suggestions.
   * Enter as many available languages as you want and get search hits in the same order as the languages were specified.
   * Get hits by any languages if 'languages' left empty.
   *
   * Required permission\
   * Resource: **products.autocomplete**\
   * Action: **query**
   */
  productAutocomplete: ProductAutocompleteResult;
  /**
   * Query `Product`s. Filters can be specified via the `filter` argument. See `ProductFilter` for further details.
   *
   * Required permission\
   * Resource: **products**\
   * Action: **query**
   */
  products: ProductQueryResult;
  /** Sub Graph: **https://ai-assistant-graph.qit-ai-assistant.svc.cluster.local:8443** */
  promptAIAssistant: AiAssistantQueryResult;
  /**
   * Get a relation by it's unique id.
   *
   * Required permission\
   * Resource: **relation**\
   * Action: **query**
   */
  relation?: Maybe<Relation>;
  /**
   * Query `Relation`s. Filters can be specified via the `filter` argument. See `RelationFilter` for further details.
   *
   * Required permission\
   * Resource: **relations**\
   * Action: **query**
   */
  relations: RelationQueryResult;
  /**
   * Returns one schematic metadata object.
   *
   * Required permission\
   * Resource: **schematic-structs**\
   * Action: **query**
   */
  schematic: Schematic;
  /**
   * Returns the current schematic API version.
   *
   * For the mock API this currently returns a hardcoded semver string.
   *
   * Required permission\
   * Resource: **schematics**\
   * Action: **query**
   */
  schematicApiVersion: Scalars['String'];
  /**
   * List schematics.
   *
   * Required permission\
   * Resource: **schematics**\
   * Action: **query**
   */
  schematics: Array<Schematic>;
  /**
   * Query a search config by id.
   *
   * Required permission\
   * Resource: **search-configs**\
   * Action: **query**
   */
  searchConfig?: Maybe<SearchConfig>;
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  sendMailsStatus?: Maybe<SendMailsStatus>;
  /**
   * Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443**
   * Returns middleware auth start information.
   */
  shopAuthStartUrl: ShopAuthStart;
  /**
   * Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443**
   * Returns the current basket for the authenticated user.
   */
  shopBasket: ShopBasket;
  /**
   * Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443**
   * Returns middleware checkout start information for the authenticated user.
   */
  shopCheckoutUrl: ShopCheckoutStart;
  /**
   * Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443**
   * Returns price and stock information for a given article context.
   */
  shopItemInfo?: Maybe<ShopItemInfo>;
  /**
   * Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443**
   * Returns current connection status to the foreign shop system.
   */
  shopSession: ShopSession;
  /**
   * Get an static page by page type.
   * The acceptedLanguages field can be used to tell the system which languages are accepted by the consumer.
   * Heads up: The order of the languages controls their priority in descending order, thus the foremost found language will be returned.
   *
   * Required permission\
   * Resource: **static-pages**\
   * Action: **query**
   */
  staticPage?: Maybe<StaticPage>;
  /**
   * Query the static page menu.
   *
   * Required permission\
   * Resource: **static-pages**\
   * Action: **query**
   */
  staticPageMenu?: Maybe<StaticPageMenu>;
  /**
   * Query status of export collection
   *
   * Required permission\
   * Resource: **collections**\
   * Action: **export**
   */
  statusExportCollection: CollectionExportResult;
  /**
   * Get a struct by its unique id.
   *
   * Required permission\
   * Resource: **schematics**\
   * Action: **query**
   */
  struct?: Maybe<Struct>;
  /**
   * Query structs with filters, pagination, and sorting.
   *
   * Use the `schematicId` argument to limit the results to a specific schematic.
   *
   * Required permission\
   * Resource: **schematics**\
   * Action: **query**
   */
  structs: StructQueryResult;
  /** Returns the current tenant. */
  tenant: Tenant;
  /** Get tenant UI configuration for a specific view */
  tenantGui?: Maybe<TenantGui>;
  /** Get all tenant UI configurations */
  tenantGuis: Array<TenantGui>;
  /**
   * Queries the theme configuration.
   * If there's no custom theme defined, it will return the default theme.
   */
  theme?: Maybe<Theme>;
  /** Query available `Topic`s. Filters can be specified via the `filter` argument. See `TopicFilter` for further details. */
  topics: TopicQueryResult;
  /**
   * Returns the server version.
   * Deprecated. Use query `api { version }` instead
   * @deprecated Field no longer supported
   */
  version?: Maybe<VersionInfo>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryActivitiesArgs = {
  filter?: InputMaybe<ActivityFilter>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryActivityArgs = {
  id: Scalars['String'];
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryActivityAccessFilterArgs = {
  filter: ActivityAccessFilter;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryActivityAutocompleteArgs = {
  filter?: InputMaybe<ActivityFilter>;
  query?: InputMaybe<Scalars['String']>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryArticleArgs = {
  id: Scalars['String'];
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryArticleAutocompleteArgs = {
  filter?: InputMaybe<ArticleFilter>;
  languages?: InputMaybe<Array<InputMaybe<Language>>>;
  query?: InputMaybe<Scalars['String']>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryArticlesArgs = {
  filter?: InputMaybe<ArticleFilter>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryAssetArgs = {
  id: Scalars['String'];
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryAssetAutocompleteArgs = {
  filter?: InputMaybe<AssetFilter>;
  languages?: InputMaybe<Array<InputMaybe<Language>>>;
  query?: InputMaybe<Scalars['String']>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryAssetsArgs = {
  filter?: InputMaybe<AssetFilter>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryBlobsArgs = {
  filter?: InputMaybe<BlobFilter>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryCollectionArgs = {
  id: Scalars['ID'];
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryCollectionsArgs = {
  filter?: InputMaybe<CollectionFilter>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryContentAutocompleteArgs = {
  filter?: InputMaybe<ContentFilter>;
  query?: InputMaybe<Scalars['String']>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryContentGroupingConfigArgs = {
  id: Scalars['ID'];
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryContentInContextArgs = {
  contentId?: InputMaybe<Scalars['ID']>;
  rootContentId?: InputMaybe<Scalars['ID']>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryContentMapsArgs = {
  filter?: InputMaybe<ContentMapFilter>;
  filterOptions?: InputMaybe<ContentMapFilterOptions>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryContentsArgs = {
  filter?: InputMaybe<ContentFilter>;
  filterOptions?: InputMaybe<ContentFilterOptions>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryContentsGroupedArgs = {
  filter?: InputMaybe<ContentFilter>;
  filterOptions?: InputMaybe<ContentFilterOptions>;
  groupBy: ContentGroupBy;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryDataDisplayConfigArgs = {
  id: Scalars['ID'];
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryDatafieldAutocompleteArgs = {
  filter: DatafieldAutocompleteFilter;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryDatafieldDefinitionArgs = {
  id: Scalars['DatafieldDefinitionID'];
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryEditableCollectionsArgs = {
  filter?: InputMaybe<CollectionFilter>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryFacetDatafieldAutocompleteArgs = {
  filter: FacetDatafieldAutocompleteFilter;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryFacetsCollectionArgs = {
  id: Scalars['ID'];
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryFieldDefinitionsArgs = {
  filter?: InputMaybe<DatafieldDefinitionFilter>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryFileArgs = {
  id: Scalars['ID'];
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryFilesArgs = {
  filter?: InputMaybe<FileFilter>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryGetUserSettingsArgs = {
  keys?: InputMaybe<Array<Scalars['String']>>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryGuiElementsArgs = {
  id: Scalars['ID'];
  type: Scalars['String'];
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryInsightsArgs = {
  role?: InputMaybe<InsightsRole>;
  search: InsightsSearchInput;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryItemArgs = {
  id: Scalars['String'];
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryItemsArgs = {
  filter?: InputMaybe<ItemFilter>;
  schematicId?: InputMaybe<Scalars['ID']>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryMechanicArgs = {
  id: Scalars['String'];
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryMechanicAutocompleteArgs = {
  filter?: InputMaybe<MechanicFilter>;
  languages?: InputMaybe<Array<InputMaybe<Language>>>;
  query?: InputMaybe<Scalars['String']>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryMechanicsArgs = {
  assetId?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<MechanicFilter>;
  productId?: InputMaybe<Scalars['ID']>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryNoteArgs = {
  id: Scalars['ID'];
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryNotesArgs = {
  filter?: InputMaybe<NoteFilter>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryNotificationsArgs = {
  filter?: InputMaybe<NotificationFilter>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryPartArgs = {
  id: Scalars['String'];
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryPartsArgs = {
  filter?: InputMaybe<PartFilter>;
  schematicId?: InputMaybe<Scalars['ID']>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryPdfCatalogRequestStatusArgs = {
  requestId: Scalars['String'];
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryProcessArgs = {
  id: Scalars['String'];
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryProcessDatafieldMappingsArgs = {
  columns: Array<Scalars['String']>;
  processType: ProcessType;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryProductArgs = {
  id: Scalars['String'];
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryProductAutocompleteArgs = {
  filter?: InputMaybe<ProductFilter>;
  languages?: InputMaybe<Array<InputMaybe<Language>>>;
  query?: InputMaybe<Scalars['String']>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryProductsArgs = {
  filter?: InputMaybe<ProductFilter>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryPromptAiAssistantArgs = {
  role?: InputMaybe<AiAssistantRole>;
  search: AiAssistantSearchInput;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryRelationArgs = {
  id: Scalars['String'];
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryRelationsArgs = {
  filter?: InputMaybe<RelationFilter>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QuerySchematicsArgs = {
  productId?: InputMaybe<Scalars['ID']>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QuerySearchConfigArgs = {
  id: Scalars['ID'];
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QuerySendMailsStatusArgs = {
  pipelineId: Scalars['String'];
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryShopAuthStartUrlArgs = {
  context: ShopRequestContextInput;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryShopCheckoutUrlArgs = {
  context?: InputMaybe<ShopRequestContextInput>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryShopItemInfoArgs = {
  input: ShopItemInfoInput;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryStaticPageArgs = {
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard>>;
  pageType: Scalars['String'];
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryStatusExportCollectionArgs = {
  jobId: Scalars['ID'];
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryStructArgs = {
  id: Scalars['String'];
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryStructsArgs = {
  filter?: InputMaybe<StructFilter>;
  schematicId?: InputMaybe<Scalars['ID']>;
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryTenantGuiArgs = {
  id: Scalars['ID'];
};


/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type QueryTopicsArgs = {
  filter?: InputMaybe<TopicFilter>;
  filterOptions?: InputMaybe<TopicFilterOptions>;
};

/** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
export type RangeDatafieldMapping = ProcessDatafieldMapping & {
  __typename?: 'RangeDatafieldMapping';
  /** Returns column(s) which also map to the same field. In this case a process cannot be created due to ambiguousness. */
  ambiguousColumns?: Maybe<Array<Scalars['String']>>;
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  column: Scalars['String'];
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  field?: Maybe<Datafield>;
  /** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
  operator: RangeOperator;
};

/** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
export enum RangeOperator {
  gte = 'gte',
  lte = 'lte'
}

/** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
export type ReferencedEntity = {
  /** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
  id: Scalars['ID'];
};

/**
 * Represents a relation between two entities.
 *
 * The relation is created manually between two accessible entities and extends existing relations.
 *
 * Supported relations:
 * - product => content-map
 * - asset => content-map
 * - product => activity
 * - asset => activity
 *
 * Note: Recommendation is to define relations using the import mechanism
 */
export type Relation = {
  __typename?: 'Relation';
  /** User that created the relation */
  createdBy: User;
  /** Date and time when it was created */
  creationDate?: Maybe<Scalars['DateTime']>;
  /** Sub Graph: **https://relations-graph.qit-relations.svc.cluster.local:8443** */
  id: Scalars['ID'];
  /** Sub Graph: **https://relations-graph.qit-relations.svc.cluster.local:8443** */
  relationSourceId: Scalars['ID'];
  /** Sub Graph: **https://relations-graph.qit-relations.svc.cluster.local:8443** */
  relationSourceType: Scalars['String'];
  /** Sub Graph: **https://relations-graph.qit-relations.svc.cluster.local:8443** */
  relationTargetId: Scalars['ID'];
  /** Sub Graph: **https://relations-graph.qit-relations.svc.cluster.local:8443** */
  relationTargetType: Scalars['String'];
};

/** Sub Graph: **https://relations-graph.qit-relations.svc.cluster.local:8443** */
export type RelationEdge = {
  __typename?: 'RelationEdge';
  /** Unique cursor for pagination. See the query's `after` argument */
  cursor: Scalars['String'];
  /** The result's relation type. */
  node: Relation;
  /** Calculated relevance score. */
  score: Scalars['NonNegativeFloat'];
};

/** Sub Graph: **https://relations-graph.qit-relations.svc.cluster.local:8443** */
export type RelationEqualsValueFilter = {
  /** Returns only with the specified creation date */
  creationDate?: InputMaybe<Scalars['DateTime']>;
  /** Returns only with the specified deletion date */
  deletionDate?: InputMaybe<Scalars['DateTime']>;
  /** Returns only relations with the specified source id */
  relationSourceId?: InputMaybe<Scalars['ID']>;
  /** Returns only relations with the specified source type */
  relationSourceType?: InputMaybe<Scalars['String']>;
  /** Returns only relations with the specified target id */
  relationTargetId?: InputMaybe<Scalars['ID']>;
  /** Returns only relations with the specified target type */
  relationTargetType?: InputMaybe<Scalars['String']>;
};

/**
 * The `RelationFilter` is used to specify filter criteria for relations.
 * If you specify more than one criterion, all criteria are grouped together and connected with a logical AND operator.
 * Further logical operations are possible by using `not` `andGroup` and `orGroup`.
 */
export type RelationFilter = {
  /** Returns all relations if set to true */
  all?: InputMaybe<Scalars['Boolean']>;
  /** Allows the specification of further filter criteria, which are grouped together and connected with a logical AND operator */
  andGroup?: InputMaybe<Array<InputMaybe<RelationFilter>>>;
  /** Boosts the score of all matches in this group by the specified factor. Heads up: The resulting score boost isn't mathematically exact due to rounding errors */
  boost?: InputMaybe<Scalars['Float']>;
  /** Returns relations that contain all of the exact values specified */
  equals?: InputMaybe<RelationEqualsValueFilter>;
  /** Returns relations that have a value in all of the specified fields */
  has?: InputMaybe<RelationHasValueFilter>;
  /** Returns relations with one of the specified unique identifiers */
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Allows you to specify logically negated filter criteria */
  not?: InputMaybe<RelationFilter>;
  /** Allows the specification of further filter criteria, which are grouped together and connected with a logical OR operator */
  orGroup?: InputMaybe<Array<InputMaybe<RelationFilter>>>;
  /** Returns relations with values within all of the ranges specified */
  range?: InputMaybe<RelationRangeFilter>;
};

/** Returns relations that have a value in all of the specified fields */
export type RelationHasValueFilter = {
  /** Specify the fields that the returned relations must have a value in */
  valueInFields?: InputMaybe<Array<InputMaybe<RelationHasValueInFields>>>;
};

/** Specify the fields that the returned relations must have a value in */
export enum RelationHasValueInFields {
  /** Returns only relations which have a relationSourceField specified */
  relationSourceField = 'relationSourceField',
  /** Returns only relations which have a relationTargetField specified */
  relationTargetField = 'relationTargetField'
}

/** Sub Graph: **https://relations-graph.qit-relations.svc.cluster.local:8443** */
export type RelationQueryResult = {
  __typename?: 'RelationQueryResult';
  /**
   * The query's matching relations.
   *
   * Use the `sort` argument to specify the list of fields and the order by which the results should be sorted.
   * Multiple fields and orders may be specified and are evaluated in the provided order.
   *
   * To limit the number of results, set the `first` argument.
   *
   * Pagination is possible by setting the `after` argument to the previous last result's `cursor` field value.
   * Please be careful not to change the query's `filter` or the `sort` argument between paginated calls.
   */
  relations: Array<Maybe<RelationEdge>>;
  /**
   * Returns the total count of results.
   *
   * Use the `trackLimit` argument to limit the track of the total count up to the specified amount.
   * If the result has more hits than the specified limit the total count is inaccurate.
   * See `CountRelation` for further information on how to interpret the result.
   *
   * Heads up: Setting the `trackLimit` to a high value may decrease performance.
   */
  total: TotalCount;
};


/** Sub Graph: **https://relations-graph.qit-relations.svc.cluster.local:8443** */
export type RelationQueryResultRelationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  sort?: InputMaybe<Array<InputMaybe<RelationSort>>>;
};


/** Sub Graph: **https://relations-graph.qit-relations.svc.cluster.local:8443** */
export type RelationQueryResultTotalArgs = {
  trackLimit?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://relations-graph.qit-relations.svc.cluster.local:8443** */
export type RelationRangeFilter = {
  /** Returns only with a creation date in the specified range */
  creationDate?: InputMaybe<DateRange>;
};

/** Sub Graph: **https://relations-graph.qit-relations.svc.cluster.local:8443** */
export type RelationSort = {
  /** Sort field */
  field: RelationSortFields;
  /** Sort order */
  order?: InputMaybe<SortOrder>;
};

/** Sub Graph: **https://relations-graph.qit-relations.svc.cluster.local:8443** */
export enum RelationSortFields {
  /** Sort by creation date */
  creationDate = 'creationDate',
  /** Sort by unique ID */
  id = 'id',
  /** Sort by source ID */
  relationSourceId = 'relationSourceId',
  /** Sort by source type */
  relationSourceType = 'relationSourceType',
  /** Sort by target ID */
  relationTargetId = 'relationTargetId',
  /** Sort by target type */
  relationTargetType = 'relationTargetType',
  /** Sort by relevance score */
  score = 'score'
}

/** Sub Graph: **https://shops-config-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type SalesforceConfig = {
  __typename?: 'SalesforceConfig';
  /** graphUrl */
  graphUrl?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://shops-config-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  id: Scalars['ID'];
  /** Sub Graph: **https://shops-config-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  shopServiceUrl?: Maybe<Scalars['String']>;
  /** ShopUrl */
  shopUrl?: Maybe<Scalars['String']>;
  /** URI to the Salesforce shop well-known OpenID configuration */
  wellKnownOpenIdConfiguration?: Maybe<Scalars['String']>;
};

/** Sub Graph: **https://shops-config-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type SapConfig = {
  __typename?: 'SapConfig';
  /** actual path that is called from the Bobst Shop */
  appEntryParameter: Scalars['String'];
  /** name of the cart id parameter */
  cartIdParameter?: Maybe<Scalars['String']>;
  /** graphUrl */
  graphUrl?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://shops-config-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  id: Scalars['ID'];
  /** Sub Graph: **https://shops-config-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  shopServiceUrl?: Maybe<Scalars['String']>;
  /** ShopUrl for redirect to the shop */
  shopUrl?: Maybe<Scalars['String']>;
  /** URI to the Sap token endpoint for the oauth 2.0 client credentials grant */
  tokenUrl?: Maybe<Scalars['String']>;
};

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type Schematic = {
  __typename?: 'Schematic';
  /** Generator information */
  generator?: Maybe<Scalars['String']>;
  /** Language-neutral schematic identifier */
  id: Scalars['ID'];
  /** Primary language */
  lang?: Maybe<Scalars['String']>;
  /** Scale information */
  scale?: Maybe<Scalars['String']>;
  /** Schematic title */
  title?: Maybe<Scalars['String']>;
  /** Supported translations */
  translations?: Maybe<Scalars['String']>;
};

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type SchematicImportResult = {
  __typename?: 'SchematicImportResult';
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  id: Scalars['ID'];
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  structCount: Scalars['NonNegativeInt'];
};

/** Sub Graph: **https://data-filter-graph.qit-data-filter.svc.cluster.local:8443** */
export type SearchConfig = {
  __typename?: 'SearchConfig';
  /**
   * Entries of this search config
   * The Field is ordered and always returns the entries in the defined order.
   */
  entries?: Maybe<Array<SearchConfigEntry>>;
  /** The unique id */
  id: Scalars['ID'];
};

/** Sub Graph: **https://data-filter-graph.qit-data-filter.svc.cluster.local:8443** */
export type SearchConfigDatafieldEntry = SearchConfigEntry & {
  __typename?: 'SearchConfigDatafieldEntry';
  /** Boosts the score of all matches for this entry the specified factor. Please note that the resulting score boost isn't mathematically exact due to rounding errors */
  boost?: Maybe<Scalars['Float']>;
  /** The full indexed field definition */
  datafieldDefinition?: Maybe<DatafieldDefinition>;
  /** The indexed field definition id */
  datafieldId: Scalars['DatafieldDefinitionID'];
  /** The entries meta type */
  fieldType: FieldDefinitionTypes;
  /** The referenced indexed field definition id */
  referencedId: Scalars['ID'];
  /** Length limited text for the indexed field definition for use e.g. in result lists, previews, etc. */
  teasers?: Maybe<SearchConfigEntryTeasers>;
  /** The title of the indexed field definition */
  title?: Maybe<MultilingualString>;
  /** The entries type */
  type: DatafieldType;
};

/** Sub Graph: **https://data-filter-graph.qit-data-filter.svc.cluster.local:8443** */
export type SearchConfigEntry = {
  /** Boosts the score of all matches for this entry the specified factor. Please note that the resulting score boost isn't mathematically exact due to rounding errors */
  boost?: Maybe<Scalars['Float']>;
  /** The entries meta type */
  fieldType: FieldDefinitionTypes;
  /** The id of the field, indexed field definition, etc. referenced by this entry */
  referencedId: Scalars['ID'];
  /** Length limited text for the entry for use e.g. in result lists, previews, etc. */
  teasers?: Maybe<SearchConfigEntryTeasers>;
  /** The title of the entry */
  title?: Maybe<MultilingualString>;
  /** The entries type */
  type: DatafieldType;
};

/** Length limited text from the indexed field definition value for use e.g. in result lists, previews, etc. */
export type SearchConfigEntryTeasers = {
  __typename?: 'SearchConfigEntryTeasers';
  /**
   * The value's title limited to `length` characters.
   * Preferred language and the precedence of fallback languages can be specified via `acceptedLanguages`.
   */
  title?: Maybe<Scalars['String']>;
};


/** Length limited text from the indexed field definition value for use e.g. in result lists, previews, etc. */
export type SearchConfigEntryTeasersTitleArgs = {
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard>>;
  length?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://data-filter-graph.qit-data-filter.svc.cluster.local:8443** */
export type SearchConfigFieldEntry = SearchConfigEntry & {
  __typename?: 'SearchConfigFieldEntry';
  /** Boosts the score of all matches for this entry the specified factor. Please note that the resulting score boost isn't mathematically exact due to rounding errors */
  boost?: Maybe<Scalars['Float']>;
  /** The entries meta type */
  fieldType: FieldDefinitionTypes;
  /** The referenced field name */
  referencedId: Scalars['ID'];
  /** Length limited text for the indexed field definition for use e.g. in result lists, previews, etc. */
  teasers?: Maybe<SearchConfigEntryTeasers>;
  /** The title of the indexed field definition */
  title?: Maybe<MultilingualString>;
  /** The entries type */
  type: DatafieldType;
};

/** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
export enum SelectionMode {
  deep = 'DEEP',
  shallow = 'SHALLOW'
}

/** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type SendMailJob = {
  __typename?: 'SendMailJob';
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  currentExecution?: Maybe<SendMailJobExecution>;
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  id: Scalars['String'];
};

/** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type SendMailJobExecution = {
  __typename?: 'SendMailJobExecution';
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  attempt: Scalars['Int'];
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  id: Scalars['String'];
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  log?: Maybe<SendMailJobLogConnection>;
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  status: Scalars['String'];
};

/** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type SendMailJobLogConnection = {
  __typename?: 'SendMailJobLogConnection';
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  edges: Array<SendMailJobLogEdge>;
};

/** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type SendMailJobLogEdge = {
  __typename?: 'SendMailJobLogEdge';
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  node: SendMailJobLogEntry;
};

/** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type SendMailJobLogEntry = {
  __typename?: 'SendMailJobLogEntry';
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  message: Array<Scalars['String']>;
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  timestamp: Scalars['String'];
};

/** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type SendMailsInput = {
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  billingAddress: AddressInput;
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  contact: ContactInput;
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  mailData: MailDataInput;
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  shippingAddress: AddressInput;
};

/** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type SendMailsStatus = {
  __typename?: 'SendMailsStatus';
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  creationDate?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  displayName?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  endDate?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  id?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  jobs?: Maybe<Array<Maybe<SendMailJob>>>;
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  startDate?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  status?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  type?: Maybe<Scalars['String']>;
};

export type ShopAuthStart = {
  __typename?: 'ShopAuthStart';
  expiresAt?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

/** Current basket for the authenticated user. */
export type ShopBasket = {
  __typename?: 'ShopBasket';
  creationDate: Scalars['String'];
  items: Array<ShopBasketItem>;
  modificationDate: Scalars['String'];
  /** Total basket price; unit is determined by the consuming application. Null when not computable (for example, the basket contains price-on-request items). */
  totalPrice?: Maybe<ShopPrice>;
};

/** Input payload for adding or updating a basket item amount. */
export type ShopBasketAddItemInput = {
  amount: Scalars['Float'];
  articleId: Scalars['ID'];
  assetId?: InputMaybe<Scalars['ID']>;
  productId?: InputMaybe<Scalars['String']>;
};

/** A basket item managed by the generic shop integration. */
export type ShopBasketItem = {
  __typename?: 'ShopBasketItem';
  amount: Scalars['Float'];
  articleId: Scalars['ID'];
  assetId?: Maybe<Scalars['ID']>;
  productId?: Maybe<Scalars['String']>;
  /** Total line price; unit is determined by the consuming application. */
  totalPrice?: Maybe<ShopPrice>;
};

/** Input payload that identifies a basket item. */
export type ShopBasketItemReferenceInput = {
  articleId: Scalars['ID'];
  assetId?: InputMaybe<Scalars['ID']>;
  productId?: InputMaybe<Scalars['String']>;
};

export type ShopCheckoutStart = {
  __typename?: 'ShopCheckoutStart';
  expiresAt?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

/** Currency metadata for a monetary amount. */
export type ShopCurrency = {
  __typename?: 'ShopCurrency';
  /** ISO 4217 currency code, for example EUR or USD. */
  code: CurrencyCode;
  /** Currency sign or symbol, for example € or $. */
  sign?: Maybe<Scalars['String']>;
};

/** Combined item information shown in frontend widgets. */
export type ShopItemInfo = {
  __typename?: 'ShopItemInfo';
  orderable: Scalars['Boolean'];
  price: ShopPrice;
  priceOnRequest?: Maybe<Scalars['Boolean']>;
  stock: ShopStock;
};

/** Lookup parameters for item information. */
export type ShopItemInfoInput = {
  articleId: Scalars['ID'];
  assetId?: InputMaybe<Scalars['ID']>;
  productId?: InputMaybe<Scalars['String']>;
};

/** The ShopLighCart, one per user. */
export type ShopLightCart = {
  __typename?: 'ShopLightCart';
  /** List of itmes in the shopping cart. */
  cartItems?: Maybe<Array<Maybe<ShopLightCartItem>>>;
  /** Unique identifier for the shopping cart. */
  id: Scalars['String'];
};

/** An item in the shopping cart. */
export type ShopLightCartItem = {
  __typename?: 'ShopLightCartItem';
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  cartItemId: CartItemId;
  /** Quantity of the item in the cart. */
  quantity: Scalars['Int'];
  /** Optional remark for the item in the cart - max 200 characters. */
  remark?: Maybe<Scalars['String']>;
};

/** Input type for deleting a cart item. */
export type ShopLightCartItemDelete = {
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  cartItemId: CartItemIdInput;
};

/** Input type for adding or updating a cart item. */
export type ShopLightCartItemInput = {
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  cartItemId: CartItemIdInput;
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  quantity: Scalars['Int'];
  /** Sub Graph: **https://shop-light-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  remark?: InputMaybe<Scalars['String']>;
};

/** Sub Graph: **https://shops-config-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type ShopLightConfig = {
  __typename?: 'ShopLightConfig';
  /** Sub Graph: **https://shops-config-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  id: Scalars['ID'];
  /** Sub Graph: **https://shops-config-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  shopEMail?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://shops-config-graph.qit-salesforce-shop.svc.cluster.local:8443** */
  shopServiceUrl?: Maybe<Scalars['String']>;
};

/** Price payload for a single item. */
export type ShopPrice = {
  __typename?: 'ShopPrice';
  /** Currency information for the price amount. */
  currency: ShopCurrency;
  /** Numeric price amount; the unit (major or minor) is determined by the consuming application. Null when no price information is available (for example, price on request). */
  price?: Maybe<Scalars['Float']>;
};

/** Request context details for middleware URL generation. Sent by the frontend. */
export type ShopRequestContextInput = {
  channel?: InputMaybe<Scalars['String']>;
  locale: Scalars['String'];
  /** Relative return path (for example: /infotwin/shops/return). */
  returnPath: Scalars['String'];
  uiHint?: InputMaybe<Scalars['String']>;
};

export type ShopSession = {
  __typename?: 'ShopSession';
  online: Scalars['Boolean'];
  status: ShopSessionStatus;
};

/** Shop session operational status for extended status flags. */
export enum ShopSessionStatus {
  /** There was an authentication error with the shop. */
  authError = 'AUTH_ERROR',
  /** User authentication has expired. Triggering the shop authentication flow is required. */
  authExpired = 'AUTH_EXPIRED',
  /** The shop is connected and the user is authenticated. */
  connected = 'CONNECTED',
  /** User is not authenticated. Triggering the shop authentication flow is required. */
  notAuthenticated = 'NOT_AUTHENTICATED',
  /** The shop has imposed a rate limit. The user cannot perform any shop operations temporarily. */
  rateLimited = 'RATE_LIMITED',
  /** The shop service is temporarily unavailable. The user cannot perform any shop operations temporarily. */
  serviceUnavailable = 'SERVICE_UNAVAILABLE',
  /** There was a validation error with the request. */
  validationError = 'VALIDATION_ERROR'
}

/** Stock payload for a single item. */
export type ShopStock = {
  __typename?: 'ShopStock';
  stock?: Maybe<Scalars['Float']>;
  stockStatus: StockStatus;
};

/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export enum SortOrder {
  /** Ascending */
  asc = 'asc',
  /** Descending */
  desc = 'desc'
}

/** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
export type StaticPage = {
  __typename?: 'StaticPage';
  /** The content of the page */
  contents?: Maybe<Array<Maybe<BlobRef>>>;
  /** Unique identifier for the static page */
  id: Scalars['ID'];
  /** The language of the static page */
  locale?: Maybe<Scalars['String']>;
  /** The page type */
  pageType?: Maybe<Scalars['String']>;
  /** The title */
  title: Scalars['String'];
};

/** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
export type StaticPageMenu = {
  __typename?: 'StaticPageMenu';
  /** Unique id of the page menu */
  id: Scalars['ID'];
  /** The static pages referenced by this menu */
  pages?: Maybe<Array<Maybe<StaticPageMenuEntry>>>;
};

/** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
export type StaticPageMenuEntry = {
  __typename?: 'StaticPageMenuEntry';
  /** The page type of the referenced static pages */
  pageType: Scalars['String'];
  /** The full static pages */
  staticPages?: Maybe<Array<Maybe<StaticPage>>>;
  /** Length limited text from the combined titles for use e.g. in result lists, previews, etc. */
  teasers?: Maybe<StaticPageMenuEntryTeasers>;
  /** The combined titles of the differntly localized static pages */
  title?: Maybe<MultilingualString>;
};

/** Length limited text from the note for use e.g. in result lists, previews, etc. */
export type StaticPageMenuEntryTeasers = {
  __typename?: 'StaticPageMenuEntryTeasers';
  /** The static page's title limited to `length` characters */
  title?: Maybe<Scalars['String']>;
};


/** Length limited text from the note for use e.g. in result lists, previews, etc. */
export type StaticPageMenuEntryTeasersTitleArgs = {
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard>>;
  length?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Normalized stock state for interoperable integrations. */
export enum StockStatus {
  discontinued = 'DISCONTINUED',
  inStock = 'IN_STOCK',
  lowStock = 'LOW_STOCK',
  outOfStock = 'OUT_OF_STOCK',
  unavailable = 'UNAVAILABLE',
  unknown = 'UNKNOWN'
}

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type Struct = {
  __typename?: 'Struct';
  /** Date and time when it was created */
  creationDate?: Maybe<Scalars['DateTime']>;
  /** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
  files?: Maybe<Array<File>>;
  /** Unique identifier for this struct node */
  id: Scalars['ID'];
  /** Localizations for detail views */
  localizations?: Maybe<StructLocalizations>;
  /** Date and time of the last modification */
  modificationDate?: Maybe<Scalars['DateTime']>;
  /** Parent struct identifier for hierarchy navigation */
  parentStructId?: Maybe<Scalars['String']>;
  /** Schematic document ID this struct belongs to (analogous to productId in mechanic) */
  schematicId: Scalars['String'];
  /** Struct identifier from the XML (struct id attribute) */
  structId?: Maybe<Scalars['String']>;
  /** Teasers for list views */
  teasers?: Maybe<StructTeasers>;
  /** Title/name of the struct */
  title?: Maybe<MultilingualString>;
};


/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type StructFilesArgs = {
  fileTypes?: InputMaybe<Array<InputMaybe<FileType>>>;
};

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type StructDatafieldAggregations = {
  __typename?: 'StructDatafieldAggregations';
  /** Provides composite aggregations with pagination support */
  composite?: Maybe<StructDatafieldCompositeAggregation>;
  /**
   * Provides terms aggregations for custom datafields.
   * Supports prefix search and the results are ordered by count.
   */
  terms?: Maybe<DatafieldTermsAggregation>;
};

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type StructDatafieldCompositeAggregation = {
  __typename?: 'StructDatafieldCompositeAggregation';
  /** Aggregation by schematic ID */
  schematicId?: Maybe<Array<AggregationEdge>>;
};


/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type StructDatafieldCompositeAggregationSchematicIdArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type StructEdge = {
  __typename?: 'StructEdge';
  /** Unique cursor for pagination. See the query's `after` argument */
  cursor: Scalars['String'];
  /** The result's schematic */
  node: Struct;
  /** Calculated relevance score */
  score: Scalars['NonNegativeFloat'];
};

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type StructEqualsValueFilter = {
  /** Returns only structs with the specified creation date */
  creationDate?: InputMaybe<Scalars['DateTime']>;
  /** Returns only structs with the specified modification date */
  modificationDate?: InputMaybe<Scalars['DateTime']>;
  /** Returns only structs with the specified parent struct ID */
  parentStructId?: InputMaybe<Scalars['String']>;
  /** Returns only structs with the specified schematic ID */
  schematicId?: InputMaybe<Scalars['String']>;
  /** Returns only structs with the specified struct ID */
  structId?: InputMaybe<Scalars['String']>;
  /** Returns only structs with the specified title */
  title?: InputMaybe<Scalars['String']>;
};

/**
 * The `StructFilter` is used to specify filter criteria for structs.
 * If you specify more than one criterion, all criteria are grouped together and connected with a logical AND operator.
 * Further logical operations are possible by using `not` `andGroup` and `orGroup`.
 */
export type StructFilter = {
  /** Returns all structs if set to true */
  all?: InputMaybe<Scalars['Boolean']>;
  /** Allows the specification of further filter criteria, which are grouped together and connected with a logical AND operator */
  andGroup?: InputMaybe<Array<InputMaybe<StructFilter>>>;
  /** Boosts the score of all matches in this group by the specified factor */
  boost?: InputMaybe<Scalars['Float']>;
  /** Returns structs that contain all of the exact values specified */
  equals?: InputMaybe<StructEqualsValueFilter>;
  /** Returns structs that match all of the specified full text searches */
  fullText?: InputMaybe<StructFullTextFilter>;
  /** Returns structs that have a value in all of the specified fields */
  has?: InputMaybe<StructHasValueFilter>;
  /** Returns structs with one of the specified unique identifiers */
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Allows you to specify logically negated filter criteria */
  not?: InputMaybe<StructFilter>;
  /** Allows the specification of further filter criteria, which are grouped together and connected with a logical OR operator */
  orGroup?: InputMaybe<Array<InputMaybe<StructFilter>>>;
  /** Returns structs with values within all of the ranges specified */
  range?: InputMaybe<StructRangeFilter>;
  /** Returns structs that match all of the regular expressions */
  regex?: InputMaybe<StructRegexFilter>;
};

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type StructFullTextFields = {
  /** Match the query against any full text searchable field and rank the results with the specified boost */
  any?: InputMaybe<Scalars['Float']>;
  /** Match the query against the schematic ID */
  schematicId?: InputMaybe<Scalars['Float']>;
  /** Match the query against the struct ID */
  structId?: InputMaybe<Scalars['Float']>;
  /** Match the query against the title and rank the results with the specified boost */
  title?: InputMaybe<Scalars['Float']>;
};

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type StructFullTextFilter = {
  /** Fields to search in with their respective score weights */
  fields?: InputMaybe<StructFullTextFields>;
  /** Indicates if a fuzzy search should be performed */
  fuzzy?: InputMaybe<Scalars['Boolean']>;
  /** Specifies if either all or any query words need to match */
  operator?: InputMaybe<FullTextOperator>;
  /** Text to search for */
  query: Scalars['FullTextSearchQuery'];
  /** Type of fulltext search to perform */
  searchType?: InputMaybe<FullTextSearchType>;
};

/** Returns structs that have a value in all of the specified fields */
export type StructHasValueFilter = {
  /** Specify the fields that the returned structs must have a value in */
  valueInFields?: InputMaybe<Array<InputMaybe<StructHasValueInFields>>>;
};

/** Specify the fields that the returned structs must have a value in */
export enum StructHasValueInFields {
  /** Returns only structs which have a parent struct ID specified */
  parentStructId = 'parentStructId',
  /** Returns only structs which have a schematic ID specified */
  schematicId = 'schematicId',
  /** Returns only structs which have a struct ID specified */
  structId = 'structId',
  /** Returns only structs which have a title specified */
  title = 'title'
}

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type StructLocalizations = {
  __typename?: 'StructLocalizations';
  /** Full title */
  title?: Maybe<Scalars['String']>;
};


/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type StructLocalizationsTitleArgs = {
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard>>;
};

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type StructQueryResult = {
  __typename?: 'StructQueryResult';
  /**
   * Matched datafield values and number of matching structs per value
   *
   * To limit the number of results, set the `first` argument.
   *
   * Pagination is possible by setting the `after` argument to the previous last result's `cursor` field value.
   */
  aggregations: StructDatafieldAggregations;
  /**
   * The query's matching structs.
   *
   * Use the `sort` argument to specify the list of fields and the order by which the results should be sorted.
   * Multiple fields and orders may be specified and are evaluated in the provided order.
   *
   * To limit the number of results, set the `first` argument.
   *
   * Pagination is possible by setting the `after` argument to the previous last result's `cursor` field value.
   * Please be careful not to change the query's `filter` or the `sort` argument between paginated calls.
   */
  structs: Array<Maybe<StructEdge>>;
  /**
   * Returns the total count of results.
   *
   * Use the `trackLimit` argument to limit the track of the total count up to the specified amount.
   * If the result has more hits than the specified limit the total count is inaccurate.
   * See `CountRelation` for further information on how to interpret the result.
   *
   * Heads up: Setting the `trackLimit` to a high value may decrease performance.
   */
  total: TotalCount;
};


/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type StructQueryResultStructsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  sort?: InputMaybe<Array<InputMaybe<StructSort>>>;
};


/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type StructQueryResultTotalArgs = {
  trackLimit?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type StructRangeFilter = {
  /** Returns only structs with a creation date in the specified range */
  creationDate?: InputMaybe<DateRange>;
  /** Returns only structs with a modification date in the specified range */
  modificationDate?: InputMaybe<DateRange>;
};

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type StructRegexFilter = {
  /** Returns only structs whose parent struct ID matches the specified Regex */
  parentStructId?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only structs whose schematic ID matches the specified Regex */
  schematicId?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only structs whose struct ID matches the specified Regex */
  structId?: InputMaybe<Scalars['FilterRegex']>;
  /** Returns only structs whose title matches the specified Regex */
  title?: InputMaybe<Scalars['FilterRegex']>;
};

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type StructSort = {
  /** Sort field */
  field: StructSortFields;
  /** Sort order */
  order?: InputMaybe<SortOrder>;
};

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export enum StructSortFields {
  /** Sort by creation date */
  creationDate = 'creationDate',
  /** Sort by unique ID */
  id = 'id',
  /** Sort by modification date */
  modificationDate = 'modificationDate',
  /** Sort by schematic ID */
  schematicId = 'schematicId',
  /** Sort by relevance score */
  score = 'score',
  /** Sort by struct ID */
  structId = 'structId',
  /** Sort by title */
  title = 'title'
}

/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type StructTeasers = {
  __typename?: 'StructTeasers';
  /** Title limited to specified length */
  title?: Maybe<Scalars['String']>;
};


/** Sub Graph: **https://nextgen-graph.qit-qit-6718.svc.cluster.local:8443** */
export type StructTeasersTitleArgs = {
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard>>;
  length?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://data-filter-graph.qit-data-filter.svc.cluster.local:8443** */
export type SynonymOptions = {
  /**
   * Indicates if a fuzzy search should be performed on synonyms matching.
   *
   * Be aware: This options doesn't enable fuzzy searching on documents. When enabled
   * the matching synonyms for the query will be retrieved using fuzzy search. To configure fuzzy search
   * for the content search itself please refer to fuzzy parameter in the full text search options.
   */
  fuzzy?: InputMaybe<Scalars['Boolean']>;
  /** Indicates whether the synonyms are ignored in the search */
  ignore?: InputMaybe<Scalars['Boolean']>;
  /** The languages synonyms will be searched in */
  languages?: InputMaybe<Array<InputMaybe<Language>>>;
};

/** Sub Graph: **https://tenant-settings-graph.qit-settings.svc.cluster.local:8443** */
export enum Target {
  blank = '_blank',
  self = '_self'
}

/** Defines a taxonomy datafield. */
export type TaxonomyDatafieldDefinition = DatafieldDefinition & {
  __typename?: 'TaxonomyDatafieldDefinition';
  /** Defines whether the taxonomy pretends to know unknown values or not */
  approveUnknownValues?: Maybe<Scalars['Boolean']>;
  /** The rule to be used when filtering using this taxonomy */
  evaluationType?: Maybe<TaxonomyEvaluationType>;
  /** Type of this indexed field definition */
  fieldType?: Maybe<FieldDefinitionTypes>;
  /**
   * Unique identifier of this indexed field definition.
   * Is used as field name in all interfaces and must adhere to the
   * following pattern: ^[_A-Za-z][_0-9A-Za-z]{0,128}$
   */
  id: Scalars['DatafieldDefinitionID'];
  /** The taxonomy's hierarchy of keys */
  keyHierarchy?: Maybe<Scalars['JSONObject']>;
  /** Text from the datafield definition for use e.g. in detail views, etc */
  localizations?: Maybe<DatafieldDefinitionLocalizations>;
  /** Datafield names which shall be mapped to this indexed field definition */
  mappedNames?: Maybe<Array<Scalars['String']>>;
  /** List of all objectTypes this definition is assigned to */
  objectTypes?: Maybe<Array<Maybe<ObjectType>>>;
  /** Length limited text from the indexed field definition for use e.g. in result lists, previews, etc. */
  teasers?: Maybe<DatafieldDefinitionTeasers>;
  /** Human readable description of this indexed field definition */
  title?: Maybe<MultilingualString>;
  /** All of the taxonomy's values in a flattened list */
  values?: Maybe<Array<TaxonomyValue>>;
};

/** Available rules to be used when a filter uses a taxonomy */
export enum TaxonomyEvaluationType {
  /**
   * A filter will return all objects that either have the specified taxonomy value
   * itself or any of its ancestors or any of its descendants
   */
  ancestorsOrDescendantsOrSelf = 'AncestorsOrDescendantsOrSelf',
  /**
   * A filter will return all objects that either have the specified taxonomy value
   * itself or any of its ancestors
   */
  ancestorsOrSelf = 'AncestorsOrSelf',
  /**
   * A filter will return all objects that either have the specified taxonomy value
   * itself or any of its descendants
   */
  descendantsOrSelf = 'DescendantsOrSelf',
  /** A filter will return all objects have the specified taxonomy value itself */
  self = 'Self'
}

/** Sub Graph: **https://data-filter-graph.qit-data-filter.svc.cluster.local:8443** */
export type TaxonomyFacetDefinition = FacetDefinition & {
  __typename?: 'TaxonomyFacetDefinition';
  /** The datafield type of the field */
  fieldType: FieldDefinitionTypes;
  /** The taxonomy's hierarchy of keys */
  keyHierarchy?: Maybe<Scalars['JSONObject']>;
  /** All of the taxonomy's values in a flattened list */
  values?: Maybe<Array<TaxonomyValue>>;
};

/** A single value in the taxonomy */
export type TaxonomyValue = {
  __typename?: 'TaxonomyValue';
  /** Unique data value of this entry in this taxonomy */
  key: Scalars['String'];
  /**
   * The flattened path to this taxonomy value
   * The path contains all keys of ancestors and the value's own key
   */
  pathKeys?: Maybe<Array<Scalars['String']>>;
  /** Length limited text from the taxonomy value for use e.g. in result lists, previews, etc. */
  teasers?: Maybe<DatafieldValueTeasers>;
  /** Human readable description of this taxonomy value */
  title?: Maybe<MultilingualString>;
};

/** A single tenant in Exegol */
export type Tenant = {
  __typename?: 'Tenant';
  /** The tenant authentication config */
  auth?: Maybe<TenantAuthConfig>;
  /** CORS options */
  corsOptions?: Maybe<TenantCorsOptions>;
  /** Domain name for the tenant's app and api as an alternative to the default sub-domain */
  customDomain?: Maybe<Scalars['String']>;
  /** Active custom features */
  customFeatures?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** InfoTwin specific custom links for the menu. */
  customLinks?: Maybe<Array<CustomLink>>;
  /** The tenant's provider specific identifier */
  displayName: Scalars['String'];
  /** The domain name under which the tenant's content delivery services are provided */
  domain: Scalars['String'];
  /** Date when the tenant will expire */
  expires?: Maybe<Scalars['DateTime']>;
  /** The tenant's feature plan ID */
  featurePlan: Scalars['String'];
  /** Additional html meta tags */
  htmlMetaTags?: Maybe<Array<Maybe<TenantHtmlMetaTag>>>;
  /** Sub Graph: **https://tenant-settings-graph.qit-settings.svc.cluster.local:8443** */
  id: Scalars['ID'];
  /** Specific landing page for the tenant. Example: /docs */
  landingPage?: Maybe<Scalars['String']>;
  /** The tenant's language configuration */
  languages?: Maybe<LanguagesQueryResult>;
  /** Operation mode of the application. If set to other mode than online, requests to the API may be rejected. */
  operationMode?: Maybe<TenantOperationMode>;
  /** InfoTwin specific settings for the tenant. */
  tenantSettings?: Maybe<TenantSettings>;
  /** Sub Graph: **https://ai-parts-search-graph.qit-ai-parts-search.svc.cluster.local:8443** */
  uploadConfig?: Maybe<TenantUploadConfig>;
};


/** A single tenant in Exegol */
export type TenantCustomLinksArgs = {
  language: Scalars['String'];
};

/** Sub Graph: **https://basic-services-graph.qit.svc.cluster.local:8443** */
export enum TenantAccessMode {
  /** Only anonymous users may access the api */
  anonymous = 'anonymous',
  /** Only users authenticated via one of the configured authenticators can access the api */
  authenticated = 'authenticated',
  /** Both anonymous and users authenticated via one of the configured authenticators may access the api */
  mixed = 'mixed'
}

/** Sub Graph: **https://basic-services-graph.qit.svc.cluster.local:8443** */
export type TenantAuthConfig = {
  __typename?: 'TenantAuthConfig';
  /** The access mode for the tenant, which indicates which types of users should be able to authenticate */
  accessMode: TenantAccessMode;
  /** The available authenticators */
  authenticators?: Maybe<AuthenticatorQueryResult>;
};

/** Sub Graph: **https://basic-services-graph.qit.svc.cluster.local:8443** */
export enum TenantAuthenticatorStatus {
  /** Authenticator is active and visible to the user */
  active = 'active',
  /** Authenticator is marked as active but hidden. It should not be visible to the user. Frontend should not show it. */
  hidden = 'hidden'
}

/** Sub Graph: **https://basic-services-graph.qit.svc.cluster.local:8443** */
export type TenantCorsOptions = {
  __typename?: 'TenantCorsOptions';
  /** The 'Access-Control-Allow-Headers' CORS header. */
  allowedHeaders?: Maybe<Array<Scalars['String']>>;
  /** The 'Access-Control-Allow-Credentials' CORS header. */
  credentials?: Maybe<Scalars['Boolean']>;
  /** The 'Access-Control-Expose-Headers' CORS header. */
  exposedHeaders?: Maybe<Array<Scalars['String']>>;
  /** The 'Access-Control-Max-Age' CORS header. */
  maxAge?: Maybe<Scalars['NonNegativeInt']>;
  /** The status code for the successful OPTIONS preflight request. */
  optionsSuccessStatus?: Maybe<Scalars['PositiveInt']>;
  /** The 'Access-Control-Allow-Origins' CORS header. */
  origin?: Maybe<Array<Scalars['String']>>;
};

/**
 * Tenant UI configuration for a specific view.
 * Allows adding custom gui elements grouped by type.
 */
export type TenantGui = {
  __typename?: 'TenantGui';
  /**
   * All control groups for this view.
   * Each group represents a different control type.
   */
  groups: Array<GuiElementGroup>;
  /** View identifier (e.g., 'articles', 'assets') */
  id: Scalars['ID'];
};

/** Sub Graph: **https://basic-services-graph.qit.svc.cluster.local:8443** */
export type TenantHtmlMetaTag = {
  __typename?: 'TenantHtmlMetaTag';
  /** The condition for the meta tag to be added to the html head */
  conditions?: Maybe<TenantHtmlMetaTagConditions>;
  /** The meta tag's content */
  content: Scalars['String'];
  /** The meta tag's name */
  name: Scalars['String'];
};

/** Sub Graph: **https://basic-services-graph.qit.svc.cluster.local:8443** */
export type TenantHtmlMetaTagConditions = {
  __typename?: 'TenantHtmlMetaTagConditions';
  /** If true, meta tag is only added, when a custom domain is configured */
  customDomain?: Maybe<Scalars['Boolean']>;
};

/** Sub Graph: **https://basic-services-graph.qit.svc.cluster.local:8443** */
export enum TenantOperationMode {
  /** The application is in emergency mode and requests to the API are rejected */
  emergency = 'emergency',
  /** The application is online and requests to the API are accepted */
  online = 'online'
}

/** Sub Graph: **https://tenant-settings-graph.qit-settings.svc.cluster.local:8443** */
export type TenantSettings = {
  __typename?: 'TenantSettings';
  /** Infotwin specific customer analytics systems. */
  analyticsSystems?: Maybe<Array<AnalyticsSystem>>;
  /** Docs route params as key value pair. */
  docsRouteParams?: Maybe<Scalars['JSONObject']>;
};


/** Sub Graph: **https://tenant-settings-graph.qit-settings.svc.cluster.local:8443** */
export type TenantSettingsAnalyticsSystemsArgs = {
  filter?: InputMaybe<AnalyticsSystemFilter>;
};

/** Sub Graph: **https://ai-parts-search-graph.qit-ai-parts-search.svc.cluster.local:8443** */
export type TenantUploadConfig = {
  __typename?: 'TenantUploadConfig';
  /** Sub Graph: **https://ai-parts-search-graph.qit-ai-parts-search.svc.cluster.local:8443** */
  aiPartsSearch?: Maybe<AiPartsSearchUploadConfig>;
  /** Upload config for notes */
  notes?: Maybe<NotesUploadConfig>;
};

/**
 * Defines a text datafield.
 * A text datafield is a string field which can be used for full text
 * filtering, fuzzy search, etc.
 */
export type TextDatafieldDefinition = DatafieldDefinition & {
  __typename?: 'TextDatafieldDefinition';
  /** Type of this indexed field definition */
  fieldType?: Maybe<FieldDefinitionTypes>;
  /**
   * Unique identifier of this indexed field definition.
   * Is used as field name in all interfaces and must adhere to the
   * following pattern: ^[_A-Za-z][_0-9A-Za-z]{0,128}$
   */
  id: Scalars['DatafieldDefinitionID'];
  /** Text from the datafield definition for use e.g. in detail views, etc */
  localizations?: Maybe<DatafieldDefinitionLocalizations>;
  /** Datafield names which shall be mapped to this indexed field definition */
  mappedNames?: Maybe<Array<Scalars['String']>>;
  /** List of all objectTypes this definition is assigned to */
  objectTypes?: Maybe<Array<Maybe<ObjectType>>>;
  /** Length limited text from the indexed field definition for use e.g. in result lists, previews, etc. */
  teasers?: Maybe<DatafieldDefinitionTeasers>;
  /** Human readable description of this indexed field definition */
  title?: Maybe<MultilingualString>;
};

/** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
export type Theme = {
  __typename?: 'Theme';
  /** The logo of the theme */
  logo?: Maybe<BlobRef>;
  /** The ai assistant logo of the theme */
  logoAIAssistant?: Maybe<BlobRef>;
  /** The email logo of the theme */
  logoEmail?: Maybe<BlobRef>;
  /** Indicates if the title should be visible */
  showTitle: Scalars['Boolean'];
  /** Length limited text from the theme for use e.g. in result lists, previews, etc. */
  teasers?: Maybe<ThemeTeasers>;
  /** Theming JSONObject */
  theming?: Maybe<Scalars['JSONObject']>;
  /** The title of the portal */
  title: MultilingualString;
};

/** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
export type ThemeTeasers = {
  __typename?: 'ThemeTeasers';
  /**
   * The theme's title limited to `length` characters.
   * Preferred language and the precedence of fallback languages can be specified via `acceptedLanguages`.
   * If no value is found for any of the accepted languages, `title` uses the English (`en`) value
   */
  title?: Maybe<Scalars['String']>;
};


/** Sub Graph: **https://app-frame-graph.qit.svc.cluster.local:8443** */
export type ThemeTeasersTitleArgs = {
  acceptedLanguages?: InputMaybe<Array<InputMaybe<LanguageWithWildcard>>>;
  length?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type TocEdge = {
  __typename?: 'TocEdge';
  /** The Path to fetch this TOC entry's children */
  childPath: Scalars['String'];
  /** The TOC element's children */
  children?: Maybe<TocResult>;
  /** Unique cursor for pagination. See the query's `after` argument */
  cursor: Scalars['String'];
  /** True if this TOC element is a branch and has children, false if it's a leaf */
  hasChildren?: Maybe<Scalars['Boolean']>;
  /** Identifier of the referenced `Topic` or `ContentMap` */
  id: Scalars['ID'];
  /** The next child node in the table of contents. Traverses to the first child if the current node has children. */
  next?: Maybe<Content>;
  /** Referenced `Topic` or `ContentMap` */
  node?: Maybe<Content>;
  /** Paths of all entries on the track from root to this entry */
  parentPaths?: Maybe<Array<Scalars['String']>>;
  /** The Path in the TOC */
  path: Scalars['String'];
  /** The previous child node in the table of contents. Traverses to the last child of the previous sibling if the previous sibling has children. */
  previous?: Maybe<Content>;
  /**
   * The variants of the current node, having either a different language and or version.
   * @deprecated Use the `variants` field on the referenced `Content` node instead
   */
  variants?: Maybe<Array<Content>>;
};


/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type TocEdgeVariantsArgs = {
  filter?: InputMaybe<ContentFilter>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  sort?: InputMaybe<Array<InputMaybe<ContentSort>>>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type TocResult = {
  __typename?: 'TocResult';
  /**
   * The entries of a `ContentMap`'s TOC in the order they are defined.
   * To limit the number of results, set the `first` argument.
   * Pagination is possible by setting the `after` argument to the previous last result's `cursor` field value.
   */
  tocEntries?: Maybe<Array<TocEdge>>;
  /** Returns the total count of entries. */
  total: TotalCount;
};


/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type TocResultTocEntriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
};

/**
 * A topic is the atomic unit of information. It primarily consists of
 * - a title
 * - indexed fields (custom fields)
 * - the content - optionally represented in different mime types
 * - attachments which are required by the content (e.g. images, style sheets, etc.)
 */
export type Topic = Content & {
  __typename?: 'Topic';
  /** The related article ids */
  articleIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The related asset ids */
  assetIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Attachments which are required by the content (e.g. images, style sheets, etc.) */
  attachments?: Maybe<Array<Maybe<BlobRef>>>;
  /** Unique identifier of the topic itself */
  contentId: Scalars['ID'];
  /** The topic's content - optionally represented in different mime types */
  contents?: Maybe<Array<Maybe<BlobRef>>>;
  /** Date and time when the content map was created */
  creationDate?: Maybe<Scalars['DateTime']>;
  /** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
  id: Scalars['ID'];
  /** Language of the topic */
  language?: Maybe<Language>;
  /** Locale of the topic */
  locale?: Maybe<Scalars['String']>;
  /** The file type of the asset this topic refers to */
  mimeType?: Maybe<Scalars['String']>;
  /** Date and time of the last modification */
  modificationDate?: Maybe<Scalars['DateTime']>;
  /**
   * Relevant notes for the topic.
   *
   * This field only shows private, pendingApproval notes created by the requesting user and any public notes
   * that reference the content.
   *
   * Even with administrative privileges this field only shows the above mentioned notes and therefore doesn't include any notes
   * which don't belong to the requesting user except the public ones. To view any note and filter them, refer to the
   * filter query for the notes.
   */
  notes?: Maybe<NoteQueryResult>;
  /** The reading duration for this topic in minutes */
  readingDuration?: Maybe<Scalars['NonNegativeInt']>;
  /** Flag that specifies if the topic is recommended */
  recommended?: Maybe<Scalars['Boolean']>;
  /** The source this content was generated from */
  source?: Maybe<Scalars['String']>;
  /** The unique id of the source */
  sourceId?: Maybe<Scalars['String']>;
  /** Length limited text from the topic for use e.g. in result lists, previews, etc. */
  teasers?: Maybe<TopicTeasers>;
  /** Extracted textual content of the topic */
  text?: Maybe<MultilingualString>;
  /** Title of the topic */
  title?: Maybe<MultilingualString>;
  /** The type of the node */
  type?: Maybe<Scalars['String']>;
  /** Most recent date and time when the content map was uploaded */
  uploadDate?: Maybe<Scalars['DateTime']>;
  /** Download URL to display the topic */
  url?: Maybe<Scalars['URL']>;
  /** The use context in which this topic is used */
  useContext?: Maybe<UseContext>;
  /** The variants of the current topic, having either a different language and or version. */
  variants: ContentQueryResult;
  /** The technical version of the topic */
  version?: Maybe<Scalars['Long']>;
};


/**
 * A topic is the atomic unit of information. It primarily consists of
 * - a title
 * - indexed fields (custom fields)
 * - the content - optionally represented in different mime types
 * - attachments which are required by the content (e.g. images, style sheets, etc.)
 */
export type TopicNotesArgs = {
  filter?: InputMaybe<NoteFilter>;
};


/**
 * A topic is the atomic unit of information. It primarily consists of
 * - a title
 * - indexed fields (custom fields)
 * - the content - optionally represented in different mime types
 * - attachments which are required by the content (e.g. images, style sheets, etc.)
 */
export type TopicVariantsArgs = {
  filter?: InputMaybe<ContentFilter>;
  filterOptions?: InputMaybe<ContentFilterOptions>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type TopicEdge = {
  __typename?: 'TopicEdge';
  /** Unique cursor for pagination. See the query's `after` argument */
  cursor: Scalars['String'];
  /** Highlighted matches for equality and full text filters. Matched terms are wrapped in <em>...</em> Tags. */
  highlights?: Maybe<TopicHighlights>;
  /** The result's topic. */
  node: Topic;
  /** Calculated relevance score. */
  score: Scalars['NonNegativeFloat'];
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type TopicEqualsValueFilter = {
  /** Returns only topics with the specified creation date */
  creationDate?: InputMaybe<Scalars['DateTime']>;
  /** Returns only topics with the specified language */
  language?: InputMaybe<Language>;
  /** Returns only topics with the specified locale */
  locale?: InputMaybe<Scalars['String']>;
  /** Returns only topics with the specified mime type */
  mimeType?: InputMaybe<Scalars['String']>;
  /** Returns only topics with the specified modification date */
  modificationDate?: InputMaybe<Scalars['DateTime']>;
  /** Returns only topics with the recommended flag set */
  recommended?: InputMaybe<Scalars['Boolean']>;
  /** Returns only topics used by the specified root content id */
  rootContentId?: InputMaybe<Scalars['ID']>;
  /** Returns only contents with the specified source */
  source?: InputMaybe<Scalars['String']>;
  /** Returns only contents with the specified source id */
  sourceId?: InputMaybe<Scalars['String']>;
  /** Returns only topics with the specified upload date */
  uploadDate?: InputMaybe<Scalars['DateTime']>;
  /** Returns only contents with the specified version */
  version?: InputMaybe<Scalars['Long']>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export enum TopicExistsValueFields {
  /** Returns only contents which have one or more article ids specified */
  articleIds = 'articleIds',
  /** Returns only contents which have one or more asset ids specified */
  assetIds = 'assetIds',
  /** Returns only topics which have a locale specified */
  locale = 'locale',
  /** Returns only topics which have a mime type specified */
  mimeType = 'mimeType',
  /** Returns only topics which have a source specified */
  source = 'source',
  /** Returns only topics which have a source id specified */
  sourceId = 'sourceId',
  /** Returns only topics which have a version specified */
  version = 'version'
}

/**
 * The `TopicFilter` is used to specify filter criteria for topics.
 * If you specify more than one criterion, all criteria are grouped together and connected with a logical AND operator.
 * Further logical operations are possible by using `not` `andGroup` and `orGroup`.
 */
export type TopicFilter = {
  /** Allows the specification of further filter criteria, which are grouped together and connected with a logical AND operator */
  andGroup?: InputMaybe<Array<InputMaybe<TopicFilter>>>;
  /** Returns only contents with one of the specified article ids */
  articleIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Returns only contents with one of the specified asset ids */
  assetIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Boosts the score of all matches in this group by the specified factor. Heads up: The resulting score boost isn't mathematically exact due to rounding errors */
  boost?: InputMaybe<Scalars['Float']>;
  /** Returns topics with one of the specified content identifiers */
  contentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Returns topics that contain all of the exact values specified */
  equals?: InputMaybe<TopicEqualsValueFilter>;
  /** Returns topics that have a value in all of the specified fields */
  exists?: InputMaybe<Array<InputMaybe<TopicExistsValueFields>>>;
  /** Returns topics that match all of the specified full text searches */
  fullText?: InputMaybe<TopicFullTextFilter>;
  /** Returns topics with one of the specified unique identifiers */
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Allows you to specify logically negated filter criteria */
  not?: InputMaybe<TopicFilter>;
  /** Allows the specification of further filter criteria, which are grouped together and connected with a logical OR operator */
  orGroup?: InputMaybe<Array<InputMaybe<TopicFilter>>>;
  /** Returns topics with values within all of the ranges specified */
  range?: InputMaybe<TopicRangeFilter>;
  /** Returns topics that match all of the regular expressions */
  regex?: InputMaybe<TopicRegexFilter>;
  /** Returns topics that match a taxonomy value according to the taxonomy's evaluation type */
  taxonomy?: InputMaybe<TopicTaxonomyFilter>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type TopicFilterOptions = {
  /** Returns contents including such with 'hidden' flag set to true. If set to false (default), only contents with 'hidden' flag set to false are returned. */
  includeHidden?: InputMaybe<Scalars['Boolean']>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type TopicFullTextFields = {
  /** Match the query against any full text searchable field and rank the results with the specified boost */
  any?: InputMaybe<Scalars['Float']>;
  /** Match the query against any tile language and rank the results with the specified boost */
  text?: InputMaybe<Scalars['Float']>;
  /** Match the query against any tile language and rank the results with the specified boost */
  title?: InputMaybe<Scalars['Float']>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type TopicFullTextFilter = {
  /** Fields to search in with their respective score weights */
  fields?: InputMaybe<TopicFullTextFields>;
  /** Indicates if a fuzzy search should be performed. */
  fuzzy?: InputMaybe<Scalars['Boolean']>;
  /** Specifies if either all or any query words need to match */
  operator?: InputMaybe<FullTextOperator>;
  /**
   * The text to search for.
   * Be aware: The Limit for full text search queries is 1024 characters and
   * anything above that will result in an error.
   */
  query: Scalars['FullTextSearchQuery'];
  /** Type of fulltext search to perform */
  searchType?: InputMaybe<FullTextSearchType>;
  /** Options to configure synonyms search */
  synonymOptions?: InputMaybe<SynonymOptions>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type TopicHighlights = ContentHighlights & {
  __typename?: 'TopicHighlights';
  /** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
  text?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
  title?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type TopicHighlightsTextArgs = {
  length?: InputMaybe<Scalars['NonNegativeInt']>;
};


/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type TopicHighlightsTitleArgs = {
  length?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type TopicQueryResult = {
  __typename?: 'TopicQueryResult';
  /**
   * Matched datafield values and number of matching topics per value
   *
   * To limit the number of results, set the `first` argument.
   *
   * Pagination is possible by setting the `after` argument to the previous last result's `cursor` field value.
   */
  aggregations: Aggregations;
  /**
   * The query's matching topics.
   *
   * Use the `sort` argument to specify the list of fields and the order by which the results should be sorted.
   * Multiple fields and orders may be specified and are evaluated in the provided order.
   *
   * To limit the number of results, set the `first` argument.
   *
   * Pagination is possible by setting the `after` argument to the previous last result's `cursor` field value.
   * Please be careful not to change the query's `filter` or the `sort` argument between paginated calls.
   */
  topics: Array<Maybe<TopicEdge>>;
  /**
   * Returns the total count of results.
   *
   * Use the `trackLimit` argument to limit the track of the total count up to the specified amount.
   * If the result has more hits than the specified limit the total count is inaccurate.
   * See `CountRelation` for further information on how to interpret the result.
   *
   * Heads up: Setting the `trackLimit` to a high value may decrease performance.
   */
  total: TotalCount;
};


/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type TopicQueryResultTopicsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  sort?: InputMaybe<Array<InputMaybe<TopicSort>>>;
};


/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type TopicQueryResultTotalArgs = {
  trackLimit?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type TopicRangeFilter = {
  /** Returns only topics with a creation date in the specified range */
  creationDate?: InputMaybe<DateRange>;
  /** Returns only topics with a modification date in the specified range */
  modificationDate?: InputMaybe<DateRange>;
  /** Returns only topics with a upload date in the specified range */
  uploadDate?: InputMaybe<DateRange>;
  /** Returns only topics with a version within the specified range */
  version?: InputMaybe<LongRange>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type TopicRegexFilter = {
  /** No regex filterable indexed field definitions exist. As soon as the first matching indexed field definition is defined, it's automatically listed here. */
  not_applicable_as_no_regex_filterable_field_definitions_exist?: InputMaybe<Scalars['NoDynamicValueDefined']>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type TopicSort = {
  /** Sort field */
  field: TopicSortFields;
  /** Sort order */
  order?: InputMaybe<SortOrder>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export enum TopicSortFields {
  /** Sort by content id */
  contentId = 'contentId',
  /** Sort by creation date */
  creationDate = 'creationDate',
  /** Sort by unique ID */
  id = 'id',
  /** Sort by language */
  language = 'language',
  /** Sort by locale */
  locale = 'locale',
  /** Sort by modification date */
  modificationDate = 'modificationDate',
  /** Sort by recommended flag */
  recommended = 'recommended',
  /** Sort by relevance score */
  score = 'score',
  /** Sort by source */
  source = 'source',
  /** Sort by source id */
  sourceId = 'sourceId',
  /** Sort by title */
  title = 'title',
  /** Sort by upload date */
  uploadDate = 'uploadDate',
  /** Sort by version */
  version = 'version'
}

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type TopicTaxonomyFilter = {
  /** No taxonomy indexed field definitions exist. As soon as the first taxonomy is defined, it's automatically listed here. */
  not_applicable_as_no_taxonomy_field_definitions_exist?: InputMaybe<Scalars['NoDynamicValueDefined']>;
};

/** Length limited text from the topic for use e.g. in result lists, previews, etc. */
export type TopicTeasers = ContentTeasers & {
  __typename?: 'TopicTeasers';
  /** The topic's text limited to `length` characters */
  text?: Maybe<Scalars['String']>;
  /** The topic's title limited to `length` characters */
  title?: Maybe<Scalars['String']>;
};


/** Length limited text from the topic for use e.g. in result lists, previews, etc. */
export type TopicTeasersTextArgs = {
  length?: InputMaybe<Scalars['NonNegativeInt']>;
};


/** Length limited text from the topic for use e.g. in result lists, previews, etc. */
export type TopicTeasersTitleArgs = {
  length?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type TotalCount = {
  __typename?: 'TotalCount';
  /**
   * The total count of results.
   *
   * See `CountRelation` for further information on how to interpret the count.
   */
  count: Scalars['NonNegativeInt'];
  /**
   * Indicator on how the count should be interpreted.
   *
   * The count may not be accurate so the relation gives information whether the real
   * actual count deviates from the provided count or is equal to.
   *
   * See `CountRelation` for further information about the possible deviations.
   */
  countRelation?: Maybe<CountRelation>;
};

/** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
export type UnresolvedArticleActivityReference = ReferencedEntity & {
  __typename?: 'UnresolvedArticleActivityReference';
  /** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
  id: Scalars['ID'];
  /** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
  localizations?: Maybe<UnresolvedArticleActivityReferenceLocalizations>;
  /** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
  teasers?: Maybe<UnresolvedArticleActivityReferenceTeasers>;
  /** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
  title?: Maybe<MultilingualString>;
};

/** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
export type UnresolvedArticleActivityReferenceLocalizations = {
  __typename?: 'UnresolvedArticleActivityReferenceLocalizations';
  /** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
  title?: Maybe<Scalars['String']>;
};


/** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
export type UnresolvedArticleActivityReferenceLocalizationsTitleArgs = {
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard>>;
};

/** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
export type UnresolvedArticleActivityReferenceTeasers = {
  __typename?: 'UnresolvedArticleActivityReferenceTeasers';
  /** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
  title?: Maybe<Scalars['String']>;
};


/** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
export type UnresolvedArticleActivityReferenceTeasersTitleArgs = {
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard>>;
  length?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
export type UpdateActivityProcessInput = {
  /** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
  activityId: Scalars['ID'];
  /** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
  completedActivity?: InputMaybe<Scalars['Boolean']>;
  /** Sub Graph: **https://activities-graph.qit-activities.svc.cluster.local:8443** */
  navContext?: InputMaybe<ActivityNavigationContextInput>;
};

/** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
export type UpdateCollectionInput = {
  /** The detailed description */
  description?: InputMaybe<Scalars['String']>;
  /** The display name */
  displayName?: InputMaybe<Scalars['String']>;
  /** The unique id */
  id: Scalars['ID'];
  /** The indicator whether the collection should be displayed in the dashboard */
  showInDashboard?: InputMaybe<Scalars['Boolean']>;
};

/** Sub Graph: **https://user-generated-data-graph.qit.svc.cluster.local:8443** */
export type UpdateNoteCommentInput = {
  /** Unique id of the comment */
  id: Scalars['ID'];
  /** The text of the comment */
  text?: InputMaybe<Scalars['String']>;
};

/** Sub Graph: **https://user-generated-data-graph.qit.svc.cluster.local:8443** */
export type UpdateNoteInput = {
  /** The unique id */
  id: Scalars['ID'];
  /** The note text */
  text?: InputMaybe<MultilingualStringInput>;
  /** The visibility for the note. See `VisibilityTypes` */
  visibility?: InputMaybe<NoteVisibilityTypesInput>;
};

/** Sub Graph: **https://schematic-graph.qit-schematic.svc.cluster.local:8443** */
export type UploadMultipleConfig = {
  __typename?: 'UploadMultipleConfig';
  /** Are all mime types allowed */
  allowAllMimeTypes?: Maybe<Scalars['Boolean']>;
  /** The allowed file extensions */
  allowedFileExtensions?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The allowed mime types */
  allowedMimeTypes: Array<Maybe<Scalars['String']>>;
  /** The limits for the files to upload */
  limits: UploadMultipleLimits;
};

/** Sub Graph: **https://schematic-graph.qit-schematic.svc.cluster.local:8443** */
export type UploadMultipleLimits = {
  __typename?: 'UploadMultipleLimits';
  /** The maximal allowed size in bytes per file */
  maxFileSize?: Maybe<Scalars['NonNegativeInt']>;
  /** The maximal number of files per upload request */
  maxFilesPerUpload?: Maybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type UseContext = {
  __typename?: 'UseContext';
  /** ID of the content map in which this context roots */
  rootContentId: Scalars['ID'];
  /** Content map in which this context roots */
  rootContentMap?: Maybe<ContentMap>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type UseContextAggregations = {
  __typename?: 'UseContextAggregations';
  /** Provides composite aggregations with pagination support */
  composite?: Maybe<UseContextCompositeAggregation>;
  /**
   * Provides terms aggregations for the use context.
   * Supports prefix search and the results are ordered by count.
   */
  terms?: Maybe<UseContextTermsAggregation>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type UseContextCompositeAggregation = {
  __typename?: 'UseContextCompositeAggregation';
  /** Provides aggregations for the rootContentId field */
  rootContentId?: Maybe<Array<AggregationEdge>>;
};


/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type UseContextCompositeAggregationRootContentIdArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type UseContextTermsAggregation = {
  __typename?: 'UseContextTermsAggregation';
  /** Provides aggregations for the rootContentId field */
  rootContentId?: Maybe<Array<AggregationEdge>>;
};


/** Sub Graph: **https://contents-graph.qit-documentation.svc.cluster.local:8443** */
export type UseContextTermsAggregationRootContentIdArgs = {
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  prefix?: InputMaybe<Scalars['String']>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type UsedInAssets = {
  __typename?: 'UsedInAssets';
  /**
   * Query `Assets`s. Filters con be specified via the `filter` argument. See `AssetFilter` for further details.
   *
   * Required permission\
   * Resource: **assets**\
   * Action: **query**
   */
  assets: AssetQueryResult;
};


/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type UsedInAssetsAssetsArgs = {
  filter?: InputMaybe<AssetFilter>;
};

/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type UsedInProducts = {
  __typename?: 'UsedInProducts';
  /**
   * Query products. Filters can be specified via the `filter` argument. See `ProductFilter` for further details.
   *
   * Required permission\
   * Resource: **products**\
   * Action: **query**
   */
  products: ProductQueryResult;
};


/** Sub Graph: **https://nextgen-graph.qit.svc.cluster.local:8443** */
export type UsedInProductsProductsArgs = {
  filter?: InputMaybe<ProductFilter>;
};

/** A single user in Exegol */
export type User = {
  __typename?: 'User';
  /** Indicates if the user is the anonymous user */
  anonymous: Scalars['Boolean'];
  /** The user's API keys */
  apiKeys?: Maybe<Array<ApiKey>>;
  /** The user's claims */
  claims?: Maybe<UserClaims>;
  /** Date of the user's account creation. This date is immutable. The creation date is null, if the user was created prior to October 2025. */
  creationDate?: Maybe<Scalars['DateTime']>;
  /** Readable name for the user */
  displayName?: Maybe<Scalars['String']>;
  /** The user's assigned and inherited roles */
  effectiveRoles?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The user's email address */
  email?: Maybe<Scalars['EmailAddress']>;
  /** The logout Url based on the last authenticator used */
  endSessionUrl?: Maybe<Scalars['String']>;
  /** Sub Graph: **https://collections-graph.qit-collections.svc.cluster.local:8443** */
  id: Scalars['ID'];
  /** Date of the user's last access. This date is updated when the user token is updated. */
  lastAccessDate?: Maybe<Scalars['DateTime']>;
  /** Date of the user's last login. This date is updated when the user successfully authenticates. This date is not updated during a session. */
  lastLoginDate?: Maybe<Scalars['DateTime']>;
  /** Date of the user's last modification. This date is updated when the user is modified using the graph api. */
  modificationDate?: Maybe<Scalars['DateTime']>;
  /** The users notes */
  notes?: Maybe<NoteQueryResult>;
  /** Date of the user's previous login. This date matches the previous lastLoginDate and may be used to query all modifications since the last login. */
  previousLoginDate?: Maybe<Scalars['DateTime']>;
  /** All of the user's claims */
  rawClaims?: Maybe<Scalars['JSONObject']>;
  /** The user's assigned roles */
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The provider which served the user information */
  sourceProvider?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The user's provider specific identifier */
  sourceUserIdentifier: Scalars['String'];
};


/** A single user in Exegol */
export type UserNotesArgs = {
  filter?: InputMaybe<NoteFilter>;
};

/** A user's claims */
export type UserClaims = {
  __typename?: 'UserClaims';
  /** No claims are currently defined. As soon as the first claims are defined, they are automatically listed here. */
  not_applicable_as_no_claims_defined?: Maybe<Scalars['NoDynamicValueDefined']>;
};

/** Sub Graph: **https://users-settings-graph.qit-settings.svc.cluster.local:8443** */
export type UserSettings = {
  __typename?: 'UserSettings';
  /**
   * The user settings as a string key value map.
   *
   * Be aware: The entries are not interpreted by the backend.
   */
  settings?: Maybe<Scalars['JSONObject']>;
};

/** Sub Graph: **https://generic-shop-graph.qit-salesforce-shop.svc.cluster.local:8443** */
export type VersionInfo = {
  __typename?: 'VersionInfo';
  /** Major version */
  major?: Maybe<Scalars['Int']>;
  /** Minor version */
  minor?: Maybe<Scalars['Int']>;
  /** Patch level */
  patch?: Maybe<Scalars['Int']>;
  /** Full version info as a semver string. E.g '1.15.8' */
  versionString?: Maybe<Scalars['String']>;
};

export type CompleteActivityMutationVariables = Exact<{
  spec: UpdateActivityProcessInput;
}>;


export type CompleteActivityMutation = { __typename?: 'Mutation', updateActivityProcess?: string | null };

export type ActivityQueryVariables = Exact<{
  activityId: Scalars['String'];
}>;


export type ActivityQuery = { __typename?: 'Query', activity?: { __typename?: 'Activity', id: string, introduction?: any | null, procedure?: any | null, localizations?: { __typename?: 'ActivityLocalizations', title?: string | null } | null } | null };

export type ActivitiesQueryVariables = Exact<{
  filter?: InputMaybe<ActivityFilter>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  after?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<ActivitySort>> | InputMaybe<ActivitySort>>;
}>;


export type ActivitiesQuery = { __typename?: 'Query', activities: { __typename?: 'ActivityQueryResult', total: { __typename?: 'TotalCount', count: any, countRelation?: CountRelation | null }, activities: Array<{ __typename?: 'ActivityEdge', cursor: string, node: { __typename?: 'Activity', id: string, language: Language, creationDate: string, uploadDate?: any | null, modificationDate?: any | null, localizations?: { __typename?: 'ActivityLocalizations', title?: string | null } | null }, highlights?: { __typename?: 'ActivityHighlights', title?: Array<string | null> | null, text?: Array<string | null> | null } | null } | null> } };

export type FeedbackMutationVariables = Exact<{
  feedback: Scalars['JSONObject'];
}>;


export type FeedbackMutation = { __typename?: 'Mutation', assessAIAssistant?: boolean | null };

export type LogoAiAssistantQueryVariables = Exact<{ [key: string]: never; }>;


export type LogoAiAssistantQuery = { __typename?: 'Query', theme?: { __typename?: 'Theme', logoAIAssistant?: { __typename?: 'BlobRef', url?: any | null } | null } | null };

export type DatafieldsWithoutFacetsCollectionsQueryVariables = Exact<{
  filter?: InputMaybe<DatafieldDefinitionFilter>;
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard> | LanguageWithWildcard>;
}>;


export type DatafieldsWithoutFacetsCollectionsQuery = { __typename?: 'Query', fieldDefinitions: { __typename?: 'DatafieldDefinitionQueryResult', fieldDefinitions: Array<{ __typename?: 'DatafieldDefinitionEdge', node: { __typename?: 'BooleanDatafieldDefinition', id: any, fieldType?: FieldDefinitionTypes | null } | { __typename?: 'DateDatafieldDefinition', id: any, fieldType?: FieldDefinitionTypes | null } | { __typename?: 'DateTimeDatafieldDefinition', id: any, fieldType?: FieldDefinitionTypes | null } | { __typename?: 'DateTimeRangeDatafieldDefinition', id: any, fieldType?: FieldDefinitionTypes | null } | { __typename?: 'EnumDatafieldDefinition', id: any, fieldType?: FieldDefinitionTypes | null } | { __typename?: 'KeywordDatafieldDefinition', id: any, fieldType?: FieldDefinitionTypes | null } | { __typename?: 'NumberDatafieldDefinition', id: any, fieldType?: FieldDefinitionTypes | null } | { __typename?: 'NumberRangeDatafieldDefinition', id: any, fieldType?: FieldDefinitionTypes | null } | { __typename: 'TaxonomyDatafieldDefinition', id: any, fieldType?: FieldDefinitionTypes | null, values?: Array<{ __typename: 'TaxonomyValue', key: string, pathKeys?: Array<string> | null, teasers?: { __typename: 'DatafieldValueTeasers', title?: string | null } | null }> | null } | { __typename?: 'TextDatafieldDefinition', id: any, fieldType?: FieldDefinitionTypes | null } } | null> } };

export type CreateCollectionMutationVariables = Exact<{
  spec?: InputMaybe<CreateCollectionInput>;
}>;


export type CreateCollectionMutation = { __typename?: 'Mutation', createCollection: string };

export type UpdateCollectionMutationVariables = Exact<{
  diff?: InputMaybe<UpdateCollectionInput>;
}>;


export type UpdateCollectionMutation = { __typename?: 'Mutation', updateCollection: { __typename?: 'Collection', id: string } };

export type DeleteCollectionByIdMutationVariables = Exact<{
  deleteCollectionId: Scalars['ID'];
}>;


export type DeleteCollectionByIdMutation = { __typename?: 'Mutation', deleteCollection: string };

export type RemoveContentsFromCollectionMutationVariables = Exact<{
  idsOfContents: Array<Scalars['ID']> | Scalars['ID'];
  collectionId: Scalars['ID'];
  context?: InputMaybe<CollectionEntryNavigationContextInput>;
}>;


export type RemoveContentsFromCollectionMutation = { __typename?: 'Mutation', removeContentsFromCollection?: boolean | null };

export type RemoveArticlesFromCollectionMutationVariables = Exact<{
  articleIds: Array<Scalars['ID']> | Scalars['ID'];
  collectionId: Scalars['ID'];
  context?: InputMaybe<CollectionEntryNavigationContextInput>;
}>;


export type RemoveArticlesFromCollectionMutation = { __typename?: 'Mutation', removeArticlesFromCollection?: boolean | null };

export type RemoveMechanicsFromCollectionMutationVariables = Exact<{
  mechanicIds: Array<Scalars['ID']> | Scalars['ID'];
  collectionId: Scalars['ID'];
  context?: InputMaybe<CollectionEntryMechanicNavigationContextInput>;
}>;


export type RemoveMechanicsFromCollectionMutation = { __typename?: 'Mutation', removeMechanicsFromCollection?: boolean | null };

export type AddContentsToCollectionMutationVariables = Exact<{
  collectionId: Scalars['ID'];
  idsOfContents: Array<Scalars['ID']> | Scalars['ID'];
  context?: InputMaybe<CollectionEntryNavigationContextInput>;
}>;


export type AddContentsToCollectionMutation = { __typename?: 'Mutation', addContentsToCollection?: boolean | null };

export type AddArticlesToCollectionMutationVariables = Exact<{
  articleIds: Array<Scalars['ID']> | Scalars['ID'];
  collectionId: Scalars['ID'];
  context?: InputMaybe<CollectionEntryNavigationContextInput>;
}>;


export type AddArticlesToCollectionMutation = { __typename?: 'Mutation', addArticlesToCollection?: boolean | null };

export type AddMechanicsToCollectionMutationVariables = Exact<{
  mechanicIds: Array<Scalars['ID']> | Scalars['ID'];
  context?: InputMaybe<CollectionEntryMechanicNavigationContextInput>;
  collectionId: Scalars['ID'];
}>;


export type AddMechanicsToCollectionMutation = { __typename?: 'Mutation', addMechanicsToCollection?: boolean | null };

export type AddActivitiesToCollectionMutationVariables = Exact<{
  activityIds: Array<Scalars['ID']> | Scalars['ID'];
  collectionId: Scalars['ID'];
  context?: InputMaybe<CollectionEntryNavigationContextInput>;
}>;


export type AddActivitiesToCollectionMutation = { __typename?: 'Mutation', addActivitiesToCollection?: boolean | null };

export type RemoveActivitiesFromCollectionMutationVariables = Exact<{
  activityIds: Array<Scalars['ID']> | Scalars['ID'];
  collectionId: Scalars['ID'];
  context?: InputMaybe<CollectionEntryNavigationContextInput>;
}>;


export type RemoveActivitiesFromCollectionMutation = { __typename?: 'Mutation', removeActivitiesFromCollection?: boolean | null };

export type ExportCollectionMutationVariables = Exact<{
  id: Scalars['ID'];
  acceptedLanguages: Array<LanguageWithWildcard> | LanguageWithWildcard;
  collectionExportType: CollectionExportType;
}>;


export type ExportCollectionMutation = { __typename?: 'Mutation', exportCollection: string };

export type CollectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type CollectionsQuery = { __typename?: 'Query', collections: { __typename?: 'CollectionQueryResult', collections: Array<{ __typename?: 'CollectionEdge', cursor: string, node?: { __typename?: 'Collection', id: string, displayName?: string | null, visibility?: CollectionVisibilityTypes | null, showInDashboard: boolean, entries: { __typename?: 'CollectionEntryQueryResult', total: { __typename?: 'TotalCount', count: any, countRelation?: CountRelation | null } }, user?: { __typename?: 'User', id: string } | null } | null } | null> } };

export type CollectionsByFilterQueryVariables = Exact<{
  filter?: InputMaybe<CollectionFilter>;
}>;


export type CollectionsByFilterQuery = { __typename?: 'Query', collections: { __typename?: 'CollectionQueryResult', collections: Array<{ __typename?: 'CollectionEdge', cursor: string, node?: { __typename?: 'Collection', id: string, displayName?: string | null, description?: string | null, visibility?: CollectionVisibilityTypes | null, showInDashboard: boolean } | null } | null> } };

export type EditableCollectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type EditableCollectionsQuery = { __typename?: 'Query', editableCollections: { __typename?: 'CollectionQueryResult', total: { __typename?: 'TotalCount', count: any, countRelation?: CountRelation | null }, collections: Array<{ __typename?: 'CollectionEdge', cursor: string, node?: { __typename?: 'Collection', id: string, displayName?: string | null, visibility?: CollectionVisibilityTypes | null } | null } | null> } };

export type TitlesForMechanicPathQueryVariables = Exact<{
  productId: Scalars['String'];
  productIdForMechanic?: InputMaybe<Scalars['ID']>;
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard> | LanguageWithWildcard>;
  assetId?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<MechanicFilter>;
}>;


export type TitlesForMechanicPathQuery = { __typename?: 'Query', product?: { __typename?: 'Product', id: string, localizations?: { __typename?: 'ProductLocalizations', title?: string | null } | null } | null, mechanics: { __typename?: 'MechanicQueryResult', mechanics: Array<{ __typename?: 'MechanicEdge', node: { __typename?: 'Mechanic', articleId?: string | null, articleNumber?: string | null, assemblyId?: string | null, localizations?: { __typename?: 'MechanicLocalizations', title?: string | null } | null } } | null> } };

export type StatusExportCollectionQueryVariables = Exact<{
  jobId: Scalars['ID'];
}>;


export type StatusExportCollectionQuery = { __typename?: 'Query', statusExportCollection: { __typename?: 'CollectionExportResult', status: CollectionExportStatus, url?: string | null } };

export type AllProcessNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllProcessNamesQuery = { __typename?: 'Query', processes?: Array<{ __typename?: 'Process', id?: string | null, name: string } | null> | null };

export type DataFieldsForProductsQueryVariables = Exact<{
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard> | LanguageWithWildcard>;
}>;


export type DataFieldsForProductsQuery = { __typename?: 'Query', datafields?: { __typename?: 'Datafields', product?: Array<{ __typename?: 'CustomDatafield', referencedId: string, fieldType: FieldDefinitionTypes, localizations?: { __typename?: 'DatafieldLocalizations', title?: string | null } | null } | { __typename?: 'InherentDatafield', referencedId: string, fieldType: FieldDefinitionTypes, localizations?: { __typename?: 'DatafieldLocalizations', title?: string | null } | null }> | null } | null };

export type FieldDefinitionsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard> | LanguageWithWildcard>;
}>;


export type FieldDefinitionsQuery = { __typename?: 'Query', fieldDefinitions: { __typename?: 'DatafieldDefinitionQueryResult', fieldDefinitions: Array<{ __typename?: 'DatafieldDefinitionEdge', node: { __typename?: 'BooleanDatafieldDefinition', fieldType?: FieldDefinitionTypes | null, id: any, mappedNames?: Array<string> | null, objectTypes?: Array<ObjectType | null> | null, localizations?: { __typename?: 'DatafieldDefinitionLocalizations', title?: string | null } | null } | { __typename?: 'DateDatafieldDefinition', fieldType?: FieldDefinitionTypes | null, id: any, mappedNames?: Array<string> | null, objectTypes?: Array<ObjectType | null> | null, localizations?: { __typename?: 'DatafieldDefinitionLocalizations', title?: string | null } | null } | { __typename?: 'DateTimeDatafieldDefinition', fieldType?: FieldDefinitionTypes | null, id: any, mappedNames?: Array<string> | null, objectTypes?: Array<ObjectType | null> | null, localizations?: { __typename?: 'DatafieldDefinitionLocalizations', title?: string | null } | null } | { __typename?: 'DateTimeRangeDatafieldDefinition', fieldType?: FieldDefinitionTypes | null, id: any, mappedNames?: Array<string> | null, objectTypes?: Array<ObjectType | null> | null, localizations?: { __typename?: 'DatafieldDefinitionLocalizations', title?: string | null } | null } | { __typename?: 'EnumDatafieldDefinition', fieldType?: FieldDefinitionTypes | null, id: any, mappedNames?: Array<string> | null, objectTypes?: Array<ObjectType | null> | null, localizations?: { __typename?: 'DatafieldDefinitionLocalizations', title?: string | null } | null } | { __typename?: 'KeywordDatafieldDefinition', fieldType?: FieldDefinitionTypes | null, id: any, mappedNames?: Array<string> | null, objectTypes?: Array<ObjectType | null> | null, localizations?: { __typename?: 'DatafieldDefinitionLocalizations', title?: string | null } | null } | { __typename?: 'NumberDatafieldDefinition', fieldType?: FieldDefinitionTypes | null, id: any, mappedNames?: Array<string> | null, objectTypes?: Array<ObjectType | null> | null, localizations?: { __typename?: 'DatafieldDefinitionLocalizations', title?: string | null } | null } | { __typename?: 'NumberRangeDatafieldDefinition', fieldType?: FieldDefinitionTypes | null, id: any, mappedNames?: Array<string> | null, objectTypes?: Array<ObjectType | null> | null, localizations?: { __typename?: 'DatafieldDefinitionLocalizations', title?: string | null } | null } | { __typename?: 'TaxonomyDatafieldDefinition', fieldType?: FieldDefinitionTypes | null, id: any, mappedNames?: Array<string> | null, objectTypes?: Array<ObjectType | null> | null, localizations?: { __typename?: 'DatafieldDefinitionLocalizations', title?: string | null } | null } | { __typename?: 'TextDatafieldDefinition', fieldType?: FieldDefinitionTypes | null, id: any, mappedNames?: Array<string> | null, objectTypes?: Array<ObjectType | null> | null, localizations?: { __typename?: 'DatafieldDefinitionLocalizations', title?: string | null } | null } } | null> } };

export type ContentGroupingConfigQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ContentGroupingConfigQuery = { __typename?: 'Query', contentGroupingConfig?: { __typename?: 'ContentGroupingConfig', id: string, criteria?: ContentGroupingCriteria | null, enabled: boolean } | null };

export type MechanicContentsGroupedQueryVariables = Exact<{
  mechanicId: Scalars['String'];
  filter?: InputMaybe<ContentFilter>;
  groupBy: ContentGroupBy;
  groupFirst?: InputMaybe<Scalars['NonNegativeInt']>;
  groupAfter?: InputMaybe<Scalars['String']>;
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard> | LanguageWithWildcard>;
}>;


export type MechanicContentsGroupedQuery = { __typename?: 'Query', mechanic?: { __typename?: 'Mechanic', id: string, relatedContentsGrouped: { __typename?: 'ContentGroupedQueryResult', totalGroups: { __typename?: 'TotalCount', count: any, countRelation?: CountRelation | null } } } | null };

export type AssetContentsGroupedQueryVariables = Exact<{
  assetFilter: AssetFilter;
  filter?: InputMaybe<ContentFilter>;
  groupBy: ContentGroupBy;
  groupFirst?: InputMaybe<Scalars['NonNegativeInt']>;
  groupAfter?: InputMaybe<Scalars['String']>;
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard> | LanguageWithWildcard>;
}>;


export type AssetContentsGroupedQuery = { __typename?: 'Query', assets: { __typename?: 'AssetQueryResult', assets: Array<{ __typename?: 'AssetEdge', cursor: string, node: { __typename?: 'Asset', id: string, relatedContentsGrouped: { __typename?: 'ContentGroupedQueryResult', totalGroups: { __typename?: 'TotalCount', count: any, countRelation?: CountRelation | null } } } } | null> } };

export type ProductContentsGroupedQueryVariables = Exact<{
  productId: Scalars['String'];
  filter?: InputMaybe<ContentFilter>;
  groupBy: ContentGroupBy;
  groupFirst?: InputMaybe<Scalars['NonNegativeInt']>;
  groupAfter?: InputMaybe<Scalars['String']>;
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard> | LanguageWithWildcard>;
}>;


export type ProductContentsGroupedQuery = { __typename?: 'Query', product?: { __typename?: 'Product', id: string, relatedContentsGrouped: { __typename?: 'ContentGroupedQueryResult', totalGroups: { __typename?: 'TotalCount', count: any, countRelation?: CountRelation | null } } } | null };

export type ArticleContentsGroupedQueryVariables = Exact<{
  articleId: Scalars['String'];
  filter?: InputMaybe<ContentFilter>;
  groupBy: ContentGroupBy;
  groupFirst?: InputMaybe<Scalars['NonNegativeInt']>;
  groupAfter?: InputMaybe<Scalars['String']>;
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard> | LanguageWithWildcard>;
}>;


export type ArticleContentsGroupedQuery = { __typename?: 'Query', article?: { __typename?: 'Article', id: string, relatedContentsGrouped: { __typename?: 'ContentGroupedQueryResult', totalGroups: { __typename?: 'TotalCount', count: any, countRelation?: CountRelation | null } } } | null };

export type ContentsGroupedQueryVariables = Exact<{
  filter?: InputMaybe<ContentFilter>;
  groupBy: ContentGroupBy;
  groupFirst?: InputMaybe<Scalars['NonNegativeInt']>;
  groupAfter?: InputMaybe<Scalars['String']>;
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard> | LanguageWithWildcard>;
}>;


export type ContentsGroupedQuery = { __typename?: 'Query', contentsGrouped: { __typename?: 'ContentGroupedQueryResult', totalGroups: { __typename?: 'TotalCount', count: any, countRelation?: CountRelation | null } } };

export type MechanicContentsGroupedItemsQueryVariables = Exact<{
  mechanicId: Scalars['String'];
  filter?: InputMaybe<ContentFilter>;
  groupBy: ContentGroupBy;
  sort?: InputMaybe<Array<ContentSort> | ContentSort>;
  groupAfter?: InputMaybe<Scalars['String']>;
  hitsFirst?: InputMaybe<Scalars['NonNegativeInt']>;
  hitsAfter?: InputMaybe<Scalars['String']>;
}>;


export type MechanicContentsGroupedItemsQuery = { __typename?: 'Query', mechanic?: { __typename?: 'Mechanic', id: string, relatedContentsGrouped: { __typename?: 'ContentGroupedQueryResult', groups: Array<{ __typename?: 'ContentGroup', cursor: string }> } } | null };

export type AssetContentsGroupedItemsQueryVariables = Exact<{
  assetFilter: AssetFilter;
  filter?: InputMaybe<ContentFilter>;
  groupBy: ContentGroupBy;
  sort?: InputMaybe<Array<ContentSort> | ContentSort>;
  groupAfter?: InputMaybe<Scalars['String']>;
  hitsFirst?: InputMaybe<Scalars['NonNegativeInt']>;
  hitsAfter?: InputMaybe<Scalars['String']>;
}>;


export type AssetContentsGroupedItemsQuery = { __typename?: 'Query', assets: { __typename?: 'AssetQueryResult', assets: Array<{ __typename?: 'AssetEdge', cursor: string, node: { __typename?: 'Asset', id: string, relatedContentsGrouped: { __typename?: 'ContentGroupedQueryResult', groups: Array<{ __typename?: 'ContentGroup', cursor: string }> } } } | null> } };

export type ProductContentsGroupedItemsQueryVariables = Exact<{
  productId: Scalars['String'];
  filter?: InputMaybe<ContentFilter>;
  groupBy: ContentGroupBy;
  sort?: InputMaybe<Array<ContentSort> | ContentSort>;
  groupAfter?: InputMaybe<Scalars['String']>;
  hitsFirst?: InputMaybe<Scalars['NonNegativeInt']>;
  hitsAfter?: InputMaybe<Scalars['String']>;
}>;


export type ProductContentsGroupedItemsQuery = { __typename?: 'Query', product?: { __typename?: 'Product', id: string, relatedContentsGrouped: { __typename?: 'ContentGroupedQueryResult', groups: Array<{ __typename?: 'ContentGroup', cursor: string }> } } | null };

export type ArticleContentsGroupedItemsQueryVariables = Exact<{
  articleId: Scalars['String'];
  filter?: InputMaybe<ContentFilter>;
  groupBy: ContentGroupBy;
  sort?: InputMaybe<Array<ContentSort> | ContentSort>;
  groupAfter?: InputMaybe<Scalars['String']>;
  hitsFirst?: InputMaybe<Scalars['NonNegativeInt']>;
  hitsAfter?: InputMaybe<Scalars['String']>;
}>;


export type ArticleContentsGroupedItemsQuery = { __typename?: 'Query', article?: { __typename?: 'Article', id: string, relatedContentsGrouped: { __typename?: 'ContentGroupedQueryResult', groups: Array<{ __typename?: 'ContentGroup', cursor: string }> } } | null };

export type ContentsGroupedItemsQueryVariables = Exact<{
  filter?: InputMaybe<ContentFilter>;
  groupBy: ContentGroupBy;
  sort?: InputMaybe<Array<ContentSort> | ContentSort>;
  groupAfter?: InputMaybe<Scalars['String']>;
  hitsFirst?: InputMaybe<Scalars['NonNegativeInt']>;
  hitsAfter?: InputMaybe<Scalars['String']>;
}>;


export type ContentsGroupedItemsQuery = { __typename?: 'Query', contentsGrouped: { __typename?: 'ContentGroupedQueryResult', groups: Array<{ __typename?: 'ContentGroup', cursor: string }> } };

export type SearchRelatedContentsMechanicQueryVariables = Exact<{
  mechanicId: Scalars['String'];
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  after?: InputMaybe<Scalars['String']>;
  contentFilter?: InputMaybe<ContentFilter>;
  sort?: InputMaybe<Array<InputMaybe<ContentSort>> | InputMaybe<ContentSort>>;
}>;


export type SearchRelatedContentsMechanicQuery = { __typename?: 'Query', mechanic?: { __typename?: 'Mechanic', id: string, relatedContents: { __typename?: 'ContentQueryResult', total: { __typename?: 'TotalCount', count: any, countRelation?: CountRelation | null } } } | null };

export type SearchDocumentsForAssetWithProductQueryVariables = Exact<{
  assetFilter: AssetFilter;
  contentFilter: ContentFilter;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  after?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<ContentSort>> | InputMaybe<ContentSort>>;
}>;


export type SearchDocumentsForAssetWithProductQuery = { __typename?: 'Query', assets: { __typename?: 'AssetQueryResult', assets: Array<{ __typename?: 'AssetEdge', cursor: string, node: { __typename?: 'Asset', id: string, relatedContents: { __typename?: 'ContentQueryResult', total: { __typename?: 'TotalCount', count: any, countRelation?: CountRelation | null } } } } | null> } };

export type SearchRelatedContentsProductQueryVariables = Exact<{
  productId: Scalars['String'];
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  after?: InputMaybe<Scalars['String']>;
  contentFilter?: InputMaybe<ContentFilter>;
  sort?: InputMaybe<Array<InputMaybe<ContentSort>> | InputMaybe<ContentSort>>;
}>;


export type SearchRelatedContentsProductQuery = { __typename?: 'Query', product?: { __typename?: 'Product', id: string, relatedContents: { __typename?: 'ContentQueryResult', total: { __typename?: 'TotalCount', count: any, countRelation?: CountRelation | null } } } | null };

export type RelatedContentsForArticleQueryVariables = Exact<{
  articleId: Scalars['String'];
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  after?: InputMaybe<Scalars['String']>;
  contentFilter?: InputMaybe<ContentFilter>;
  sort?: InputMaybe<Array<InputMaybe<ContentSort>> | InputMaybe<ContentSort>>;
}>;


export type RelatedContentsForArticleQuery = { __typename?: 'Query', article?: { __typename?: 'Article', id: string, relatedContents: { __typename?: 'ContentQueryResult', total: { __typename?: 'TotalCount', count: any, countRelation?: CountRelation | null } } } | null };

export type SearchDocumentsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  after?: InputMaybe<Scalars['String']>;
  contentFilter?: InputMaybe<ContentFilter>;
  sort?: InputMaybe<Array<InputMaybe<ContentSort>> | InputMaybe<ContentSort>>;
}>;


export type SearchDocumentsQuery = { __typename?: 'Query', contents: { __typename?: 'ContentQueryResult', total: { __typename?: 'TotalCount', count: any, countRelation?: CountRelation | null } } };

export type ContentInContextQueryVariables = Exact<{
  rootContentId?: InputMaybe<Scalars['ID']>;
  contentId?: InputMaybe<Scalars['ID']>;
}>;


export type ContentInContextQuery = { __typename?: 'Query', contentInContext?: Array<{ __typename?: 'TocEdge', id: string, path: string, parentPaths?: Array<string> | null, node?: { __typename?: 'ContentMap' } | { __typename?: 'Topic', id: string, language?: Language | null, teasers?: { __typename?: 'TopicTeasers', title?: string | null } | null } | null }> | null };

export type TitleOfContentMapQueryVariables = Exact<{
  filter?: InputMaybe<ContentMapFilter>;
}>;


export type TitleOfContentMapQuery = { __typename?: 'Query', contentMaps: { __typename?: 'ContentMapQueryResult', contentMaps: Array<{ __typename?: 'ContentMapEdge', node: { __typename?: 'ContentMap', id: string, language?: Language | null, teasers?: { __typename?: 'ContentMapTeasers', title?: string | null } | null } } | null> } };

export type DocumentationVariantsAggregationsQueryVariables = Exact<{
  contentMapFilter?: InputMaybe<ContentMapFilter>;
}>;


export type DocumentationVariantsAggregationsQuery = { __typename?: 'Query', contentMaps: { __typename?: 'ContentMapQueryResult', contentMaps: Array<{ __typename?: 'ContentMapEdge', cursor: string, node: { __typename?: 'ContentMap', id: string, variants: { __typename?: 'ContentQueryResult', aggregations: { __typename?: 'Aggregations', language?: Array<{ __typename?: 'AggregationEdge', count: any, value: string }> | null } } } } | null> } };

export type TopicVariantsQueryVariables = Exact<{
  topicFilter?: InputMaybe<TopicFilter>;
  variantsFilter?: InputMaybe<ContentFilter>;
}>;


export type TopicVariantsQuery = { __typename?: 'Query', topics: { __typename?: 'TopicQueryResult', topics: Array<{ __typename?: 'TopicEdge', node: { __typename?: 'Topic', id: string, variants: { __typename?: 'ContentQueryResult', contents: Array<{ __typename?: 'ContentEdge', node?: { __typename?: 'ContentMap', id: string, contentId: string } | { __typename?: 'Topic', mimeType?: string | null, id: string, contentId: string } | null } | null> } } } | null> } };

export type DeleteNoteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteNoteMutation = { __typename?: 'Mutation', deleteNote: string };

export type DeleteNoteAttachmentsMutationVariables = Exact<{
  id: Scalars['ID'];
  attachmentIds: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
}>;


export type DeleteNoteAttachmentsMutation = { __typename?: 'Mutation', deleteNoteAttachments?: Array<string | null> | null };

export type UpdateNoteMutationVariables = Exact<{
  note: UpdateNoteInput;
}>;


export type UpdateNoteMutation = { __typename?: 'Mutation', updateNote: { __typename?: 'Note', id: string } };

export type CreateNoteMutationVariables = Exact<{
  note: CreateNoteInput;
}>;


export type CreateNoteMutation = { __typename?: 'Mutation', createNote: string };

export type NotesQueryVariables = Exact<{
  noteFilter: NoteFilter;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type NotesQuery = { __typename?: 'Query', notes?: { __typename?: 'NoteQueryResult', total: { __typename?: 'TotalCount', count: any, countRelation?: CountRelation | null }, notes: Array<{ __typename?: 'NoteEdge', cursor: string, node: { __typename?: 'Note', id: string, creationDate?: any | null, modificationDate?: any | null, visibility?: NoteVisibilityTypes | null, user?: { __typename?: 'User', id: string, displayName?: string | null } | null, text?: { __typename?: 'MultilingualString', ar?: string | null, da?: string | null, de?: string | null, el?: string | null, en?: string | null, es?: string | null, fr?: string | null, fi?: string | null, hu?: string | null, it?: string | null, ja?: string | null, nb?: string | null, nl?: string | null, pt?: string | null, ro?: string | null, ru?: string | null, sv?: string | null, tr?: string | null, zh?: string | null } | null, content?: { __typename?: 'ContentMap', contentId: string } | { __typename?: 'Topic', contentId: string } | null, attachments?: Array<{ __typename?: 'BlobRef', path?: string | null, blob?: { __typename?: 'Blob', size?: number | null, url?: any | null, id: string, mimeType?: string | null } | null } | null> | null } } | null> } | null };

export type UploadConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type UploadConfigQuery = { __typename?: 'Query', tenant: { __typename?: 'Tenant', uploadConfig?: { __typename?: 'TenantUploadConfig', notes?: { __typename?: 'NotesUploadConfig', attachments?: { __typename?: 'UploadMultipleConfig', allowedMimeTypes: Array<string | null>, limits: { __typename?: 'UploadMultipleLimits', maxFileSize?: any | null, maxFilesPerUpload?: any | null } } | null } | null } | null } };

export type NumberOfNotesQueryVariables = Exact<{
  noteFilter: NoteFilter;
}>;


export type NumberOfNotesQuery = { __typename?: 'Query', notes?: { __typename?: 'NoteQueryResult', total: { __typename?: 'TotalCount', count: any, countRelation?: CountRelation | null } } | null };

export type RawClaimsQueryVariables = Exact<{ [key: string]: never; }>;


export type RawClaimsQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, rawClaims?: any | null } };

export type RelatedArticlesFromContentMapQueryVariables = Exact<{
  filter?: InputMaybe<ContentMapFilter>;
}>;


export type RelatedArticlesFromContentMapQuery = { __typename?: 'Query', contentMaps: { __typename?: 'ContentMapQueryResult', contentMaps: Array<{ __typename?: 'ContentMapEdge', node: { __typename?: 'ContentMap', id: string, articleIds?: Array<string | null> | null } } | null> } };

export type ShowDocumentationSearchQueryVariables = Exact<{
  contentFilter?: InputMaybe<ContentFilter>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  sort?: InputMaybe<Array<InputMaybe<ContentSort>> | InputMaybe<ContentSort>>;
}>;


export type ShowDocumentationSearchQuery = { __typename?: 'Query', contents: { __typename?: 'ContentQueryResult', contents: Array<{ __typename?: 'ContentEdge', node?: { __typename?: 'ContentMap', id: string, contentId: string, locale?: string | null, language?: Language | null, teasers?: { __typename?: 'ContentMapTeasers', title?: string | null } | null } | { __typename?: 'Topic', id: string, contentId: string, locale?: string | null, language?: Language | null, teasers?: { __typename?: 'TopicTeasers', title?: string | null } | null } | null } | null> } };

export type TocQueryVariables = Exact<{
  filter?: InputMaybe<ContentMapFilter>;
  paths?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  first: Scalars['NonNegativeInt'];
  after: Scalars['String'];
}>;


export type TocQuery = { __typename?: 'Query', contentMaps: { __typename?: 'ContentMapQueryResult', contentMaps: Array<{ __typename?: 'ContentMapEdge', node: { __typename?: 'ContentMap', id: string, contentId: string, toc?: { __typename?: 'TocResult', total: { __typename?: 'TotalCount', count: any, countRelation?: CountRelation | null }, tocEntries?: Array<{ __typename?: 'TocEdge', id: string, path: string, cursor: string, childPath: string, hasChildren?: boolean | null, node?: { __typename?: 'ContentMap', id: string, teasers?: { __typename?: 'ContentMapTeasers', title?: string | null } | null } | { __typename?: 'Topic', url?: any | null, mimeType?: string | null, id: string, teasers?: { __typename?: 'TopicTeasers', title?: string | null } | null } | null }> | null } | null } } | null> } };

export type TocPathAndTitleQueryVariables = Exact<{
  rootContentId?: InputMaybe<Scalars['ID']>;
  contentId?: InputMaybe<Scalars['ID']>;
}>;


export type TocPathAndTitleQuery = { __typename?: 'Query', contentInContext?: Array<{ __typename?: 'TocEdge', path: string, id: string, childPath: string, hasChildren?: boolean | null, next?: { __typename?: 'ContentMap', id: string, teasers?: { __typename?: 'ContentMapTeasers', title?: string | null } | null } | { __typename?: 'Topic', id: string, teasers?: { __typename?: 'TopicTeasers', title?: string | null } | null } | null, previous?: { __typename?: 'ContentMap', id: string, teasers?: { __typename?: 'ContentMapTeasers', title?: string | null } | null } | { __typename?: 'Topic', id: string, teasers?: { __typename?: 'TopicTeasers', title?: string | null } | null } | null, node?: { __typename?: 'ContentMap', versionLabel?: string | null, version?: any | null, id: string, contentId: string, locale?: string | null } | { __typename?: 'Topic', url?: any | null, mimeType?: string | null, version?: any | null, id: string, contentId: string, locale?: string | null, teasers?: { __typename?: 'TopicTeasers', title?: string | null } | null, useContext?: { __typename?: 'UseContext', rootContentMap?: { __typename?: 'ContentMap', id: string, contentId: string, version?: any | null, versionLabel?: string | null } | null } | null } | null }> | null };

export type ContentsSearchQueryVariables = Exact<{
  filter?: InputMaybe<ContentFilter>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
}>;


export type ContentsSearchQuery = { __typename?: 'Query', contents: { __typename?: 'ContentQueryResult', contents: Array<{ __typename?: 'ContentEdge', cursor: string, highlights?: { __typename: 'ContentMapHighlights', title?: Array<string | null> | null, text?: Array<string | null> | null } | { __typename: 'TopicHighlights', title?: Array<string | null> | null, text?: Array<string | null> | null } | null, node?: { __typename: 'ContentMap', type?: string | null, id: string, contentId: string, locale?: string | null, teasers?: { __typename: 'ContentMapTeasers', title?: string | null } | null } | { __typename: 'Topic', type?: string | null, mimeType?: string | null, id: string, contentId: string, locale?: string | null, teasers?: { __typename: 'TopicTeasers', title?: string | null } | null } | null } | null>, total: { __typename?: 'TotalCount', count: any, countRelation?: CountRelation | null } } };

export type GetConfig3dLatticeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetConfig3dLatticeQuery = { __typename?: 'Query', config?: { __typename?: 'Config', config3dLattice?: { __typename?: 'Config3dLattice', id: string, selectionColor?: string | null, fps?: number | null, camera?: string | null, viewport?: string | null, selectionMode?: SelectionMode | null, hover?: boolean | null, articleRef?: Array<{ __typename?: 'ArticleLatticeRef', section?: string | null, field?: string | null } | null> | null } | null } | null };

export type GetConfig3dHoopsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetConfig3dHoopsQuery = { __typename?: 'Query', config?: { __typename?: 'Config', config3dHoops?: { __typename?: 'Config3dHoops', id: string, selectionColor?: string | null, outlineColor?: string | null, fps?: number | null, camera?: string | null, viewport?: string | null, selectionMode?: SelectionMode | null, hover?: boolean | null, articleRef?: Array<{ __typename?: 'ArticleHoopsRef', nodeProperty?: string | null } | null> | null } | null } | null };

export type Mechanicsref3dExistsQueryVariables = Exact<{
  filter?: InputMaybe<MechanicFilter>;
  assetId?: InputMaybe<Scalars['ID']>;
  productId?: InputMaybe<Scalars['ID']>;
}>;


export type Mechanicsref3dExistsQuery = { __typename?: 'Query', mechanics: { __typename?: 'MechanicQueryResult', mechanics: Array<{ __typename?: 'MechanicEdge', cursor: string, node: { __typename?: 'Mechanic', id: string, reference3d?: string | null } } | null> } };

export type AssembliesForTreeQueryVariables = Exact<{
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard> | LanguageWithWildcard>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  after?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<MechanicSort>> | InputMaybe<MechanicSort>>;
  filter?: InputMaybe<MechanicFilter>;
  productId?: InputMaybe<Scalars['ID']>;
  assetId?: InputMaybe<Scalars['ID']>;
}>;


export type AssembliesForTreeQuery = { __typename?: 'Query', mechanics: { __typename?: 'MechanicQueryResult', mechanics: Array<{ __typename?: 'MechanicEdge', cursor: string, node: { __typename?: 'Mechanic', articleNumber?: string | null, assemblyId?: string | null, id: string, parentAssemblyId?: string | null, localizations?: { __typename?: 'MechanicLocalizations', title?: string | null } | null, previewImage?: { __typename?: 'BlobRef', url?: any | null, blobId: string } | null } } | null> } };

export type AssemblyHasChildrenQueryVariables = Exact<{
  filter?: InputMaybe<MechanicFilter>;
  productId?: InputMaybe<Scalars['ID']>;
  assetId?: InputMaybe<Scalars['ID']>;
}>;


export type AssemblyHasChildrenQuery = { __typename?: 'Query', mechanics: { __typename?: 'MechanicQueryResult', mechanics: Array<{ __typename?: 'MechanicEdge', node: { __typename?: 'Mechanic', assemblyId?: string | null, id: string } } | null> } };

export type MechanicsLocationsQueryVariables = Exact<{
  filter?: InputMaybe<MechanicFilter>;
  assetId?: InputMaybe<Scalars['ID']>;
  productId: Scalars['ID'];
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard> | LanguageWithWildcard>;
}>;


export type MechanicsLocationsQuery = { __typename?: 'Query', mechanics: { __typename?: 'MechanicQueryResult', mechanics: Array<{ __typename?: 'MechanicEdge', node: { __typename?: 'Mechanic', id: string, articleId?: string | null, localizations?: { __typename?: 'MechanicLocalizations', title?: string | null } | null, pathsToRoot?: Array<{ __typename?: 'MechanicPath', path?: Array<{ __typename?: 'MechanicPathEntry', mechanicId: string, mechanic?: { __typename?: 'Mechanic', id: string, assemblyId?: string | null, articleId?: string | null, isAssembly?: boolean | null, reference3d?: string | null, localizations?: { __typename?: 'MechanicLocalizations', title?: string | null } | null } | null } | null> | null } | null> | null } } | null> } };

export type MechanicArticleQueryVariables = Exact<{
  mechanicId: Scalars['String'];
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard> | LanguageWithWildcard>;
}>;


export type MechanicArticleQuery = { __typename?: 'Query', mechanic?: { __typename?: 'Mechanic', id: string, assemblyId?: string | null, parentAssemblyId?: string | null, articleId?: string | null, isAssembly?: boolean | null, itemNumber?: string | null, articleNumber?: string | null, localizations?: { __typename?: 'MechanicLocalizations', title?: string | null } | null } | null };

export type MechanicHotspotQueryVariables = Exact<{
  filter?: InputMaybe<MechanicFilter>;
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard> | LanguageWithWildcard>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
}>;


export type MechanicHotspotQuery = { __typename?: 'Query', mechanics: { __typename?: 'MechanicQueryResult', mechanics: Array<{ __typename?: 'MechanicEdge', node: { __typename?: 'Mechanic', id: string, assemblyId?: string | null, parentAssemblyId?: string | null, articleId?: string | null, isAssembly?: boolean | null, reference2d?: string | null, reference3d?: string | null, articleNumber?: string | null, localizations?: { __typename?: 'MechanicLocalizations', title?: string | null } | null, previewImage?: { __typename?: 'BlobRef', blobId: string, url?: any | null, mimeType?: string | null } | null } } | null> } };

export type MechanicsParentAssemblyQueryVariables = Exact<{
  filter?: InputMaybe<MechanicFilter>;
  assetId?: InputMaybe<Scalars['ID']>;
  productId?: InputMaybe<Scalars['ID']>;
}>;


export type MechanicsParentAssemblyQuery = { __typename?: 'Query', mechanics: { __typename?: 'MechanicQueryResult', mechanics: Array<{ __typename?: 'MechanicEdge', node: { __typename?: 'Mechanic', assemblyId?: string | null, articleId?: string | null, parentAssemblyId?: string | null } } | null> } };

export type ArticleUsedInAssetsQueryVariables = Exact<{
  filter?: InputMaybe<MechanicFilter>;
  assetsFirst?: InputMaybe<Scalars['NonNegativeInt']>;
  assetsAfter?: InputMaybe<Scalars['String']>;
  mechanicsFirst?: InputMaybe<Scalars['NonNegativeInt']>;
  mechanicsAfter?: InputMaybe<Scalars['String']>;
}>;


export type ArticleUsedInAssetsQuery = { __typename?: 'Query', mechanics: { __typename?: 'MechanicQueryResult', mechanics: Array<{ __typename?: 'MechanicEdge', cursor: string, node: { __typename?: 'Mechanic', id: string, usedInAssets?: { __typename?: 'UsedInAssets', assets: { __typename?: 'AssetQueryResult', assets: Array<{ __typename?: 'AssetEdge', cursor: string, node: { __typename?: 'Asset', assetId?: string | null, id: string } } | null> } } | null } } | null> } };

export type ArticleUsedInProductsQueryVariables = Exact<{
  filter?: InputMaybe<MechanicFilter>;
  productsFirst?: InputMaybe<Scalars['NonNegativeInt']>;
  productsAfter?: InputMaybe<Scalars['String']>;
}>;


export type ArticleUsedInProductsQuery = { __typename?: 'Query', mechanicsUsedInProducts: { __typename?: 'MechanicQueryResult', usedInProducts?: { __typename?: 'UsedInProducts', products: { __typename?: 'ProductQueryResult', products: Array<{ __typename?: 'ProductEdge', cursor: string, node: { __typename?: 'Product', id: string } } | null> } } | null } };

export type MechanicsAssemblyTitleQueryVariables = Exact<{
  filter?: InputMaybe<MechanicFilter>;
  assetId?: InputMaybe<Scalars['ID']>;
  productId?: InputMaybe<Scalars['ID']>;
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard> | LanguageWithWildcard>;
}>;


export type MechanicsAssemblyTitleQuery = { __typename?: 'Query', mechanics: { __typename?: 'MechanicQueryResult', mechanics: Array<{ __typename?: 'MechanicEdge', node: { __typename?: 'Mechanic', assemblyId?: string | null, articleId?: string | null, articleNumber?: string | null, localizations?: { __typename?: 'MechanicLocalizations', title?: string | null } | null } } | null> } };

export type AvailablePartsListQueryVariables = Exact<{
  filter?: InputMaybe<MechanicFilter>;
  assetId?: InputMaybe<Scalars['ID']>;
  productId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type AvailablePartsListQuery = { __typename?: 'Query', mechanics: { __typename?: 'MechanicQueryResult', mechanics: Array<{ __typename?: 'MechanicEdge', node: { __typename?: 'Mechanic', id: string, assemblyId?: string | null } } | null> } };

export type PartslistFilesQueryVariables = Exact<{
  filter?: InputMaybe<MechanicFilter>;
  assetId?: InputMaybe<Scalars['ID']>;
  productId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
}>;


export type PartslistFilesQuery = { __typename?: 'Query', mechanics: { __typename?: 'MechanicQueryResult', mechanics: Array<{ __typename?: 'MechanicEdge', node: { __typename?: 'Mechanic', id: string, files?: Array<{ __typename?: 'CommonFile', objectType?: FileType | null, objectSubType?: FileSubType | null, file: { __typename?: 'BlobRef', blobId: string, url?: any | null, mimeType?: string | null } } | { __typename?: 'FileSchematicWithHotspots', objectType?: FileType | null, objectSubType?: FileSubType | null, file: { __typename?: 'BlobRef', blobId: string, url?: any | null, mimeType?: string | null } } | { __typename?: 'FileSvgWithHotspots', objectType?: FileType | null, objectSubType?: FileSubType | null, hotspots?: Array<{ __typename?: 'HotspotSvg', linkText?: string | null, linkType?: HotspotLinkType | null, linkValue?: string | null } | null> | null, file: { __typename?: 'BlobRef', blobId: string, url?: any | null, mimeType?: string | null } } | { __typename?: 'FileWithHotspots', objectType?: FileType | null, objectSubType?: FileSubType | null, hotspots?: Array<{ __typename?: 'Hotspot', x1?: number | null, x2?: number | null, y1?: number | null, y2?: number | null, linkType?: HotspotLinkType | null, linkValue?: string | null } | null> | null, file: { __typename?: 'BlobRef', blobId: string, url?: any | null, mimeType?: string | null } } | { __typename?: 'Image3dFile', objectType?: FileType | null, objectSubType?: FileSubType | null, file: { __typename?: 'BlobRef', blobId: string, url?: any | null, mimeType?: string | null } }> | null } } | null> } };

export type MechanicProcessQueryVariables = Exact<{
  processId: Scalars['String'];
}>;


export type MechanicProcessQuery = { __typename?: 'Query', process?: { __typename?: 'Process', id?: string | null, processType: ProcessType, name: string, columns?: Array<string | null> | null, filenameSchemaName?: string | null, deleteAll?: boolean | null, delimiter?: string | null, escape?: string | null, encoding?: ProcessEncodingType | null, mappingOptions?: Array<{ __typename?: 'MappingOption', type?: ProcessMappingType | null, upToChar?: string | null } | null> | null } | null };

export type ProcessDatafieldMappingsQueryVariables = Exact<{
  processType: ProcessType;
  columns: Array<Scalars['String']> | Scalars['String'];
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard> | LanguageWithWildcard>;
}>;


export type ProcessDatafieldMappingsQuery = { __typename?: 'Query', processDatafieldMappings?: Array<{ __typename?: 'CommonProcessDatafieldMapping', column: string, ambiguousColumns?: Array<string> | null, field?: { __typename?: 'CustomDatafield', fieldType: FieldDefinitionTypes, referencedId: string, type: DatafieldType, localizations?: { __typename?: 'DatafieldLocalizations', title?: string | null } | null } | { __typename?: 'InherentDatafield', fieldType: FieldDefinitionTypes, referencedId: string, type: DatafieldType, localizations?: { __typename?: 'DatafieldLocalizations', title?: string | null } | null } | null } | { __typename?: 'MultilingualDatafieldMapping', language: Language, column: string, ambiguousColumns?: Array<string> | null, field?: { __typename?: 'CustomDatafield', fieldType: FieldDefinitionTypes, referencedId: string, type: DatafieldType, localizations?: { __typename?: 'DatafieldLocalizations', title?: string | null } | null } | { __typename?: 'InherentDatafield', fieldType: FieldDefinitionTypes, referencedId: string, type: DatafieldType, localizations?: { __typename?: 'DatafieldLocalizations', title?: string | null } | null } | null } | { __typename?: 'RangeDatafieldMapping', operator: RangeOperator, column: string, ambiguousColumns?: Array<string> | null, field?: { __typename?: 'CustomDatafield', fieldType: FieldDefinitionTypes, referencedId: string, type: DatafieldType, localizations?: { __typename?: 'DatafieldLocalizations', title?: string | null } | null } | { __typename?: 'InherentDatafield', fieldType: FieldDefinitionTypes, referencedId: string, type: DatafieldType, localizations?: { __typename?: 'DatafieldLocalizations', title?: string | null } | null } | null } | null> | null };

export type ProductQueryVariables = Exact<{
  id: Scalars['String'];
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard> | LanguageWithWildcard>;
}>;


export type ProductQuery = { __typename?: 'Query', product?: { __typename?: 'Product', id: string, referenceId?: string | null, localizations?: { __typename?: 'ProductLocalizations', title?: string | null } | null } | null };

export type GetItemByIdQueryVariables = Exact<{
  schematicId: Scalars['ID'];
  itemId: Scalars['String'];
}>;


export type GetItemByIdQuery = { __typename?: 'Query', items: { __typename?: 'ItemQueryResult', items: Array<{ __typename?: 'ItemEdge', cursor: string, score: any, node: { __typename?: 'Item', id: string, schematicId: string, itemId: string, type: string, parentItemId: string, name?: string | null, nodecaption?: string | null, mainSheet?: string | null, mainHotspotId?: string | null, isSubItem?: boolean | null, title?: { __typename?: 'MultilingualString', en?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null, ja?: string | null, zh?: string | null } | null } } | null>, total: { __typename?: 'TotalCount', count: any, countRelation?: CountRelation | null } } };

export type GetItemsByParentQueryVariables = Exact<{
  schematicId: Scalars['ID'];
  parentItemId: Scalars['String'];
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetItemsByParentQuery = { __typename?: 'Query', items: { __typename?: 'ItemQueryResult', items: Array<{ __typename?: 'ItemEdge', cursor: string, score: any, node: { __typename?: 'Item', id: string, schematicId: string, itemId: string, type: string, parentItemId: string, name?: string | null, nodecaption?: string | null, mainSheet?: string | null, mainHotspotId?: string | null, isSubItem?: boolean | null, title?: { __typename?: 'MultilingualString', en?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null, ja?: string | null, zh?: string | null } | null } } | null>, total: { __typename?: 'TotalCount', count: any, countRelation?: CountRelation | null } } };

export type GetPartsBySchematicIdQueryVariables = Exact<{
  schematicId: Scalars['ID'];
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetPartsBySchematicIdQuery = { __typename?: 'Query', parts: { __typename?: 'PartQueryResult', parts: Array<{ __typename?: 'PartEdge', cursor: string, score: any, node: { __typename?: 'Part', id: string, schematicId: string, partNo: string, linkPartNo?: string | null, visiblePartNo?: string | null, orderNo?: string | null, title?: { __typename?: 'MultilingualString', en?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null, ja?: string | null, zh?: string | null } | null, data: Array<{ __typename?: 'PartDataEntry', key: string, value?: string | null }> } } | null>, total: { __typename?: 'TotalCount', count: any, countRelation?: CountRelation | null } } };

export type GetSchematicApiVersionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSchematicApiVersionQuery = { __typename?: 'Query', schematicApiVersion: string };

export type GetAllSchematicsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllSchematicsQuery = { __typename?: 'Query', schematics: Array<{ __typename?: 'Schematic', generator?: string | null, id: string, lang?: string | null, scale?: string | null, title?: string | null, translations?: string | null }> };

export type GetStructsByParentQueryVariables = Exact<{
  schematicId: Scalars['ID'];
  parentStructId: Scalars['String'];
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetStructsByParentQuery = { __typename?: 'Query', structs: { __typename?: 'StructQueryResult', structs: Array<{ __typename?: 'StructEdge', cursor: string, score: any, node: { __typename?: 'Struct', id: string, schematicId: string, structId?: string | null, parentStructId?: string | null, title?: { __typename?: 'MultilingualString', en?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null, ja?: string | null, zh?: string | null } | null, files?: Array<{ __typename?: 'CommonFile', id: string, schemaId: string, file: { __typename?: 'BlobRef', blobId: string, url?: any | null, path?: string | null, mimeType?: string | null } } | { __typename?: 'FileSchematicWithHotspots', name?: string | null, id: string, schemaId: string, hotspots?: Array<{ __typename?: 'HotspotSchematic', hotspotId?: string | null, x1?: number | null, x2?: number | null, y1?: number | null, y2?: number | null, itemType?: string | null, itemId?: string | null } | null> | null, file: { __typename?: 'BlobRef', blobId: string, url?: any | null, path?: string | null, mimeType?: string | null } } | { __typename?: 'FileSvgWithHotspots', id: string, schemaId: string, file: { __typename?: 'BlobRef', blobId: string, url?: any | null, path?: string | null, mimeType?: string | null } } | { __typename?: 'FileWithHotspots', id: string, schemaId: string, file: { __typename?: 'BlobRef', blobId: string, url?: any | null, path?: string | null, mimeType?: string | null } } | { __typename?: 'Image3dFile', id: string, schemaId: string, file: { __typename?: 'BlobRef', blobId: string, url?: any | null, path?: string | null, mimeType?: string | null } }> | null } } | null>, total: { __typename?: 'TotalCount', count: any, countRelation?: CountRelation | null } } };

export type GetSchematicsByProductQueryVariables = Exact<{
  productId?: InputMaybe<Scalars['ID']>;
}>;


export type GetSchematicsByProductQuery = { __typename?: 'Query', schematics: Array<{ __typename?: 'Schematic', id: string, title?: string | null, generator?: string | null, lang?: string | null, scale?: string | null, translations?: string | null }> };

export type GetFdiShopConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFdiShopConfigQuery = { __typename?: 'Query', getFdiShopConfig?: { __typename?: 'FdiShopConfig', baseUrl?: string | null, id: string, shopServiceUrl?: string | null } | null };

export type MySourceProviderQueryVariables = Exact<{ [key: string]: never; }>;


export type MySourceProviderQuery = { __typename?: 'Query', me: { __typename?: 'User', sourceProvider?: Array<string | null> | null, id: string } };

export type GenericShopBasketFieldsFragment = { __typename?: 'ShopBasket', items: Array<{ __typename?: 'ShopBasketItem', articleId: string, assetId?: string | null, productId?: string | null, amount: number, totalPrice?: { __typename?: 'ShopPrice', price?: number | null, currency: { __typename?: 'ShopCurrency', code: CurrencyCode } } | null }>, totalPrice?: { __typename?: 'ShopPrice', price?: number | null, currency: { __typename?: 'ShopCurrency', code: CurrencyCode } } | null };

export type GenericShopBasketQueryVariables = Exact<{ [key: string]: never; }>;


export type GenericShopBasketQuery = { __typename?: 'Query', shopBasket: { __typename?: 'ShopBasket', items: Array<{ __typename?: 'ShopBasketItem', articleId: string, assetId?: string | null, productId?: string | null, amount: number, totalPrice?: { __typename?: 'ShopPrice', price?: number | null, currency: { __typename?: 'ShopCurrency', code: CurrencyCode } } | null }>, totalPrice?: { __typename?: 'ShopPrice', price?: number | null, currency: { __typename?: 'ShopCurrency', code: CurrencyCode } } | null } };

export type GenericShopBasketAddItemMutationVariables = Exact<{
  item: ShopBasketAddItemInput;
}>;


export type GenericShopBasketAddItemMutation = { __typename?: 'Mutation', shopBasketAddItem: { __typename?: 'ShopBasket', items: Array<{ __typename?: 'ShopBasketItem', articleId: string, assetId?: string | null, productId?: string | null, amount: number, totalPrice?: { __typename?: 'ShopPrice', price?: number | null, currency: { __typename?: 'ShopCurrency', code: CurrencyCode } } | null }>, totalPrice?: { __typename?: 'ShopPrice', price?: number | null, currency: { __typename?: 'ShopCurrency', code: CurrencyCode } } | null } };

export type GenericShopCheckoutUrlQueryVariables = Exact<{
  context: ShopRequestContextInput;
}>;


export type GenericShopCheckoutUrlQuery = { __typename?: 'Query', shopCheckoutUrl: { __typename?: 'ShopCheckoutStart', url: string, expiresAt?: string | null } };

export type GenericShopConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GenericShopConfigQuery = { __typename?: 'Query', getGenericShopConfig?: { __typename?: 'GenericShopConfig', id: string, graphqlUrl?: string | null } | null };

export type GenericShopItemInfoQueryVariables = Exact<{
  input: ShopItemInfoInput;
}>;


export type GenericShopItemInfoQuery = { __typename?: 'Query', shopItemInfo?: { __typename?: 'ShopItemInfo', priceOnRequest?: boolean | null, orderable: boolean, price: { __typename?: 'ShopPrice', price?: number | null, currency: { __typename?: 'ShopCurrency', code: CurrencyCode, sign?: string | null } }, stock: { __typename?: 'ShopStock', stock?: number | null, stockStatus: StockStatus } } | null };

export type GenericShopSessionQueryVariables = Exact<{ [key: string]: never; }>;


export type GenericShopSessionQuery = { __typename?: 'Query', shopSession: { __typename?: 'ShopSession', online: boolean, status: ShopSessionStatus } };

export type GenericShopAuthStartUrlQueryVariables = Exact<{
  context: ShopRequestContextInput;
}>;


export type GenericShopAuthStartUrlQuery = { __typename?: 'Query', shopAuthStartUrl: { __typename?: 'ShopAuthStart', url: string } };

export type GetSalesforceConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSalesforceConfigQuery = { __typename?: 'Query', getSalesforceConfig?: { __typename?: 'SalesforceConfig', graphUrl?: string | null, id: string, shopServiceUrl?: string | null, shopUrl?: string | null, wellKnownOpenIdConfiguration?: string | null } | null };

export type GetConfigSapShopQueryVariables = Exact<{ [key: string]: never; }>;


export type GetConfigSapShopQuery = { __typename?: 'Query', getSapShopConfig?: { __typename?: 'SapConfig', id: string, shopServiceUrl?: string | null, graphUrl?: string | null, shopUrl?: string | null, tokenUrl?: string | null, cartIdParameter?: string | null, appEntryParameter: string } | null };

export type CartItemFieldsFragment = { __typename?: 'ShopLightCartItem', quantity: number, remark?: string | null, cartItemId: { __typename?: 'CartItemId', articleId: string, partLocation?: { __typename?: 'PartLocation', mechanicId?: string | null } | null } };

export type GetShopLightCartQueryVariables = Exact<{ [key: string]: never; }>;


export type GetShopLightCartQuery = { __typename?: 'Query', getCart?: { __typename?: 'ShopLightCart', id: string, cartItems?: Array<{ __typename?: 'ShopLightCartItem', quantity: number, remark?: string | null, cartItemId: { __typename?: 'CartItemId', articleId: string, partLocation?: { __typename?: 'PartLocation', mechanicId?: string | null } | null } } | null> | null } | null };

export type AddCartItemMutationVariables = Exact<{
  spec: ShopLightCartItemInput;
}>;


export type AddCartItemMutation = { __typename?: 'Mutation', addCartItem: { __typename?: 'ShopLightCartItem', quantity: number, remark?: string | null, cartItemId: { __typename?: 'CartItemId', articleId: string, partLocation?: { __typename?: 'PartLocation', mechanicId?: string | null } | null } } };

export type DeleteCartItemMutationVariables = Exact<{
  spec: ShopLightCartItemDelete;
}>;


export type DeleteCartItemMutation = { __typename?: 'Mutation', deleteCartItem: boolean };

export type UpdateCartItemMutationVariables = Exact<{
  spec: ShopLightCartItemInput;
}>;


export type UpdateCartItemMutation = { __typename?: 'Mutation', updateCartItem: { __typename?: 'ShopLightCartItem', quantity: number, remark?: string | null, cartItemId: { __typename?: 'CartItemId', articleId: string, partLocation?: { __typename?: 'PartLocation', mechanicId?: string | null } | null } } };

export type SendMailsMutationVariables = Exact<{
  spec: SendMailsInput;
}>;


export type SendMailsMutation = { __typename?: 'Mutation', sendMails: string };

export type GetShopLightConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetShopLightConfigQuery = { __typename?: 'Query', getShopLightConfig?: { __typename?: 'ShopLightConfig', id: string, shopServiceUrl?: string | null, shopEMail?: string | null } | null };

export type GetArticleShopInfoQueryVariables = Exact<{
  articleId: Scalars['String'];
}>;


export type GetArticleShopInfoQuery = { __typename?: 'Query', article?: { __typename?: 'Article', id: string, currency?: string | null, orderable?: boolean | null, price?: string | null } | null };

export type GetArticleWithContextShopInfoQueryVariables = Exact<{
  mechanicId: Scalars['String'];
}>;


export type GetArticleWithContextShopInfoQuery = { __typename?: 'Query', mechanic?: { __typename?: 'Mechanic', id: string, currency?: string | null, orderable?: boolean | null, price?: string | null } | null };

export type GetDetailsForArticlesQueryVariables = Exact<{
  filter?: InputMaybe<ArticleFilter>;
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard> | LanguageWithWildcard>;
}>;


export type GetDetailsForArticlesQuery = { __typename?: 'Query', articles: { __typename?: 'ArticleQueryResult', articles: Array<{ __typename?: 'ArticleEdge', node: { __typename?: 'Article', id: string, articleNumber?: string | null, currency?: string | null, orderable?: boolean | null, price?: string | null, localizations?: { __typename?: 'ArticleLocalizations', title?: string | null } | null, previewImage?: { __typename?: 'BlobRef', blobId: string, url?: any | null } | null } } | null> } };

export type GetDetailsForArticlesWithContextQueryVariables = Exact<{
  filter?: InputMaybe<MechanicFilter>;
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard> | LanguageWithWildcard>;
}>;


export type GetDetailsForArticlesWithContextQuery = { __typename?: 'Query', mechanics: { __typename?: 'MechanicQueryResult', mechanics: Array<{ __typename?: 'MechanicEdge', node: { __typename?: 'Mechanic', id: string, articleNumber?: string | null, assemblyId?: string | null, currency?: string | null, orderable?: boolean | null, price?: string | null, localizations?: { __typename?: 'MechanicLocalizations', title?: string | null } | null, previewImage?: { __typename?: 'BlobRef', url?: any | null } | null } } | null> } };

export type StaticPageQueryVariables = Exact<{
  pageType: Scalars['String'];
  languages?: InputMaybe<Array<LanguageWithWildcard> | LanguageWithWildcard>;
}>;


export type StaticPageQuery = { __typename?: 'Query', staticPage?: { __typename?: 'StaticPage', id: string, title: string, contents?: Array<{ __typename?: 'BlobRef', url?: any | null } | null> | null } | null };

export type AccessComposableQueryVariables = Exact<{ [key: string]: never; }>;


export type AccessComposableQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, email?: any | null, roles?: Array<string | null> | null, anonymous: boolean, displayName?: string | null, effectiveRoles?: Array<string | null> | null, endSessionUrl?: string | null }, accessControlSettings: { __typename?: 'AccessControlSettings', id: string, rolesConfig?: any | null }, availableFeatures?: Array<{ __typename?: 'Feature', id: string } | null> | null };

export type UserQueryVariables = Exact<{ [key: string]: never; }>;


export type UserQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, email?: any | null, roles?: Array<string | null> | null, anonymous: boolean, displayName?: string | null, effectiveRoles?: Array<string | null> | null, endSessionUrl?: string | null } };

export type AccessControlSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type AccessControlSettingsQuery = { __typename?: 'Query', accessControlSettings: { __typename?: 'AccessControlSettings', id: string, rolesConfig?: any | null } };

export type AvailableFeaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailableFeaturesQuery = { __typename?: 'Query', availableFeatures?: Array<{ __typename?: 'Feature', id: string } | null> | null };

export type LogoQueryVariables = Exact<{ [key: string]: never; }>;


export type LogoQuery = { __typename?: 'Query', theme?: { __typename?: 'Theme', logo?: { __typename?: 'BlobRef', url?: any | null } | null } | null };

export type FacetAutocompleteQueryVariables = Exact<{
  filter: FacetDatafieldAutocompleteFilter;
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard> | LanguageWithWildcard>;
}>;


export type FacetAutocompleteQuery = { __typename?: 'Query', facetDatafieldAutocomplete: { __typename?: 'FacetDatafieldAutocompleteResult', hits: Array<{ __typename?: 'FacetDatafieldAutocompleteEdge', displayName: string, filterSelection?: Array<string | null> | null, language?: Language | null, value: string, datafieldDefinitionId: any, datafieldDefinition?: { __typename?: 'BooleanDatafieldDefinition', teasers?: { __typename?: 'DatafieldDefinitionTeasers', title?: string | null } | null } | { __typename?: 'DateDatafieldDefinition', teasers?: { __typename?: 'DatafieldDefinitionTeasers', title?: string | null } | null } | { __typename?: 'DateTimeDatafieldDefinition', teasers?: { __typename?: 'DatafieldDefinitionTeasers', title?: string | null } | null } | { __typename?: 'DateTimeRangeDatafieldDefinition', teasers?: { __typename?: 'DatafieldDefinitionTeasers', title?: string | null } | null } | { __typename?: 'EnumDatafieldDefinition', teasers?: { __typename?: 'DatafieldDefinitionTeasers', title?: string | null } | null } | { __typename?: 'KeywordDatafieldDefinition', teasers?: { __typename?: 'DatafieldDefinitionTeasers', title?: string | null } | null } | { __typename?: 'NumberDatafieldDefinition', teasers?: { __typename?: 'DatafieldDefinitionTeasers', title?: string | null } | null } | { __typename?: 'NumberRangeDatafieldDefinition', teasers?: { __typename?: 'DatafieldDefinitionTeasers', title?: string | null } | null } | { __typename?: 'TaxonomyDatafieldDefinition', teasers?: { __typename?: 'DatafieldDefinitionTeasers', title?: string | null } | null } | { __typename?: 'TextDatafieldDefinition', teasers?: { __typename?: 'DatafieldDefinitionTeasers', title?: string | null } | null } | null }> } };

export type StaticPageMenuQueryVariables = Exact<{
  languages?: InputMaybe<Array<LanguageWithWildcard> | LanguageWithWildcard>;
}>;


export type StaticPageMenuQuery = { __typename?: 'Query', staticPageMenu?: { __typename?: 'StaticPageMenu', id: string, pages?: Array<{ __typename?: 'StaticPageMenuEntry', pageType: string, teasers?: { __typename?: 'StaticPageMenuEntryTeasers', title?: string | null } | null, staticPages?: Array<{ __typename?: 'StaticPage', id: string } | null> | null } | null> | null } | null };

export type MarkNotificationsAsReadMutationVariables = Exact<{
  ids: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
}>;


export type MarkNotificationsAsReadMutation = { __typename?: 'Mutation', markNotificationsAsRead: Array<string | null> };

export type NotificationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  after?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard> | LanguageWithWildcard>;
}>;


export type NotificationsQuery = { __typename?: 'Query', notifications?: { __typename?: 'NotificationQueryResult', total: { __typename?: 'TotalCount', count: any, countRelation?: CountRelation | null }, notifications: Array<{ __typename?: 'NotificationEdge', cursor: string, node: { __typename?: 'Notification', id: string, objectId?: string | null, objectType?: string | null, notificationType?: string | null, creationDate?: any | null, teasers?: { __typename?: 'NotificationTeasers', text?: string | null } | null, users?: Array<{ __typename?: 'User', id: string, email?: any | null } | null> | null } } | null> } | null };

export type GetContentByNoteIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetContentByNoteIdQuery = { __typename?: 'Query', note?: { __typename?: 'Note', content?: { __typename?: 'ContentMap', id: string, contentId: string } | { __typename?: 'Topic', id: string, contentId: string } | null } | null };

export type NotificationsTopBarQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type NotificationsTopBarQuery = { __typename?: 'Query', notifications?: { __typename?: 'NotificationQueryResult', total: { __typename?: 'TotalCount', count: any } } | null };

export type GetConfigProductAndAssetQueryVariables = Exact<{ [key: string]: never; }>;


export type GetConfigProductAndAssetQuery = { __typename?: 'Query', config?: { __typename?: 'Config', configProductAndAsset?: { __typename?: 'ConfigProductAndAsset', id: string, productName: ProductNames, assetName: AssetNames, deactivateAssets?: boolean | null } | null } | null };

export type CreateAppKeyMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateAppKeyMutation = { __typename?: 'Mutation', createAppKey: { __typename?: 'CreateApiKeyResponse', apiPass: string, key?: { __typename?: 'ApiKey', id: string, validUntil?: any | null } | null } };

export type AppKeyQueryVariables = Exact<{ [key: string]: never; }>;


export type AppKeyQuery = { __typename?: 'Query', appKey?: { __typename?: 'ApiKey', validUntil?: any | null, id: string, displayName: string } | null };

export type DataDisplayConfigQueryVariables = Exact<{
  dataDisplayConfigId: Scalars['ID'];
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard> | LanguageWithWildcard>;
  length?: InputMaybe<Scalars['NonNegativeInt']>;
}>;


export type DataDisplayConfigQuery = { __typename?: 'Query', dataDisplayConfig?: { __typename?: 'DataDisplayConfig', id: string, entries?: Array<{ __typename?: 'DataDisplayConfigDatafieldEntry', referencedId: string, fieldType: FieldDefinitionTypes, type: DatafieldType, displayOptions?: any | null, datafieldDefinition?: { __typename?: 'BooleanDatafieldDefinition', objectTypes?: Array<ObjectType | null> | null, falseValue?: { __typename?: 'BooleanValue', teasers?: { __typename?: 'DatafieldValueTeasers', title?: string | null } | null } | null, trueValue?: { __typename?: 'BooleanValue', teasers?: { __typename?: 'DatafieldValueTeasers', title?: string | null } | null } | null } | { __typename?: 'DateDatafieldDefinition', objectTypes?: Array<ObjectType | null> | null } | { __typename?: 'DateTimeDatafieldDefinition', objectTypes?: Array<ObjectType | null> | null } | { __typename?: 'DateTimeRangeDatafieldDefinition', objectTypes?: Array<ObjectType | null> | null } | { __typename?: 'EnumDatafieldDefinition', objectTypes?: Array<ObjectType | null> | null, values?: Array<{ __typename?: 'EnumValue', key: string, teasers?: { __typename?: 'DatafieldValueTeasers', title?: string | null } | null }> | null } | { __typename?: 'KeywordDatafieldDefinition', objectTypes?: Array<ObjectType | null> | null } | { __typename?: 'NumberDatafieldDefinition', objectTypes?: Array<ObjectType | null> | null } | { __typename?: 'NumberRangeDatafieldDefinition', objectTypes?: Array<ObjectType | null> | null } | { __typename?: 'TaxonomyDatafieldDefinition', objectTypes?: Array<ObjectType | null> | null, values?: Array<{ __typename?: 'TaxonomyValue', key: string, teasers?: { __typename?: 'DatafieldValueTeasers', title?: string | null } | null }> | null } | { __typename?: 'TextDatafieldDefinition', objectTypes?: Array<ObjectType | null> | null } | null, teasers?: { __typename?: 'DataDisplayConfigEntryTeasers', title?: string | null } | null } | { __typename?: 'DataDisplayConfigFieldEntry', nodeTypes?: Array<string | null> | null, referencedId: string, fieldType: FieldDefinitionTypes, type: DatafieldType, displayOptions?: any | null, datafieldDefinition?: { __typename?: 'BooleanDatafieldDefinition', falseValue?: { __typename?: 'BooleanValue', teasers?: { __typename?: 'DatafieldValueTeasers', title?: string | null } | null } | null, trueValue?: { __typename?: 'BooleanValue', teasers?: { __typename?: 'DatafieldValueTeasers', title?: string | null } | null } | null } | { __typename?: 'DateDatafieldDefinition' } | { __typename?: 'DateTimeDatafieldDefinition' } | { __typename?: 'DateTimeRangeDatafieldDefinition' } | { __typename?: 'EnumDatafieldDefinition', values?: Array<{ __typename?: 'EnumValue', key: string, teasers?: { __typename?: 'DatafieldValueTeasers', title?: string | null } | null }> | null } | { __typename?: 'KeywordDatafieldDefinition' } | { __typename?: 'NumberDatafieldDefinition' } | { __typename?: 'NumberRangeDatafieldDefinition' } | { __typename?: 'TaxonomyDatafieldDefinition', values?: Array<{ __typename?: 'TaxonomyValue', key: string, teasers?: { __typename?: 'DatafieldValueTeasers', title?: string | null } | null }> | null } | { __typename?: 'TextDatafieldDefinition' } | null, teasers?: { __typename?: 'DataDisplayConfigEntryTeasers', title?: string | null } | null }> | null } | null };

export type FieldDefinitionsTitleQueryVariables = Exact<{
  filter?: InputMaybe<DatafieldDefinitionFilter>;
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard> | LanguageWithWildcard>;
}>;


export type FieldDefinitionsTitleQuery = { __typename?: 'Query', fieldDefinitions: { __typename?: 'DatafieldDefinitionQueryResult', fieldDefinitions: Array<{ __typename?: 'DatafieldDefinitionEdge', node: { __typename?: 'BooleanDatafieldDefinition', id: any, localizations?: { __typename?: 'DatafieldDefinitionLocalizations', title?: string | null } | null } | { __typename?: 'DateDatafieldDefinition', id: any, localizations?: { __typename?: 'DatafieldDefinitionLocalizations', title?: string | null } | null } | { __typename?: 'DateTimeDatafieldDefinition', id: any, localizations?: { __typename?: 'DatafieldDefinitionLocalizations', title?: string | null } | null } | { __typename?: 'DateTimeRangeDatafieldDefinition', id: any, localizations?: { __typename?: 'DatafieldDefinitionLocalizations', title?: string | null } | null } | { __typename?: 'EnumDatafieldDefinition', id: any, localizations?: { __typename?: 'DatafieldDefinitionLocalizations', title?: string | null } | null } | { __typename?: 'KeywordDatafieldDefinition', id: any, localizations?: { __typename?: 'DatafieldDefinitionLocalizations', title?: string | null } | null } | { __typename?: 'NumberDatafieldDefinition', id: any, localizations?: { __typename?: 'DatafieldDefinitionLocalizations', title?: string | null } | null } | { __typename?: 'NumberRangeDatafieldDefinition', id: any, localizations?: { __typename?: 'DatafieldDefinitionLocalizations', title?: string | null } | null } | { __typename?: 'TaxonomyDatafieldDefinition', id: any, localizations?: { __typename?: 'DatafieldDefinitionLocalizations', title?: string | null } | null } | { __typename?: 'TextDatafieldDefinition', id: any, localizations?: { __typename?: 'DatafieldDefinitionLocalizations', title?: string | null } | null } } | null> } };

export type FacetDefinitionsQueryVariables = Exact<{
  referencedIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard> | LanguageWithWildcard>;
  id: Scalars['ID'];
}>;


export type FacetDefinitionsQuery = { __typename?: 'Query', facetsCollection?: { __typename?: 'FacetsCollection', facets?: Array<{ __typename?: 'CustomDatafieldFacet', id: string, type: DatafieldType, referencedId: string, definition?: { __typename?: 'BooleanFacetDefinition', fieldType: FieldDefinitionTypes, falseValue?: { __typename?: 'BooleanValue', teasers?: { __typename?: 'DatafieldValueTeasers', title?: string | null } | null } | null, trueValue?: { __typename?: 'BooleanValue', teasers?: { __typename?: 'DatafieldValueTeasers', title?: string | null } | null } | null } | { __typename?: 'DateFacetDefinition', fieldType: FieldDefinitionTypes } | { __typename?: 'DateTimeFacetDefinition', fieldType: FieldDefinitionTypes } | { __typename?: 'DateTimeRangeFacetDefinition', fieldType: FieldDefinitionTypes } | { __typename?: 'EnumFacetDefinition', fieldType: FieldDefinitionTypes, values?: Array<{ __typename?: 'EnumValue', key: string, teasers?: { __typename?: 'DatafieldValueTeasers', title?: string | null } | null }> | null } | { __typename?: 'KeywordFacetDefinition', fieldType: FieldDefinitionTypes } | { __typename?: 'NumberRangeFacetDefinition', fieldType: FieldDefinitionTypes } | { __typename?: 'TaxonomyFacetDefinition', fieldType: FieldDefinitionTypes, values?: Array<{ __typename?: 'TaxonomyValue', key: string, pathKeys?: Array<string> | null, teasers?: { __typename?: 'DatafieldValueTeasers', title?: string | null } | null }> | null } | null } | { __typename?: 'FieldFacet', id: string, type: DatafieldType, referencedId: string, definition?: { __typename?: 'BooleanFacetDefinition', fieldType: FieldDefinitionTypes, falseValue?: { __typename?: 'BooleanValue', teasers?: { __typename?: 'DatafieldValueTeasers', title?: string | null } | null } | null, trueValue?: { __typename?: 'BooleanValue', teasers?: { __typename?: 'DatafieldValueTeasers', title?: string | null } | null } | null } | { __typename?: 'DateFacetDefinition', fieldType: FieldDefinitionTypes } | { __typename?: 'DateTimeFacetDefinition', fieldType: FieldDefinitionTypes } | { __typename?: 'DateTimeRangeFacetDefinition', fieldType: FieldDefinitionTypes } | { __typename?: 'EnumFacetDefinition', fieldType: FieldDefinitionTypes, values?: Array<{ __typename?: 'EnumValue', key: string, teasers?: { __typename?: 'DatafieldValueTeasers', title?: string | null } | null }> | null } | { __typename?: 'KeywordFacetDefinition', fieldType: FieldDefinitionTypes } | { __typename?: 'NumberRangeFacetDefinition', fieldType: FieldDefinitionTypes } | { __typename?: 'TaxonomyFacetDefinition', fieldType: FieldDefinitionTypes, values?: Array<{ __typename?: 'TaxonomyValue', key: string, pathKeys?: Array<string> | null, teasers?: { __typename?: 'DatafieldValueTeasers', title?: string | null } | null }> | null } | null } | null> | null } | null };

export type FacetsQueryVariables = Exact<{
  id: Scalars['ID'];
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard> | LanguageWithWildcard>;
}>;


export type FacetsQuery = { __typename?: 'Query', facetsCollection?: { __typename?: 'FacetsCollection', facets?: Array<{ __typename?: 'CustomDatafieldFacet', id: string, type: DatafieldType, kind: string, referencedId: string, display: { __typename?: 'FacetDisplay', type: string, options?: any | null }, teasers?: { __typename?: 'FacetTeasers', title?: string | null } | null, definition?: { __typename?: 'BooleanFacetDefinition', fieldType: FieldDefinitionTypes } | { __typename?: 'DateFacetDefinition', fieldType: FieldDefinitionTypes } | { __typename?: 'DateTimeFacetDefinition', fieldType: FieldDefinitionTypes } | { __typename?: 'DateTimeRangeFacetDefinition', fieldType: FieldDefinitionTypes } | { __typename?: 'EnumFacetDefinition', fieldType: FieldDefinitionTypes } | { __typename?: 'KeywordFacetDefinition', fieldType: FieldDefinitionTypes } | { __typename?: 'NumberRangeFacetDefinition', fieldType: FieldDefinitionTypes } | { __typename?: 'TaxonomyFacetDefinition', fieldType: FieldDefinitionTypes } | null } | { __typename?: 'FieldFacet', id: string, type: DatafieldType, kind: string, referencedId: string, display: { __typename?: 'FacetDisplay', type: string, options?: any | null }, teasers?: { __typename?: 'FacetTeasers', title?: string | null } | null, definition?: { __typename?: 'BooleanFacetDefinition', fieldType: FieldDefinitionTypes } | { __typename?: 'DateFacetDefinition', fieldType: FieldDefinitionTypes } | { __typename?: 'DateTimeFacetDefinition', fieldType: FieldDefinitionTypes } | { __typename?: 'DateTimeRangeFacetDefinition', fieldType: FieldDefinitionTypes } | { __typename?: 'EnumFacetDefinition', fieldType: FieldDefinitionTypes } | { __typename?: 'KeywordFacetDefinition', fieldType: FieldDefinitionTypes } | { __typename?: 'NumberRangeFacetDefinition', fieldType: FieldDefinitionTypes } | { __typename?: 'TaxonomyFacetDefinition', fieldType: FieldDefinitionTypes } | null } | null> | null } | null };

export type MetadataDefinitionsWithLocalizationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard> | LanguageWithWildcard>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type MetadataDefinitionsWithLocalizationsQuery = { __typename?: 'Query', fieldDefinitions: { __typename?: 'DatafieldDefinitionQueryResult', fieldDefinitions: Array<{ __typename?: 'DatafieldDefinitionEdge', node: { __typename?: 'BooleanDatafieldDefinition', id: any, mappedNames?: Array<string> | null, localizations?: { __typename?: 'DatafieldDefinitionLocalizations', title?: string | null } | null } | { __typename?: 'DateDatafieldDefinition', id: any, mappedNames?: Array<string> | null, localizations?: { __typename?: 'DatafieldDefinitionLocalizations', title?: string | null } | null } | { __typename?: 'DateTimeDatafieldDefinition', id: any, mappedNames?: Array<string> | null, localizations?: { __typename?: 'DatafieldDefinitionLocalizations', title?: string | null } | null } | { __typename?: 'DateTimeRangeDatafieldDefinition', id: any, mappedNames?: Array<string> | null, localizations?: { __typename?: 'DatafieldDefinitionLocalizations', title?: string | null } | null } | { __typename?: 'EnumDatafieldDefinition', id: any, mappedNames?: Array<string> | null, localizations?: { __typename?: 'DatafieldDefinitionLocalizations', title?: string | null } | null } | { __typename?: 'KeywordDatafieldDefinition', id: any, mappedNames?: Array<string> | null, localizations?: { __typename?: 'DatafieldDefinitionLocalizations', title?: string | null } | null } | { __typename?: 'NumberDatafieldDefinition', id: any, mappedNames?: Array<string> | null, localizations?: { __typename?: 'DatafieldDefinitionLocalizations', title?: string | null } | null } | { __typename?: 'NumberRangeDatafieldDefinition', id: any, mappedNames?: Array<string> | null, localizations?: { __typename?: 'DatafieldDefinitionLocalizations', title?: string | null } | null } | { __typename?: 'TaxonomyDatafieldDefinition', id: any, mappedNames?: Array<string> | null, localizations?: { __typename?: 'DatafieldDefinitionLocalizations', title?: string | null } | null } | { __typename?: 'TextDatafieldDefinition', id: any, mappedNames?: Array<string> | null, localizations?: { __typename?: 'DatafieldDefinitionLocalizations', title?: string | null } | null } } | null> } };

export type ProductTitleQueryVariables = Exact<{
  id: Scalars['String'];
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard> | LanguageWithWildcard>;
}>;


export type ProductTitleQuery = { __typename?: 'Query', product?: { __typename?: 'Product', id: string, localizations?: { __typename?: 'ProductLocalizations', title?: string | null } | null } | null };

export type PartsSearchConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type PartsSearchConfigQuery = { __typename?: 'Query', tenant: { __typename?: 'Tenant', uploadConfig?: { __typename?: 'TenantUploadConfig', aiPartsSearch?: { __typename?: 'AIPartsSearchUploadConfig', image?: { __typename?: 'AIPartsSearchImageUploadConfig', allowAllMimeTypes?: boolean | null, allowedFileExtensions?: Array<string | null> | null, allowedMimeTypes: Array<string | null>, limits: { __typename?: 'AIPartsSearchImageUploadLimits', maxFileSize?: any | null } } | null } | null } | null } };

export type SearchConfigQueryVariables = Exact<{
  searchConfigId: Scalars['ID'];
}>;


export type SearchConfigQuery = { __typename?: 'Query', searchConfig?: { __typename?: 'SearchConfig', id: string, entries?: Array<{ __typename?: 'SearchConfigDatafieldEntry', referencedId: string, fieldType: FieldDefinitionTypes, boost?: number | null } | { __typename?: 'SearchConfigFieldEntry', referencedId: string, fieldType: FieldDefinitionTypes, boost?: number | null }> | null } | null };

export type TenantQueryVariables = Exact<{ [key: string]: never; }>;


export type TenantQuery = { __typename?: 'Query', tenant: { __typename?: 'Tenant', landingPage?: string | null, domain: string, displayName: string, tenantSettings?: { __typename?: 'TenantSettings', docsRouteParams?: any | null } | null, languages?: { __typename?: 'LanguagesQueryResult', available?: Array<string | null> | null, default?: string | null } | null, auth?: { __typename?: 'TenantAuthConfig', accessMode: TenantAccessMode, authenticators?: { __typename?: 'AuthenticatorQueryResult', authenticators?: Array<{ __typename?: 'AuthenticatorEdge', node?: { __typename?: 'Authenticator', url: string, default?: boolean | null, strategyName: string, displayName: string, sortIndex: number, status?: TenantAuthenticatorStatus | null } | null } | null> | null } | null } | null } };

export type UserSettingsByKeysQueryVariables = Exact<{
  keys?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type UserSettingsByKeysQuery = { __typename?: 'Query', getUserSettings?: { __typename?: 'UserSettings', settings?: any | null } | null };

export type CreateOrUpdateUserSettingsMutationVariables = Exact<{
  diff?: InputMaybe<CreateOrUpdateUserSettings>;
}>;


export type CreateOrUpdateUserSettingsMutation = { __typename?: 'Mutation', createOrUpdateUserSettings: { __typename?: 'UserSettings', settings?: any | null } };

export type GuiElementsAndUserQueryVariables = Exact<{
  guiElementsId: Scalars['ID'];
  type: Scalars['String'];
}>;


export type GuiElementsAndUserQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, email?: any | null, rawClaims?: any | null, effectiveRoles?: Array<string | null> | null }, guiElements: Array<{ __typename?: 'GuiElement', id: string, config: any }> };

export type ThemeQueryVariables = Exact<{
  acceptedLanguages?: InputMaybe<Array<LanguageWithWildcard> | LanguageWithWildcard>;
}>;


export type ThemeQuery = { __typename?: 'Query', theme?: { __typename?: 'Theme', showTitle: boolean, theming?: any | null, logo?: { __typename?: 'BlobRef', blobId: string, url?: any | null, path?: string | null } | null, teasers?: { __typename?: 'ThemeTeasers', title?: string | null } | null } | null };

export const GenericShopBasketFieldsFragmentDoc = gql`
    fragment GenericShopBasketFields on ShopBasket {
  items {
    articleId
    assetId
    productId
    amount
    totalPrice {
      price
      currency {
        code
      }
    }
  }
  totalPrice {
    price
    currency {
      code
    }
  }
}
    `;
export const CartItemFieldsFragmentDoc = gql`
    fragment CartItemFields on ShopLightCartItem {
  cartItemId {
    articleId
    partLocation {
      mechanicId
    }
  }
  quantity
  remark
}
    `;
export const CompleteActivityDocument = gql`
    mutation completeActivity($spec: UpdateActivityProcessInput!) {
  updateActivityProcess(spec: $spec)
}
    `;

/**
 * __useCompleteActivityMutation__
 *
 * To run a mutation, you first call `useCompleteActivityMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCompleteActivityMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCompleteActivityMutation({
 *   variables: {
 *     spec: // value for 'spec'
 *   },
 * });
 */
export function useCompleteActivityMutation(options: VueApolloComposable.UseMutationOptions<CompleteActivityMutation, CompleteActivityMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CompleteActivityMutation, CompleteActivityMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CompleteActivityMutation, CompleteActivityMutationVariables>(CompleteActivityDocument, options);
}
export type CompleteActivityMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CompleteActivityMutation, CompleteActivityMutationVariables>;
export const ActivityDocument = gql`
    query activity($activityId: String!) {
  activity(id: $activityId) {
    id
    localizations {
      title
    }
    introduction
    procedure
  }
}
    `;

/**
 * __useActivityQuery__
 *
 * To run a query within a Vue component, call `useActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useActivityQuery({
 *   activityId: // value for 'activityId'
 * });
 */
export function useActivityQuery(variables: ActivityQueryVariables | VueCompositionApi.Ref<ActivityQueryVariables> | ReactiveFunction<ActivityQueryVariables>, options: VueApolloComposable.UseQueryOptions<ActivityQuery, ActivityQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ActivityQuery, ActivityQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ActivityQuery, ActivityQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ActivityQuery, ActivityQueryVariables>(ActivityDocument, variables, options);
}
export function useActivityLazyQuery(variables: ActivityQueryVariables | VueCompositionApi.Ref<ActivityQueryVariables> | ReactiveFunction<ActivityQueryVariables>, options: VueApolloComposable.UseQueryOptions<ActivityQuery, ActivityQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ActivityQuery, ActivityQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ActivityQuery, ActivityQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ActivityQuery, ActivityQueryVariables>(ActivityDocument, variables, options);
}
export type ActivityQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ActivityQuery, ActivityQueryVariables>;
export const ActivitiesDocument = gql`
    query activities($filter: ActivityFilter, $first: NonNegativeInt, $after: String, $sort: [ActivitySort]) {
  activities(filter: $filter) {
    total {
      count
      countRelation
    }
    activities(first: $first, after: $after, sort: $sort) {
      cursor
      node {
        id
        language
        creationDate
        uploadDate
        modificationDate
        localizations {
          title
        }
      }
      highlights {
        title
        text
      }
    }
  }
}
    `;

/**
 * __useActivitiesQuery__
 *
 * To run a query within a Vue component, call `useActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivitiesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useActivitiesQuery({
 *   filter: // value for 'filter'
 *   first: // value for 'first'
 *   after: // value for 'after'
 *   sort: // value for 'sort'
 * });
 */
export function useActivitiesQuery(variables: ActivitiesQueryVariables | VueCompositionApi.Ref<ActivitiesQueryVariables> | ReactiveFunction<ActivitiesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ActivitiesQuery, ActivitiesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ActivitiesQuery, ActivitiesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ActivitiesQuery, ActivitiesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ActivitiesQuery, ActivitiesQueryVariables>(ActivitiesDocument, variables, options);
}
export function useActivitiesLazyQuery(variables: ActivitiesQueryVariables | VueCompositionApi.Ref<ActivitiesQueryVariables> | ReactiveFunction<ActivitiesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ActivitiesQuery, ActivitiesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ActivitiesQuery, ActivitiesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ActivitiesQuery, ActivitiesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ActivitiesQuery, ActivitiesQueryVariables>(ActivitiesDocument, variables, options);
}
export type ActivitiesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ActivitiesQuery, ActivitiesQueryVariables>;
export const FeedbackDocument = gql`
    mutation feedback($feedback: JSONObject!) {
  assessAIAssistant(feedback: $feedback)
}
    `;

/**
 * __useFeedbackMutation__
 *
 * To run a mutation, you first call `useFeedbackMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useFeedbackMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useFeedbackMutation({
 *   variables: {
 *     feedback: // value for 'feedback'
 *   },
 * });
 */
export function useFeedbackMutation(options: VueApolloComposable.UseMutationOptions<FeedbackMutation, FeedbackMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<FeedbackMutation, FeedbackMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<FeedbackMutation, FeedbackMutationVariables>(FeedbackDocument, options);
}
export type FeedbackMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<FeedbackMutation, FeedbackMutationVariables>;
export const LogoAiAssistantDocument = gql`
    query logoAIAssistant {
  theme {
    logoAIAssistant {
      url
    }
  }
}
    `;

/**
 * __useLogoAiAssistantQuery__
 *
 * To run a query within a Vue component, call `useLogoAiAssistantQuery` and pass it any options that fit your needs.
 * When your component renders, `useLogoAiAssistantQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLogoAiAssistantQuery();
 */
export function useLogoAiAssistantQuery(options: VueApolloComposable.UseQueryOptions<LogoAiAssistantQuery, LogoAiAssistantQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LogoAiAssistantQuery, LogoAiAssistantQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LogoAiAssistantQuery, LogoAiAssistantQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<LogoAiAssistantQuery, LogoAiAssistantQueryVariables>(LogoAiAssistantDocument, {}, options);
}
export function useLogoAiAssistantLazyQuery(options: VueApolloComposable.UseQueryOptions<LogoAiAssistantQuery, LogoAiAssistantQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LogoAiAssistantQuery, LogoAiAssistantQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LogoAiAssistantQuery, LogoAiAssistantQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<LogoAiAssistantQuery, LogoAiAssistantQueryVariables>(LogoAiAssistantDocument, {}, options);
}
export type LogoAiAssistantQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<LogoAiAssistantQuery, LogoAiAssistantQueryVariables>;
export const DatafieldsWithoutFacetsCollectionsDocument = gql`
    query datafieldsWithoutFacetsCollections($filter: DatafieldDefinitionFilter, $acceptedLanguages: [LanguageWithWildcard!]) {
  fieldDefinitions(filter: $filter) {
    fieldDefinitions {
      node {
        id
        fieldType
        ... on TaxonomyDatafieldDefinition {
          values {
            key
            pathKeys
            teasers {
              title(acceptedLanguages: $acceptedLanguages)
              __typename
            }
            __typename
          }
          __typename
        }
      }
    }
  }
}
    `;

/**
 * __useDatafieldsWithoutFacetsCollectionsQuery__
 *
 * To run a query within a Vue component, call `useDatafieldsWithoutFacetsCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDatafieldsWithoutFacetsCollectionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDatafieldsWithoutFacetsCollectionsQuery({
 *   filter: // value for 'filter'
 *   acceptedLanguages: // value for 'acceptedLanguages'
 * });
 */
export function useDatafieldsWithoutFacetsCollectionsQuery(variables: DatafieldsWithoutFacetsCollectionsQueryVariables | VueCompositionApi.Ref<DatafieldsWithoutFacetsCollectionsQueryVariables> | ReactiveFunction<DatafieldsWithoutFacetsCollectionsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<DatafieldsWithoutFacetsCollectionsQuery, DatafieldsWithoutFacetsCollectionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DatafieldsWithoutFacetsCollectionsQuery, DatafieldsWithoutFacetsCollectionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DatafieldsWithoutFacetsCollectionsQuery, DatafieldsWithoutFacetsCollectionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<DatafieldsWithoutFacetsCollectionsQuery, DatafieldsWithoutFacetsCollectionsQueryVariables>(DatafieldsWithoutFacetsCollectionsDocument, variables, options);
}
export function useDatafieldsWithoutFacetsCollectionsLazyQuery(variables: DatafieldsWithoutFacetsCollectionsQueryVariables | VueCompositionApi.Ref<DatafieldsWithoutFacetsCollectionsQueryVariables> | ReactiveFunction<DatafieldsWithoutFacetsCollectionsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<DatafieldsWithoutFacetsCollectionsQuery, DatafieldsWithoutFacetsCollectionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DatafieldsWithoutFacetsCollectionsQuery, DatafieldsWithoutFacetsCollectionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DatafieldsWithoutFacetsCollectionsQuery, DatafieldsWithoutFacetsCollectionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<DatafieldsWithoutFacetsCollectionsQuery, DatafieldsWithoutFacetsCollectionsQueryVariables>(DatafieldsWithoutFacetsCollectionsDocument, variables, options);
}
export type DatafieldsWithoutFacetsCollectionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<DatafieldsWithoutFacetsCollectionsQuery, DatafieldsWithoutFacetsCollectionsQueryVariables>;
export const CreateCollectionDocument = gql`
    mutation createCollection($spec: CreateCollectionInput) {
  createCollection(spec: $spec)
}
    `;

/**
 * __useCreateCollectionMutation__
 *
 * To run a mutation, you first call `useCreateCollectionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCollectionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCollectionMutation({
 *   variables: {
 *     spec: // value for 'spec'
 *   },
 * });
 */
export function useCreateCollectionMutation(options: VueApolloComposable.UseMutationOptions<CreateCollectionMutation, CreateCollectionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateCollectionMutation, CreateCollectionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateCollectionMutation, CreateCollectionMutationVariables>(CreateCollectionDocument, options);
}
export type CreateCollectionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateCollectionMutation, CreateCollectionMutationVariables>;
export const UpdateCollectionDocument = gql`
    mutation updateCollection($diff: UpdateCollectionInput) {
  updateCollection(diff: $diff) {
    id
  }
}
    `;

/**
 * __useUpdateCollectionMutation__
 *
 * To run a mutation, you first call `useUpdateCollectionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCollectionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCollectionMutation({
 *   variables: {
 *     diff: // value for 'diff'
 *   },
 * });
 */
export function useUpdateCollectionMutation(options: VueApolloComposable.UseMutationOptions<UpdateCollectionMutation, UpdateCollectionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateCollectionMutation, UpdateCollectionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateCollectionMutation, UpdateCollectionMutationVariables>(UpdateCollectionDocument, options);
}
export type UpdateCollectionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateCollectionMutation, UpdateCollectionMutationVariables>;
export const DeleteCollectionByIdDocument = gql`
    mutation deleteCollectionById($deleteCollectionId: ID!) {
  deleteCollection(id: $deleteCollectionId)
}
    `;

/**
 * __useDeleteCollectionByIdMutation__
 *
 * To run a mutation, you first call `useDeleteCollectionByIdMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCollectionByIdMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteCollectionByIdMutation({
 *   variables: {
 *     deleteCollectionId: // value for 'deleteCollectionId'
 *   },
 * });
 */
export function useDeleteCollectionByIdMutation(options: VueApolloComposable.UseMutationOptions<DeleteCollectionByIdMutation, DeleteCollectionByIdMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteCollectionByIdMutation, DeleteCollectionByIdMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteCollectionByIdMutation, DeleteCollectionByIdMutationVariables>(DeleteCollectionByIdDocument, options);
}
export type DeleteCollectionByIdMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteCollectionByIdMutation, DeleteCollectionByIdMutationVariables>;
export const RemoveContentsFromCollectionDocument = gql`
    mutation removeContentsFromCollection($idsOfContents: [ID!]!, $collectionId: ID!, $context: CollectionEntryNavigationContextInput) {
  removeContentsFromCollection(
    idsOfContents: $idsOfContents
    collectionId: $collectionId
    navContext: $context
  )
}
    `;

/**
 * __useRemoveContentsFromCollectionMutation__
 *
 * To run a mutation, you first call `useRemoveContentsFromCollectionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveContentsFromCollectionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveContentsFromCollectionMutation({
 *   variables: {
 *     idsOfContents: // value for 'idsOfContents'
 *     collectionId: // value for 'collectionId'
 *     context: // value for 'context'
 *   },
 * });
 */
export function useRemoveContentsFromCollectionMutation(options: VueApolloComposable.UseMutationOptions<RemoveContentsFromCollectionMutation, RemoveContentsFromCollectionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RemoveContentsFromCollectionMutation, RemoveContentsFromCollectionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RemoveContentsFromCollectionMutation, RemoveContentsFromCollectionMutationVariables>(RemoveContentsFromCollectionDocument, options);
}
export type RemoveContentsFromCollectionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RemoveContentsFromCollectionMutation, RemoveContentsFromCollectionMutationVariables>;
export const RemoveArticlesFromCollectionDocument = gql`
    mutation removeArticlesFromCollection($articleIds: [ID!]!, $collectionId: ID!, $context: CollectionEntryNavigationContextInput) {
  removeArticlesFromCollection(
    articleIds: $articleIds
    collectionId: $collectionId
    navContext: $context
  )
}
    `;

/**
 * __useRemoveArticlesFromCollectionMutation__
 *
 * To run a mutation, you first call `useRemoveArticlesFromCollectionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveArticlesFromCollectionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveArticlesFromCollectionMutation({
 *   variables: {
 *     articleIds: // value for 'articleIds'
 *     collectionId: // value for 'collectionId'
 *     context: // value for 'context'
 *   },
 * });
 */
export function useRemoveArticlesFromCollectionMutation(options: VueApolloComposable.UseMutationOptions<RemoveArticlesFromCollectionMutation, RemoveArticlesFromCollectionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RemoveArticlesFromCollectionMutation, RemoveArticlesFromCollectionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RemoveArticlesFromCollectionMutation, RemoveArticlesFromCollectionMutationVariables>(RemoveArticlesFromCollectionDocument, options);
}
export type RemoveArticlesFromCollectionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RemoveArticlesFromCollectionMutation, RemoveArticlesFromCollectionMutationVariables>;
export const RemoveMechanicsFromCollectionDocument = gql`
    mutation removeMechanicsFromCollection($mechanicIds: [ID!]!, $collectionId: ID!, $context: CollectionEntryMechanicNavigationContextInput) {
  removeMechanicsFromCollection(
    mechanicIds: $mechanicIds
    collectionId: $collectionId
    navContext: $context
  )
}
    `;

/**
 * __useRemoveMechanicsFromCollectionMutation__
 *
 * To run a mutation, you first call `useRemoveMechanicsFromCollectionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMechanicsFromCollectionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveMechanicsFromCollectionMutation({
 *   variables: {
 *     mechanicIds: // value for 'mechanicIds'
 *     collectionId: // value for 'collectionId'
 *     context: // value for 'context'
 *   },
 * });
 */
export function useRemoveMechanicsFromCollectionMutation(options: VueApolloComposable.UseMutationOptions<RemoveMechanicsFromCollectionMutation, RemoveMechanicsFromCollectionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RemoveMechanicsFromCollectionMutation, RemoveMechanicsFromCollectionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RemoveMechanicsFromCollectionMutation, RemoveMechanicsFromCollectionMutationVariables>(RemoveMechanicsFromCollectionDocument, options);
}
export type RemoveMechanicsFromCollectionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RemoveMechanicsFromCollectionMutation, RemoveMechanicsFromCollectionMutationVariables>;
export const AddContentsToCollectionDocument = gql`
    mutation addContentsToCollection($collectionId: ID!, $idsOfContents: [ID!]!, $context: CollectionEntryNavigationContextInput) {
  addContentsToCollection(
    collectionId: $collectionId
    idsOfContents: $idsOfContents
    navContext: $context
  )
}
    `;

/**
 * __useAddContentsToCollectionMutation__
 *
 * To run a mutation, you first call `useAddContentsToCollectionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddContentsToCollectionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddContentsToCollectionMutation({
 *   variables: {
 *     collectionId: // value for 'collectionId'
 *     idsOfContents: // value for 'idsOfContents'
 *     context: // value for 'context'
 *   },
 * });
 */
export function useAddContentsToCollectionMutation(options: VueApolloComposable.UseMutationOptions<AddContentsToCollectionMutation, AddContentsToCollectionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddContentsToCollectionMutation, AddContentsToCollectionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddContentsToCollectionMutation, AddContentsToCollectionMutationVariables>(AddContentsToCollectionDocument, options);
}
export type AddContentsToCollectionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddContentsToCollectionMutation, AddContentsToCollectionMutationVariables>;
export const AddArticlesToCollectionDocument = gql`
    mutation addArticlesToCollection($articleIds: [ID!]!, $collectionId: ID!, $context: CollectionEntryNavigationContextInput) {
  addArticlesToCollection(
    articleIds: $articleIds
    collectionId: $collectionId
    navContext: $context
  )
}
    `;

/**
 * __useAddArticlesToCollectionMutation__
 *
 * To run a mutation, you first call `useAddArticlesToCollectionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddArticlesToCollectionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddArticlesToCollectionMutation({
 *   variables: {
 *     articleIds: // value for 'articleIds'
 *     collectionId: // value for 'collectionId'
 *     context: // value for 'context'
 *   },
 * });
 */
export function useAddArticlesToCollectionMutation(options: VueApolloComposable.UseMutationOptions<AddArticlesToCollectionMutation, AddArticlesToCollectionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddArticlesToCollectionMutation, AddArticlesToCollectionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddArticlesToCollectionMutation, AddArticlesToCollectionMutationVariables>(AddArticlesToCollectionDocument, options);
}
export type AddArticlesToCollectionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddArticlesToCollectionMutation, AddArticlesToCollectionMutationVariables>;
export const AddMechanicsToCollectionDocument = gql`
    mutation addMechanicsToCollection($mechanicIds: [ID!]!, $context: CollectionEntryMechanicNavigationContextInput, $collectionId: ID!) {
  addMechanicsToCollection(
    mechanicIds: $mechanicIds
    collectionId: $collectionId
    navContext: $context
  )
}
    `;

/**
 * __useAddMechanicsToCollectionMutation__
 *
 * To run a mutation, you first call `useAddMechanicsToCollectionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddMechanicsToCollectionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddMechanicsToCollectionMutation({
 *   variables: {
 *     mechanicIds: // value for 'mechanicIds'
 *     context: // value for 'context'
 *     collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useAddMechanicsToCollectionMutation(options: VueApolloComposable.UseMutationOptions<AddMechanicsToCollectionMutation, AddMechanicsToCollectionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddMechanicsToCollectionMutation, AddMechanicsToCollectionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddMechanicsToCollectionMutation, AddMechanicsToCollectionMutationVariables>(AddMechanicsToCollectionDocument, options);
}
export type AddMechanicsToCollectionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddMechanicsToCollectionMutation, AddMechanicsToCollectionMutationVariables>;
export const AddActivitiesToCollectionDocument = gql`
    mutation addActivitiesToCollection($activityIds: [ID!]!, $collectionId: ID!, $context: CollectionEntryNavigationContextInput) {
  addActivitiesToCollection(
    activityIds: $activityIds
    collectionId: $collectionId
    navContext: $context
  )
}
    `;

/**
 * __useAddActivitiesToCollectionMutation__
 *
 * To run a mutation, you first call `useAddActivitiesToCollectionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddActivitiesToCollectionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddActivitiesToCollectionMutation({
 *   variables: {
 *     activityIds: // value for 'activityIds'
 *     collectionId: // value for 'collectionId'
 *     context: // value for 'context'
 *   },
 * });
 */
export function useAddActivitiesToCollectionMutation(options: VueApolloComposable.UseMutationOptions<AddActivitiesToCollectionMutation, AddActivitiesToCollectionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddActivitiesToCollectionMutation, AddActivitiesToCollectionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddActivitiesToCollectionMutation, AddActivitiesToCollectionMutationVariables>(AddActivitiesToCollectionDocument, options);
}
export type AddActivitiesToCollectionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddActivitiesToCollectionMutation, AddActivitiesToCollectionMutationVariables>;
export const RemoveActivitiesFromCollectionDocument = gql`
    mutation removeActivitiesFromCollection($activityIds: [ID!]!, $collectionId: ID!, $context: CollectionEntryNavigationContextInput) {
  removeActivitiesFromCollection(
    activityIds: $activityIds
    collectionId: $collectionId
    navContext: $context
  )
}
    `;

/**
 * __useRemoveActivitiesFromCollectionMutation__
 *
 * To run a mutation, you first call `useRemoveActivitiesFromCollectionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveActivitiesFromCollectionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveActivitiesFromCollectionMutation({
 *   variables: {
 *     activityIds: // value for 'activityIds'
 *     collectionId: // value for 'collectionId'
 *     context: // value for 'context'
 *   },
 * });
 */
export function useRemoveActivitiesFromCollectionMutation(options: VueApolloComposable.UseMutationOptions<RemoveActivitiesFromCollectionMutation, RemoveActivitiesFromCollectionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RemoveActivitiesFromCollectionMutation, RemoveActivitiesFromCollectionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RemoveActivitiesFromCollectionMutation, RemoveActivitiesFromCollectionMutationVariables>(RemoveActivitiesFromCollectionDocument, options);
}
export type RemoveActivitiesFromCollectionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RemoveActivitiesFromCollectionMutation, RemoveActivitiesFromCollectionMutationVariables>;
export const ExportCollectionDocument = gql`
    mutation exportCollection($id: ID!, $acceptedLanguages: [LanguageWithWildcard!]!, $collectionExportType: CollectionExportType!) {
  exportCollection(
    id: $id
    acceptedLanguages: $acceptedLanguages
    collectionExportType: $collectionExportType
  )
}
    `;

/**
 * __useExportCollectionMutation__
 *
 * To run a mutation, you first call `useExportCollectionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useExportCollectionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useExportCollectionMutation({
 *   variables: {
 *     id: // value for 'id'
 *     acceptedLanguages: // value for 'acceptedLanguages'
 *     collectionExportType: // value for 'collectionExportType'
 *   },
 * });
 */
export function useExportCollectionMutation(options: VueApolloComposable.UseMutationOptions<ExportCollectionMutation, ExportCollectionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ExportCollectionMutation, ExportCollectionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ExportCollectionMutation, ExportCollectionMutationVariables>(ExportCollectionDocument, options);
}
export type ExportCollectionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ExportCollectionMutation, ExportCollectionMutationVariables>;
export const CollectionsDocument = gql`
    query collections {
  collections {
    collections(first: 100) {
      cursor
      node {
        id
        displayName
        visibility
        showInDashboard
        entries {
          total {
            count
            countRelation
          }
        }
        user {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useCollectionsQuery__
 *
 * To run a query within a Vue component, call `useCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCollectionsQuery();
 */
export function useCollectionsQuery(options: VueApolloComposable.UseQueryOptions<CollectionsQuery, CollectionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CollectionsQuery, CollectionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CollectionsQuery, CollectionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CollectionsQuery, CollectionsQueryVariables>(CollectionsDocument, {}, options);
}
export function useCollectionsLazyQuery(options: VueApolloComposable.UseQueryOptions<CollectionsQuery, CollectionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CollectionsQuery, CollectionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CollectionsQuery, CollectionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CollectionsQuery, CollectionsQueryVariables>(CollectionsDocument, {}, options);
}
export type CollectionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CollectionsQuery, CollectionsQueryVariables>;
export const CollectionsByFilterDocument = gql`
    query collectionsByFilter($filter: CollectionFilter) {
  collections(filter: $filter) {
    collections {
      cursor
      node {
        id
        displayName
        description
        visibility
        showInDashboard
      }
    }
  }
}
    `;

/**
 * __useCollectionsByFilterQuery__
 *
 * To run a query within a Vue component, call `useCollectionsByFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionsByFilterQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCollectionsByFilterQuery({
 *   filter: // value for 'filter'
 * });
 */
export function useCollectionsByFilterQuery(variables: CollectionsByFilterQueryVariables | VueCompositionApi.Ref<CollectionsByFilterQueryVariables> | ReactiveFunction<CollectionsByFilterQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<CollectionsByFilterQuery, CollectionsByFilterQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CollectionsByFilterQuery, CollectionsByFilterQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CollectionsByFilterQuery, CollectionsByFilterQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CollectionsByFilterQuery, CollectionsByFilterQueryVariables>(CollectionsByFilterDocument, variables, options);
}
export function useCollectionsByFilterLazyQuery(variables: CollectionsByFilterQueryVariables | VueCompositionApi.Ref<CollectionsByFilterQueryVariables> | ReactiveFunction<CollectionsByFilterQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<CollectionsByFilterQuery, CollectionsByFilterQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CollectionsByFilterQuery, CollectionsByFilterQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CollectionsByFilterQuery, CollectionsByFilterQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CollectionsByFilterQuery, CollectionsByFilterQueryVariables>(CollectionsByFilterDocument, variables, options);
}
export type CollectionsByFilterQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CollectionsByFilterQuery, CollectionsByFilterQueryVariables>;
export const EditableCollectionsDocument = gql`
    query editableCollections {
  editableCollections {
    total {
      count
      countRelation
    }
    collections(first: 100, sort: {field: displayName, order: asc}) {
      cursor
      node {
        id
        displayName
        visibility
      }
    }
  }
}
    `;

/**
 * __useEditableCollectionsQuery__
 *
 * To run a query within a Vue component, call `useEditableCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditableCollectionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useEditableCollectionsQuery();
 */
export function useEditableCollectionsQuery(options: VueApolloComposable.UseQueryOptions<EditableCollectionsQuery, EditableCollectionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<EditableCollectionsQuery, EditableCollectionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<EditableCollectionsQuery, EditableCollectionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<EditableCollectionsQuery, EditableCollectionsQueryVariables>(EditableCollectionsDocument, {}, options);
}
export function useEditableCollectionsLazyQuery(options: VueApolloComposable.UseQueryOptions<EditableCollectionsQuery, EditableCollectionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<EditableCollectionsQuery, EditableCollectionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<EditableCollectionsQuery, EditableCollectionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<EditableCollectionsQuery, EditableCollectionsQueryVariables>(EditableCollectionsDocument, {}, options);
}
export type EditableCollectionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<EditableCollectionsQuery, EditableCollectionsQueryVariables>;
export const TitlesForMechanicPathDocument = gql`
    query titlesForMechanicPath($productId: String!, $productIdForMechanic: ID, $acceptedLanguages: [LanguageWithWildcard!], $assetId: ID, $filter: MechanicFilter) {
  product(id: $productId) {
    id
    localizations {
      title(acceptedLanguages: $acceptedLanguages)
    }
  }
  mechanics(assetId: $assetId, productId: $productIdForMechanic, filter: $filter) {
    mechanics {
      node {
        articleId
        articleNumber
        assemblyId
        localizations {
          title(acceptedLanguages: $acceptedLanguages)
        }
      }
    }
  }
}
    `;

/**
 * __useTitlesForMechanicPathQuery__
 *
 * To run a query within a Vue component, call `useTitlesForMechanicPathQuery` and pass it any options that fit your needs.
 * When your component renders, `useTitlesForMechanicPathQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTitlesForMechanicPathQuery({
 *   productId: // value for 'productId'
 *   productIdForMechanic: // value for 'productIdForMechanic'
 *   acceptedLanguages: // value for 'acceptedLanguages'
 *   assetId: // value for 'assetId'
 *   filter: // value for 'filter'
 * });
 */
export function useTitlesForMechanicPathQuery(variables: TitlesForMechanicPathQueryVariables | VueCompositionApi.Ref<TitlesForMechanicPathQueryVariables> | ReactiveFunction<TitlesForMechanicPathQueryVariables>, options: VueApolloComposable.UseQueryOptions<TitlesForMechanicPathQuery, TitlesForMechanicPathQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TitlesForMechanicPathQuery, TitlesForMechanicPathQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TitlesForMechanicPathQuery, TitlesForMechanicPathQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TitlesForMechanicPathQuery, TitlesForMechanicPathQueryVariables>(TitlesForMechanicPathDocument, variables, options);
}
export function useTitlesForMechanicPathLazyQuery(variables: TitlesForMechanicPathQueryVariables | VueCompositionApi.Ref<TitlesForMechanicPathQueryVariables> | ReactiveFunction<TitlesForMechanicPathQueryVariables>, options: VueApolloComposable.UseQueryOptions<TitlesForMechanicPathQuery, TitlesForMechanicPathQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TitlesForMechanicPathQuery, TitlesForMechanicPathQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TitlesForMechanicPathQuery, TitlesForMechanicPathQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TitlesForMechanicPathQuery, TitlesForMechanicPathQueryVariables>(TitlesForMechanicPathDocument, variables, options);
}
export type TitlesForMechanicPathQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TitlesForMechanicPathQuery, TitlesForMechanicPathQueryVariables>;
export const StatusExportCollectionDocument = gql`
    query statusExportCollection($jobId: ID!) {
  statusExportCollection(jobId: $jobId) {
    status
    url
  }
}
    `;

/**
 * __useStatusExportCollectionQuery__
 *
 * To run a query within a Vue component, call `useStatusExportCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useStatusExportCollectionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useStatusExportCollectionQuery({
 *   jobId: // value for 'jobId'
 * });
 */
export function useStatusExportCollectionQuery(variables: StatusExportCollectionQueryVariables | VueCompositionApi.Ref<StatusExportCollectionQueryVariables> | ReactiveFunction<StatusExportCollectionQueryVariables>, options: VueApolloComposable.UseQueryOptions<StatusExportCollectionQuery, StatusExportCollectionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<StatusExportCollectionQuery, StatusExportCollectionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<StatusExportCollectionQuery, StatusExportCollectionQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<StatusExportCollectionQuery, StatusExportCollectionQueryVariables>(StatusExportCollectionDocument, variables, options);
}
export function useStatusExportCollectionLazyQuery(variables: StatusExportCollectionQueryVariables | VueCompositionApi.Ref<StatusExportCollectionQueryVariables> | ReactiveFunction<StatusExportCollectionQueryVariables>, options: VueApolloComposable.UseQueryOptions<StatusExportCollectionQuery, StatusExportCollectionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<StatusExportCollectionQuery, StatusExportCollectionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<StatusExportCollectionQuery, StatusExportCollectionQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<StatusExportCollectionQuery, StatusExportCollectionQueryVariables>(StatusExportCollectionDocument, variables, options);
}
export type StatusExportCollectionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<StatusExportCollectionQuery, StatusExportCollectionQueryVariables>;
export const AllProcessNamesDocument = gql`
    query AllProcessNames {
  processes {
    id
    name
  }
}
    `;

/**
 * __useAllProcessNamesQuery__
 *
 * To run a query within a Vue component, call `useAllProcessNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllProcessNamesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAllProcessNamesQuery();
 */
export function useAllProcessNamesQuery(options: VueApolloComposable.UseQueryOptions<AllProcessNamesQuery, AllProcessNamesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllProcessNamesQuery, AllProcessNamesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllProcessNamesQuery, AllProcessNamesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AllProcessNamesQuery, AllProcessNamesQueryVariables>(AllProcessNamesDocument, {}, options);
}
export function useAllProcessNamesLazyQuery(options: VueApolloComposable.UseQueryOptions<AllProcessNamesQuery, AllProcessNamesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllProcessNamesQuery, AllProcessNamesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllProcessNamesQuery, AllProcessNamesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AllProcessNamesQuery, AllProcessNamesQueryVariables>(AllProcessNamesDocument, {}, options);
}
export type AllProcessNamesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AllProcessNamesQuery, AllProcessNamesQueryVariables>;
export const DataFieldsForProductsDocument = gql`
    query DataFieldsForProducts($acceptedLanguages: [LanguageWithWildcard!]) {
  datafields {
    product {
      referencedId
      localizations {
        title(acceptedLanguages: $acceptedLanguages)
      }
      fieldType
    }
  }
}
    `;

/**
 * __useDataFieldsForProductsQuery__
 *
 * To run a query within a Vue component, call `useDataFieldsForProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataFieldsForProductsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDataFieldsForProductsQuery({
 *   acceptedLanguages: // value for 'acceptedLanguages'
 * });
 */
export function useDataFieldsForProductsQuery(variables: DataFieldsForProductsQueryVariables | VueCompositionApi.Ref<DataFieldsForProductsQueryVariables> | ReactiveFunction<DataFieldsForProductsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<DataFieldsForProductsQuery, DataFieldsForProductsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DataFieldsForProductsQuery, DataFieldsForProductsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DataFieldsForProductsQuery, DataFieldsForProductsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<DataFieldsForProductsQuery, DataFieldsForProductsQueryVariables>(DataFieldsForProductsDocument, variables, options);
}
export function useDataFieldsForProductsLazyQuery(variables: DataFieldsForProductsQueryVariables | VueCompositionApi.Ref<DataFieldsForProductsQueryVariables> | ReactiveFunction<DataFieldsForProductsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<DataFieldsForProductsQuery, DataFieldsForProductsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DataFieldsForProductsQuery, DataFieldsForProductsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DataFieldsForProductsQuery, DataFieldsForProductsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<DataFieldsForProductsQuery, DataFieldsForProductsQueryVariables>(DataFieldsForProductsDocument, variables, options);
}
export type DataFieldsForProductsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<DataFieldsForProductsQuery, DataFieldsForProductsQueryVariables>;
export const FieldDefinitionsDocument = gql`
    query FieldDefinitions($first: NonNegativeInt, $acceptedLanguages: [LanguageWithWildcard!]) {
  fieldDefinitions {
    fieldDefinitions(first: $first) {
      node {
        fieldType
        id
        localizations {
          title(acceptedLanguages: $acceptedLanguages)
        }
        mappedNames
        objectTypes
      }
    }
  }
}
    `;

/**
 * __useFieldDefinitionsQuery__
 *
 * To run a query within a Vue component, call `useFieldDefinitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFieldDefinitionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFieldDefinitionsQuery({
 *   first: // value for 'first'
 *   acceptedLanguages: // value for 'acceptedLanguages'
 * });
 */
export function useFieldDefinitionsQuery(variables: FieldDefinitionsQueryVariables | VueCompositionApi.Ref<FieldDefinitionsQueryVariables> | ReactiveFunction<FieldDefinitionsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<FieldDefinitionsQuery, FieldDefinitionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FieldDefinitionsQuery, FieldDefinitionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FieldDefinitionsQuery, FieldDefinitionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FieldDefinitionsQuery, FieldDefinitionsQueryVariables>(FieldDefinitionsDocument, variables, options);
}
export function useFieldDefinitionsLazyQuery(variables: FieldDefinitionsQueryVariables | VueCompositionApi.Ref<FieldDefinitionsQueryVariables> | ReactiveFunction<FieldDefinitionsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<FieldDefinitionsQuery, FieldDefinitionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FieldDefinitionsQuery, FieldDefinitionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FieldDefinitionsQuery, FieldDefinitionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FieldDefinitionsQuery, FieldDefinitionsQueryVariables>(FieldDefinitionsDocument, variables, options);
}
export type FieldDefinitionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FieldDefinitionsQuery, FieldDefinitionsQueryVariables>;
export const ContentGroupingConfigDocument = gql`
    query contentGroupingConfig($id: ID!) {
  contentGroupingConfig(id: $id) {
    id
    criteria
    enabled
  }
}
    `;

/**
 * __useContentGroupingConfigQuery__
 *
 * To run a query within a Vue component, call `useContentGroupingConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentGroupingConfigQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useContentGroupingConfigQuery({
 *   id: // value for 'id'
 * });
 */
export function useContentGroupingConfigQuery(variables: ContentGroupingConfigQueryVariables | VueCompositionApi.Ref<ContentGroupingConfigQueryVariables> | ReactiveFunction<ContentGroupingConfigQueryVariables>, options: VueApolloComposable.UseQueryOptions<ContentGroupingConfigQuery, ContentGroupingConfigQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ContentGroupingConfigQuery, ContentGroupingConfigQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ContentGroupingConfigQuery, ContentGroupingConfigQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ContentGroupingConfigQuery, ContentGroupingConfigQueryVariables>(ContentGroupingConfigDocument, variables, options);
}
export function useContentGroupingConfigLazyQuery(variables: ContentGroupingConfigQueryVariables | VueCompositionApi.Ref<ContentGroupingConfigQueryVariables> | ReactiveFunction<ContentGroupingConfigQueryVariables>, options: VueApolloComposable.UseQueryOptions<ContentGroupingConfigQuery, ContentGroupingConfigQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ContentGroupingConfigQuery, ContentGroupingConfigQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ContentGroupingConfigQuery, ContentGroupingConfigQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ContentGroupingConfigQuery, ContentGroupingConfigQueryVariables>(ContentGroupingConfigDocument, variables, options);
}
export type ContentGroupingConfigQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ContentGroupingConfigQuery, ContentGroupingConfigQueryVariables>;
export const MechanicContentsGroupedDocument = gql`
    query mechanicContentsGrouped($mechanicId: String!, $filter: ContentFilter, $groupBy: ContentGroupBy!, $groupFirst: NonNegativeInt, $groupAfter: String, $acceptedLanguages: [LanguageWithWildcard!]) {
  mechanic(id: $mechanicId) {
    id
    relatedContentsGrouped(groupBy: $groupBy, filter: $filter) {
      totalGroups {
        count
        countRelation
      }
    }
  }
}
    `;

/**
 * __useMechanicContentsGroupedQuery__
 *
 * To run a query within a Vue component, call `useMechanicContentsGroupedQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicContentsGroupedQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMechanicContentsGroupedQuery({
 *   mechanicId: // value for 'mechanicId'
 *   filter: // value for 'filter'
 *   groupBy: // value for 'groupBy'
 *   groupFirst: // value for 'groupFirst'
 *   groupAfter: // value for 'groupAfter'
 *   acceptedLanguages: // value for 'acceptedLanguages'
 * });
 */
export function useMechanicContentsGroupedQuery(variables: MechanicContentsGroupedQueryVariables | VueCompositionApi.Ref<MechanicContentsGroupedQueryVariables> | ReactiveFunction<MechanicContentsGroupedQueryVariables>, options: VueApolloComposable.UseQueryOptions<MechanicContentsGroupedQuery, MechanicContentsGroupedQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MechanicContentsGroupedQuery, MechanicContentsGroupedQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MechanicContentsGroupedQuery, MechanicContentsGroupedQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MechanicContentsGroupedQuery, MechanicContentsGroupedQueryVariables>(MechanicContentsGroupedDocument, variables, options);
}
export function useMechanicContentsGroupedLazyQuery(variables: MechanicContentsGroupedQueryVariables | VueCompositionApi.Ref<MechanicContentsGroupedQueryVariables> | ReactiveFunction<MechanicContentsGroupedQueryVariables>, options: VueApolloComposable.UseQueryOptions<MechanicContentsGroupedQuery, MechanicContentsGroupedQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MechanicContentsGroupedQuery, MechanicContentsGroupedQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MechanicContentsGroupedQuery, MechanicContentsGroupedQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<MechanicContentsGroupedQuery, MechanicContentsGroupedQueryVariables>(MechanicContentsGroupedDocument, variables, options);
}
export type MechanicContentsGroupedQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MechanicContentsGroupedQuery, MechanicContentsGroupedQueryVariables>;
export const AssetContentsGroupedDocument = gql`
    query assetContentsGrouped($assetFilter: AssetFilter!, $filter: ContentFilter, $groupBy: ContentGroupBy!, $groupFirst: NonNegativeInt, $groupAfter: String, $acceptedLanguages: [LanguageWithWildcard!]) {
  assets(filter: $assetFilter) {
    assets(first: 1) {
      cursor
      node {
        id
        relatedContentsGrouped(groupBy: $groupBy, filter: $filter) {
          totalGroups {
            count
            countRelation
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAssetContentsGroupedQuery__
 *
 * To run a query within a Vue component, call `useAssetContentsGroupedQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetContentsGroupedQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAssetContentsGroupedQuery({
 *   assetFilter: // value for 'assetFilter'
 *   filter: // value for 'filter'
 *   groupBy: // value for 'groupBy'
 *   groupFirst: // value for 'groupFirst'
 *   groupAfter: // value for 'groupAfter'
 *   acceptedLanguages: // value for 'acceptedLanguages'
 * });
 */
export function useAssetContentsGroupedQuery(variables: AssetContentsGroupedQueryVariables | VueCompositionApi.Ref<AssetContentsGroupedQueryVariables> | ReactiveFunction<AssetContentsGroupedQueryVariables>, options: VueApolloComposable.UseQueryOptions<AssetContentsGroupedQuery, AssetContentsGroupedQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AssetContentsGroupedQuery, AssetContentsGroupedQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AssetContentsGroupedQuery, AssetContentsGroupedQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AssetContentsGroupedQuery, AssetContentsGroupedQueryVariables>(AssetContentsGroupedDocument, variables, options);
}
export function useAssetContentsGroupedLazyQuery(variables: AssetContentsGroupedQueryVariables | VueCompositionApi.Ref<AssetContentsGroupedQueryVariables> | ReactiveFunction<AssetContentsGroupedQueryVariables>, options: VueApolloComposable.UseQueryOptions<AssetContentsGroupedQuery, AssetContentsGroupedQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AssetContentsGroupedQuery, AssetContentsGroupedQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AssetContentsGroupedQuery, AssetContentsGroupedQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AssetContentsGroupedQuery, AssetContentsGroupedQueryVariables>(AssetContentsGroupedDocument, variables, options);
}
export type AssetContentsGroupedQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AssetContentsGroupedQuery, AssetContentsGroupedQueryVariables>;
export const ProductContentsGroupedDocument = gql`
    query productContentsGrouped($productId: String!, $filter: ContentFilter, $groupBy: ContentGroupBy!, $groupFirst: NonNegativeInt, $groupAfter: String, $acceptedLanguages: [LanguageWithWildcard!]) {
  product(id: $productId) {
    id
    relatedContentsGrouped(groupBy: $groupBy, filter: $filter) {
      totalGroups {
        count
        countRelation
      }
    }
  }
}
    `;

/**
 * __useProductContentsGroupedQuery__
 *
 * To run a query within a Vue component, call `useProductContentsGroupedQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductContentsGroupedQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProductContentsGroupedQuery({
 *   productId: // value for 'productId'
 *   filter: // value for 'filter'
 *   groupBy: // value for 'groupBy'
 *   groupFirst: // value for 'groupFirst'
 *   groupAfter: // value for 'groupAfter'
 *   acceptedLanguages: // value for 'acceptedLanguages'
 * });
 */
export function useProductContentsGroupedQuery(variables: ProductContentsGroupedQueryVariables | VueCompositionApi.Ref<ProductContentsGroupedQueryVariables> | ReactiveFunction<ProductContentsGroupedQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProductContentsGroupedQuery, ProductContentsGroupedQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProductContentsGroupedQuery, ProductContentsGroupedQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProductContentsGroupedQuery, ProductContentsGroupedQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProductContentsGroupedQuery, ProductContentsGroupedQueryVariables>(ProductContentsGroupedDocument, variables, options);
}
export function useProductContentsGroupedLazyQuery(variables: ProductContentsGroupedQueryVariables | VueCompositionApi.Ref<ProductContentsGroupedQueryVariables> | ReactiveFunction<ProductContentsGroupedQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProductContentsGroupedQuery, ProductContentsGroupedQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProductContentsGroupedQuery, ProductContentsGroupedQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProductContentsGroupedQuery, ProductContentsGroupedQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProductContentsGroupedQuery, ProductContentsGroupedQueryVariables>(ProductContentsGroupedDocument, variables, options);
}
export type ProductContentsGroupedQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProductContentsGroupedQuery, ProductContentsGroupedQueryVariables>;
export const ArticleContentsGroupedDocument = gql`
    query articleContentsGrouped($articleId: String!, $filter: ContentFilter, $groupBy: ContentGroupBy!, $groupFirst: NonNegativeInt, $groupAfter: String, $acceptedLanguages: [LanguageWithWildcard!]) {
  article(id: $articleId) {
    id
    relatedContentsGrouped(groupBy: $groupBy, filter: $filter) {
      totalGroups {
        count
        countRelation
      }
    }
  }
}
    `;

/**
 * __useArticleContentsGroupedQuery__
 *
 * To run a query within a Vue component, call `useArticleContentsGroupedQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleContentsGroupedQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useArticleContentsGroupedQuery({
 *   articleId: // value for 'articleId'
 *   filter: // value for 'filter'
 *   groupBy: // value for 'groupBy'
 *   groupFirst: // value for 'groupFirst'
 *   groupAfter: // value for 'groupAfter'
 *   acceptedLanguages: // value for 'acceptedLanguages'
 * });
 */
export function useArticleContentsGroupedQuery(variables: ArticleContentsGroupedQueryVariables | VueCompositionApi.Ref<ArticleContentsGroupedQueryVariables> | ReactiveFunction<ArticleContentsGroupedQueryVariables>, options: VueApolloComposable.UseQueryOptions<ArticleContentsGroupedQuery, ArticleContentsGroupedQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ArticleContentsGroupedQuery, ArticleContentsGroupedQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ArticleContentsGroupedQuery, ArticleContentsGroupedQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ArticleContentsGroupedQuery, ArticleContentsGroupedQueryVariables>(ArticleContentsGroupedDocument, variables, options);
}
export function useArticleContentsGroupedLazyQuery(variables: ArticleContentsGroupedQueryVariables | VueCompositionApi.Ref<ArticleContentsGroupedQueryVariables> | ReactiveFunction<ArticleContentsGroupedQueryVariables>, options: VueApolloComposable.UseQueryOptions<ArticleContentsGroupedQuery, ArticleContentsGroupedQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ArticleContentsGroupedQuery, ArticleContentsGroupedQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ArticleContentsGroupedQuery, ArticleContentsGroupedQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ArticleContentsGroupedQuery, ArticleContentsGroupedQueryVariables>(ArticleContentsGroupedDocument, variables, options);
}
export type ArticleContentsGroupedQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ArticleContentsGroupedQuery, ArticleContentsGroupedQueryVariables>;
export const ContentsGroupedDocument = gql`
    query contentsGrouped($filter: ContentFilter, $groupBy: ContentGroupBy!, $groupFirst: NonNegativeInt, $groupAfter: String, $acceptedLanguages: [LanguageWithWildcard!]) {
  contentsGrouped(groupBy: $groupBy, filter: $filter) {
    totalGroups {
      count
      countRelation
    }
  }
}
    `;

/**
 * __useContentsGroupedQuery__
 *
 * To run a query within a Vue component, call `useContentsGroupedQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentsGroupedQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useContentsGroupedQuery({
 *   filter: // value for 'filter'
 *   groupBy: // value for 'groupBy'
 *   groupFirst: // value for 'groupFirst'
 *   groupAfter: // value for 'groupAfter'
 *   acceptedLanguages: // value for 'acceptedLanguages'
 * });
 */
export function useContentsGroupedQuery(variables: ContentsGroupedQueryVariables | VueCompositionApi.Ref<ContentsGroupedQueryVariables> | ReactiveFunction<ContentsGroupedQueryVariables>, options: VueApolloComposable.UseQueryOptions<ContentsGroupedQuery, ContentsGroupedQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ContentsGroupedQuery, ContentsGroupedQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ContentsGroupedQuery, ContentsGroupedQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ContentsGroupedQuery, ContentsGroupedQueryVariables>(ContentsGroupedDocument, variables, options);
}
export function useContentsGroupedLazyQuery(variables: ContentsGroupedQueryVariables | VueCompositionApi.Ref<ContentsGroupedQueryVariables> | ReactiveFunction<ContentsGroupedQueryVariables>, options: VueApolloComposable.UseQueryOptions<ContentsGroupedQuery, ContentsGroupedQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ContentsGroupedQuery, ContentsGroupedQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ContentsGroupedQuery, ContentsGroupedQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ContentsGroupedQuery, ContentsGroupedQueryVariables>(ContentsGroupedDocument, variables, options);
}
export type ContentsGroupedQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ContentsGroupedQuery, ContentsGroupedQueryVariables>;
export const MechanicContentsGroupedItemsDocument = gql`
    query mechanicContentsGroupedItems($mechanicId: String!, $filter: ContentFilter, $groupBy: ContentGroupBy!, $sort: [ContentSort!], $groupAfter: String, $hitsFirst: NonNegativeInt, $hitsAfter: String) {
  mechanic(id: $mechanicId) {
    id
    relatedContentsGrouped(groupBy: $groupBy, filter: $filter) {
      groups(first: 1, after: $groupAfter) {
        cursor
      }
    }
  }
}
    `;

/**
 * __useMechanicContentsGroupedItemsQuery__
 *
 * To run a query within a Vue component, call `useMechanicContentsGroupedItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicContentsGroupedItemsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMechanicContentsGroupedItemsQuery({
 *   mechanicId: // value for 'mechanicId'
 *   filter: // value for 'filter'
 *   groupBy: // value for 'groupBy'
 *   sort: // value for 'sort'
 *   groupAfter: // value for 'groupAfter'
 *   hitsFirst: // value for 'hitsFirst'
 *   hitsAfter: // value for 'hitsAfter'
 * });
 */
export function useMechanicContentsGroupedItemsQuery(variables: MechanicContentsGroupedItemsQueryVariables | VueCompositionApi.Ref<MechanicContentsGroupedItemsQueryVariables> | ReactiveFunction<MechanicContentsGroupedItemsQueryVariables>, options: VueApolloComposable.UseQueryOptions<MechanicContentsGroupedItemsQuery, MechanicContentsGroupedItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MechanicContentsGroupedItemsQuery, MechanicContentsGroupedItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MechanicContentsGroupedItemsQuery, MechanicContentsGroupedItemsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MechanicContentsGroupedItemsQuery, MechanicContentsGroupedItemsQueryVariables>(MechanicContentsGroupedItemsDocument, variables, options);
}
export function useMechanicContentsGroupedItemsLazyQuery(variables: MechanicContentsGroupedItemsQueryVariables | VueCompositionApi.Ref<MechanicContentsGroupedItemsQueryVariables> | ReactiveFunction<MechanicContentsGroupedItemsQueryVariables>, options: VueApolloComposable.UseQueryOptions<MechanicContentsGroupedItemsQuery, MechanicContentsGroupedItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MechanicContentsGroupedItemsQuery, MechanicContentsGroupedItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MechanicContentsGroupedItemsQuery, MechanicContentsGroupedItemsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<MechanicContentsGroupedItemsQuery, MechanicContentsGroupedItemsQueryVariables>(MechanicContentsGroupedItemsDocument, variables, options);
}
export type MechanicContentsGroupedItemsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MechanicContentsGroupedItemsQuery, MechanicContentsGroupedItemsQueryVariables>;
export const AssetContentsGroupedItemsDocument = gql`
    query assetContentsGroupedItems($assetFilter: AssetFilter!, $filter: ContentFilter, $groupBy: ContentGroupBy!, $sort: [ContentSort!], $groupAfter: String, $hitsFirst: NonNegativeInt, $hitsAfter: String) {
  assets(filter: $assetFilter) {
    assets(first: 1) {
      cursor
      node {
        id
        relatedContentsGrouped(groupBy: $groupBy, filter: $filter) {
          groups(first: 1, after: $groupAfter) {
            cursor
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAssetContentsGroupedItemsQuery__
 *
 * To run a query within a Vue component, call `useAssetContentsGroupedItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetContentsGroupedItemsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAssetContentsGroupedItemsQuery({
 *   assetFilter: // value for 'assetFilter'
 *   filter: // value for 'filter'
 *   groupBy: // value for 'groupBy'
 *   sort: // value for 'sort'
 *   groupAfter: // value for 'groupAfter'
 *   hitsFirst: // value for 'hitsFirst'
 *   hitsAfter: // value for 'hitsAfter'
 * });
 */
export function useAssetContentsGroupedItemsQuery(variables: AssetContentsGroupedItemsQueryVariables | VueCompositionApi.Ref<AssetContentsGroupedItemsQueryVariables> | ReactiveFunction<AssetContentsGroupedItemsQueryVariables>, options: VueApolloComposable.UseQueryOptions<AssetContentsGroupedItemsQuery, AssetContentsGroupedItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AssetContentsGroupedItemsQuery, AssetContentsGroupedItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AssetContentsGroupedItemsQuery, AssetContentsGroupedItemsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AssetContentsGroupedItemsQuery, AssetContentsGroupedItemsQueryVariables>(AssetContentsGroupedItemsDocument, variables, options);
}
export function useAssetContentsGroupedItemsLazyQuery(variables: AssetContentsGroupedItemsQueryVariables | VueCompositionApi.Ref<AssetContentsGroupedItemsQueryVariables> | ReactiveFunction<AssetContentsGroupedItemsQueryVariables>, options: VueApolloComposable.UseQueryOptions<AssetContentsGroupedItemsQuery, AssetContentsGroupedItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AssetContentsGroupedItemsQuery, AssetContentsGroupedItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AssetContentsGroupedItemsQuery, AssetContentsGroupedItemsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AssetContentsGroupedItemsQuery, AssetContentsGroupedItemsQueryVariables>(AssetContentsGroupedItemsDocument, variables, options);
}
export type AssetContentsGroupedItemsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AssetContentsGroupedItemsQuery, AssetContentsGroupedItemsQueryVariables>;
export const ProductContentsGroupedItemsDocument = gql`
    query productContentsGroupedItems($productId: String!, $filter: ContentFilter, $groupBy: ContentGroupBy!, $sort: [ContentSort!], $groupAfter: String, $hitsFirst: NonNegativeInt, $hitsAfter: String) {
  product(id: $productId) {
    id
    relatedContentsGrouped(groupBy: $groupBy, filter: $filter) {
      groups(first: 1, after: $groupAfter) {
        cursor
      }
    }
  }
}
    `;

/**
 * __useProductContentsGroupedItemsQuery__
 *
 * To run a query within a Vue component, call `useProductContentsGroupedItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductContentsGroupedItemsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProductContentsGroupedItemsQuery({
 *   productId: // value for 'productId'
 *   filter: // value for 'filter'
 *   groupBy: // value for 'groupBy'
 *   sort: // value for 'sort'
 *   groupAfter: // value for 'groupAfter'
 *   hitsFirst: // value for 'hitsFirst'
 *   hitsAfter: // value for 'hitsAfter'
 * });
 */
export function useProductContentsGroupedItemsQuery(variables: ProductContentsGroupedItemsQueryVariables | VueCompositionApi.Ref<ProductContentsGroupedItemsQueryVariables> | ReactiveFunction<ProductContentsGroupedItemsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProductContentsGroupedItemsQuery, ProductContentsGroupedItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProductContentsGroupedItemsQuery, ProductContentsGroupedItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProductContentsGroupedItemsQuery, ProductContentsGroupedItemsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProductContentsGroupedItemsQuery, ProductContentsGroupedItemsQueryVariables>(ProductContentsGroupedItemsDocument, variables, options);
}
export function useProductContentsGroupedItemsLazyQuery(variables: ProductContentsGroupedItemsQueryVariables | VueCompositionApi.Ref<ProductContentsGroupedItemsQueryVariables> | ReactiveFunction<ProductContentsGroupedItemsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProductContentsGroupedItemsQuery, ProductContentsGroupedItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProductContentsGroupedItemsQuery, ProductContentsGroupedItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProductContentsGroupedItemsQuery, ProductContentsGroupedItemsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProductContentsGroupedItemsQuery, ProductContentsGroupedItemsQueryVariables>(ProductContentsGroupedItemsDocument, variables, options);
}
export type ProductContentsGroupedItemsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProductContentsGroupedItemsQuery, ProductContentsGroupedItemsQueryVariables>;
export const ArticleContentsGroupedItemsDocument = gql`
    query articleContentsGroupedItems($articleId: String!, $filter: ContentFilter, $groupBy: ContentGroupBy!, $sort: [ContentSort!], $groupAfter: String, $hitsFirst: NonNegativeInt, $hitsAfter: String) {
  article(id: $articleId) {
    id
    relatedContentsGrouped(groupBy: $groupBy, filter: $filter) {
      groups(first: 1, after: $groupAfter) {
        cursor
      }
    }
  }
}
    `;

/**
 * __useArticleContentsGroupedItemsQuery__
 *
 * To run a query within a Vue component, call `useArticleContentsGroupedItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleContentsGroupedItemsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useArticleContentsGroupedItemsQuery({
 *   articleId: // value for 'articleId'
 *   filter: // value for 'filter'
 *   groupBy: // value for 'groupBy'
 *   sort: // value for 'sort'
 *   groupAfter: // value for 'groupAfter'
 *   hitsFirst: // value for 'hitsFirst'
 *   hitsAfter: // value for 'hitsAfter'
 * });
 */
export function useArticleContentsGroupedItemsQuery(variables: ArticleContentsGroupedItemsQueryVariables | VueCompositionApi.Ref<ArticleContentsGroupedItemsQueryVariables> | ReactiveFunction<ArticleContentsGroupedItemsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ArticleContentsGroupedItemsQuery, ArticleContentsGroupedItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ArticleContentsGroupedItemsQuery, ArticleContentsGroupedItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ArticleContentsGroupedItemsQuery, ArticleContentsGroupedItemsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ArticleContentsGroupedItemsQuery, ArticleContentsGroupedItemsQueryVariables>(ArticleContentsGroupedItemsDocument, variables, options);
}
export function useArticleContentsGroupedItemsLazyQuery(variables: ArticleContentsGroupedItemsQueryVariables | VueCompositionApi.Ref<ArticleContentsGroupedItemsQueryVariables> | ReactiveFunction<ArticleContentsGroupedItemsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ArticleContentsGroupedItemsQuery, ArticleContentsGroupedItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ArticleContentsGroupedItemsQuery, ArticleContentsGroupedItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ArticleContentsGroupedItemsQuery, ArticleContentsGroupedItemsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ArticleContentsGroupedItemsQuery, ArticleContentsGroupedItemsQueryVariables>(ArticleContentsGroupedItemsDocument, variables, options);
}
export type ArticleContentsGroupedItemsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ArticleContentsGroupedItemsQuery, ArticleContentsGroupedItemsQueryVariables>;
export const ContentsGroupedItemsDocument = gql`
    query contentsGroupedItems($filter: ContentFilter, $groupBy: ContentGroupBy!, $sort: [ContentSort!], $groupAfter: String, $hitsFirst: NonNegativeInt, $hitsAfter: String) {
  contentsGrouped(groupBy: $groupBy, filter: $filter) {
    groups(first: 1, after: $groupAfter) {
      cursor
    }
  }
}
    `;

/**
 * __useContentsGroupedItemsQuery__
 *
 * To run a query within a Vue component, call `useContentsGroupedItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentsGroupedItemsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useContentsGroupedItemsQuery({
 *   filter: // value for 'filter'
 *   groupBy: // value for 'groupBy'
 *   sort: // value for 'sort'
 *   groupAfter: // value for 'groupAfter'
 *   hitsFirst: // value for 'hitsFirst'
 *   hitsAfter: // value for 'hitsAfter'
 * });
 */
export function useContentsGroupedItemsQuery(variables: ContentsGroupedItemsQueryVariables | VueCompositionApi.Ref<ContentsGroupedItemsQueryVariables> | ReactiveFunction<ContentsGroupedItemsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ContentsGroupedItemsQuery, ContentsGroupedItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ContentsGroupedItemsQuery, ContentsGroupedItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ContentsGroupedItemsQuery, ContentsGroupedItemsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ContentsGroupedItemsQuery, ContentsGroupedItemsQueryVariables>(ContentsGroupedItemsDocument, variables, options);
}
export function useContentsGroupedItemsLazyQuery(variables: ContentsGroupedItemsQueryVariables | VueCompositionApi.Ref<ContentsGroupedItemsQueryVariables> | ReactiveFunction<ContentsGroupedItemsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ContentsGroupedItemsQuery, ContentsGroupedItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ContentsGroupedItemsQuery, ContentsGroupedItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ContentsGroupedItemsQuery, ContentsGroupedItemsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ContentsGroupedItemsQuery, ContentsGroupedItemsQueryVariables>(ContentsGroupedItemsDocument, variables, options);
}
export type ContentsGroupedItemsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ContentsGroupedItemsQuery, ContentsGroupedItemsQueryVariables>;
export const SearchRelatedContentsMechanicDocument = gql`
    query searchRelatedContentsMechanic($mechanicId: String!, $first: NonNegativeInt, $after: String, $contentFilter: ContentFilter, $sort: [ContentSort]) {
  mechanic(id: $mechanicId) {
    id
    relatedContents(filter: $contentFilter) {
      total(trackLimit: 500) {
        count
        countRelation
      }
    }
  }
}
    `;

/**
 * __useSearchRelatedContentsMechanicQuery__
 *
 * To run a query within a Vue component, call `useSearchRelatedContentsMechanicQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchRelatedContentsMechanicQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchRelatedContentsMechanicQuery({
 *   mechanicId: // value for 'mechanicId'
 *   first: // value for 'first'
 *   after: // value for 'after'
 *   contentFilter: // value for 'contentFilter'
 *   sort: // value for 'sort'
 * });
 */
export function useSearchRelatedContentsMechanicQuery(variables: SearchRelatedContentsMechanicQueryVariables | VueCompositionApi.Ref<SearchRelatedContentsMechanicQueryVariables> | ReactiveFunction<SearchRelatedContentsMechanicQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchRelatedContentsMechanicQuery, SearchRelatedContentsMechanicQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchRelatedContentsMechanicQuery, SearchRelatedContentsMechanicQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchRelatedContentsMechanicQuery, SearchRelatedContentsMechanicQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchRelatedContentsMechanicQuery, SearchRelatedContentsMechanicQueryVariables>(SearchRelatedContentsMechanicDocument, variables, options);
}
export function useSearchRelatedContentsMechanicLazyQuery(variables: SearchRelatedContentsMechanicQueryVariables | VueCompositionApi.Ref<SearchRelatedContentsMechanicQueryVariables> | ReactiveFunction<SearchRelatedContentsMechanicQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchRelatedContentsMechanicQuery, SearchRelatedContentsMechanicQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchRelatedContentsMechanicQuery, SearchRelatedContentsMechanicQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchRelatedContentsMechanicQuery, SearchRelatedContentsMechanicQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SearchRelatedContentsMechanicQuery, SearchRelatedContentsMechanicQueryVariables>(SearchRelatedContentsMechanicDocument, variables, options);
}
export type SearchRelatedContentsMechanicQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchRelatedContentsMechanicQuery, SearchRelatedContentsMechanicQueryVariables>;
export const SearchDocumentsForAssetWithProductDocument = gql`
    query searchDocumentsForAssetWithProduct($assetFilter: AssetFilter!, $contentFilter: ContentFilter!, $first: NonNegativeInt, $after: String, $sort: [ContentSort]) {
  assets(filter: $assetFilter) {
    assets(first: 1) {
      cursor
      node {
        id
        relatedContents(filter: $contentFilter) {
          total(trackLimit: 500) {
            count
            countRelation
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSearchDocumentsForAssetWithProductQuery__
 *
 * To run a query within a Vue component, call `useSearchDocumentsForAssetWithProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchDocumentsForAssetWithProductQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchDocumentsForAssetWithProductQuery({
 *   assetFilter: // value for 'assetFilter'
 *   contentFilter: // value for 'contentFilter'
 *   first: // value for 'first'
 *   after: // value for 'after'
 *   sort: // value for 'sort'
 * });
 */
export function useSearchDocumentsForAssetWithProductQuery(variables: SearchDocumentsForAssetWithProductQueryVariables | VueCompositionApi.Ref<SearchDocumentsForAssetWithProductQueryVariables> | ReactiveFunction<SearchDocumentsForAssetWithProductQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchDocumentsForAssetWithProductQuery, SearchDocumentsForAssetWithProductQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchDocumentsForAssetWithProductQuery, SearchDocumentsForAssetWithProductQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchDocumentsForAssetWithProductQuery, SearchDocumentsForAssetWithProductQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchDocumentsForAssetWithProductQuery, SearchDocumentsForAssetWithProductQueryVariables>(SearchDocumentsForAssetWithProductDocument, variables, options);
}
export function useSearchDocumentsForAssetWithProductLazyQuery(variables: SearchDocumentsForAssetWithProductQueryVariables | VueCompositionApi.Ref<SearchDocumentsForAssetWithProductQueryVariables> | ReactiveFunction<SearchDocumentsForAssetWithProductQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchDocumentsForAssetWithProductQuery, SearchDocumentsForAssetWithProductQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchDocumentsForAssetWithProductQuery, SearchDocumentsForAssetWithProductQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchDocumentsForAssetWithProductQuery, SearchDocumentsForAssetWithProductQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SearchDocumentsForAssetWithProductQuery, SearchDocumentsForAssetWithProductQueryVariables>(SearchDocumentsForAssetWithProductDocument, variables, options);
}
export type SearchDocumentsForAssetWithProductQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchDocumentsForAssetWithProductQuery, SearchDocumentsForAssetWithProductQueryVariables>;
export const SearchRelatedContentsProductDocument = gql`
    query searchRelatedContentsProduct($productId: String!, $first: NonNegativeInt, $after: String, $contentFilter: ContentFilter, $sort: [ContentSort]) {
  product(id: $productId) {
    id
    relatedContents(filter: $contentFilter) {
      total(trackLimit: 500) {
        count
        countRelation
      }
    }
  }
}
    `;

/**
 * __useSearchRelatedContentsProductQuery__
 *
 * To run a query within a Vue component, call `useSearchRelatedContentsProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchRelatedContentsProductQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchRelatedContentsProductQuery({
 *   productId: // value for 'productId'
 *   first: // value for 'first'
 *   after: // value for 'after'
 *   contentFilter: // value for 'contentFilter'
 *   sort: // value for 'sort'
 * });
 */
export function useSearchRelatedContentsProductQuery(variables: SearchRelatedContentsProductQueryVariables | VueCompositionApi.Ref<SearchRelatedContentsProductQueryVariables> | ReactiveFunction<SearchRelatedContentsProductQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchRelatedContentsProductQuery, SearchRelatedContentsProductQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchRelatedContentsProductQuery, SearchRelatedContentsProductQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchRelatedContentsProductQuery, SearchRelatedContentsProductQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchRelatedContentsProductQuery, SearchRelatedContentsProductQueryVariables>(SearchRelatedContentsProductDocument, variables, options);
}
export function useSearchRelatedContentsProductLazyQuery(variables: SearchRelatedContentsProductQueryVariables | VueCompositionApi.Ref<SearchRelatedContentsProductQueryVariables> | ReactiveFunction<SearchRelatedContentsProductQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchRelatedContentsProductQuery, SearchRelatedContentsProductQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchRelatedContentsProductQuery, SearchRelatedContentsProductQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchRelatedContentsProductQuery, SearchRelatedContentsProductQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SearchRelatedContentsProductQuery, SearchRelatedContentsProductQueryVariables>(SearchRelatedContentsProductDocument, variables, options);
}
export type SearchRelatedContentsProductQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchRelatedContentsProductQuery, SearchRelatedContentsProductQueryVariables>;
export const RelatedContentsForArticleDocument = gql`
    query relatedContentsForArticle($articleId: String!, $first: NonNegativeInt, $after: String, $contentFilter: ContentFilter, $sort: [ContentSort]) {
  article(id: $articleId) {
    id
    relatedContents(filter: $contentFilter) {
      total(trackLimit: 500) {
        count
        countRelation
      }
    }
  }
}
    `;

/**
 * __useRelatedContentsForArticleQuery__
 *
 * To run a query within a Vue component, call `useRelatedContentsForArticleQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelatedContentsForArticleQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRelatedContentsForArticleQuery({
 *   articleId: // value for 'articleId'
 *   first: // value for 'first'
 *   after: // value for 'after'
 *   contentFilter: // value for 'contentFilter'
 *   sort: // value for 'sort'
 * });
 */
export function useRelatedContentsForArticleQuery(variables: RelatedContentsForArticleQueryVariables | VueCompositionApi.Ref<RelatedContentsForArticleQueryVariables> | ReactiveFunction<RelatedContentsForArticleQueryVariables>, options: VueApolloComposable.UseQueryOptions<RelatedContentsForArticleQuery, RelatedContentsForArticleQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RelatedContentsForArticleQuery, RelatedContentsForArticleQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RelatedContentsForArticleQuery, RelatedContentsForArticleQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<RelatedContentsForArticleQuery, RelatedContentsForArticleQueryVariables>(RelatedContentsForArticleDocument, variables, options);
}
export function useRelatedContentsForArticleLazyQuery(variables: RelatedContentsForArticleQueryVariables | VueCompositionApi.Ref<RelatedContentsForArticleQueryVariables> | ReactiveFunction<RelatedContentsForArticleQueryVariables>, options: VueApolloComposable.UseQueryOptions<RelatedContentsForArticleQuery, RelatedContentsForArticleQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RelatedContentsForArticleQuery, RelatedContentsForArticleQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RelatedContentsForArticleQuery, RelatedContentsForArticleQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<RelatedContentsForArticleQuery, RelatedContentsForArticleQueryVariables>(RelatedContentsForArticleDocument, variables, options);
}
export type RelatedContentsForArticleQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<RelatedContentsForArticleQuery, RelatedContentsForArticleQueryVariables>;
export const SearchDocumentsDocument = gql`
    query searchDocuments($first: NonNegativeInt, $after: String, $contentFilter: ContentFilter, $sort: [ContentSort]) {
  contents(filter: $contentFilter) {
    total(trackLimit: 500) {
      count
      countRelation
    }
  }
}
    `;

/**
 * __useSearchDocumentsQuery__
 *
 * To run a query within a Vue component, call `useSearchDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchDocumentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchDocumentsQuery({
 *   first: // value for 'first'
 *   after: // value for 'after'
 *   contentFilter: // value for 'contentFilter'
 *   sort: // value for 'sort'
 * });
 */
export function useSearchDocumentsQuery(variables: SearchDocumentsQueryVariables | VueCompositionApi.Ref<SearchDocumentsQueryVariables> | ReactiveFunction<SearchDocumentsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<SearchDocumentsQuery, SearchDocumentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchDocumentsQuery, SearchDocumentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchDocumentsQuery, SearchDocumentsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchDocumentsQuery, SearchDocumentsQueryVariables>(SearchDocumentsDocument, variables, options);
}
export function useSearchDocumentsLazyQuery(variables: SearchDocumentsQueryVariables | VueCompositionApi.Ref<SearchDocumentsQueryVariables> | ReactiveFunction<SearchDocumentsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<SearchDocumentsQuery, SearchDocumentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchDocumentsQuery, SearchDocumentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchDocumentsQuery, SearchDocumentsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SearchDocumentsQuery, SearchDocumentsQueryVariables>(SearchDocumentsDocument, variables, options);
}
export type SearchDocumentsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchDocumentsQuery, SearchDocumentsQueryVariables>;
export const ContentInContextDocument = gql`
    query contentInContext($rootContentId: ID, $contentId: ID) {
  contentInContext(rootContentId: $rootContentId, contentId: $contentId) {
    id
    path
    parentPaths
    node {
      ... on Topic {
        id
        language
        teasers {
          title(length: 256)
        }
      }
    }
  }
}
    `;

/**
 * __useContentInContextQuery__
 *
 * To run a query within a Vue component, call `useContentInContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentInContextQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useContentInContextQuery({
 *   rootContentId: // value for 'rootContentId'
 *   contentId: // value for 'contentId'
 * });
 */
export function useContentInContextQuery(variables: ContentInContextQueryVariables | VueCompositionApi.Ref<ContentInContextQueryVariables> | ReactiveFunction<ContentInContextQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ContentInContextQuery, ContentInContextQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ContentInContextQuery, ContentInContextQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ContentInContextQuery, ContentInContextQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ContentInContextQuery, ContentInContextQueryVariables>(ContentInContextDocument, variables, options);
}
export function useContentInContextLazyQuery(variables: ContentInContextQueryVariables | VueCompositionApi.Ref<ContentInContextQueryVariables> | ReactiveFunction<ContentInContextQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ContentInContextQuery, ContentInContextQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ContentInContextQuery, ContentInContextQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ContentInContextQuery, ContentInContextQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ContentInContextQuery, ContentInContextQueryVariables>(ContentInContextDocument, variables, options);
}
export type ContentInContextQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ContentInContextQuery, ContentInContextQueryVariables>;
export const TitleOfContentMapDocument = gql`
    query titleOfContentMap($filter: ContentMapFilter) {
  contentMaps(filter: $filter) {
    contentMaps {
      node {
        id
        language
        teasers {
          title(length: 256)
        }
      }
    }
  }
}
    `;

/**
 * __useTitleOfContentMapQuery__
 *
 * To run a query within a Vue component, call `useTitleOfContentMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useTitleOfContentMapQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTitleOfContentMapQuery({
 *   filter: // value for 'filter'
 * });
 */
export function useTitleOfContentMapQuery(variables: TitleOfContentMapQueryVariables | VueCompositionApi.Ref<TitleOfContentMapQueryVariables> | ReactiveFunction<TitleOfContentMapQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<TitleOfContentMapQuery, TitleOfContentMapQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TitleOfContentMapQuery, TitleOfContentMapQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TitleOfContentMapQuery, TitleOfContentMapQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TitleOfContentMapQuery, TitleOfContentMapQueryVariables>(TitleOfContentMapDocument, variables, options);
}
export function useTitleOfContentMapLazyQuery(variables: TitleOfContentMapQueryVariables | VueCompositionApi.Ref<TitleOfContentMapQueryVariables> | ReactiveFunction<TitleOfContentMapQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<TitleOfContentMapQuery, TitleOfContentMapQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TitleOfContentMapQuery, TitleOfContentMapQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TitleOfContentMapQuery, TitleOfContentMapQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TitleOfContentMapQuery, TitleOfContentMapQueryVariables>(TitleOfContentMapDocument, variables, options);
}
export type TitleOfContentMapQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TitleOfContentMapQuery, TitleOfContentMapQueryVariables>;
export const DocumentationVariantsAggregationsDocument = gql`
    query documentationVariantsAggregations($contentMapFilter: ContentMapFilter) {
  contentMaps(filter: $contentMapFilter) {
    contentMaps {
      cursor
      node {
        id
        variants {
          aggregations {
            language {
              count
              value
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useDocumentationVariantsAggregationsQuery__
 *
 * To run a query within a Vue component, call `useDocumentationVariantsAggregationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentationVariantsAggregationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDocumentationVariantsAggregationsQuery({
 *   contentMapFilter: // value for 'contentMapFilter'
 * });
 */
export function useDocumentationVariantsAggregationsQuery(variables: DocumentationVariantsAggregationsQueryVariables | VueCompositionApi.Ref<DocumentationVariantsAggregationsQueryVariables> | ReactiveFunction<DocumentationVariantsAggregationsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<DocumentationVariantsAggregationsQuery, DocumentationVariantsAggregationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DocumentationVariantsAggregationsQuery, DocumentationVariantsAggregationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DocumentationVariantsAggregationsQuery, DocumentationVariantsAggregationsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<DocumentationVariantsAggregationsQuery, DocumentationVariantsAggregationsQueryVariables>(DocumentationVariantsAggregationsDocument, variables, options);
}
export function useDocumentationVariantsAggregationsLazyQuery(variables: DocumentationVariantsAggregationsQueryVariables | VueCompositionApi.Ref<DocumentationVariantsAggregationsQueryVariables> | ReactiveFunction<DocumentationVariantsAggregationsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<DocumentationVariantsAggregationsQuery, DocumentationVariantsAggregationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DocumentationVariantsAggregationsQuery, DocumentationVariantsAggregationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DocumentationVariantsAggregationsQuery, DocumentationVariantsAggregationsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<DocumentationVariantsAggregationsQuery, DocumentationVariantsAggregationsQueryVariables>(DocumentationVariantsAggregationsDocument, variables, options);
}
export type DocumentationVariantsAggregationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<DocumentationVariantsAggregationsQuery, DocumentationVariantsAggregationsQueryVariables>;
export const TopicVariantsDocument = gql`
    query topicVariants($topicFilter: TopicFilter, $variantsFilter: ContentFilter) {
  topics(filter: $topicFilter) {
    topics {
      node {
        id
        variants(filter: $variantsFilter) {
          contents {
            node {
              id
              contentId
              ... on Topic {
                mimeType
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useTopicVariantsQuery__
 *
 * To run a query within a Vue component, call `useTopicVariantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopicVariantsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTopicVariantsQuery({
 *   topicFilter: // value for 'topicFilter'
 *   variantsFilter: // value for 'variantsFilter'
 * });
 */
export function useTopicVariantsQuery(variables: TopicVariantsQueryVariables | VueCompositionApi.Ref<TopicVariantsQueryVariables> | ReactiveFunction<TopicVariantsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<TopicVariantsQuery, TopicVariantsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TopicVariantsQuery, TopicVariantsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TopicVariantsQuery, TopicVariantsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TopicVariantsQuery, TopicVariantsQueryVariables>(TopicVariantsDocument, variables, options);
}
export function useTopicVariantsLazyQuery(variables: TopicVariantsQueryVariables | VueCompositionApi.Ref<TopicVariantsQueryVariables> | ReactiveFunction<TopicVariantsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<TopicVariantsQuery, TopicVariantsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TopicVariantsQuery, TopicVariantsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TopicVariantsQuery, TopicVariantsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TopicVariantsQuery, TopicVariantsQueryVariables>(TopicVariantsDocument, variables, options);
}
export type TopicVariantsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TopicVariantsQuery, TopicVariantsQueryVariables>;
export const DeleteNoteDocument = gql`
    mutation deleteNote($id: ID!) {
  deleteNote(id: $id)
}
    `;

/**
 * __useDeleteNoteMutation__
 *
 * To run a mutation, you first call `useDeleteNoteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNoteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteNoteMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteNoteMutation(options: VueApolloComposable.UseMutationOptions<DeleteNoteMutation, DeleteNoteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteNoteMutation, DeleteNoteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteNoteMutation, DeleteNoteMutationVariables>(DeleteNoteDocument, options);
}
export type DeleteNoteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteNoteMutation, DeleteNoteMutationVariables>;
export const DeleteNoteAttachmentsDocument = gql`
    mutation deleteNoteAttachments($id: ID!, $attachmentIds: [ID]!) {
  deleteNoteAttachments(noteId: $id, attachmentIds: $attachmentIds)
}
    `;

/**
 * __useDeleteNoteAttachmentsMutation__
 *
 * To run a mutation, you first call `useDeleteNoteAttachmentsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNoteAttachmentsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteNoteAttachmentsMutation({
 *   variables: {
 *     id: // value for 'id'
 *     attachmentIds: // value for 'attachmentIds'
 *   },
 * });
 */
export function useDeleteNoteAttachmentsMutation(options: VueApolloComposable.UseMutationOptions<DeleteNoteAttachmentsMutation, DeleteNoteAttachmentsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteNoteAttachmentsMutation, DeleteNoteAttachmentsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteNoteAttachmentsMutation, DeleteNoteAttachmentsMutationVariables>(DeleteNoteAttachmentsDocument, options);
}
export type DeleteNoteAttachmentsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteNoteAttachmentsMutation, DeleteNoteAttachmentsMutationVariables>;
export const UpdateNoteDocument = gql`
    mutation updateNote($note: UpdateNoteInput!) {
  updateNote(partialNote: $note) {
    id
  }
}
    `;

/**
 * __useUpdateNoteMutation__
 *
 * To run a mutation, you first call `useUpdateNoteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNoteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateNoteMutation({
 *   variables: {
 *     note: // value for 'note'
 *   },
 * });
 */
export function useUpdateNoteMutation(options: VueApolloComposable.UseMutationOptions<UpdateNoteMutation, UpdateNoteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateNoteMutation, UpdateNoteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateNoteMutation, UpdateNoteMutationVariables>(UpdateNoteDocument, options);
}
export type UpdateNoteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateNoteMutation, UpdateNoteMutationVariables>;
export const CreateNoteDocument = gql`
    mutation createNote($note: CreateNoteInput!) {
  createNote(noteSpec: $note)
}
    `;

/**
 * __useCreateNoteMutation__
 *
 * To run a mutation, you first call `useCreateNoteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateNoteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateNoteMutation({
 *   variables: {
 *     note: // value for 'note'
 *   },
 * });
 */
export function useCreateNoteMutation(options: VueApolloComposable.UseMutationOptions<CreateNoteMutation, CreateNoteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateNoteMutation, CreateNoteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateNoteMutation, CreateNoteMutationVariables>(CreateNoteDocument, options);
}
export type CreateNoteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateNoteMutation, CreateNoteMutationVariables>;
export const NotesDocument = gql`
    query notes($noteFilter: NoteFilter!, $first: NonNegativeInt, $after: String) {
  notes(filter: $noteFilter) {
    total {
      count
      countRelation
    }
    notes(first: $first, sort: {field: creationDate, order: desc}, after: $after) {
      cursor
      node {
        id
        creationDate
        modificationDate
        user {
          id
          displayName
        }
        visibility
        text {
          ar
          da
          de
          el
          en
          es
          fr
          fi
          hu
          it
          ja
          nb
          nl
          pt
          ro
          ru
          sv
          tr
          zh
        }
        content {
          contentId
        }
        attachments {
          path
          blob {
            size
            url
            id
            mimeType
            url
          }
        }
      }
    }
  }
}
    `;

/**
 * __useNotesQuery__
 *
 * To run a query within a Vue component, call `useNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useNotesQuery({
 *   noteFilter: // value for 'noteFilter'
 *   first: // value for 'first'
 *   after: // value for 'after'
 * });
 */
export function useNotesQuery(variables: NotesQueryVariables | VueCompositionApi.Ref<NotesQueryVariables> | ReactiveFunction<NotesQueryVariables>, options: VueApolloComposable.UseQueryOptions<NotesQuery, NotesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<NotesQuery, NotesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<NotesQuery, NotesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<NotesQuery, NotesQueryVariables>(NotesDocument, variables, options);
}
export function useNotesLazyQuery(variables: NotesQueryVariables | VueCompositionApi.Ref<NotesQueryVariables> | ReactiveFunction<NotesQueryVariables>, options: VueApolloComposable.UseQueryOptions<NotesQuery, NotesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<NotesQuery, NotesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<NotesQuery, NotesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<NotesQuery, NotesQueryVariables>(NotesDocument, variables, options);
}
export type NotesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<NotesQuery, NotesQueryVariables>;
export const UploadConfigDocument = gql`
    query uploadConfig {
  tenant {
    uploadConfig {
      notes {
        attachments {
          allowedMimeTypes
          limits {
            maxFileSize
            maxFilesPerUpload
          }
        }
      }
    }
  }
}
    `;

/**
 * __useUploadConfigQuery__
 *
 * To run a query within a Vue component, call `useUploadConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useUploadConfigQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUploadConfigQuery();
 */
export function useUploadConfigQuery(options: VueApolloComposable.UseQueryOptions<UploadConfigQuery, UploadConfigQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UploadConfigQuery, UploadConfigQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UploadConfigQuery, UploadConfigQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UploadConfigQuery, UploadConfigQueryVariables>(UploadConfigDocument, {}, options);
}
export function useUploadConfigLazyQuery(options: VueApolloComposable.UseQueryOptions<UploadConfigQuery, UploadConfigQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UploadConfigQuery, UploadConfigQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UploadConfigQuery, UploadConfigQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UploadConfigQuery, UploadConfigQueryVariables>(UploadConfigDocument, {}, options);
}
export type UploadConfigQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UploadConfigQuery, UploadConfigQueryVariables>;
export const NumberOfNotesDocument = gql`
    query numberOfNotes($noteFilter: NoteFilter!) {
  notes(filter: $noteFilter) {
    total {
      count
      countRelation
    }
  }
}
    `;

/**
 * __useNumberOfNotesQuery__
 *
 * To run a query within a Vue component, call `useNumberOfNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNumberOfNotesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useNumberOfNotesQuery({
 *   noteFilter: // value for 'noteFilter'
 * });
 */
export function useNumberOfNotesQuery(variables: NumberOfNotesQueryVariables | VueCompositionApi.Ref<NumberOfNotesQueryVariables> | ReactiveFunction<NumberOfNotesQueryVariables>, options: VueApolloComposable.UseQueryOptions<NumberOfNotesQuery, NumberOfNotesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<NumberOfNotesQuery, NumberOfNotesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<NumberOfNotesQuery, NumberOfNotesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<NumberOfNotesQuery, NumberOfNotesQueryVariables>(NumberOfNotesDocument, variables, options);
}
export function useNumberOfNotesLazyQuery(variables: NumberOfNotesQueryVariables | VueCompositionApi.Ref<NumberOfNotesQueryVariables> | ReactiveFunction<NumberOfNotesQueryVariables>, options: VueApolloComposable.UseQueryOptions<NumberOfNotesQuery, NumberOfNotesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<NumberOfNotesQuery, NumberOfNotesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<NumberOfNotesQuery, NumberOfNotesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<NumberOfNotesQuery, NumberOfNotesQueryVariables>(NumberOfNotesDocument, variables, options);
}
export type NumberOfNotesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<NumberOfNotesQuery, NumberOfNotesQueryVariables>;
export const RawClaimsDocument = gql`
    query rawClaims {
  me {
    id
    rawClaims
  }
}
    `;

/**
 * __useRawClaimsQuery__
 *
 * To run a query within a Vue component, call `useRawClaimsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRawClaimsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRawClaimsQuery();
 */
export function useRawClaimsQuery(options: VueApolloComposable.UseQueryOptions<RawClaimsQuery, RawClaimsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RawClaimsQuery, RawClaimsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RawClaimsQuery, RawClaimsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<RawClaimsQuery, RawClaimsQueryVariables>(RawClaimsDocument, {}, options);
}
export function useRawClaimsLazyQuery(options: VueApolloComposable.UseQueryOptions<RawClaimsQuery, RawClaimsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RawClaimsQuery, RawClaimsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RawClaimsQuery, RawClaimsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<RawClaimsQuery, RawClaimsQueryVariables>(RawClaimsDocument, {}, options);
}
export type RawClaimsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<RawClaimsQuery, RawClaimsQueryVariables>;
export const RelatedArticlesFromContentMapDocument = gql`
    query relatedArticlesFromContentMap($filter: ContentMapFilter) {
  contentMaps(filter: $filter) {
    contentMaps {
      node {
        id
        articleIds
      }
    }
  }
}
    `;

/**
 * __useRelatedArticlesFromContentMapQuery__
 *
 * To run a query within a Vue component, call `useRelatedArticlesFromContentMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelatedArticlesFromContentMapQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRelatedArticlesFromContentMapQuery({
 *   filter: // value for 'filter'
 * });
 */
export function useRelatedArticlesFromContentMapQuery(variables: RelatedArticlesFromContentMapQueryVariables | VueCompositionApi.Ref<RelatedArticlesFromContentMapQueryVariables> | ReactiveFunction<RelatedArticlesFromContentMapQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<RelatedArticlesFromContentMapQuery, RelatedArticlesFromContentMapQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RelatedArticlesFromContentMapQuery, RelatedArticlesFromContentMapQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RelatedArticlesFromContentMapQuery, RelatedArticlesFromContentMapQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<RelatedArticlesFromContentMapQuery, RelatedArticlesFromContentMapQueryVariables>(RelatedArticlesFromContentMapDocument, variables, options);
}
export function useRelatedArticlesFromContentMapLazyQuery(variables: RelatedArticlesFromContentMapQueryVariables | VueCompositionApi.Ref<RelatedArticlesFromContentMapQueryVariables> | ReactiveFunction<RelatedArticlesFromContentMapQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<RelatedArticlesFromContentMapQuery, RelatedArticlesFromContentMapQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RelatedArticlesFromContentMapQuery, RelatedArticlesFromContentMapQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RelatedArticlesFromContentMapQuery, RelatedArticlesFromContentMapQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<RelatedArticlesFromContentMapQuery, RelatedArticlesFromContentMapQueryVariables>(RelatedArticlesFromContentMapDocument, variables, options);
}
export type RelatedArticlesFromContentMapQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<RelatedArticlesFromContentMapQuery, RelatedArticlesFromContentMapQueryVariables>;
export const ShowDocumentationSearchDocument = gql`
    query showDocumentationSearch($contentFilter: ContentFilter, $first: NonNegativeInt, $sort: [ContentSort]) {
  contents(filter: $contentFilter) {
    contents(first: $first, sort: $sort) {
      node {
        id
        contentId
        locale
        language
        teasers {
          title(length: 256)
        }
      }
    }
  }
}
    `;

/**
 * __useShowDocumentationSearchQuery__
 *
 * To run a query within a Vue component, call `useShowDocumentationSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useShowDocumentationSearchQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useShowDocumentationSearchQuery({
 *   contentFilter: // value for 'contentFilter'
 *   first: // value for 'first'
 *   sort: // value for 'sort'
 * });
 */
export function useShowDocumentationSearchQuery(variables: ShowDocumentationSearchQueryVariables | VueCompositionApi.Ref<ShowDocumentationSearchQueryVariables> | ReactiveFunction<ShowDocumentationSearchQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ShowDocumentationSearchQuery, ShowDocumentationSearchQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ShowDocumentationSearchQuery, ShowDocumentationSearchQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ShowDocumentationSearchQuery, ShowDocumentationSearchQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ShowDocumentationSearchQuery, ShowDocumentationSearchQueryVariables>(ShowDocumentationSearchDocument, variables, options);
}
export function useShowDocumentationSearchLazyQuery(variables: ShowDocumentationSearchQueryVariables | VueCompositionApi.Ref<ShowDocumentationSearchQueryVariables> | ReactiveFunction<ShowDocumentationSearchQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ShowDocumentationSearchQuery, ShowDocumentationSearchQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ShowDocumentationSearchQuery, ShowDocumentationSearchQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ShowDocumentationSearchQuery, ShowDocumentationSearchQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ShowDocumentationSearchQuery, ShowDocumentationSearchQueryVariables>(ShowDocumentationSearchDocument, variables, options);
}
export type ShowDocumentationSearchQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ShowDocumentationSearchQuery, ShowDocumentationSearchQueryVariables>;
export const TocDocument = gql`
    query toc($filter: ContentMapFilter, $paths: [String!], $first: NonNegativeInt!, $after: String!) {
  contentMaps(filter: $filter, filterOptions: {includeHidden: true}) {
    contentMaps(first: 1) {
      node {
        id
        contentId
        toc(paths: $paths) {
          total {
            count
            countRelation
          }
          tocEntries(first: $first, after: $after) {
            id
            path
            cursor
            childPath
            hasChildren
            node {
              id
              teasers {
                title(length: 256)
              }
              ... on Topic {
                url
                mimeType
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useTocQuery__
 *
 * To run a query within a Vue component, call `useTocQuery` and pass it any options that fit your needs.
 * When your component renders, `useTocQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTocQuery({
 *   filter: // value for 'filter'
 *   paths: // value for 'paths'
 *   first: // value for 'first'
 *   after: // value for 'after'
 * });
 */
export function useTocQuery(variables: TocQueryVariables | VueCompositionApi.Ref<TocQueryVariables> | ReactiveFunction<TocQueryVariables>, options: VueApolloComposable.UseQueryOptions<TocQuery, TocQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TocQuery, TocQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TocQuery, TocQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TocQuery, TocQueryVariables>(TocDocument, variables, options);
}
export function useTocLazyQuery(variables: TocQueryVariables | VueCompositionApi.Ref<TocQueryVariables> | ReactiveFunction<TocQueryVariables>, options: VueApolloComposable.UseQueryOptions<TocQuery, TocQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TocQuery, TocQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TocQuery, TocQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TocQuery, TocQueryVariables>(TocDocument, variables, options);
}
export type TocQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TocQuery, TocQueryVariables>;
export const TocPathAndTitleDocument = gql`
    query tocPathAndTitle($rootContentId: ID, $contentId: ID) {
  contentInContext(rootContentId: $rootContentId, contentId: $contentId) {
    path
    id
    childPath
    hasChildren
    next {
      id
      teasers {
        title(length: 256)
      }
    }
    previous {
      id
      teasers {
        title(length: 256)
      }
    }
    node {
      id
      contentId
      locale
      version
      ... on ContentMap {
        versionLabel
        version
      }
      ... on Topic {
        url
        mimeType
        teasers {
          title(length: 256)
        }
        version
        useContext {
          rootContentMap {
            id
            contentId
            version
            versionLabel
          }
        }
      }
    }
  }
}
    `;

/**
 * __useTocPathAndTitleQuery__
 *
 * To run a query within a Vue component, call `useTocPathAndTitleQuery` and pass it any options that fit your needs.
 * When your component renders, `useTocPathAndTitleQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTocPathAndTitleQuery({
 *   rootContentId: // value for 'rootContentId'
 *   contentId: // value for 'contentId'
 * });
 */
export function useTocPathAndTitleQuery(variables: TocPathAndTitleQueryVariables | VueCompositionApi.Ref<TocPathAndTitleQueryVariables> | ReactiveFunction<TocPathAndTitleQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<TocPathAndTitleQuery, TocPathAndTitleQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TocPathAndTitleQuery, TocPathAndTitleQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TocPathAndTitleQuery, TocPathAndTitleQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TocPathAndTitleQuery, TocPathAndTitleQueryVariables>(TocPathAndTitleDocument, variables, options);
}
export function useTocPathAndTitleLazyQuery(variables: TocPathAndTitleQueryVariables | VueCompositionApi.Ref<TocPathAndTitleQueryVariables> | ReactiveFunction<TocPathAndTitleQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<TocPathAndTitleQuery, TocPathAndTitleQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TocPathAndTitleQuery, TocPathAndTitleQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TocPathAndTitleQuery, TocPathAndTitleQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TocPathAndTitleQuery, TocPathAndTitleQueryVariables>(TocPathAndTitleDocument, variables, options);
}
export type TocPathAndTitleQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TocPathAndTitleQuery, TocPathAndTitleQueryVariables>;
export const ContentsSearchDocument = gql`
    query contentsSearch($filter: ContentFilter, $first: NonNegativeInt) {
  contents(filter: $filter) {
    contents(first: $first) {
      cursor
      highlights {
        title(length: 256)
        text(length: 256)
        __typename
      }
      node {
        id
        contentId
        locale
        ... on ContentMap {
          type
          teasers {
            title(length: 256)
            __typename
          }
          __typename
        }
        ... on Topic {
          type
          teasers {
            title(length: 256)
            __typename
          }
          mimeType
          __typename
        }
        __typename
      }
    }
    total {
      count
      countRelation
    }
  }
}
    `;

/**
 * __useContentsSearchQuery__
 *
 * To run a query within a Vue component, call `useContentsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentsSearchQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useContentsSearchQuery({
 *   filter: // value for 'filter'
 *   first: // value for 'first'
 * });
 */
export function useContentsSearchQuery(variables: ContentsSearchQueryVariables | VueCompositionApi.Ref<ContentsSearchQueryVariables> | ReactiveFunction<ContentsSearchQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ContentsSearchQuery, ContentsSearchQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ContentsSearchQuery, ContentsSearchQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ContentsSearchQuery, ContentsSearchQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ContentsSearchQuery, ContentsSearchQueryVariables>(ContentsSearchDocument, variables, options);
}
export function useContentsSearchLazyQuery(variables: ContentsSearchQueryVariables | VueCompositionApi.Ref<ContentsSearchQueryVariables> | ReactiveFunction<ContentsSearchQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ContentsSearchQuery, ContentsSearchQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ContentsSearchQuery, ContentsSearchQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ContentsSearchQuery, ContentsSearchQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ContentsSearchQuery, ContentsSearchQueryVariables>(ContentsSearchDocument, variables, options);
}
export type ContentsSearchQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ContentsSearchQuery, ContentsSearchQueryVariables>;
export const GetConfig3dLatticeDocument = gql`
    query getConfig3dLattice {
  config {
    config3dLattice {
      id
      articleRef {
        section
        field
      }
      selectionColor
      fps
      camera
      viewport
      selectionMode
      hover
    }
  }
}
    `;

/**
 * __useGetConfig3dLatticeQuery__
 *
 * To run a query within a Vue component, call `useGetConfig3dLatticeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConfig3dLatticeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetConfig3dLatticeQuery();
 */
export function useGetConfig3dLatticeQuery(options: VueApolloComposable.UseQueryOptions<GetConfig3dLatticeQuery, GetConfig3dLatticeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetConfig3dLatticeQuery, GetConfig3dLatticeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetConfig3dLatticeQuery, GetConfig3dLatticeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetConfig3dLatticeQuery, GetConfig3dLatticeQueryVariables>(GetConfig3dLatticeDocument, {}, options);
}
export function useGetConfig3dLatticeLazyQuery(options: VueApolloComposable.UseQueryOptions<GetConfig3dLatticeQuery, GetConfig3dLatticeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetConfig3dLatticeQuery, GetConfig3dLatticeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetConfig3dLatticeQuery, GetConfig3dLatticeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetConfig3dLatticeQuery, GetConfig3dLatticeQueryVariables>(GetConfig3dLatticeDocument, {}, options);
}
export type GetConfig3dLatticeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetConfig3dLatticeQuery, GetConfig3dLatticeQueryVariables>;
export const GetConfig3dHoopsDocument = gql`
    query getConfig3dHoops {
  config {
    config3dHoops {
      id
      articleRef {
        nodeProperty
      }
      selectionColor
      outlineColor
      fps
      camera
      viewport
      selectionMode
      hover
    }
  }
}
    `;

/**
 * __useGetConfig3dHoopsQuery__
 *
 * To run a query within a Vue component, call `useGetConfig3dHoopsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConfig3dHoopsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetConfig3dHoopsQuery();
 */
export function useGetConfig3dHoopsQuery(options: VueApolloComposable.UseQueryOptions<GetConfig3dHoopsQuery, GetConfig3dHoopsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetConfig3dHoopsQuery, GetConfig3dHoopsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetConfig3dHoopsQuery, GetConfig3dHoopsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetConfig3dHoopsQuery, GetConfig3dHoopsQueryVariables>(GetConfig3dHoopsDocument, {}, options);
}
export function useGetConfig3dHoopsLazyQuery(options: VueApolloComposable.UseQueryOptions<GetConfig3dHoopsQuery, GetConfig3dHoopsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetConfig3dHoopsQuery, GetConfig3dHoopsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetConfig3dHoopsQuery, GetConfig3dHoopsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetConfig3dHoopsQuery, GetConfig3dHoopsQueryVariables>(GetConfig3dHoopsDocument, {}, options);
}
export type GetConfig3dHoopsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetConfig3dHoopsQuery, GetConfig3dHoopsQueryVariables>;
export const Mechanicsref3dExistsDocument = gql`
    query mechanicsref3dExists($filter: MechanicFilter, $assetId: ID, $productId: ID) {
  mechanics(filter: $filter, assetId: $assetId, productId: $productId) {
    mechanics {
      cursor
      node {
        id
        reference3d
      }
    }
  }
}
    `;

/**
 * __useMechanicsref3dExistsQuery__
 *
 * To run a query within a Vue component, call `useMechanicsref3dExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicsref3dExistsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMechanicsref3dExistsQuery({
 *   filter: // value for 'filter'
 *   assetId: // value for 'assetId'
 *   productId: // value for 'productId'
 * });
 */
export function useMechanicsref3dExistsQuery(variables: Mechanicsref3dExistsQueryVariables | VueCompositionApi.Ref<Mechanicsref3dExistsQueryVariables> | ReactiveFunction<Mechanicsref3dExistsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Mechanicsref3dExistsQuery, Mechanicsref3dExistsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Mechanicsref3dExistsQuery, Mechanicsref3dExistsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Mechanicsref3dExistsQuery, Mechanicsref3dExistsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Mechanicsref3dExistsQuery, Mechanicsref3dExistsQueryVariables>(Mechanicsref3dExistsDocument, variables, options);
}
export function useMechanicsref3dExistsLazyQuery(variables: Mechanicsref3dExistsQueryVariables | VueCompositionApi.Ref<Mechanicsref3dExistsQueryVariables> | ReactiveFunction<Mechanicsref3dExistsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Mechanicsref3dExistsQuery, Mechanicsref3dExistsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Mechanicsref3dExistsQuery, Mechanicsref3dExistsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Mechanicsref3dExistsQuery, Mechanicsref3dExistsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Mechanicsref3dExistsQuery, Mechanicsref3dExistsQueryVariables>(Mechanicsref3dExistsDocument, variables, options);
}
export type Mechanicsref3dExistsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Mechanicsref3dExistsQuery, Mechanicsref3dExistsQueryVariables>;
export const AssembliesForTreeDocument = gql`
    query AssembliesForTree($acceptedLanguages: [LanguageWithWildcard!], $first: NonNegativeInt, $after: String, $sort: [MechanicSort], $filter: MechanicFilter, $productId: ID, $assetId: ID) {
  mechanics(filter: $filter, productId: $productId, assetId: $assetId) {
    mechanics(first: $first, after: $after, sort: $sort) {
      node {
        articleNumber
        assemblyId
        id
        localizations {
          title(acceptedLanguages: $acceptedLanguages)
        }
        parentAssemblyId
        previewImage {
          url
          blobId
        }
      }
      cursor
    }
  }
}
    `;

/**
 * __useAssembliesForTreeQuery__
 *
 * To run a query within a Vue component, call `useAssembliesForTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssembliesForTreeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAssembliesForTreeQuery({
 *   acceptedLanguages: // value for 'acceptedLanguages'
 *   first: // value for 'first'
 *   after: // value for 'after'
 *   sort: // value for 'sort'
 *   filter: // value for 'filter'
 *   productId: // value for 'productId'
 *   assetId: // value for 'assetId'
 * });
 */
export function useAssembliesForTreeQuery(variables: AssembliesForTreeQueryVariables | VueCompositionApi.Ref<AssembliesForTreeQueryVariables> | ReactiveFunction<AssembliesForTreeQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<AssembliesForTreeQuery, AssembliesForTreeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AssembliesForTreeQuery, AssembliesForTreeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AssembliesForTreeQuery, AssembliesForTreeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AssembliesForTreeQuery, AssembliesForTreeQueryVariables>(AssembliesForTreeDocument, variables, options);
}
export function useAssembliesForTreeLazyQuery(variables: AssembliesForTreeQueryVariables | VueCompositionApi.Ref<AssembliesForTreeQueryVariables> | ReactiveFunction<AssembliesForTreeQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<AssembliesForTreeQuery, AssembliesForTreeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AssembliesForTreeQuery, AssembliesForTreeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AssembliesForTreeQuery, AssembliesForTreeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AssembliesForTreeQuery, AssembliesForTreeQueryVariables>(AssembliesForTreeDocument, variables, options);
}
export type AssembliesForTreeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AssembliesForTreeQuery, AssembliesForTreeQueryVariables>;
export const AssemblyHasChildrenDocument = gql`
    query AssemblyHasChildren($filter: MechanicFilter, $productId: ID, $assetId: ID) {
  mechanics(filter: $filter, productId: $productId, assetId: $assetId) {
    mechanics(first: 1) {
      node {
        assemblyId
        id
      }
    }
  }
}
    `;

/**
 * __useAssemblyHasChildrenQuery__
 *
 * To run a query within a Vue component, call `useAssemblyHasChildrenQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssemblyHasChildrenQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAssemblyHasChildrenQuery({
 *   filter: // value for 'filter'
 *   productId: // value for 'productId'
 *   assetId: // value for 'assetId'
 * });
 */
export function useAssemblyHasChildrenQuery(variables: AssemblyHasChildrenQueryVariables | VueCompositionApi.Ref<AssemblyHasChildrenQueryVariables> | ReactiveFunction<AssemblyHasChildrenQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<AssemblyHasChildrenQuery, AssemblyHasChildrenQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AssemblyHasChildrenQuery, AssemblyHasChildrenQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AssemblyHasChildrenQuery, AssemblyHasChildrenQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AssemblyHasChildrenQuery, AssemblyHasChildrenQueryVariables>(AssemblyHasChildrenDocument, variables, options);
}
export function useAssemblyHasChildrenLazyQuery(variables: AssemblyHasChildrenQueryVariables | VueCompositionApi.Ref<AssemblyHasChildrenQueryVariables> | ReactiveFunction<AssemblyHasChildrenQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<AssemblyHasChildrenQuery, AssemblyHasChildrenQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AssemblyHasChildrenQuery, AssemblyHasChildrenQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AssemblyHasChildrenQuery, AssemblyHasChildrenQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AssemblyHasChildrenQuery, AssemblyHasChildrenQueryVariables>(AssemblyHasChildrenDocument, variables, options);
}
export type AssemblyHasChildrenQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AssemblyHasChildrenQuery, AssemblyHasChildrenQueryVariables>;
export const MechanicsLocationsDocument = gql`
    query mechanicsLocations($filter: MechanicFilter, $assetId: ID, $productId: ID!, $acceptedLanguages: [LanguageWithWildcard!]) {
  mechanics(filter: $filter, assetId: $assetId, productId: $productId) {
    mechanics {
      node {
        id
        articleId
        localizations {
          title(acceptedLanguages: $acceptedLanguages)
        }
        pathsToRoot {
          path {
            mechanicId
            mechanic {
              id
              assemblyId
              articleId
              isAssembly
              reference3d
              localizations {
                title(acceptedLanguages: $acceptedLanguages)
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useMechanicsLocationsQuery__
 *
 * To run a query within a Vue component, call `useMechanicsLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicsLocationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMechanicsLocationsQuery({
 *   filter: // value for 'filter'
 *   assetId: // value for 'assetId'
 *   productId: // value for 'productId'
 *   acceptedLanguages: // value for 'acceptedLanguages'
 * });
 */
export function useMechanicsLocationsQuery(variables: MechanicsLocationsQueryVariables | VueCompositionApi.Ref<MechanicsLocationsQueryVariables> | ReactiveFunction<MechanicsLocationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<MechanicsLocationsQuery, MechanicsLocationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MechanicsLocationsQuery, MechanicsLocationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MechanicsLocationsQuery, MechanicsLocationsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MechanicsLocationsQuery, MechanicsLocationsQueryVariables>(MechanicsLocationsDocument, variables, options);
}
export function useMechanicsLocationsLazyQuery(variables: MechanicsLocationsQueryVariables | VueCompositionApi.Ref<MechanicsLocationsQueryVariables> | ReactiveFunction<MechanicsLocationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<MechanicsLocationsQuery, MechanicsLocationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MechanicsLocationsQuery, MechanicsLocationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MechanicsLocationsQuery, MechanicsLocationsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<MechanicsLocationsQuery, MechanicsLocationsQueryVariables>(MechanicsLocationsDocument, variables, options);
}
export type MechanicsLocationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MechanicsLocationsQuery, MechanicsLocationsQueryVariables>;
export const MechanicArticleDocument = gql`
    query mechanicArticle($mechanicId: String!, $acceptedLanguages: [LanguageWithWildcard!]) {
  mechanic(id: $mechanicId) {
    id
    assemblyId
    parentAssemblyId
    articleId
    isAssembly
    itemNumber
    articleNumber
    localizations {
      title(acceptedLanguages: $acceptedLanguages)
    }
  }
}
    `;

/**
 * __useMechanicArticleQuery__
 *
 * To run a query within a Vue component, call `useMechanicArticleQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicArticleQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMechanicArticleQuery({
 *   mechanicId: // value for 'mechanicId'
 *   acceptedLanguages: // value for 'acceptedLanguages'
 * });
 */
export function useMechanicArticleQuery(variables: MechanicArticleQueryVariables | VueCompositionApi.Ref<MechanicArticleQueryVariables> | ReactiveFunction<MechanicArticleQueryVariables>, options: VueApolloComposable.UseQueryOptions<MechanicArticleQuery, MechanicArticleQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MechanicArticleQuery, MechanicArticleQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MechanicArticleQuery, MechanicArticleQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MechanicArticleQuery, MechanicArticleQueryVariables>(MechanicArticleDocument, variables, options);
}
export function useMechanicArticleLazyQuery(variables: MechanicArticleQueryVariables | VueCompositionApi.Ref<MechanicArticleQueryVariables> | ReactiveFunction<MechanicArticleQueryVariables>, options: VueApolloComposable.UseQueryOptions<MechanicArticleQuery, MechanicArticleQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MechanicArticleQuery, MechanicArticleQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MechanicArticleQuery, MechanicArticleQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<MechanicArticleQuery, MechanicArticleQueryVariables>(MechanicArticleDocument, variables, options);
}
export type MechanicArticleQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MechanicArticleQuery, MechanicArticleQueryVariables>;
export const MechanicHotspotDocument = gql`
    query mechanicHotspot($filter: MechanicFilter, $acceptedLanguages: [LanguageWithWildcard!], $first: NonNegativeInt) {
  mechanics(filter: $filter) {
    mechanics(first: $first) {
      node {
        id
        assemblyId
        parentAssemblyId
        articleId
        isAssembly
        reference2d
        reference3d
        articleNumber
        localizations {
          title(acceptedLanguages: $acceptedLanguages)
        }
        previewImage {
          blobId
          url
          mimeType
        }
      }
    }
  }
}
    `;

/**
 * __useMechanicHotspotQuery__
 *
 * To run a query within a Vue component, call `useMechanicHotspotQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicHotspotQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMechanicHotspotQuery({
 *   filter: // value for 'filter'
 *   acceptedLanguages: // value for 'acceptedLanguages'
 *   first: // value for 'first'
 * });
 */
export function useMechanicHotspotQuery(variables: MechanicHotspotQueryVariables | VueCompositionApi.Ref<MechanicHotspotQueryVariables> | ReactiveFunction<MechanicHotspotQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<MechanicHotspotQuery, MechanicHotspotQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MechanicHotspotQuery, MechanicHotspotQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MechanicHotspotQuery, MechanicHotspotQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MechanicHotspotQuery, MechanicHotspotQueryVariables>(MechanicHotspotDocument, variables, options);
}
export function useMechanicHotspotLazyQuery(variables: MechanicHotspotQueryVariables | VueCompositionApi.Ref<MechanicHotspotQueryVariables> | ReactiveFunction<MechanicHotspotQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<MechanicHotspotQuery, MechanicHotspotQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MechanicHotspotQuery, MechanicHotspotQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MechanicHotspotQuery, MechanicHotspotQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<MechanicHotspotQuery, MechanicHotspotQueryVariables>(MechanicHotspotDocument, variables, options);
}
export type MechanicHotspotQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MechanicHotspotQuery, MechanicHotspotQueryVariables>;
export const MechanicsParentAssemblyDocument = gql`
    query mechanicsParentAssembly($filter: MechanicFilter, $assetId: ID, $productId: ID) {
  mechanics(filter: $filter, assetId: $assetId, productId: $productId) {
    mechanics {
      node {
        assemblyId
        articleId
        parentAssemblyId
      }
    }
  }
}
    `;

/**
 * __useMechanicsParentAssemblyQuery__
 *
 * To run a query within a Vue component, call `useMechanicsParentAssemblyQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicsParentAssemblyQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMechanicsParentAssemblyQuery({
 *   filter: // value for 'filter'
 *   assetId: // value for 'assetId'
 *   productId: // value for 'productId'
 * });
 */
export function useMechanicsParentAssemblyQuery(variables: MechanicsParentAssemblyQueryVariables | VueCompositionApi.Ref<MechanicsParentAssemblyQueryVariables> | ReactiveFunction<MechanicsParentAssemblyQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<MechanicsParentAssemblyQuery, MechanicsParentAssemblyQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MechanicsParentAssemblyQuery, MechanicsParentAssemblyQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MechanicsParentAssemblyQuery, MechanicsParentAssemblyQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MechanicsParentAssemblyQuery, MechanicsParentAssemblyQueryVariables>(MechanicsParentAssemblyDocument, variables, options);
}
export function useMechanicsParentAssemblyLazyQuery(variables: MechanicsParentAssemblyQueryVariables | VueCompositionApi.Ref<MechanicsParentAssemblyQueryVariables> | ReactiveFunction<MechanicsParentAssemblyQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<MechanicsParentAssemblyQuery, MechanicsParentAssemblyQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MechanicsParentAssemblyQuery, MechanicsParentAssemblyQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MechanicsParentAssemblyQuery, MechanicsParentAssemblyQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<MechanicsParentAssemblyQuery, MechanicsParentAssemblyQueryVariables>(MechanicsParentAssemblyDocument, variables, options);
}
export type MechanicsParentAssemblyQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MechanicsParentAssemblyQuery, MechanicsParentAssemblyQueryVariables>;
export const ArticleUsedInAssetsDocument = gql`
    query articleUsedInAssets($filter: MechanicFilter, $assetsFirst: NonNegativeInt, $assetsAfter: String, $mechanicsFirst: NonNegativeInt, $mechanicsAfter: String) {
  mechanics(filter: $filter) {
    mechanics(first: $mechanicsFirst, after: $mechanicsAfter) {
      node {
        id
        usedInAssets {
          assets {
            assets(first: $assetsFirst, after: $assetsAfter) {
              node {
                assetId
                id
              }
              cursor
            }
          }
        }
      }
      cursor
    }
  }
}
    `;

/**
 * __useArticleUsedInAssetsQuery__
 *
 * To run a query within a Vue component, call `useArticleUsedInAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleUsedInAssetsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useArticleUsedInAssetsQuery({
 *   filter: // value for 'filter'
 *   assetsFirst: // value for 'assetsFirst'
 *   assetsAfter: // value for 'assetsAfter'
 *   mechanicsFirst: // value for 'mechanicsFirst'
 *   mechanicsAfter: // value for 'mechanicsAfter'
 * });
 */
export function useArticleUsedInAssetsQuery(variables: ArticleUsedInAssetsQueryVariables | VueCompositionApi.Ref<ArticleUsedInAssetsQueryVariables> | ReactiveFunction<ArticleUsedInAssetsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ArticleUsedInAssetsQuery, ArticleUsedInAssetsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ArticleUsedInAssetsQuery, ArticleUsedInAssetsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ArticleUsedInAssetsQuery, ArticleUsedInAssetsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ArticleUsedInAssetsQuery, ArticleUsedInAssetsQueryVariables>(ArticleUsedInAssetsDocument, variables, options);
}
export function useArticleUsedInAssetsLazyQuery(variables: ArticleUsedInAssetsQueryVariables | VueCompositionApi.Ref<ArticleUsedInAssetsQueryVariables> | ReactiveFunction<ArticleUsedInAssetsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ArticleUsedInAssetsQuery, ArticleUsedInAssetsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ArticleUsedInAssetsQuery, ArticleUsedInAssetsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ArticleUsedInAssetsQuery, ArticleUsedInAssetsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ArticleUsedInAssetsQuery, ArticleUsedInAssetsQueryVariables>(ArticleUsedInAssetsDocument, variables, options);
}
export type ArticleUsedInAssetsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ArticleUsedInAssetsQuery, ArticleUsedInAssetsQueryVariables>;
export const ArticleUsedInProductsDocument = gql`
    query articleUsedInProducts($filter: MechanicFilter, $productsFirst: NonNegativeInt, $productsAfter: String) {
  mechanicsUsedInProducts: mechanics(filter: $filter) {
    usedInProducts {
      products {
        products(first: $productsFirst, after: $productsAfter) {
          node {
            id
          }
          cursor
        }
      }
    }
  }
}
    `;

/**
 * __useArticleUsedInProductsQuery__
 *
 * To run a query within a Vue component, call `useArticleUsedInProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleUsedInProductsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useArticleUsedInProductsQuery({
 *   filter: // value for 'filter'
 *   productsFirst: // value for 'productsFirst'
 *   productsAfter: // value for 'productsAfter'
 * });
 */
export function useArticleUsedInProductsQuery(variables: ArticleUsedInProductsQueryVariables | VueCompositionApi.Ref<ArticleUsedInProductsQueryVariables> | ReactiveFunction<ArticleUsedInProductsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ArticleUsedInProductsQuery, ArticleUsedInProductsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ArticleUsedInProductsQuery, ArticleUsedInProductsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ArticleUsedInProductsQuery, ArticleUsedInProductsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ArticleUsedInProductsQuery, ArticleUsedInProductsQueryVariables>(ArticleUsedInProductsDocument, variables, options);
}
export function useArticleUsedInProductsLazyQuery(variables: ArticleUsedInProductsQueryVariables | VueCompositionApi.Ref<ArticleUsedInProductsQueryVariables> | ReactiveFunction<ArticleUsedInProductsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ArticleUsedInProductsQuery, ArticleUsedInProductsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ArticleUsedInProductsQuery, ArticleUsedInProductsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ArticleUsedInProductsQuery, ArticleUsedInProductsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ArticleUsedInProductsQuery, ArticleUsedInProductsQueryVariables>(ArticleUsedInProductsDocument, variables, options);
}
export type ArticleUsedInProductsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ArticleUsedInProductsQuery, ArticleUsedInProductsQueryVariables>;
export const MechanicsAssemblyTitleDocument = gql`
    query mechanicsAssemblyTitle($filter: MechanicFilter, $assetId: ID, $productId: ID, $acceptedLanguages: [LanguageWithWildcard!]) {
  mechanics(filter: $filter, assetId: $assetId, productId: $productId) {
    mechanics {
      node {
        assemblyId
        articleId
        articleNumber
        localizations {
          title(acceptedLanguages: $acceptedLanguages)
        }
      }
    }
  }
}
    `;

/**
 * __useMechanicsAssemblyTitleQuery__
 *
 * To run a query within a Vue component, call `useMechanicsAssemblyTitleQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicsAssemblyTitleQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMechanicsAssemblyTitleQuery({
 *   filter: // value for 'filter'
 *   assetId: // value for 'assetId'
 *   productId: // value for 'productId'
 *   acceptedLanguages: // value for 'acceptedLanguages'
 * });
 */
export function useMechanicsAssemblyTitleQuery(variables: MechanicsAssemblyTitleQueryVariables | VueCompositionApi.Ref<MechanicsAssemblyTitleQueryVariables> | ReactiveFunction<MechanicsAssemblyTitleQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<MechanicsAssemblyTitleQuery, MechanicsAssemblyTitleQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MechanicsAssemblyTitleQuery, MechanicsAssemblyTitleQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MechanicsAssemblyTitleQuery, MechanicsAssemblyTitleQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MechanicsAssemblyTitleQuery, MechanicsAssemblyTitleQueryVariables>(MechanicsAssemblyTitleDocument, variables, options);
}
export function useMechanicsAssemblyTitleLazyQuery(variables: MechanicsAssemblyTitleQueryVariables | VueCompositionApi.Ref<MechanicsAssemblyTitleQueryVariables> | ReactiveFunction<MechanicsAssemblyTitleQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<MechanicsAssemblyTitleQuery, MechanicsAssemblyTitleQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MechanicsAssemblyTitleQuery, MechanicsAssemblyTitleQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MechanicsAssemblyTitleQuery, MechanicsAssemblyTitleQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<MechanicsAssemblyTitleQuery, MechanicsAssemblyTitleQueryVariables>(MechanicsAssemblyTitleDocument, variables, options);
}
export type MechanicsAssemblyTitleQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MechanicsAssemblyTitleQuery, MechanicsAssemblyTitleQueryVariables>;
export const AvailablePartsListDocument = gql`
    query availablePartsList($filter: MechanicFilter, $assetId: ID, $productId: ID, $first: NonNegativeInt, $after: String) {
  mechanics(filter: $filter, assetId: $assetId, productId: $productId) {
    mechanics(first: $first, after: $after) {
      node {
        id
        assemblyId
      }
    }
  }
}
    `;

/**
 * __useAvailablePartsListQuery__
 *
 * To run a query within a Vue component, call `useAvailablePartsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailablePartsListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAvailablePartsListQuery({
 *   filter: // value for 'filter'
 *   assetId: // value for 'assetId'
 *   productId: // value for 'productId'
 *   first: // value for 'first'
 *   after: // value for 'after'
 * });
 */
export function useAvailablePartsListQuery(variables: AvailablePartsListQueryVariables | VueCompositionApi.Ref<AvailablePartsListQueryVariables> | ReactiveFunction<AvailablePartsListQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<AvailablePartsListQuery, AvailablePartsListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AvailablePartsListQuery, AvailablePartsListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AvailablePartsListQuery, AvailablePartsListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AvailablePartsListQuery, AvailablePartsListQueryVariables>(AvailablePartsListDocument, variables, options);
}
export function useAvailablePartsListLazyQuery(variables: AvailablePartsListQueryVariables | VueCompositionApi.Ref<AvailablePartsListQueryVariables> | ReactiveFunction<AvailablePartsListQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<AvailablePartsListQuery, AvailablePartsListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AvailablePartsListQuery, AvailablePartsListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AvailablePartsListQuery, AvailablePartsListQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AvailablePartsListQuery, AvailablePartsListQueryVariables>(AvailablePartsListDocument, variables, options);
}
export type AvailablePartsListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AvailablePartsListQuery, AvailablePartsListQueryVariables>;
export const PartslistFilesDocument = gql`
    query partslistFiles($filter: MechanicFilter, $assetId: ID, $productId: ID, $first: NonNegativeInt) {
  mechanics(filter: $filter, assetId: $assetId, productId: $productId) {
    mechanics(first: $first) {
      node {
        id
        files {
          objectType
          objectSubType
          file {
            blobId
            url
            mimeType
          }
          ... on FileWithHotspots {
            hotspots {
              x1
              x2
              y1
              y2
              linkType
              linkValue
            }
          }
          ... on FileSvgWithHotspots {
            hotspots {
              linkText
              linkType
              linkValue
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePartslistFilesQuery__
 *
 * To run a query within a Vue component, call `usePartslistFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartslistFilesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePartslistFilesQuery({
 *   filter: // value for 'filter'
 *   assetId: // value for 'assetId'
 *   productId: // value for 'productId'
 *   first: // value for 'first'
 * });
 */
export function usePartslistFilesQuery(variables: PartslistFilesQueryVariables | VueCompositionApi.Ref<PartslistFilesQueryVariables> | ReactiveFunction<PartslistFilesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<PartslistFilesQuery, PartslistFilesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PartslistFilesQuery, PartslistFilesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PartslistFilesQuery, PartslistFilesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PartslistFilesQuery, PartslistFilesQueryVariables>(PartslistFilesDocument, variables, options);
}
export function usePartslistFilesLazyQuery(variables: PartslistFilesQueryVariables | VueCompositionApi.Ref<PartslistFilesQueryVariables> | ReactiveFunction<PartslistFilesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<PartslistFilesQuery, PartslistFilesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PartslistFilesQuery, PartslistFilesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PartslistFilesQuery, PartslistFilesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<PartslistFilesQuery, PartslistFilesQueryVariables>(PartslistFilesDocument, variables, options);
}
export type PartslistFilesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PartslistFilesQuery, PartslistFilesQueryVariables>;
export const MechanicProcessDocument = gql`
    query mechanicProcess($processId: String!) {
  process(id: $processId) {
    id
    processType
    name
    columns
    filenameSchemaName
    deleteAll
    mappingOptions {
      type
      upToChar
    }
    delimiter
    escape
    encoding
  }
}
    `;

/**
 * __useMechanicProcessQuery__
 *
 * To run a query within a Vue component, call `useMechanicProcessQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicProcessQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMechanicProcessQuery({
 *   processId: // value for 'processId'
 * });
 */
export function useMechanicProcessQuery(variables: MechanicProcessQueryVariables | VueCompositionApi.Ref<MechanicProcessQueryVariables> | ReactiveFunction<MechanicProcessQueryVariables>, options: VueApolloComposable.UseQueryOptions<MechanicProcessQuery, MechanicProcessQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MechanicProcessQuery, MechanicProcessQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MechanicProcessQuery, MechanicProcessQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MechanicProcessQuery, MechanicProcessQueryVariables>(MechanicProcessDocument, variables, options);
}
export function useMechanicProcessLazyQuery(variables: MechanicProcessQueryVariables | VueCompositionApi.Ref<MechanicProcessQueryVariables> | ReactiveFunction<MechanicProcessQueryVariables>, options: VueApolloComposable.UseQueryOptions<MechanicProcessQuery, MechanicProcessQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MechanicProcessQuery, MechanicProcessQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MechanicProcessQuery, MechanicProcessQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<MechanicProcessQuery, MechanicProcessQueryVariables>(MechanicProcessDocument, variables, options);
}
export type MechanicProcessQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MechanicProcessQuery, MechanicProcessQueryVariables>;
export const ProcessDatafieldMappingsDocument = gql`
    query ProcessDatafieldMappings($processType: ProcessType!, $columns: [String!]!, $acceptedLanguages: [LanguageWithWildcard!]) {
  processDatafieldMappings(processType: $processType, columns: $columns) {
    column
    ambiguousColumns
    field {
      fieldType
      referencedId
      type
      localizations {
        title(acceptedLanguages: $acceptedLanguages)
      }
    }
    ... on MultilingualDatafieldMapping {
      language
    }
    ... on RangeDatafieldMapping {
      operator
    }
  }
}
    `;

/**
 * __useProcessDatafieldMappingsQuery__
 *
 * To run a query within a Vue component, call `useProcessDatafieldMappingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessDatafieldMappingsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProcessDatafieldMappingsQuery({
 *   processType: // value for 'processType'
 *   columns: // value for 'columns'
 *   acceptedLanguages: // value for 'acceptedLanguages'
 * });
 */
export function useProcessDatafieldMappingsQuery(variables: ProcessDatafieldMappingsQueryVariables | VueCompositionApi.Ref<ProcessDatafieldMappingsQueryVariables> | ReactiveFunction<ProcessDatafieldMappingsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProcessDatafieldMappingsQuery, ProcessDatafieldMappingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProcessDatafieldMappingsQuery, ProcessDatafieldMappingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProcessDatafieldMappingsQuery, ProcessDatafieldMappingsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProcessDatafieldMappingsQuery, ProcessDatafieldMappingsQueryVariables>(ProcessDatafieldMappingsDocument, variables, options);
}
export function useProcessDatafieldMappingsLazyQuery(variables: ProcessDatafieldMappingsQueryVariables | VueCompositionApi.Ref<ProcessDatafieldMappingsQueryVariables> | ReactiveFunction<ProcessDatafieldMappingsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProcessDatafieldMappingsQuery, ProcessDatafieldMappingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProcessDatafieldMappingsQuery, ProcessDatafieldMappingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProcessDatafieldMappingsQuery, ProcessDatafieldMappingsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProcessDatafieldMappingsQuery, ProcessDatafieldMappingsQueryVariables>(ProcessDatafieldMappingsDocument, variables, options);
}
export type ProcessDatafieldMappingsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProcessDatafieldMappingsQuery, ProcessDatafieldMappingsQueryVariables>;
export const ProductDocument = gql`
    query product($id: String!, $acceptedLanguages: [LanguageWithWildcard!]) {
  product(id: $id) {
    id
    referenceId
    localizations {
      title(acceptedLanguages: $acceptedLanguages)
    }
  }
}
    `;

/**
 * __useProductQuery__
 *
 * To run a query within a Vue component, call `useProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProductQuery({
 *   id: // value for 'id'
 *   acceptedLanguages: // value for 'acceptedLanguages'
 * });
 */
export function useProductQuery(variables: ProductQueryVariables | VueCompositionApi.Ref<ProductQueryVariables> | ReactiveFunction<ProductQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProductQuery, ProductQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProductQuery, ProductQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProductQuery, ProductQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProductQuery, ProductQueryVariables>(ProductDocument, variables, options);
}
export function useProductLazyQuery(variables: ProductQueryVariables | VueCompositionApi.Ref<ProductQueryVariables> | ReactiveFunction<ProductQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProductQuery, ProductQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProductQuery, ProductQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProductQuery, ProductQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProductQuery, ProductQueryVariables>(ProductDocument, variables, options);
}
export type ProductQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProductQuery, ProductQueryVariables>;
export const GetItemByIdDocument = gql`
    query GetItemById($schematicId: ID!, $itemId: String!) {
  items(schematicId: $schematicId, filter: {equals: {itemId: $itemId}}) {
    items(first: 1) {
      node {
        id
        schematicId
        itemId
        type
        parentItemId
        name
        nodecaption
        title {
          en
          de
          es
          fr
          it
          ja
          zh
        }
        mainSheet
        mainHotspotId
        isSubItem
      }
      cursor
      score
    }
    total {
      count
      countRelation
    }
  }
}
    `;

/**
 * __useGetItemByIdQuery__
 *
 * To run a query within a Vue component, call `useGetItemByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItemByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetItemByIdQuery({
 *   schematicId: // value for 'schematicId'
 *   itemId: // value for 'itemId'
 * });
 */
export function useGetItemByIdQuery(variables: GetItemByIdQueryVariables | VueCompositionApi.Ref<GetItemByIdQueryVariables> | ReactiveFunction<GetItemByIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetItemByIdQuery, GetItemByIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetItemByIdQuery, GetItemByIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetItemByIdQuery, GetItemByIdQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetItemByIdQuery, GetItemByIdQueryVariables>(GetItemByIdDocument, variables, options);
}
export function useGetItemByIdLazyQuery(variables: GetItemByIdQueryVariables | VueCompositionApi.Ref<GetItemByIdQueryVariables> | ReactiveFunction<GetItemByIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetItemByIdQuery, GetItemByIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetItemByIdQuery, GetItemByIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetItemByIdQuery, GetItemByIdQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetItemByIdQuery, GetItemByIdQueryVariables>(GetItemByIdDocument, variables, options);
}
export type GetItemByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetItemByIdQuery, GetItemByIdQueryVariables>;
export const GetItemsByParentDocument = gql`
    query GetItemsByParent($schematicId: ID!, $parentItemId: String!, $first: NonNegativeInt = 50, $after: String) {
  items(
    schematicId: $schematicId
    filter: {equals: {parentItemId: $parentItemId}}
  ) {
    items(first: $first, after: $after) {
      node {
        id
        schematicId
        itemId
        type
        parentItemId
        name
        nodecaption
        title {
          en
          de
          es
          fr
          it
          ja
          zh
        }
        mainSheet
        mainHotspotId
        isSubItem
      }
      cursor
      score
    }
    total {
      count
      countRelation
    }
  }
}
    `;

/**
 * __useGetItemsByParentQuery__
 *
 * To run a query within a Vue component, call `useGetItemsByParentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItemsByParentQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetItemsByParentQuery({
 *   schematicId: // value for 'schematicId'
 *   parentItemId: // value for 'parentItemId'
 *   first: // value for 'first'
 *   after: // value for 'after'
 * });
 */
export function useGetItemsByParentQuery(variables: GetItemsByParentQueryVariables | VueCompositionApi.Ref<GetItemsByParentQueryVariables> | ReactiveFunction<GetItemsByParentQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetItemsByParentQuery, GetItemsByParentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetItemsByParentQuery, GetItemsByParentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetItemsByParentQuery, GetItemsByParentQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetItemsByParentQuery, GetItemsByParentQueryVariables>(GetItemsByParentDocument, variables, options);
}
export function useGetItemsByParentLazyQuery(variables: GetItemsByParentQueryVariables | VueCompositionApi.Ref<GetItemsByParentQueryVariables> | ReactiveFunction<GetItemsByParentQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetItemsByParentQuery, GetItemsByParentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetItemsByParentQuery, GetItemsByParentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetItemsByParentQuery, GetItemsByParentQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetItemsByParentQuery, GetItemsByParentQueryVariables>(GetItemsByParentDocument, variables, options);
}
export type GetItemsByParentQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetItemsByParentQuery, GetItemsByParentQueryVariables>;
export const GetPartsBySchematicIdDocument = gql`
    query GetPartsBySchematicId($schematicId: ID!, $first: NonNegativeInt = 20, $after: String) {
  parts(schematicId: $schematicId) {
    parts(first: $first, after: $after) {
      node {
        id
        schematicId
        partNo
        linkPartNo
        visiblePartNo
        orderNo
        title {
          en
          de
          es
          fr
          it
          ja
          zh
        }
        data {
          key
          value
        }
      }
      cursor
      score
    }
    total {
      count
      countRelation
    }
  }
}
    `;

/**
 * __useGetPartsBySchematicIdQuery__
 *
 * To run a query within a Vue component, call `useGetPartsBySchematicIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartsBySchematicIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPartsBySchematicIdQuery({
 *   schematicId: // value for 'schematicId'
 *   first: // value for 'first'
 *   after: // value for 'after'
 * });
 */
export function useGetPartsBySchematicIdQuery(variables: GetPartsBySchematicIdQueryVariables | VueCompositionApi.Ref<GetPartsBySchematicIdQueryVariables> | ReactiveFunction<GetPartsBySchematicIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPartsBySchematicIdQuery, GetPartsBySchematicIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPartsBySchematicIdQuery, GetPartsBySchematicIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPartsBySchematicIdQuery, GetPartsBySchematicIdQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPartsBySchematicIdQuery, GetPartsBySchematicIdQueryVariables>(GetPartsBySchematicIdDocument, variables, options);
}
export function useGetPartsBySchematicIdLazyQuery(variables: GetPartsBySchematicIdQueryVariables | VueCompositionApi.Ref<GetPartsBySchematicIdQueryVariables> | ReactiveFunction<GetPartsBySchematicIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPartsBySchematicIdQuery, GetPartsBySchematicIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPartsBySchematicIdQuery, GetPartsBySchematicIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPartsBySchematicIdQuery, GetPartsBySchematicIdQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetPartsBySchematicIdQuery, GetPartsBySchematicIdQueryVariables>(GetPartsBySchematicIdDocument, variables, options);
}
export type GetPartsBySchematicIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPartsBySchematicIdQuery, GetPartsBySchematicIdQueryVariables>;
export const GetSchematicApiVersionDocument = gql`
    query GetSchematicApiVersion {
  schematicApiVersion
}
    `;

/**
 * __useGetSchematicApiVersionQuery__
 *
 * To run a query within a Vue component, call `useGetSchematicApiVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchematicApiVersionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSchematicApiVersionQuery();
 */
export function useGetSchematicApiVersionQuery(options: VueApolloComposable.UseQueryOptions<GetSchematicApiVersionQuery, GetSchematicApiVersionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetSchematicApiVersionQuery, GetSchematicApiVersionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetSchematicApiVersionQuery, GetSchematicApiVersionQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetSchematicApiVersionQuery, GetSchematicApiVersionQueryVariables>(GetSchematicApiVersionDocument, {}, options);
}
export function useGetSchematicApiVersionLazyQuery(options: VueApolloComposable.UseQueryOptions<GetSchematicApiVersionQuery, GetSchematicApiVersionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetSchematicApiVersionQuery, GetSchematicApiVersionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetSchematicApiVersionQuery, GetSchematicApiVersionQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetSchematicApiVersionQuery, GetSchematicApiVersionQueryVariables>(GetSchematicApiVersionDocument, {}, options);
}
export type GetSchematicApiVersionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetSchematicApiVersionQuery, GetSchematicApiVersionQueryVariables>;
export const GetAllSchematicsDocument = gql`
    query GetAllSchematics {
  schematics {
    generator
    id
    lang
    scale
    title
    translations
  }
}
    `;

/**
 * __useGetAllSchematicsQuery__
 *
 * To run a query within a Vue component, call `useGetAllSchematicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSchematicsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllSchematicsQuery();
 */
export function useGetAllSchematicsQuery(options: VueApolloComposable.UseQueryOptions<GetAllSchematicsQuery, GetAllSchematicsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAllSchematicsQuery, GetAllSchematicsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAllSchematicsQuery, GetAllSchematicsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetAllSchematicsQuery, GetAllSchematicsQueryVariables>(GetAllSchematicsDocument, {}, options);
}
export function useGetAllSchematicsLazyQuery(options: VueApolloComposable.UseQueryOptions<GetAllSchematicsQuery, GetAllSchematicsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAllSchematicsQuery, GetAllSchematicsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAllSchematicsQuery, GetAllSchematicsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetAllSchematicsQuery, GetAllSchematicsQueryVariables>(GetAllSchematicsDocument, {}, options);
}
export type GetAllSchematicsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetAllSchematicsQuery, GetAllSchematicsQueryVariables>;
export const GetStructsByParentDocument = gql`
    query GetStructsByParent($schematicId: ID!, $parentStructId: String!, $first: NonNegativeInt = 20, $after: String) {
  structs(
    schematicId: $schematicId
    filter: {equals: {parentStructId: $parentStructId}}
  ) {
    structs(first: $first, after: $after) {
      node {
        id
        schematicId
        structId
        parentStructId
        title {
          en
          de
          es
          fr
          it
          ja
          zh
        }
        files {
          id
          schemaId: objectId
          file {
            blobId
            url
            path
            mimeType
          }
          ... on FileSchematicWithHotspots {
            name
            hotspots {
              hotspotId
              x1
              x2
              y1
              y2
              itemType
              itemId
            }
          }
        }
      }
      cursor
      score
    }
    total {
      count
      countRelation
    }
  }
}
    `;

/**
 * __useGetStructsByParentQuery__
 *
 * To run a query within a Vue component, call `useGetStructsByParentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStructsByParentQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetStructsByParentQuery({
 *   schematicId: // value for 'schematicId'
 *   parentStructId: // value for 'parentStructId'
 *   first: // value for 'first'
 *   after: // value for 'after'
 * });
 */
export function useGetStructsByParentQuery(variables: GetStructsByParentQueryVariables | VueCompositionApi.Ref<GetStructsByParentQueryVariables> | ReactiveFunction<GetStructsByParentQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetStructsByParentQuery, GetStructsByParentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetStructsByParentQuery, GetStructsByParentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetStructsByParentQuery, GetStructsByParentQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetStructsByParentQuery, GetStructsByParentQueryVariables>(GetStructsByParentDocument, variables, options);
}
export function useGetStructsByParentLazyQuery(variables: GetStructsByParentQueryVariables | VueCompositionApi.Ref<GetStructsByParentQueryVariables> | ReactiveFunction<GetStructsByParentQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetStructsByParentQuery, GetStructsByParentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetStructsByParentQuery, GetStructsByParentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetStructsByParentQuery, GetStructsByParentQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetStructsByParentQuery, GetStructsByParentQueryVariables>(GetStructsByParentDocument, variables, options);
}
export type GetStructsByParentQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetStructsByParentQuery, GetStructsByParentQueryVariables>;
export const GetSchematicsByProductDocument = gql`
    query GetSchematicsByProduct($productId: ID) {
  schematics(productId: $productId) {
    id
    title
    generator
    lang
    scale
    translations
  }
}
    `;

/**
 * __useGetSchematicsByProductQuery__
 *
 * To run a query within a Vue component, call `useGetSchematicsByProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchematicsByProductQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSchematicsByProductQuery({
 *   productId: // value for 'productId'
 * });
 */
export function useGetSchematicsByProductQuery(variables: GetSchematicsByProductQueryVariables | VueCompositionApi.Ref<GetSchematicsByProductQueryVariables> | ReactiveFunction<GetSchematicsByProductQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetSchematicsByProductQuery, GetSchematicsByProductQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetSchematicsByProductQuery, GetSchematicsByProductQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetSchematicsByProductQuery, GetSchematicsByProductQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetSchematicsByProductQuery, GetSchematicsByProductQueryVariables>(GetSchematicsByProductDocument, variables, options);
}
export function useGetSchematicsByProductLazyQuery(variables: GetSchematicsByProductQueryVariables | VueCompositionApi.Ref<GetSchematicsByProductQueryVariables> | ReactiveFunction<GetSchematicsByProductQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetSchematicsByProductQuery, GetSchematicsByProductQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetSchematicsByProductQuery, GetSchematicsByProductQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetSchematicsByProductQuery, GetSchematicsByProductQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetSchematicsByProductQuery, GetSchematicsByProductQueryVariables>(GetSchematicsByProductDocument, variables, options);
}
export type GetSchematicsByProductQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetSchematicsByProductQuery, GetSchematicsByProductQueryVariables>;
export const GetFdiShopConfigDocument = gql`
    query GetFdiShopConfig {
  getFdiShopConfig {
    baseUrl
    id
    shopServiceUrl
  }
}
    `;

/**
 * __useGetFdiShopConfigQuery__
 *
 * To run a query within a Vue component, call `useGetFdiShopConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFdiShopConfigQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetFdiShopConfigQuery();
 */
export function useGetFdiShopConfigQuery(options: VueApolloComposable.UseQueryOptions<GetFdiShopConfigQuery, GetFdiShopConfigQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetFdiShopConfigQuery, GetFdiShopConfigQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetFdiShopConfigQuery, GetFdiShopConfigQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetFdiShopConfigQuery, GetFdiShopConfigQueryVariables>(GetFdiShopConfigDocument, {}, options);
}
export function useGetFdiShopConfigLazyQuery(options: VueApolloComposable.UseQueryOptions<GetFdiShopConfigQuery, GetFdiShopConfigQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetFdiShopConfigQuery, GetFdiShopConfigQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetFdiShopConfigQuery, GetFdiShopConfigQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetFdiShopConfigQuery, GetFdiShopConfigQueryVariables>(GetFdiShopConfigDocument, {}, options);
}
export type GetFdiShopConfigQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetFdiShopConfigQuery, GetFdiShopConfigQueryVariables>;
export const MySourceProviderDocument = gql`
    query mySourceProvider {
  me {
    sourceProvider
    id
  }
}
    `;

/**
 * __useMySourceProviderQuery__
 *
 * To run a query within a Vue component, call `useMySourceProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useMySourceProviderQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMySourceProviderQuery();
 */
export function useMySourceProviderQuery(options: VueApolloComposable.UseQueryOptions<MySourceProviderQuery, MySourceProviderQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MySourceProviderQuery, MySourceProviderQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MySourceProviderQuery, MySourceProviderQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MySourceProviderQuery, MySourceProviderQueryVariables>(MySourceProviderDocument, {}, options);
}
export function useMySourceProviderLazyQuery(options: VueApolloComposable.UseQueryOptions<MySourceProviderQuery, MySourceProviderQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MySourceProviderQuery, MySourceProviderQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MySourceProviderQuery, MySourceProviderQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<MySourceProviderQuery, MySourceProviderQueryVariables>(MySourceProviderDocument, {}, options);
}
export type MySourceProviderQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MySourceProviderQuery, MySourceProviderQueryVariables>;
export const GenericShopBasketDocument = gql`
    query GenericShopBasket {
  shopBasket {
    ...GenericShopBasketFields
  }
}
    ${GenericShopBasketFieldsFragmentDoc}`;

/**
 * __useGenericShopBasketQuery__
 *
 * To run a query within a Vue component, call `useGenericShopBasketQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenericShopBasketQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGenericShopBasketQuery();
 */
export function useGenericShopBasketQuery(options: VueApolloComposable.UseQueryOptions<GenericShopBasketQuery, GenericShopBasketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GenericShopBasketQuery, GenericShopBasketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GenericShopBasketQuery, GenericShopBasketQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GenericShopBasketQuery, GenericShopBasketQueryVariables>(GenericShopBasketDocument, {}, options);
}
export function useGenericShopBasketLazyQuery(options: VueApolloComposable.UseQueryOptions<GenericShopBasketQuery, GenericShopBasketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GenericShopBasketQuery, GenericShopBasketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GenericShopBasketQuery, GenericShopBasketQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GenericShopBasketQuery, GenericShopBasketQueryVariables>(GenericShopBasketDocument, {}, options);
}
export type GenericShopBasketQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GenericShopBasketQuery, GenericShopBasketQueryVariables>;
export const GenericShopBasketAddItemDocument = gql`
    mutation GenericShopBasketAddItem($item: ShopBasketAddItemInput!) {
  shopBasketAddItem(item: $item) {
    ...GenericShopBasketFields
  }
}
    ${GenericShopBasketFieldsFragmentDoc}`;

/**
 * __useGenericShopBasketAddItemMutation__
 *
 * To run a mutation, you first call `useGenericShopBasketAddItemMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useGenericShopBasketAddItemMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useGenericShopBasketAddItemMutation({
 *   variables: {
 *     item: // value for 'item'
 *   },
 * });
 */
export function useGenericShopBasketAddItemMutation(options: VueApolloComposable.UseMutationOptions<GenericShopBasketAddItemMutation, GenericShopBasketAddItemMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<GenericShopBasketAddItemMutation, GenericShopBasketAddItemMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<GenericShopBasketAddItemMutation, GenericShopBasketAddItemMutationVariables>(GenericShopBasketAddItemDocument, options);
}
export type GenericShopBasketAddItemMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<GenericShopBasketAddItemMutation, GenericShopBasketAddItemMutationVariables>;
export const GenericShopCheckoutUrlDocument = gql`
    query GenericShopCheckoutUrl($context: ShopRequestContextInput!) {
  shopCheckoutUrl(context: $context) {
    url
    expiresAt
  }
}
    `;

/**
 * __useGenericShopCheckoutUrlQuery__
 *
 * To run a query within a Vue component, call `useGenericShopCheckoutUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenericShopCheckoutUrlQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGenericShopCheckoutUrlQuery({
 *   context: // value for 'context'
 * });
 */
export function useGenericShopCheckoutUrlQuery(variables: GenericShopCheckoutUrlQueryVariables | VueCompositionApi.Ref<GenericShopCheckoutUrlQueryVariables> | ReactiveFunction<GenericShopCheckoutUrlQueryVariables>, options: VueApolloComposable.UseQueryOptions<GenericShopCheckoutUrlQuery, GenericShopCheckoutUrlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GenericShopCheckoutUrlQuery, GenericShopCheckoutUrlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GenericShopCheckoutUrlQuery, GenericShopCheckoutUrlQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GenericShopCheckoutUrlQuery, GenericShopCheckoutUrlQueryVariables>(GenericShopCheckoutUrlDocument, variables, options);
}
export function useGenericShopCheckoutUrlLazyQuery(variables: GenericShopCheckoutUrlQueryVariables | VueCompositionApi.Ref<GenericShopCheckoutUrlQueryVariables> | ReactiveFunction<GenericShopCheckoutUrlQueryVariables>, options: VueApolloComposable.UseQueryOptions<GenericShopCheckoutUrlQuery, GenericShopCheckoutUrlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GenericShopCheckoutUrlQuery, GenericShopCheckoutUrlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GenericShopCheckoutUrlQuery, GenericShopCheckoutUrlQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GenericShopCheckoutUrlQuery, GenericShopCheckoutUrlQueryVariables>(GenericShopCheckoutUrlDocument, variables, options);
}
export type GenericShopCheckoutUrlQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GenericShopCheckoutUrlQuery, GenericShopCheckoutUrlQueryVariables>;
export const GenericShopConfigDocument = gql`
    query GenericShopConfig {
  getGenericShopConfig {
    id
    graphqlUrl
  }
}
    `;

/**
 * __useGenericShopConfigQuery__
 *
 * To run a query within a Vue component, call `useGenericShopConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenericShopConfigQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGenericShopConfigQuery();
 */
export function useGenericShopConfigQuery(options: VueApolloComposable.UseQueryOptions<GenericShopConfigQuery, GenericShopConfigQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GenericShopConfigQuery, GenericShopConfigQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GenericShopConfigQuery, GenericShopConfigQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GenericShopConfigQuery, GenericShopConfigQueryVariables>(GenericShopConfigDocument, {}, options);
}
export function useGenericShopConfigLazyQuery(options: VueApolloComposable.UseQueryOptions<GenericShopConfigQuery, GenericShopConfigQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GenericShopConfigQuery, GenericShopConfigQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GenericShopConfigQuery, GenericShopConfigQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GenericShopConfigQuery, GenericShopConfigQueryVariables>(GenericShopConfigDocument, {}, options);
}
export type GenericShopConfigQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GenericShopConfigQuery, GenericShopConfigQueryVariables>;
export const GenericShopItemInfoDocument = gql`
    query GenericShopItemInfo($input: ShopItemInfoInput!) {
  shopItemInfo(input: $input) {
    price {
      price
      currency {
        code
        sign
      }
    }
    stock {
      stock
      stockStatus
    }
    priceOnRequest
    orderable
  }
}
    `;

/**
 * __useGenericShopItemInfoQuery__
 *
 * To run a query within a Vue component, call `useGenericShopItemInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenericShopItemInfoQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGenericShopItemInfoQuery({
 *   input: // value for 'input'
 * });
 */
export function useGenericShopItemInfoQuery(variables: GenericShopItemInfoQueryVariables | VueCompositionApi.Ref<GenericShopItemInfoQueryVariables> | ReactiveFunction<GenericShopItemInfoQueryVariables>, options: VueApolloComposable.UseQueryOptions<GenericShopItemInfoQuery, GenericShopItemInfoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GenericShopItemInfoQuery, GenericShopItemInfoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GenericShopItemInfoQuery, GenericShopItemInfoQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GenericShopItemInfoQuery, GenericShopItemInfoQueryVariables>(GenericShopItemInfoDocument, variables, options);
}
export function useGenericShopItemInfoLazyQuery(variables: GenericShopItemInfoQueryVariables | VueCompositionApi.Ref<GenericShopItemInfoQueryVariables> | ReactiveFunction<GenericShopItemInfoQueryVariables>, options: VueApolloComposable.UseQueryOptions<GenericShopItemInfoQuery, GenericShopItemInfoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GenericShopItemInfoQuery, GenericShopItemInfoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GenericShopItemInfoQuery, GenericShopItemInfoQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GenericShopItemInfoQuery, GenericShopItemInfoQueryVariables>(GenericShopItemInfoDocument, variables, options);
}
export type GenericShopItemInfoQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GenericShopItemInfoQuery, GenericShopItemInfoQueryVariables>;
export const GenericShopSessionDocument = gql`
    query GenericShopSession {
  shopSession {
    online
    status
  }
}
    `;

/**
 * __useGenericShopSessionQuery__
 *
 * To run a query within a Vue component, call `useGenericShopSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenericShopSessionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGenericShopSessionQuery();
 */
export function useGenericShopSessionQuery(options: VueApolloComposable.UseQueryOptions<GenericShopSessionQuery, GenericShopSessionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GenericShopSessionQuery, GenericShopSessionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GenericShopSessionQuery, GenericShopSessionQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GenericShopSessionQuery, GenericShopSessionQueryVariables>(GenericShopSessionDocument, {}, options);
}
export function useGenericShopSessionLazyQuery(options: VueApolloComposable.UseQueryOptions<GenericShopSessionQuery, GenericShopSessionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GenericShopSessionQuery, GenericShopSessionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GenericShopSessionQuery, GenericShopSessionQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GenericShopSessionQuery, GenericShopSessionQueryVariables>(GenericShopSessionDocument, {}, options);
}
export type GenericShopSessionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GenericShopSessionQuery, GenericShopSessionQueryVariables>;
export const GenericShopAuthStartUrlDocument = gql`
    query GenericShopAuthStartUrl($context: ShopRequestContextInput!) {
  shopAuthStartUrl(context: $context) {
    url
  }
}
    `;

/**
 * __useGenericShopAuthStartUrlQuery__
 *
 * To run a query within a Vue component, call `useGenericShopAuthStartUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenericShopAuthStartUrlQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGenericShopAuthStartUrlQuery({
 *   context: // value for 'context'
 * });
 */
export function useGenericShopAuthStartUrlQuery(variables: GenericShopAuthStartUrlQueryVariables | VueCompositionApi.Ref<GenericShopAuthStartUrlQueryVariables> | ReactiveFunction<GenericShopAuthStartUrlQueryVariables>, options: VueApolloComposable.UseQueryOptions<GenericShopAuthStartUrlQuery, GenericShopAuthStartUrlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GenericShopAuthStartUrlQuery, GenericShopAuthStartUrlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GenericShopAuthStartUrlQuery, GenericShopAuthStartUrlQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GenericShopAuthStartUrlQuery, GenericShopAuthStartUrlQueryVariables>(GenericShopAuthStartUrlDocument, variables, options);
}
export function useGenericShopAuthStartUrlLazyQuery(variables: GenericShopAuthStartUrlQueryVariables | VueCompositionApi.Ref<GenericShopAuthStartUrlQueryVariables> | ReactiveFunction<GenericShopAuthStartUrlQueryVariables>, options: VueApolloComposable.UseQueryOptions<GenericShopAuthStartUrlQuery, GenericShopAuthStartUrlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GenericShopAuthStartUrlQuery, GenericShopAuthStartUrlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GenericShopAuthStartUrlQuery, GenericShopAuthStartUrlQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GenericShopAuthStartUrlQuery, GenericShopAuthStartUrlQueryVariables>(GenericShopAuthStartUrlDocument, variables, options);
}
export type GenericShopAuthStartUrlQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GenericShopAuthStartUrlQuery, GenericShopAuthStartUrlQueryVariables>;
export const GetSalesforceConfigDocument = gql`
    query GetSalesforceConfig {
  getSalesforceConfig {
    graphUrl
    id
    shopServiceUrl
    shopUrl
    wellKnownOpenIdConfiguration
  }
}
    `;

/**
 * __useGetSalesforceConfigQuery__
 *
 * To run a query within a Vue component, call `useGetSalesforceConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesforceConfigQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSalesforceConfigQuery();
 */
export function useGetSalesforceConfigQuery(options: VueApolloComposable.UseQueryOptions<GetSalesforceConfigQuery, GetSalesforceConfigQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetSalesforceConfigQuery, GetSalesforceConfigQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetSalesforceConfigQuery, GetSalesforceConfigQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetSalesforceConfigQuery, GetSalesforceConfigQueryVariables>(GetSalesforceConfigDocument, {}, options);
}
export function useGetSalesforceConfigLazyQuery(options: VueApolloComposable.UseQueryOptions<GetSalesforceConfigQuery, GetSalesforceConfigQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetSalesforceConfigQuery, GetSalesforceConfigQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetSalesforceConfigQuery, GetSalesforceConfigQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetSalesforceConfigQuery, GetSalesforceConfigQueryVariables>(GetSalesforceConfigDocument, {}, options);
}
export type GetSalesforceConfigQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetSalesforceConfigQuery, GetSalesforceConfigQueryVariables>;
export const GetConfigSapShopDocument = gql`
    query getConfigSapShop {
  getSapShopConfig {
    id
    shopServiceUrl
    graphUrl
    shopUrl
    tokenUrl
    cartIdParameter
    appEntryParameter
  }
}
    `;

/**
 * __useGetConfigSapShopQuery__
 *
 * To run a query within a Vue component, call `useGetConfigSapShopQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConfigSapShopQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetConfigSapShopQuery();
 */
export function useGetConfigSapShopQuery(options: VueApolloComposable.UseQueryOptions<GetConfigSapShopQuery, GetConfigSapShopQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetConfigSapShopQuery, GetConfigSapShopQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetConfigSapShopQuery, GetConfigSapShopQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetConfigSapShopQuery, GetConfigSapShopQueryVariables>(GetConfigSapShopDocument, {}, options);
}
export function useGetConfigSapShopLazyQuery(options: VueApolloComposable.UseQueryOptions<GetConfigSapShopQuery, GetConfigSapShopQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetConfigSapShopQuery, GetConfigSapShopQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetConfigSapShopQuery, GetConfigSapShopQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetConfigSapShopQuery, GetConfigSapShopQueryVariables>(GetConfigSapShopDocument, {}, options);
}
export type GetConfigSapShopQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetConfigSapShopQuery, GetConfigSapShopQueryVariables>;
export const GetShopLightCartDocument = gql`
    query GetShopLightCart {
  getCart {
    id
    cartItems {
      ...CartItemFields
    }
  }
}
    ${CartItemFieldsFragmentDoc}`;

/**
 * __useGetShopLightCartQuery__
 *
 * To run a query within a Vue component, call `useGetShopLightCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShopLightCartQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetShopLightCartQuery();
 */
export function useGetShopLightCartQuery(options: VueApolloComposable.UseQueryOptions<GetShopLightCartQuery, GetShopLightCartQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetShopLightCartQuery, GetShopLightCartQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetShopLightCartQuery, GetShopLightCartQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetShopLightCartQuery, GetShopLightCartQueryVariables>(GetShopLightCartDocument, {}, options);
}
export function useGetShopLightCartLazyQuery(options: VueApolloComposable.UseQueryOptions<GetShopLightCartQuery, GetShopLightCartQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetShopLightCartQuery, GetShopLightCartQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetShopLightCartQuery, GetShopLightCartQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetShopLightCartQuery, GetShopLightCartQueryVariables>(GetShopLightCartDocument, {}, options);
}
export type GetShopLightCartQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetShopLightCartQuery, GetShopLightCartQueryVariables>;
export const AddCartItemDocument = gql`
    mutation AddCartItem($spec: ShopLightCartItemInput!) {
  addCartItem(spec: $spec) {
    ...CartItemFields
  }
}
    ${CartItemFieldsFragmentDoc}`;

/**
 * __useAddCartItemMutation__
 *
 * To run a mutation, you first call `useAddCartItemMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddCartItemMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddCartItemMutation({
 *   variables: {
 *     spec: // value for 'spec'
 *   },
 * });
 */
export function useAddCartItemMutation(options: VueApolloComposable.UseMutationOptions<AddCartItemMutation, AddCartItemMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddCartItemMutation, AddCartItemMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddCartItemMutation, AddCartItemMutationVariables>(AddCartItemDocument, options);
}
export type AddCartItemMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddCartItemMutation, AddCartItemMutationVariables>;
export const DeleteCartItemDocument = gql`
    mutation DeleteCartItem($spec: ShopLightCartItemDelete!) {
  deleteCartItem(spec: $spec)
}
    `;

/**
 * __useDeleteCartItemMutation__
 *
 * To run a mutation, you first call `useDeleteCartItemMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCartItemMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteCartItemMutation({
 *   variables: {
 *     spec: // value for 'spec'
 *   },
 * });
 */
export function useDeleteCartItemMutation(options: VueApolloComposable.UseMutationOptions<DeleteCartItemMutation, DeleteCartItemMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteCartItemMutation, DeleteCartItemMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteCartItemMutation, DeleteCartItemMutationVariables>(DeleteCartItemDocument, options);
}
export type DeleteCartItemMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteCartItemMutation, DeleteCartItemMutationVariables>;
export const UpdateCartItemDocument = gql`
    mutation UpdateCartItem($spec: ShopLightCartItemInput!) {
  updateCartItem(spec: $spec) {
    ...CartItemFields
  }
}
    ${CartItemFieldsFragmentDoc}`;

/**
 * __useUpdateCartItemMutation__
 *
 * To run a mutation, you first call `useUpdateCartItemMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCartItemMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCartItemMutation({
 *   variables: {
 *     spec: // value for 'spec'
 *   },
 * });
 */
export function useUpdateCartItemMutation(options: VueApolloComposable.UseMutationOptions<UpdateCartItemMutation, UpdateCartItemMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateCartItemMutation, UpdateCartItemMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateCartItemMutation, UpdateCartItemMutationVariables>(UpdateCartItemDocument, options);
}
export type UpdateCartItemMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateCartItemMutation, UpdateCartItemMutationVariables>;
export const SendMailsDocument = gql`
    mutation SendMails($spec: SendMailsInput!) {
  sendMails(spec: $spec)
}
    `;

/**
 * __useSendMailsMutation__
 *
 * To run a mutation, you first call `useSendMailsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSendMailsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSendMailsMutation({
 *   variables: {
 *     spec: // value for 'spec'
 *   },
 * });
 */
export function useSendMailsMutation(options: VueApolloComposable.UseMutationOptions<SendMailsMutation, SendMailsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SendMailsMutation, SendMailsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SendMailsMutation, SendMailsMutationVariables>(SendMailsDocument, options);
}
export type SendMailsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SendMailsMutation, SendMailsMutationVariables>;
export const GetShopLightConfigDocument = gql`
    query GetShopLightConfig {
  getShopLightConfig {
    id
    shopServiceUrl
    shopEMail
  }
}
    `;

/**
 * __useGetShopLightConfigQuery__
 *
 * To run a query within a Vue component, call `useGetShopLightConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShopLightConfigQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetShopLightConfigQuery();
 */
export function useGetShopLightConfigQuery(options: VueApolloComposable.UseQueryOptions<GetShopLightConfigQuery, GetShopLightConfigQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetShopLightConfigQuery, GetShopLightConfigQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetShopLightConfigQuery, GetShopLightConfigQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetShopLightConfigQuery, GetShopLightConfigQueryVariables>(GetShopLightConfigDocument, {}, options);
}
export function useGetShopLightConfigLazyQuery(options: VueApolloComposable.UseQueryOptions<GetShopLightConfigQuery, GetShopLightConfigQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetShopLightConfigQuery, GetShopLightConfigQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetShopLightConfigQuery, GetShopLightConfigQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetShopLightConfigQuery, GetShopLightConfigQueryVariables>(GetShopLightConfigDocument, {}, options);
}
export type GetShopLightConfigQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetShopLightConfigQuery, GetShopLightConfigQueryVariables>;
export const GetArticleShopInfoDocument = gql`
    query GetArticleShopInfo($articleId: String!) {
  article(id: $articleId) {
    id
    currency
    orderable
    price
  }
}
    `;

/**
 * __useGetArticleShopInfoQuery__
 *
 * To run a query within a Vue component, call `useGetArticleShopInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticleShopInfoQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetArticleShopInfoQuery({
 *   articleId: // value for 'articleId'
 * });
 */
export function useGetArticleShopInfoQuery(variables: GetArticleShopInfoQueryVariables | VueCompositionApi.Ref<GetArticleShopInfoQueryVariables> | ReactiveFunction<GetArticleShopInfoQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetArticleShopInfoQuery, GetArticleShopInfoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetArticleShopInfoQuery, GetArticleShopInfoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetArticleShopInfoQuery, GetArticleShopInfoQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetArticleShopInfoQuery, GetArticleShopInfoQueryVariables>(GetArticleShopInfoDocument, variables, options);
}
export function useGetArticleShopInfoLazyQuery(variables: GetArticleShopInfoQueryVariables | VueCompositionApi.Ref<GetArticleShopInfoQueryVariables> | ReactiveFunction<GetArticleShopInfoQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetArticleShopInfoQuery, GetArticleShopInfoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetArticleShopInfoQuery, GetArticleShopInfoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetArticleShopInfoQuery, GetArticleShopInfoQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetArticleShopInfoQuery, GetArticleShopInfoQueryVariables>(GetArticleShopInfoDocument, variables, options);
}
export type GetArticleShopInfoQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetArticleShopInfoQuery, GetArticleShopInfoQueryVariables>;
export const GetArticleWithContextShopInfoDocument = gql`
    query GetArticleWithContextShopInfo($mechanicId: String!) {
  mechanic(id: $mechanicId) {
    id
    currency
    orderable
    price
  }
}
    `;

/**
 * __useGetArticleWithContextShopInfoQuery__
 *
 * To run a query within a Vue component, call `useGetArticleWithContextShopInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticleWithContextShopInfoQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetArticleWithContextShopInfoQuery({
 *   mechanicId: // value for 'mechanicId'
 * });
 */
export function useGetArticleWithContextShopInfoQuery(variables: GetArticleWithContextShopInfoQueryVariables | VueCompositionApi.Ref<GetArticleWithContextShopInfoQueryVariables> | ReactiveFunction<GetArticleWithContextShopInfoQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetArticleWithContextShopInfoQuery, GetArticleWithContextShopInfoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetArticleWithContextShopInfoQuery, GetArticleWithContextShopInfoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetArticleWithContextShopInfoQuery, GetArticleWithContextShopInfoQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetArticleWithContextShopInfoQuery, GetArticleWithContextShopInfoQueryVariables>(GetArticleWithContextShopInfoDocument, variables, options);
}
export function useGetArticleWithContextShopInfoLazyQuery(variables: GetArticleWithContextShopInfoQueryVariables | VueCompositionApi.Ref<GetArticleWithContextShopInfoQueryVariables> | ReactiveFunction<GetArticleWithContextShopInfoQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetArticleWithContextShopInfoQuery, GetArticleWithContextShopInfoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetArticleWithContextShopInfoQuery, GetArticleWithContextShopInfoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetArticleWithContextShopInfoQuery, GetArticleWithContextShopInfoQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetArticleWithContextShopInfoQuery, GetArticleWithContextShopInfoQueryVariables>(GetArticleWithContextShopInfoDocument, variables, options);
}
export type GetArticleWithContextShopInfoQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetArticleWithContextShopInfoQuery, GetArticleWithContextShopInfoQueryVariables>;
export const GetDetailsForArticlesDocument = gql`
    query GetDetailsForArticles($filter: ArticleFilter, $acceptedLanguages: [LanguageWithWildcard!]) {
  articles(filter: $filter) {
    articles {
      node {
        id
        articleNumber
        currency
        localizations {
          title(acceptedLanguages: $acceptedLanguages)
        }
        orderable
        previewImage {
          blobId
          url
        }
        price
      }
    }
  }
}
    `;

/**
 * __useGetDetailsForArticlesQuery__
 *
 * To run a query within a Vue component, call `useGetDetailsForArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDetailsForArticlesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetDetailsForArticlesQuery({
 *   filter: // value for 'filter'
 *   acceptedLanguages: // value for 'acceptedLanguages'
 * });
 */
export function useGetDetailsForArticlesQuery(variables: GetDetailsForArticlesQueryVariables | VueCompositionApi.Ref<GetDetailsForArticlesQueryVariables> | ReactiveFunction<GetDetailsForArticlesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetDetailsForArticlesQuery, GetDetailsForArticlesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetDetailsForArticlesQuery, GetDetailsForArticlesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetDetailsForArticlesQuery, GetDetailsForArticlesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetDetailsForArticlesQuery, GetDetailsForArticlesQueryVariables>(GetDetailsForArticlesDocument, variables, options);
}
export function useGetDetailsForArticlesLazyQuery(variables: GetDetailsForArticlesQueryVariables | VueCompositionApi.Ref<GetDetailsForArticlesQueryVariables> | ReactiveFunction<GetDetailsForArticlesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetDetailsForArticlesQuery, GetDetailsForArticlesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetDetailsForArticlesQuery, GetDetailsForArticlesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetDetailsForArticlesQuery, GetDetailsForArticlesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetDetailsForArticlesQuery, GetDetailsForArticlesQueryVariables>(GetDetailsForArticlesDocument, variables, options);
}
export type GetDetailsForArticlesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetDetailsForArticlesQuery, GetDetailsForArticlesQueryVariables>;
export const GetDetailsForArticlesWithContextDocument = gql`
    query GetDetailsForArticlesWithContext($filter: MechanicFilter, $acceptedLanguages: [LanguageWithWildcard!]) {
  mechanics(filter: $filter) {
    mechanics {
      node {
        id
        articleNumber
        assemblyId
        currency
        localizations {
          title(acceptedLanguages: $acceptedLanguages)
        }
        orderable
        previewImage {
          url
        }
        price
      }
    }
  }
}
    `;

/**
 * __useGetDetailsForArticlesWithContextQuery__
 *
 * To run a query within a Vue component, call `useGetDetailsForArticlesWithContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDetailsForArticlesWithContextQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetDetailsForArticlesWithContextQuery({
 *   filter: // value for 'filter'
 *   acceptedLanguages: // value for 'acceptedLanguages'
 * });
 */
export function useGetDetailsForArticlesWithContextQuery(variables: GetDetailsForArticlesWithContextQueryVariables | VueCompositionApi.Ref<GetDetailsForArticlesWithContextQueryVariables> | ReactiveFunction<GetDetailsForArticlesWithContextQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetDetailsForArticlesWithContextQuery, GetDetailsForArticlesWithContextQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetDetailsForArticlesWithContextQuery, GetDetailsForArticlesWithContextQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetDetailsForArticlesWithContextQuery, GetDetailsForArticlesWithContextQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetDetailsForArticlesWithContextQuery, GetDetailsForArticlesWithContextQueryVariables>(GetDetailsForArticlesWithContextDocument, variables, options);
}
export function useGetDetailsForArticlesWithContextLazyQuery(variables: GetDetailsForArticlesWithContextQueryVariables | VueCompositionApi.Ref<GetDetailsForArticlesWithContextQueryVariables> | ReactiveFunction<GetDetailsForArticlesWithContextQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetDetailsForArticlesWithContextQuery, GetDetailsForArticlesWithContextQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetDetailsForArticlesWithContextQuery, GetDetailsForArticlesWithContextQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetDetailsForArticlesWithContextQuery, GetDetailsForArticlesWithContextQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetDetailsForArticlesWithContextQuery, GetDetailsForArticlesWithContextQueryVariables>(GetDetailsForArticlesWithContextDocument, variables, options);
}
export type GetDetailsForArticlesWithContextQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetDetailsForArticlesWithContextQuery, GetDetailsForArticlesWithContextQueryVariables>;
export const StaticPageDocument = gql`
    query staticPage($pageType: String!, $languages: [LanguageWithWildcard!]) {
  staticPage(pageType: $pageType, acceptedLanguages: $languages) {
    id
    title
    contents {
      url
    }
  }
}
    `;

/**
 * __useStaticPageQuery__
 *
 * To run a query within a Vue component, call `useStaticPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useStaticPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useStaticPageQuery({
 *   pageType: // value for 'pageType'
 *   languages: // value for 'languages'
 * });
 */
export function useStaticPageQuery(variables: StaticPageQueryVariables | VueCompositionApi.Ref<StaticPageQueryVariables> | ReactiveFunction<StaticPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<StaticPageQuery, StaticPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<StaticPageQuery, StaticPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<StaticPageQuery, StaticPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<StaticPageQuery, StaticPageQueryVariables>(StaticPageDocument, variables, options);
}
export function useStaticPageLazyQuery(variables: StaticPageQueryVariables | VueCompositionApi.Ref<StaticPageQueryVariables> | ReactiveFunction<StaticPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<StaticPageQuery, StaticPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<StaticPageQuery, StaticPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<StaticPageQuery, StaticPageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<StaticPageQuery, StaticPageQueryVariables>(StaticPageDocument, variables, options);
}
export type StaticPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<StaticPageQuery, StaticPageQueryVariables>;
export const AccessComposableDocument = gql`
    query accessComposable {
  me {
    id
    email
    roles
    anonymous
    displayName
    effectiveRoles
    endSessionUrl
  }
  accessControlSettings {
    id
    rolesConfig
  }
  availableFeatures {
    id
  }
}
    `;

/**
 * __useAccessComposableQuery__
 *
 * To run a query within a Vue component, call `useAccessComposableQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccessComposableQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAccessComposableQuery();
 */
export function useAccessComposableQuery(options: VueApolloComposable.UseQueryOptions<AccessComposableQuery, AccessComposableQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AccessComposableQuery, AccessComposableQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AccessComposableQuery, AccessComposableQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AccessComposableQuery, AccessComposableQueryVariables>(AccessComposableDocument, {}, options);
}
export function useAccessComposableLazyQuery(options: VueApolloComposable.UseQueryOptions<AccessComposableQuery, AccessComposableQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AccessComposableQuery, AccessComposableQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AccessComposableQuery, AccessComposableQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AccessComposableQuery, AccessComposableQueryVariables>(AccessComposableDocument, {}, options);
}
export type AccessComposableQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AccessComposableQuery, AccessComposableQueryVariables>;
export const UserDocument = gql`
    query user {
  me {
    id
    email
    roles
    anonymous
    displayName
    effectiveRoles
    endSessionUrl
  }
}
    `;

/**
 * __useUserQuery__
 *
 * To run a query within a Vue component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserQuery();
 */
export function useUserQuery(options: VueApolloComposable.UseQueryOptions<UserQuery, UserQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserQuery, UserQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserQuery, UserQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UserQuery, UserQueryVariables>(UserDocument, {}, options);
}
export function useUserLazyQuery(options: VueApolloComposable.UseQueryOptions<UserQuery, UserQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserQuery, UserQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserQuery, UserQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, {}, options);
}
export type UserQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UserQuery, UserQueryVariables>;
export const AccessControlSettingsDocument = gql`
    query accessControlSettings {
  accessControlSettings {
    id
    rolesConfig
  }
}
    `;

/**
 * __useAccessControlSettingsQuery__
 *
 * To run a query within a Vue component, call `useAccessControlSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccessControlSettingsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAccessControlSettingsQuery();
 */
export function useAccessControlSettingsQuery(options: VueApolloComposable.UseQueryOptions<AccessControlSettingsQuery, AccessControlSettingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AccessControlSettingsQuery, AccessControlSettingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AccessControlSettingsQuery, AccessControlSettingsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AccessControlSettingsQuery, AccessControlSettingsQueryVariables>(AccessControlSettingsDocument, {}, options);
}
export function useAccessControlSettingsLazyQuery(options: VueApolloComposable.UseQueryOptions<AccessControlSettingsQuery, AccessControlSettingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AccessControlSettingsQuery, AccessControlSettingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AccessControlSettingsQuery, AccessControlSettingsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AccessControlSettingsQuery, AccessControlSettingsQueryVariables>(AccessControlSettingsDocument, {}, options);
}
export type AccessControlSettingsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AccessControlSettingsQuery, AccessControlSettingsQueryVariables>;
export const AvailableFeaturesDocument = gql`
    query availableFeatures {
  availableFeatures {
    id
  }
}
    `;

/**
 * __useAvailableFeaturesQuery__
 *
 * To run a query within a Vue component, call `useAvailableFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableFeaturesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAvailableFeaturesQuery();
 */
export function useAvailableFeaturesQuery(options: VueApolloComposable.UseQueryOptions<AvailableFeaturesQuery, AvailableFeaturesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AvailableFeaturesQuery, AvailableFeaturesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AvailableFeaturesQuery, AvailableFeaturesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AvailableFeaturesQuery, AvailableFeaturesQueryVariables>(AvailableFeaturesDocument, {}, options);
}
export function useAvailableFeaturesLazyQuery(options: VueApolloComposable.UseQueryOptions<AvailableFeaturesQuery, AvailableFeaturesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AvailableFeaturesQuery, AvailableFeaturesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AvailableFeaturesQuery, AvailableFeaturesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AvailableFeaturesQuery, AvailableFeaturesQueryVariables>(AvailableFeaturesDocument, {}, options);
}
export type AvailableFeaturesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AvailableFeaturesQuery, AvailableFeaturesQueryVariables>;
export const LogoDocument = gql`
    query logo {
  theme {
    logo {
      url
    }
  }
}
    `;

/**
 * __useLogoQuery__
 *
 * To run a query within a Vue component, call `useLogoQuery` and pass it any options that fit your needs.
 * When your component renders, `useLogoQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLogoQuery();
 */
export function useLogoQuery(options: VueApolloComposable.UseQueryOptions<LogoQuery, LogoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LogoQuery, LogoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LogoQuery, LogoQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<LogoQuery, LogoQueryVariables>(LogoDocument, {}, options);
}
export function useLogoLazyQuery(options: VueApolloComposable.UseQueryOptions<LogoQuery, LogoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LogoQuery, LogoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LogoQuery, LogoQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<LogoQuery, LogoQueryVariables>(LogoDocument, {}, options);
}
export type LogoQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<LogoQuery, LogoQueryVariables>;
export const FacetAutocompleteDocument = gql`
    query facetAutocomplete($filter: FacetDatafieldAutocompleteFilter!, $first: NonNegativeInt, $acceptedLanguages: [LanguageWithWildcard!]) {
  facetDatafieldAutocomplete(filter: $filter, first: $first) {
    hits {
      displayName
      filterSelection
      language
      value
      datafieldDefinition {
        teasers {
          title(acceptedLanguages: $acceptedLanguages)
        }
      }
      datafieldDefinitionId
    }
  }
}
    `;

/**
 * __useFacetAutocompleteQuery__
 *
 * To run a query within a Vue component, call `useFacetAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacetAutocompleteQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFacetAutocompleteQuery({
 *   filter: // value for 'filter'
 *   first: // value for 'first'
 *   acceptedLanguages: // value for 'acceptedLanguages'
 * });
 */
export function useFacetAutocompleteQuery(variables: FacetAutocompleteQueryVariables | VueCompositionApi.Ref<FacetAutocompleteQueryVariables> | ReactiveFunction<FacetAutocompleteQueryVariables>, options: VueApolloComposable.UseQueryOptions<FacetAutocompleteQuery, FacetAutocompleteQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FacetAutocompleteQuery, FacetAutocompleteQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FacetAutocompleteQuery, FacetAutocompleteQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FacetAutocompleteQuery, FacetAutocompleteQueryVariables>(FacetAutocompleteDocument, variables, options);
}
export function useFacetAutocompleteLazyQuery(variables: FacetAutocompleteQueryVariables | VueCompositionApi.Ref<FacetAutocompleteQueryVariables> | ReactiveFunction<FacetAutocompleteQueryVariables>, options: VueApolloComposable.UseQueryOptions<FacetAutocompleteQuery, FacetAutocompleteQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FacetAutocompleteQuery, FacetAutocompleteQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FacetAutocompleteQuery, FacetAutocompleteQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FacetAutocompleteQuery, FacetAutocompleteQueryVariables>(FacetAutocompleteDocument, variables, options);
}
export type FacetAutocompleteQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FacetAutocompleteQuery, FacetAutocompleteQueryVariables>;
export const StaticPageMenuDocument = gql`
    query staticPageMenu($languages: [LanguageWithWildcard!]) {
  staticPageMenu {
    id
    pages {
      teasers {
        title(acceptedLanguages: $languages)
      }
      staticPages {
        id
      }
      pageType
    }
  }
}
    `;

/**
 * __useStaticPageMenuQuery__
 *
 * To run a query within a Vue component, call `useStaticPageMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useStaticPageMenuQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useStaticPageMenuQuery({
 *   languages: // value for 'languages'
 * });
 */
export function useStaticPageMenuQuery(variables: StaticPageMenuQueryVariables | VueCompositionApi.Ref<StaticPageMenuQueryVariables> | ReactiveFunction<StaticPageMenuQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<StaticPageMenuQuery, StaticPageMenuQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<StaticPageMenuQuery, StaticPageMenuQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<StaticPageMenuQuery, StaticPageMenuQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<StaticPageMenuQuery, StaticPageMenuQueryVariables>(StaticPageMenuDocument, variables, options);
}
export function useStaticPageMenuLazyQuery(variables: StaticPageMenuQueryVariables | VueCompositionApi.Ref<StaticPageMenuQueryVariables> | ReactiveFunction<StaticPageMenuQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<StaticPageMenuQuery, StaticPageMenuQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<StaticPageMenuQuery, StaticPageMenuQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<StaticPageMenuQuery, StaticPageMenuQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<StaticPageMenuQuery, StaticPageMenuQueryVariables>(StaticPageMenuDocument, variables, options);
}
export type StaticPageMenuQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<StaticPageMenuQuery, StaticPageMenuQueryVariables>;
export const MarkNotificationsAsReadDocument = gql`
    mutation markNotificationsAsRead($ids: [ID]!) {
  markNotificationsAsRead(ids: $ids)
}
    `;

/**
 * __useMarkNotificationsAsReadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationsAsReadMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationsAsReadMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMarkNotificationsAsReadMutation({
 *   variables: {
 *     ids: // value for 'ids'
 *   },
 * });
 */
export function useMarkNotificationsAsReadMutation(options: VueApolloComposable.UseMutationOptions<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>(MarkNotificationsAsReadDocument, options);
}
export type MarkNotificationsAsReadMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>;
export const NotificationsDocument = gql`
    query notifications($first: NonNegativeInt, $after: String, $userId: ID!, $acceptedLanguages: [LanguageWithWildcard!]) {
  notifications(
    filter: {andGroup: [{equals: {userId: $userId}}, {not: {exists: readDate}}]}
  ) {
    total {
      count
      countRelation
    }
    notifications(
      first: $first
      sort: {field: creationDate, order: desc}
      after: $after
    ) {
      cursor
      node {
        id
        teasers {
          text(acceptedLanguages: $acceptedLanguages)
        }
        objectId
        objectType
        notificationType
        creationDate
        users {
          id
          email
        }
      }
    }
  }
}
    `;

/**
 * __useNotificationsQuery__
 *
 * To run a query within a Vue component, call `useNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useNotificationsQuery({
 *   first: // value for 'first'
 *   after: // value for 'after'
 *   userId: // value for 'userId'
 *   acceptedLanguages: // value for 'acceptedLanguages'
 * });
 */
export function useNotificationsQuery(variables: NotificationsQueryVariables | VueCompositionApi.Ref<NotificationsQueryVariables> | ReactiveFunction<NotificationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<NotificationsQuery, NotificationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<NotificationsQuery, NotificationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<NotificationsQuery, NotificationsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, variables, options);
}
export function useNotificationsLazyQuery(variables: NotificationsQueryVariables | VueCompositionApi.Ref<NotificationsQueryVariables> | ReactiveFunction<NotificationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<NotificationsQuery, NotificationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<NotificationsQuery, NotificationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<NotificationsQuery, NotificationsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, variables, options);
}
export type NotificationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<NotificationsQuery, NotificationsQueryVariables>;
export const GetContentByNoteIdDocument = gql`
    query getContentByNoteId($id: ID!) {
  note(id: $id) {
    content {
      id
      contentId
    }
  }
}
    `;

/**
 * __useGetContentByNoteIdQuery__
 *
 * To run a query within a Vue component, call `useGetContentByNoteIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentByNoteIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetContentByNoteIdQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetContentByNoteIdQuery(variables: GetContentByNoteIdQueryVariables | VueCompositionApi.Ref<GetContentByNoteIdQueryVariables> | ReactiveFunction<GetContentByNoteIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetContentByNoteIdQuery, GetContentByNoteIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetContentByNoteIdQuery, GetContentByNoteIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetContentByNoteIdQuery, GetContentByNoteIdQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetContentByNoteIdQuery, GetContentByNoteIdQueryVariables>(GetContentByNoteIdDocument, variables, options);
}
export function useGetContentByNoteIdLazyQuery(variables: GetContentByNoteIdQueryVariables | VueCompositionApi.Ref<GetContentByNoteIdQueryVariables> | ReactiveFunction<GetContentByNoteIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetContentByNoteIdQuery, GetContentByNoteIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetContentByNoteIdQuery, GetContentByNoteIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetContentByNoteIdQuery, GetContentByNoteIdQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetContentByNoteIdQuery, GetContentByNoteIdQueryVariables>(GetContentByNoteIdDocument, variables, options);
}
export type GetContentByNoteIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetContentByNoteIdQuery, GetContentByNoteIdQueryVariables>;
export const NotificationsTopBarDocument = gql`
    query notificationsTopBar($userId: ID!) {
  notifications(
    filter: {andGroup: [{equals: {userId: $userId}}, {not: {exists: readDate}}]}
  ) {
    total {
      count
    }
  }
}
    `;

/**
 * __useNotificationsTopBarQuery__
 *
 * To run a query within a Vue component, call `useNotificationsTopBarQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsTopBarQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useNotificationsTopBarQuery({
 *   userId: // value for 'userId'
 * });
 */
export function useNotificationsTopBarQuery(variables: NotificationsTopBarQueryVariables | VueCompositionApi.Ref<NotificationsTopBarQueryVariables> | ReactiveFunction<NotificationsTopBarQueryVariables>, options: VueApolloComposable.UseQueryOptions<NotificationsTopBarQuery, NotificationsTopBarQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<NotificationsTopBarQuery, NotificationsTopBarQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<NotificationsTopBarQuery, NotificationsTopBarQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<NotificationsTopBarQuery, NotificationsTopBarQueryVariables>(NotificationsTopBarDocument, variables, options);
}
export function useNotificationsTopBarLazyQuery(variables: NotificationsTopBarQueryVariables | VueCompositionApi.Ref<NotificationsTopBarQueryVariables> | ReactiveFunction<NotificationsTopBarQueryVariables>, options: VueApolloComposable.UseQueryOptions<NotificationsTopBarQuery, NotificationsTopBarQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<NotificationsTopBarQuery, NotificationsTopBarQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<NotificationsTopBarQuery, NotificationsTopBarQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<NotificationsTopBarQuery, NotificationsTopBarQueryVariables>(NotificationsTopBarDocument, variables, options);
}
export type NotificationsTopBarQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<NotificationsTopBarQuery, NotificationsTopBarQueryVariables>;
export const GetConfigProductAndAssetDocument = gql`
    query getConfigProductAndAsset {
  config {
    configProductAndAsset {
      id
      productName
      assetName
      deactivateAssets
    }
  }
}
    `;

/**
 * __useGetConfigProductAndAssetQuery__
 *
 * To run a query within a Vue component, call `useGetConfigProductAndAssetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConfigProductAndAssetQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetConfigProductAndAssetQuery();
 */
export function useGetConfigProductAndAssetQuery(options: VueApolloComposable.UseQueryOptions<GetConfigProductAndAssetQuery, GetConfigProductAndAssetQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetConfigProductAndAssetQuery, GetConfigProductAndAssetQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetConfigProductAndAssetQuery, GetConfigProductAndAssetQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetConfigProductAndAssetQuery, GetConfigProductAndAssetQueryVariables>(GetConfigProductAndAssetDocument, {}, options);
}
export function useGetConfigProductAndAssetLazyQuery(options: VueApolloComposable.UseQueryOptions<GetConfigProductAndAssetQuery, GetConfigProductAndAssetQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetConfigProductAndAssetQuery, GetConfigProductAndAssetQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetConfigProductAndAssetQuery, GetConfigProductAndAssetQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetConfigProductAndAssetQuery, GetConfigProductAndAssetQueryVariables>(GetConfigProductAndAssetDocument, {}, options);
}
export type GetConfigProductAndAssetQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetConfigProductAndAssetQuery, GetConfigProductAndAssetQueryVariables>;
export const CreateAppKeyDocument = gql`
    mutation createAppKey {
  createAppKey {
    apiPass
    key {
      id
      validUntil
    }
  }
}
    `;

/**
 * __useCreateAppKeyMutation__
 *
 * To run a mutation, you first call `useCreateAppKeyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppKeyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateAppKeyMutation();
 */
export function useCreateAppKeyMutation(options: VueApolloComposable.UseMutationOptions<CreateAppKeyMutation, CreateAppKeyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateAppKeyMutation, CreateAppKeyMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateAppKeyMutation, CreateAppKeyMutationVariables>(CreateAppKeyDocument, options);
}
export type CreateAppKeyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateAppKeyMutation, CreateAppKeyMutationVariables>;
export const AppKeyDocument = gql`
    query appKey {
  appKey {
    validUntil
    id
    displayName
  }
}
    `;

/**
 * __useAppKeyQuery__
 *
 * To run a query within a Vue component, call `useAppKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppKeyQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAppKeyQuery();
 */
export function useAppKeyQuery(options: VueApolloComposable.UseQueryOptions<AppKeyQuery, AppKeyQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AppKeyQuery, AppKeyQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AppKeyQuery, AppKeyQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AppKeyQuery, AppKeyQueryVariables>(AppKeyDocument, {}, options);
}
export function useAppKeyLazyQuery(options: VueApolloComposable.UseQueryOptions<AppKeyQuery, AppKeyQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AppKeyQuery, AppKeyQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AppKeyQuery, AppKeyQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AppKeyQuery, AppKeyQueryVariables>(AppKeyDocument, {}, options);
}
export type AppKeyQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AppKeyQuery, AppKeyQueryVariables>;
export const DataDisplayConfigDocument = gql`
    query dataDisplayConfig($dataDisplayConfigId: ID!, $acceptedLanguages: [LanguageWithWildcard!], $length: NonNegativeInt) {
  dataDisplayConfig(id: $dataDisplayConfigId) {
    id
    entries {
      teasers {
        title(acceptedLanguages: $acceptedLanguages, length: $length)
      }
      referencedId
      fieldType
      type
      displayOptions
      ... on DataDisplayConfigFieldEntry {
        nodeTypes
        datafieldDefinition {
          ... on TaxonomyDatafieldDefinition {
            values {
              key
              teasers {
                title(acceptedLanguages: $acceptedLanguages)
              }
            }
          }
          ... on EnumDatafieldDefinition {
            values {
              key
              teasers {
                title(acceptedLanguages: $acceptedLanguages)
              }
            }
          }
          ... on BooleanDatafieldDefinition {
            falseValue {
              teasers {
                title(acceptedLanguages: $acceptedLanguages)
              }
            }
            trueValue {
              teasers {
                title(acceptedLanguages: $acceptedLanguages)
              }
            }
          }
        }
      }
      ... on DataDisplayConfigDatafieldEntry {
        datafieldDefinition {
          objectTypes
          ... on TaxonomyDatafieldDefinition {
            values {
              key
              teasers {
                title(acceptedLanguages: $acceptedLanguages)
              }
            }
          }
          ... on EnumDatafieldDefinition {
            values {
              key
              teasers {
                title(acceptedLanguages: $acceptedLanguages)
              }
            }
          }
          ... on BooleanDatafieldDefinition {
            falseValue {
              teasers {
                title(acceptedLanguages: $acceptedLanguages)
              }
            }
            trueValue {
              teasers {
                title(acceptedLanguages: $acceptedLanguages)
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useDataDisplayConfigQuery__
 *
 * To run a query within a Vue component, call `useDataDisplayConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataDisplayConfigQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDataDisplayConfigQuery({
 *   dataDisplayConfigId: // value for 'dataDisplayConfigId'
 *   acceptedLanguages: // value for 'acceptedLanguages'
 *   length: // value for 'length'
 * });
 */
export function useDataDisplayConfigQuery(variables: DataDisplayConfigQueryVariables | VueCompositionApi.Ref<DataDisplayConfigQueryVariables> | ReactiveFunction<DataDisplayConfigQueryVariables>, options: VueApolloComposable.UseQueryOptions<DataDisplayConfigQuery, DataDisplayConfigQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DataDisplayConfigQuery, DataDisplayConfigQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DataDisplayConfigQuery, DataDisplayConfigQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<DataDisplayConfigQuery, DataDisplayConfigQueryVariables>(DataDisplayConfigDocument, variables, options);
}
export function useDataDisplayConfigLazyQuery(variables: DataDisplayConfigQueryVariables | VueCompositionApi.Ref<DataDisplayConfigQueryVariables> | ReactiveFunction<DataDisplayConfigQueryVariables>, options: VueApolloComposable.UseQueryOptions<DataDisplayConfigQuery, DataDisplayConfigQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DataDisplayConfigQuery, DataDisplayConfigQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DataDisplayConfigQuery, DataDisplayConfigQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<DataDisplayConfigQuery, DataDisplayConfigQueryVariables>(DataDisplayConfigDocument, variables, options);
}
export type DataDisplayConfigQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<DataDisplayConfigQuery, DataDisplayConfigQueryVariables>;
export const FieldDefinitionsTitleDocument = gql`
    query fieldDefinitionsTitle($filter: DatafieldDefinitionFilter, $acceptedLanguages: [LanguageWithWildcard!]) {
  fieldDefinitions(filter: $filter) {
    fieldDefinitions {
      node {
        id
        localizations {
          title(acceptedLanguages: $acceptedLanguages)
        }
      }
    }
  }
}
    `;

/**
 * __useFieldDefinitionsTitleQuery__
 *
 * To run a query within a Vue component, call `useFieldDefinitionsTitleQuery` and pass it any options that fit your needs.
 * When your component renders, `useFieldDefinitionsTitleQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFieldDefinitionsTitleQuery({
 *   filter: // value for 'filter'
 *   acceptedLanguages: // value for 'acceptedLanguages'
 * });
 */
export function useFieldDefinitionsTitleQuery(variables: FieldDefinitionsTitleQueryVariables | VueCompositionApi.Ref<FieldDefinitionsTitleQueryVariables> | ReactiveFunction<FieldDefinitionsTitleQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<FieldDefinitionsTitleQuery, FieldDefinitionsTitleQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FieldDefinitionsTitleQuery, FieldDefinitionsTitleQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FieldDefinitionsTitleQuery, FieldDefinitionsTitleQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FieldDefinitionsTitleQuery, FieldDefinitionsTitleQueryVariables>(FieldDefinitionsTitleDocument, variables, options);
}
export function useFieldDefinitionsTitleLazyQuery(variables: FieldDefinitionsTitleQueryVariables | VueCompositionApi.Ref<FieldDefinitionsTitleQueryVariables> | ReactiveFunction<FieldDefinitionsTitleQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<FieldDefinitionsTitleQuery, FieldDefinitionsTitleQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FieldDefinitionsTitleQuery, FieldDefinitionsTitleQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FieldDefinitionsTitleQuery, FieldDefinitionsTitleQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FieldDefinitionsTitleQuery, FieldDefinitionsTitleQueryVariables>(FieldDefinitionsTitleDocument, variables, options);
}
export type FieldDefinitionsTitleQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FieldDefinitionsTitleQuery, FieldDefinitionsTitleQueryVariables>;
export const FacetDefinitionsDocument = gql`
    query facetDefinitions($referencedIds: [String!], $acceptedLanguages: [LanguageWithWildcard!], $id: ID!) {
  facetsCollection(id: $id) {
    facets(referencedIds: $referencedIds) {
      id
      type
      referencedId
      definition {
        fieldType
        ... on EnumFacetDefinition {
          values {
            key
            teasers {
              title(acceptedLanguages: $acceptedLanguages)
            }
          }
        }
        ... on TaxonomyFacetDefinition {
          values {
            key
            pathKeys
            teasers {
              title(acceptedLanguages: $acceptedLanguages)
            }
          }
        }
        ... on BooleanFacetDefinition {
          falseValue {
            teasers {
              title(acceptedLanguages: $acceptedLanguages)
            }
          }
          trueValue {
            teasers {
              title(acceptedLanguages: $acceptedLanguages)
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFacetDefinitionsQuery__
 *
 * To run a query within a Vue component, call `useFacetDefinitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacetDefinitionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFacetDefinitionsQuery({
 *   referencedIds: // value for 'referencedIds'
 *   acceptedLanguages: // value for 'acceptedLanguages'
 *   id: // value for 'id'
 * });
 */
export function useFacetDefinitionsQuery(variables: FacetDefinitionsQueryVariables | VueCompositionApi.Ref<FacetDefinitionsQueryVariables> | ReactiveFunction<FacetDefinitionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<FacetDefinitionsQuery, FacetDefinitionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FacetDefinitionsQuery, FacetDefinitionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FacetDefinitionsQuery, FacetDefinitionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FacetDefinitionsQuery, FacetDefinitionsQueryVariables>(FacetDefinitionsDocument, variables, options);
}
export function useFacetDefinitionsLazyQuery(variables: FacetDefinitionsQueryVariables | VueCompositionApi.Ref<FacetDefinitionsQueryVariables> | ReactiveFunction<FacetDefinitionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<FacetDefinitionsQuery, FacetDefinitionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FacetDefinitionsQuery, FacetDefinitionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FacetDefinitionsQuery, FacetDefinitionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FacetDefinitionsQuery, FacetDefinitionsQueryVariables>(FacetDefinitionsDocument, variables, options);
}
export type FacetDefinitionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FacetDefinitionsQuery, FacetDefinitionsQueryVariables>;
export const FacetsDocument = gql`
    query facets($id: ID!, $acceptedLanguages: [LanguageWithWildcard!]) {
  facetsCollection(id: $id) {
    facets {
      id
      type
      kind
      display {
        type
        options
      }
      referencedId
      teasers {
        title(acceptedLanguages: $acceptedLanguages)
      }
      definition {
        fieldType
      }
    }
  }
}
    `;

/**
 * __useFacetsQuery__
 *
 * To run a query within a Vue component, call `useFacetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacetsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFacetsQuery({
 *   id: // value for 'id'
 *   acceptedLanguages: // value for 'acceptedLanguages'
 * });
 */
export function useFacetsQuery(variables: FacetsQueryVariables | VueCompositionApi.Ref<FacetsQueryVariables> | ReactiveFunction<FacetsQueryVariables>, options: VueApolloComposable.UseQueryOptions<FacetsQuery, FacetsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FacetsQuery, FacetsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FacetsQuery, FacetsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FacetsQuery, FacetsQueryVariables>(FacetsDocument, variables, options);
}
export function useFacetsLazyQuery(variables: FacetsQueryVariables | VueCompositionApi.Ref<FacetsQueryVariables> | ReactiveFunction<FacetsQueryVariables>, options: VueApolloComposable.UseQueryOptions<FacetsQuery, FacetsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FacetsQuery, FacetsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FacetsQuery, FacetsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FacetsQuery, FacetsQueryVariables>(FacetsDocument, variables, options);
}
export type FacetsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FacetsQuery, FacetsQueryVariables>;
export const MetadataDefinitionsWithLocalizationsDocument = gql`
    query metadataDefinitionsWithLocalizations($first: NonNegativeInt, $acceptedLanguages: [LanguageWithWildcard!], $after: String) {
  fieldDefinitions {
    fieldDefinitions(first: $first, after: $after) {
      node {
        id
        mappedNames
        localizations {
          title(acceptedLanguages: $acceptedLanguages)
        }
      }
    }
  }
}
    `;

/**
 * __useMetadataDefinitionsWithLocalizationsQuery__
 *
 * To run a query within a Vue component, call `useMetadataDefinitionsWithLocalizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetadataDefinitionsWithLocalizationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMetadataDefinitionsWithLocalizationsQuery({
 *   first: // value for 'first'
 *   acceptedLanguages: // value for 'acceptedLanguages'
 *   after: // value for 'after'
 * });
 */
export function useMetadataDefinitionsWithLocalizationsQuery(variables: MetadataDefinitionsWithLocalizationsQueryVariables | VueCompositionApi.Ref<MetadataDefinitionsWithLocalizationsQueryVariables> | ReactiveFunction<MetadataDefinitionsWithLocalizationsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<MetadataDefinitionsWithLocalizationsQuery, MetadataDefinitionsWithLocalizationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MetadataDefinitionsWithLocalizationsQuery, MetadataDefinitionsWithLocalizationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MetadataDefinitionsWithLocalizationsQuery, MetadataDefinitionsWithLocalizationsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MetadataDefinitionsWithLocalizationsQuery, MetadataDefinitionsWithLocalizationsQueryVariables>(MetadataDefinitionsWithLocalizationsDocument, variables, options);
}
export function useMetadataDefinitionsWithLocalizationsLazyQuery(variables: MetadataDefinitionsWithLocalizationsQueryVariables | VueCompositionApi.Ref<MetadataDefinitionsWithLocalizationsQueryVariables> | ReactiveFunction<MetadataDefinitionsWithLocalizationsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<MetadataDefinitionsWithLocalizationsQuery, MetadataDefinitionsWithLocalizationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MetadataDefinitionsWithLocalizationsQuery, MetadataDefinitionsWithLocalizationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MetadataDefinitionsWithLocalizationsQuery, MetadataDefinitionsWithLocalizationsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<MetadataDefinitionsWithLocalizationsQuery, MetadataDefinitionsWithLocalizationsQueryVariables>(MetadataDefinitionsWithLocalizationsDocument, variables, options);
}
export type MetadataDefinitionsWithLocalizationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MetadataDefinitionsWithLocalizationsQuery, MetadataDefinitionsWithLocalizationsQueryVariables>;
export const ProductTitleDocument = gql`
    query productTitle($id: String!, $acceptedLanguages: [LanguageWithWildcard!]) {
  product(id: $id) {
    id
    localizations {
      title(acceptedLanguages: $acceptedLanguages)
    }
  }
}
    `;

/**
 * __useProductTitleQuery__
 *
 * To run a query within a Vue component, call `useProductTitleQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductTitleQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProductTitleQuery({
 *   id: // value for 'id'
 *   acceptedLanguages: // value for 'acceptedLanguages'
 * });
 */
export function useProductTitleQuery(variables: ProductTitleQueryVariables | VueCompositionApi.Ref<ProductTitleQueryVariables> | ReactiveFunction<ProductTitleQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProductTitleQuery, ProductTitleQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProductTitleQuery, ProductTitleQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProductTitleQuery, ProductTitleQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProductTitleQuery, ProductTitleQueryVariables>(ProductTitleDocument, variables, options);
}
export function useProductTitleLazyQuery(variables: ProductTitleQueryVariables | VueCompositionApi.Ref<ProductTitleQueryVariables> | ReactiveFunction<ProductTitleQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProductTitleQuery, ProductTitleQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProductTitleQuery, ProductTitleQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProductTitleQuery, ProductTitleQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProductTitleQuery, ProductTitleQueryVariables>(ProductTitleDocument, variables, options);
}
export type ProductTitleQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProductTitleQuery, ProductTitleQueryVariables>;
export const PartsSearchConfigDocument = gql`
    query partsSearchConfig {
  tenant {
    uploadConfig {
      aiPartsSearch {
        image {
          allowAllMimeTypes
          allowedFileExtensions
          allowedMimeTypes
          limits {
            maxFileSize
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePartsSearchConfigQuery__
 *
 * To run a query within a Vue component, call `usePartsSearchConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartsSearchConfigQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePartsSearchConfigQuery();
 */
export function usePartsSearchConfigQuery(options: VueApolloComposable.UseQueryOptions<PartsSearchConfigQuery, PartsSearchConfigQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PartsSearchConfigQuery, PartsSearchConfigQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PartsSearchConfigQuery, PartsSearchConfigQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PartsSearchConfigQuery, PartsSearchConfigQueryVariables>(PartsSearchConfigDocument, {}, options);
}
export function usePartsSearchConfigLazyQuery(options: VueApolloComposable.UseQueryOptions<PartsSearchConfigQuery, PartsSearchConfigQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PartsSearchConfigQuery, PartsSearchConfigQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PartsSearchConfigQuery, PartsSearchConfigQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<PartsSearchConfigQuery, PartsSearchConfigQueryVariables>(PartsSearchConfigDocument, {}, options);
}
export type PartsSearchConfigQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PartsSearchConfigQuery, PartsSearchConfigQueryVariables>;
export const SearchConfigDocument = gql`
    query searchConfig($searchConfigId: ID!) {
  searchConfig(id: $searchConfigId) {
    id
    entries {
      referencedId
      fieldType
      boost
    }
  }
}
    `;

/**
 * __useSearchConfigQuery__
 *
 * To run a query within a Vue component, call `useSearchConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchConfigQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchConfigQuery({
 *   searchConfigId: // value for 'searchConfigId'
 * });
 */
export function useSearchConfigQuery(variables: SearchConfigQueryVariables | VueCompositionApi.Ref<SearchConfigQueryVariables> | ReactiveFunction<SearchConfigQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchConfigQuery, SearchConfigQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchConfigQuery, SearchConfigQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchConfigQuery, SearchConfigQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchConfigQuery, SearchConfigQueryVariables>(SearchConfigDocument, variables, options);
}
export function useSearchConfigLazyQuery(variables: SearchConfigQueryVariables | VueCompositionApi.Ref<SearchConfigQueryVariables> | ReactiveFunction<SearchConfigQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchConfigQuery, SearchConfigQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchConfigQuery, SearchConfigQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchConfigQuery, SearchConfigQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SearchConfigQuery, SearchConfigQueryVariables>(SearchConfigDocument, variables, options);
}
export type SearchConfigQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchConfigQuery, SearchConfigQueryVariables>;
export const TenantDocument = gql`
    query tenant {
  tenant {
    landingPage
    tenantSettings {
      docsRouteParams
    }
    domain
    displayName
    languages {
      available
      default
    }
    auth {
      accessMode
      authenticators {
        authenticators {
          node {
            url
            default
            strategyName
            displayName
            sortIndex
            status
          }
        }
      }
    }
  }
}
    `;

/**
 * __useTenantQuery__
 *
 * To run a query within a Vue component, call `useTenantQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenantQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTenantQuery();
 */
export function useTenantQuery(options: VueApolloComposable.UseQueryOptions<TenantQuery, TenantQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TenantQuery, TenantQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TenantQuery, TenantQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TenantQuery, TenantQueryVariables>(TenantDocument, {}, options);
}
export function useTenantLazyQuery(options: VueApolloComposable.UseQueryOptions<TenantQuery, TenantQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TenantQuery, TenantQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TenantQuery, TenantQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TenantQuery, TenantQueryVariables>(TenantDocument, {}, options);
}
export type TenantQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TenantQuery, TenantQueryVariables>;
export const UserSettingsByKeysDocument = gql`
    query userSettingsByKeys($keys: [String!]) {
  getUserSettings(keys: $keys) {
    settings
  }
}
    `;

/**
 * __useUserSettingsByKeysQuery__
 *
 * To run a query within a Vue component, call `useUserSettingsByKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSettingsByKeysQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserSettingsByKeysQuery({
 *   keys: // value for 'keys'
 * });
 */
export function useUserSettingsByKeysQuery(variables: UserSettingsByKeysQueryVariables | VueCompositionApi.Ref<UserSettingsByKeysQueryVariables> | ReactiveFunction<UserSettingsByKeysQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<UserSettingsByKeysQuery, UserSettingsByKeysQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserSettingsByKeysQuery, UserSettingsByKeysQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserSettingsByKeysQuery, UserSettingsByKeysQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UserSettingsByKeysQuery, UserSettingsByKeysQueryVariables>(UserSettingsByKeysDocument, variables, options);
}
export function useUserSettingsByKeysLazyQuery(variables: UserSettingsByKeysQueryVariables | VueCompositionApi.Ref<UserSettingsByKeysQueryVariables> | ReactiveFunction<UserSettingsByKeysQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<UserSettingsByKeysQuery, UserSettingsByKeysQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserSettingsByKeysQuery, UserSettingsByKeysQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserSettingsByKeysQuery, UserSettingsByKeysQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UserSettingsByKeysQuery, UserSettingsByKeysQueryVariables>(UserSettingsByKeysDocument, variables, options);
}
export type UserSettingsByKeysQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UserSettingsByKeysQuery, UserSettingsByKeysQueryVariables>;
export const CreateOrUpdateUserSettingsDocument = gql`
    mutation CreateOrUpdateUserSettings($diff: CreateOrUpdateUserSettings) {
  createOrUpdateUserSettings(diff: $diff) {
    settings
  }
}
    `;

/**
 * __useCreateOrUpdateUserSettingsMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateUserSettingsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateUserSettingsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateOrUpdateUserSettingsMutation({
 *   variables: {
 *     diff: // value for 'diff'
 *   },
 * });
 */
export function useCreateOrUpdateUserSettingsMutation(options: VueApolloComposable.UseMutationOptions<CreateOrUpdateUserSettingsMutation, CreateOrUpdateUserSettingsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateOrUpdateUserSettingsMutation, CreateOrUpdateUserSettingsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateOrUpdateUserSettingsMutation, CreateOrUpdateUserSettingsMutationVariables>(CreateOrUpdateUserSettingsDocument, options);
}
export type CreateOrUpdateUserSettingsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateOrUpdateUserSettingsMutation, CreateOrUpdateUserSettingsMutationVariables>;
export const GuiElementsAndUserDocument = gql`
    query guiElementsAndUser($guiElementsId: ID!, $type: String!) {
  me {
    id
    email
    rawClaims
    effectiveRoles
  }
  guiElements(id: $guiElementsId, type: $type) {
    id
    config
  }
}
    `;

/**
 * __useGuiElementsAndUserQuery__
 *
 * To run a query within a Vue component, call `useGuiElementsAndUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuiElementsAndUserQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGuiElementsAndUserQuery({
 *   guiElementsId: // value for 'guiElementsId'
 *   type: // value for 'type'
 * });
 */
export function useGuiElementsAndUserQuery(variables: GuiElementsAndUserQueryVariables | VueCompositionApi.Ref<GuiElementsAndUserQueryVariables> | ReactiveFunction<GuiElementsAndUserQueryVariables>, options: VueApolloComposable.UseQueryOptions<GuiElementsAndUserQuery, GuiElementsAndUserQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GuiElementsAndUserQuery, GuiElementsAndUserQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GuiElementsAndUserQuery, GuiElementsAndUserQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GuiElementsAndUserQuery, GuiElementsAndUserQueryVariables>(GuiElementsAndUserDocument, variables, options);
}
export function useGuiElementsAndUserLazyQuery(variables: GuiElementsAndUserQueryVariables | VueCompositionApi.Ref<GuiElementsAndUserQueryVariables> | ReactiveFunction<GuiElementsAndUserQueryVariables>, options: VueApolloComposable.UseQueryOptions<GuiElementsAndUserQuery, GuiElementsAndUserQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GuiElementsAndUserQuery, GuiElementsAndUserQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GuiElementsAndUserQuery, GuiElementsAndUserQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GuiElementsAndUserQuery, GuiElementsAndUserQueryVariables>(GuiElementsAndUserDocument, variables, options);
}
export type GuiElementsAndUserQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GuiElementsAndUserQuery, GuiElementsAndUserQueryVariables>;
export const ThemeDocument = gql`
    query theme($acceptedLanguages: [LanguageWithWildcard!]) {
  theme {
    showTitle
    logo {
      blobId
      url
      path
    }
    theming
    teasers {
      title(acceptedLanguages: $acceptedLanguages)
    }
  }
}
    `;

/**
 * __useThemeQuery__
 *
 * To run a query within a Vue component, call `useThemeQuery` and pass it any options that fit your needs.
 * When your component renders, `useThemeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useThemeQuery({
 *   acceptedLanguages: // value for 'acceptedLanguages'
 * });
 */
export function useThemeQuery(variables: ThemeQueryVariables | VueCompositionApi.Ref<ThemeQueryVariables> | ReactiveFunction<ThemeQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ThemeQuery, ThemeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ThemeQuery, ThemeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ThemeQuery, ThemeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ThemeQuery, ThemeQueryVariables>(ThemeDocument, variables, options);
}
export function useThemeLazyQuery(variables: ThemeQueryVariables | VueCompositionApi.Ref<ThemeQueryVariables> | ReactiveFunction<ThemeQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ThemeQuery, ThemeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ThemeQuery, ThemeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ThemeQuery, ThemeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ThemeQuery, ThemeQueryVariables>(ThemeDocument, variables, options);
}
export type ThemeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ThemeQuery, ThemeQueryVariables>;